{
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              18.3430400057917,
              -33.5706300010736
            ],
            [
              18.395559995997,
              -33.6233600009632
            ],
            [
              18.4379599979556,
              -33.6925600040409
            ],
            [
              18.4497700011847,
              -33.7818200013919
            ],
            [
              18.4886999969074,
              -33.851910003244
            ],
            [
              18.4652199960061,
              -33.912100000015
            ],
            [
              18.3982599973011,
              -33.9008800024101
            ],
            [
              18.369799998771,
              -33.9745999890982
            ],
            [
              18.3106300022729,
              -34.0432900028313
            ],
            [
              18.3569499997428,
              -34.1103800030346
            ],
            [
              18.3183300030273,
              -34.1459099957497
            ],
            [
              18.3628399997662,
              -34.1843699967779
            ],
            [
              18.4021999982314,
              -34.3096500031451
            ],
            [
              18.4532200029009,
              -34.3366699973225
            ],
            [
              18.4754300009938,
              -34.2304499975693
            ],
            [
              18.4264100031192,
              -34.1771899966209
            ],
            [
              18.4690900009029,
              -34.109140010603
            ],
            [
              18.5974399968584,
              -34.0776099991022
            ],
            [
              18.6946599970612,
              -34.0721099999765
            ],
            [
              18.813380003984,
              -34.101329996682
            ],
            [
              18.8681199931433,
              -34.1604799976538
            ],
            [
              18.8197300009388,
              -34.1853299996797
            ],
            [
              18.8527699957387,
              -34.2381000014139
            ],
            [
              18.8458149996625,
              -34.2695900029762
            ],
            [
              18.9802700019591,
              -34.154989992694
            ],
            [
              18.9439000028828,
              -34.138239999976
            ],
            [
              19.0048242259573,
              -34.0755668572246
            ],
            [
              18.9846060418355,
              -34.0358997429787
            ],
            [
              18.9437100022148,
              -34.0037200027759
            ],
            [
              18.8418400016148,
              -34.0471100018251
            ],
            [
              18.7922699990612,
              -34.0533799977886
            ],
            [
              18.7444300043412,
              -34.0248200018416
            ],
            [
              18.7108100016803,
              -33.9211689973513
            ],
            [
              18.7528700014494,
              -33.8344199997831
            ],
            [
              18.7897599957272,
              -33.8201500009218
            ],
            [
              18.8094599985801,
              -33.7407800018955
            ],
            [
              18.7875399967735,
              -33.6376300007239
            ],
            [
              18.7367300098821,
              -33.6870300017331
            ],
            [
              18.6270000002499,
              -33.6245900001284
            ],
            [
              18.6179937603039,
              -33.5843588652694
            ],
            [
              18.5743700022739,
              -33.5735000030227
            ],
            [
              18.5764199996833,
              -33.5314799970043
            ],
            [
              18.5241600043808,
              -33.5252299965671
            ],
            [
              18.495749995566,
              -33.4811299989502
            ],
            [
              18.4554349989262,
              -33.4712999979965
            ],
            [
              18.3888199972451,
              -33.5089100002962
            ],
            [
              18.3430400057917,
              -33.5706300010736
            ]
          ]
        ]
      },
      "properties": {
        "Name": "City of Cape Town",
        "Code": "CPT",
        "Parent_cod": "WC",
        "Area": 244056
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              25.2214900027615,
              -33.9707700004351
            ],
            [
              25.3949400010802,
              -34.0313700026234
            ],
            [
              25.5892499999876,
              -34.0506100022497
            ],
            [
              25.6529200007575,
              -34.0280399974478
            ],
            [
              25.6714000013091,
              -33.9831300011486
            ],
            [
              25.6125199992986,
              -33.948269997962
            ],
            [
              25.6414900006631,
              -33.8516500020459
            ],
            [
              25.7039600018526,
              -33.7904600014279
            ],
            [
              25.8490099990123,
              -33.7224599979305
            ],
            [
              25.8498000012691,
              -33.6654100011706
            ],
            [
              25.7800599993695,
              -33.692310000606
            ],
            [
              25.7367900040555,
              -33.6299299990702
            ],
            [
              25.5580100000615,
              -33.5961600002838
            ],
            [
              25.437709999417,
              -33.5530800011411
            ],
            [
              25.3462999982464,
              -33.5570700088738
            ],
            [
              25.3080599983703,
              -33.6378500009767
            ],
            [
              25.3478400000161,
              -33.6709100002962
            ],
            [
              25.3273291513193,
              -33.7263963943781
            ],
            [
              25.2657664977258,
              -33.6979158697216
            ],
            [
              25.3016540968592,
              -33.7263116000004
            ],
            [
              25.2008199992436,
              -33.8992099991421
            ],
            [
              25.2214900027615,
              -33.9707700004351
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Nelson Mandela Bay",
        "Code": "NMA",
        "Parent_cod": "EC",
        "Area": 195696
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              28.5030549967907,
              -26.0638000032675
            ],
            [
              28.5789399969833,
              -26.0595900033759
            ],
            [
              28.590949996845,
              -26.0024799939565
            ],
            [
              28.6322600033965,
              -25.9707799970992
            ],
            [
              28.7938600038362,
              -26.0045700004051
            ],
            [
              28.8648399972682,
              -26.0012699957137
            ],
            [
              28.8850499957607,
              -25.9743999985611
            ],
            [
              28.8889600016029,
              -25.8803299988304
            ],
            [
              28.9381799961099,
              -25.8886400016347
            ],
            [
              28.9381699992461,
              -25.8232849960057
            ],
            [
              28.981310002055,
              -25.7425400019195
            ],
            [
              28.9506729975609,
              -25.7282730031965
            ],
            [
              28.968829999405,
              -25.6733099983577
            ],
            [
              29.0646200011122,
              -25.6424199992835
            ],
            [
              29.0077600023223,
              -25.5741600017826
            ],
            [
              28.9465399994215,
              -25.5997999970722
            ],
            [
              28.8517800029448,
              -25.5018100000314
            ],
            [
              28.7970540009414,
              -25.54204499568
            ],
            [
              28.8431099997268,
              -25.5664400037032
            ],
            [
              28.8583800033346,
              -25.6348099963842
            ],
            [
              28.8469500032401,
              -25.682420001182
            ],
            [
              28.7927300002893,
              -25.7024299958475
            ],
            [
              28.7528498888114,
              -25.6939105841061
            ],
            [
              28.7663100014055,
              -25.6469799991276
            ],
            [
              28.723869999401,
              -25.6317700009847
            ],
            [
              28.6837799969493,
              -25.6753800002867
            ],
            [
              28.6425120031265,
              -25.5898650029675
            ],
            [
              28.6336800014309,
              -25.5151399969132
            ],
            [
              28.6197899976104,
              -25.4113899959515
            ],
            [
              28.6389399966836,
              -25.3939800042737
            ],
            [
              28.6225799976688,
              -25.333649999248
            ],
            [
              28.7324299984457,
              -25.2691700006949
            ],
            [
              28.7754100001714,
              -25.183770003283
            ],
            [
              28.7445889970846,
              -25.1096120017924
            ],
            [
              28.6515699963583,
              -25.1428999972371
            ],
            [
              28.6158700020989,
              -25.1516299969268
            ],
            [
              28.6593099989573,
              -25.234780001196
            ],
            [
              28.6326299997747,
              -25.279970003213
            ],
            [
              28.5948100039785,
              -25.2494299959975
            ],
            [
              28.5132800033695,
              -25.2561499992231
            ],
            [
              28.503590000778,
              -25.3088399990666
            ],
            [
              28.3826000042868,
              -25.3211500001723
            ],
            [
              28.379160997682,
              -25.2920559975863
            ],
            [
              28.2981600007834,
              -25.3103700021739
            ],
            [
              28.2980600033665,
              -25.3393399963438
            ],
            [
              28.0447300031871,
              -25.4017399952046
            ],
            [
              28.0112800020704,
              -25.3693199921239
            ],
            [
              28.009463001916,
              -25.3676649976415
            ],
            [
              28.0059029969258,
              -25.3644229893295
            ],
            [
              27.9707599968763,
              -25.3629499897502
            ],
            [
              27.9456399958892,
              -25.4067000027029
            ],
            [
              27.9726800098746,
              -25.4371299967519
            ],
            [
              27.9741900102608,
              -25.4361199960409
            ],
            [
              27.9925899999286,
              -25.4254699977421
            ],
            [
              28.0001600009833,
              -25.4334399992565
            ],
            [
              28.0054850037299,
              -25.4886900011426
            ],
            [
              28.0034249995641,
              -25.4933719994182
            ],
            [
              27.9934920001557,
              -25.5465750022346
            ],
            [
              27.990763163889,
              -25.5457076070204
            ],
            [
              27.9576300002243,
              -25.5926199969153
            ],
            [
              27.9805600117352,
              -25.6328000071147
            ],
            [
              27.9481900001684,
              -25.6952100037386
            ],
            [
              27.9601699968479,
              -25.8159899977401
            ],
            [
              27.8982000007295,
              -25.8597400043976
            ],
            [
              27.8937980000777,
              -25.9056810032757
            ],
            [
              27.9321199983393,
              -25.9163000010442
            ],
            [
              28.029906001261,
              -25.9111019978588
            ],
            [
              28.0312699931158,
              -25.9133499972046
            ],
            [
              28.0326099991522,
              -25.9155699961584
            ],
            [
              28.1102300011137,
              -25.9449100109882
            ],
            [
              28.1810499997577,
              -25.9195499980339
            ],
            [
              28.3194790018545,
              -25.9137200016767
            ],
            [
              28.3523800037343,
              -25.9545999982913
            ],
            [
              28.4071899970208,
              -25.9240900023517
            ],
            [
              28.4444200042799,
              -25.9911499993729
            ],
            [
              28.4686700011197,
              -26.0780899985546
            ],
            [
              28.5030549967907,
              -26.0638000032675
            ]
          ]
        ]
      },
      "properties": {
        "Name": "City of Tshwane",
        "Code": "TSH",
        "Parent_cod": "GT",
        "Area": 629783
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              28.0671019988582,
              -26.3419400036282
            ],
            [
              28.0975160020619,
              -26.3603099991071
            ],
            [
              28.0771799995573,
              -26.4173000002947
            ],
            [
              28.263749996765,
              -26.4350400116871
            ],
            [
              28.2441800017058,
              -26.3765700078995
            ],
            [
              28.2740100013606,
              -26.3586799976837
            ],
            [
              28.3702949980158,
              -26.3936309969729
            ],
            [
              28.4502300024128,
              -26.4407499971147
            ],
            [
              28.4990799996423,
              -26.4393000021933
            ],
            [
              28.5178799969643,
              -26.3619599978556
            ],
            [
              28.5136300042214,
              -26.2214300013934
            ],
            [
              28.5271500026705,
              -26.1787400040479
            ],
            [
              28.4905000041719,
              -26.1263920019893
            ],
            [
              28.5030549967907,
              -26.0638000032675
            ],
            [
              28.4686700011197,
              -26.0780899985546
            ],
            [
              28.4444200042799,
              -25.9911499993729
            ],
            [
              28.4071899970208,
              -25.9240900023517
            ],
            [
              28.3523800037343,
              -25.9545999982913
            ],
            [
              28.3194790018545,
              -25.9137200016767
            ],
            [
              28.1810499997577,
              -25.9195499980339
            ],
            [
              28.1664599969313,
              -25.9792699884191
            ],
            [
              28.1898130018685,
              -26.0132710032542
            ],
            [
              28.1896999975568,
              -26.0133599956672
            ],
            [
              28.1581830010448,
              -26.0382500004371
            ],
            [
              28.1848299969069,
              -26.0892599992495
            ],
            [
              28.1127399963538,
              -26.1677799977487
            ],
            [
              28.1265800005666,
              -26.2243299957326
            ],
            [
              28.1270299997348,
              -26.2243900020969
            ],
            [
              28.070560002742,
              -26.2726199977147
            ],
            [
              28.0671019988582,
              -26.3419400036282
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Ekurhuleni",
        "Code": "EKU",
        "Parent_cod": "GT",
        "Area": 197569
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              30.7648679426016,
              -30.2687839414257
            ],
            [
              30.8986799431249,
              -30.0417200652288
            ],
            [
              30.9685199433407,
              -29.9823299398748
            ],
            [
              31.0614199430759,
              -29.8759799404218
            ],
            [
              31.0384099431645,
              -29.82322993961
            ],
            [
              31.128019943166,
              -29.653579940262
            ],
            [
              31.1857549436358,
              -29.5717849400229
            ],
            [
              31.1831299439918,
              -29.5280200648741
            ],
            [
              31.1358399431589,
              -29.5011300650005
            ],
            [
              31.1097050680345,
              -29.5389449400569
            ],
            [
              31.033750925265,
              -29.5496012012343
            ],
            [
              31.0308199429861,
              -29.5510299397799
            ],
            [
              30.9692799433148,
              -29.5864999396204
            ],
            [
              30.9691599431768,
              -29.5863999404049
            ],
            [
              30.8425099428796,
              -29.6256199396085
            ],
            [
              30.7932199433458,
              -29.5754999395705
            ],
            [
              30.727179943,
              -29.5709399399999
            ],
            [
              30.7260899430001,
              -29.606040065
            ],
            [
              30.6737529430002,
              -29.6199020649999
            ],
            [
              30.6221699432883,
              -29.6683499396979
            ],
            [
              30.5837509243658,
              -29.6543228306341
            ],
            [
              30.5693899428915,
              -29.731649939593
            ],
            [
              30.5864699427337,
              -29.7807299402345
            ],
            [
              30.5759999428431,
              -29.8314999396704
            ],
            [
              30.6752500681362,
              -29.9222209396445
            ],
            [
              30.5961138712582,
              -30.1238988709361
            ],
            [
              30.6914505229234,
              -30.1496068163015
            ],
            [
              30.6924319431797,
              -30.1985479409347
            ],
            [
              30.7648679426016,
              -30.2687839414257
            ]
          ]
        ]
      },
      "properties": {
        "Name": "eThekwini",
        "Code": "ETH",
        "Parent_cod": "KZN",
        "Area": 255592
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              27.4918300000545,
              -33.2820399981474
            ],
            [
              27.6085999970922,
              -33.2181899980699
            ],
            [
              27.727969998017,
              -33.1214400006555
            ],
            [
              27.7821199977398,
              -33.1026199988139
            ],
            [
              27.9196599993095,
              -33.0296100043982
            ],
            [
              27.9691199967904,
              -32.9736500030452
            ],
            [
              28.0755299936144,
              -32.9077950004389
            ],
            [
              27.9914599460197,
              -32.8555618337116
            ],
            [
              27.9571778336902,
              -32.7583392245756
            ],
            [
              27.882910000696,
              -32.7855000031226
            ],
            [
              27.8299799978786,
              -32.7802900002832
            ],
            [
              27.7952100033391,
              -32.747499999925
            ],
            [
              27.6741699991462,
              -32.8343500003521
            ],
            [
              27.5364400014049,
              -32.7926199978146
            ],
            [
              27.5152799968744,
              -32.7159400014299
            ],
            [
              27.4561000008144,
              -32.7816299982258
            ],
            [
              27.3700634182921,
              -32.8043418476981
            ],
            [
              27.3957448309593,
              -32.7322708048538
            ],
            [
              27.3712900009328,
              -32.699760002622
            ],
            [
              27.2974399965587,
              -32.676680001281
            ],
            [
              27.2306199971152,
              -32.7173899963512
            ],
            [
              27.2127199981294,
              -32.7653500011016
            ],
            [
              27.1577799997472,
              -32.8385000001748
            ],
            [
              27.2162070060485,
              -32.8548930043087
            ],
            [
              27.2397528912829,
              -32.956689917006
            ],
            [
              27.2958642827105,
              -33.0241727293878
            ],
            [
              27.3616813690001,
              -32.9672064496179
            ],
            [
              27.5039100022449,
              -32.9952199968053
            ],
            [
              27.4441700109373,
              -33.0797600058195
            ],
            [
              27.3601329432808,
              -33.1299472841398
            ],
            [
              27.3748899987744,
              -33.1800899956567
            ],
            [
              27.4247300011887,
              -33.1930199983741
            ],
            [
              27.4429499987434,
              -33.2583799979385
            ],
            [
              27.4918300000545,
              -33.2820399981474
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Buffalo City",
        "Code": "BUF",
        "Parent_cod": "EC",
        "Area": 275258
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              27.761289999434,
              -26.4191500010717
            ],
            [
              27.7597100039136,
              -26.4838699882094
            ],
            [
              27.8216899977952,
              -26.4848799979135
            ],
            [
              27.8756300040215,
              -26.5204999992755
            ],
            [
              27.8690749994117,
              -26.4448009986672
            ],
            [
              27.9122299957178,
              -26.358949996645
            ],
            [
              27.9699800022753,
              -26.3417000069498
            ],
            [
              27.9843430018281,
              -26.344967997575
            ],
            [
              28.0671019988582,
              -26.3419400036282
            ],
            [
              28.070560002742,
              -26.2726199977147
            ],
            [
              28.1270299997348,
              -26.2243900020969
            ],
            [
              28.1265800005666,
              -26.2243299957326
            ],
            [
              28.1127399963538,
              -26.1677799977487
            ],
            [
              28.1848299969069,
              -26.0892599992495
            ],
            [
              28.1581830010448,
              -26.0382500004371
            ],
            [
              28.1896999975568,
              -26.0133599956672
            ],
            [
              28.1898130018685,
              -26.0132710032542
            ],
            [
              28.1664599969313,
              -25.9792699884191
            ],
            [
              28.1810499997577,
              -25.9195499980339
            ],
            [
              28.1102300011137,
              -25.9449100109882
            ],
            [
              28.0326099991522,
              -25.9155699961584
            ],
            [
              28.0312699931158,
              -25.9133499972046
            ],
            [
              28.029906001261,
              -25.9111019978588
            ],
            [
              27.9321199983393,
              -25.9163000010442
            ],
            [
              27.8975899905856,
              -25.9543600007134
            ],
            [
              27.9235300042064,
              -25.9983100022048
            ],
            [
              27.9004799970542,
              -26.0458100028294
            ],
            [
              27.9002199958562,
              -26.04679999992
            ],
            [
              27.8353100026545,
              -26.0846300015733
            ],
            [
              27.8388100030792,
              -26.1202199997531
            ],
            [
              27.8105999998901,
              -26.1820800006914
            ],
            [
              27.7813400031387,
              -26.1925999983912
            ],
            [
              27.779685002361,
              -26.1962199917591
            ],
            [
              27.7147900017572,
              -26.2150699958836
            ],
            [
              27.717761278160513,
              -26.221987971367835
            ],
            [
              27.7534800008014,
              -26.2580399989467
            ],
            [
              27.8136799962349,
              -26.2856499978491
            ],
            [
              27.8115899969808,
              -26.3644750032188
            ],
            [
              27.7518640027216,
              -26.3619950030669
            ],
            [
              27.761289999434,
              -26.4191500010717
            ]
          ]
        ]
      },
      "properties": {
        "Name": "City of Johannesburg",
        "Code": "JHB",
        "Parent_cod": "GT",
        "Area": 164263
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              27.1274300030923,
              -29.5746700029183
            ],
            [
              27.0814000010093,
              -29.5591799990577
            ],
            [
              27.0607100001664,
              -29.5228300018031
            ],
            [
              26.9989999980516,
              -29.5197599960269
            ],
            [
              26.9629100100889,
              -29.4280399886545
            ],
            [
              27.0109599983054,
              -29.3951399994114
            ],
            [
              27.0676500027455,
              -29.441589996581
            ],
            [
              27.085640004083,
              -29.3856699970727
            ],
            [
              26.9769199996584,
              -29.3740899990541
            ],
            [
              26.9427800080909,
              -29.315669991277
            ],
            [
              26.9632899889419,
              -29.2569399961838
            ],
            [
              26.9174299893026,
              -29.2197599966265
            ],
            [
              26.9172099917478,
              -29.1820999929203
            ],
            [
              27.051339996144,
              -29.070609996554
            ],
            [
              26.9948500027255,
              -29.0219300017681
            ],
            [
              26.9624299942489,
              -29.0219400148198
            ],
            [
              26.946320004065,
              -28.9397200039749
            ],
            [
              26.8181300109912,
              -28.9271399931162
            ],
            [
              26.7526900104357,
              -29.003049992663
            ],
            [
              26.7163900037957,
              -29.0723799981384
            ],
            [
              26.6343400007905,
              -29.0596500001474
            ],
            [
              26.566949999343,
              -28.9680800041888
            ],
            [
              26.5173500017013,
              -28.983119999888
            ],
            [
              26.4719300016683,
              -28.9480299995848
            ],
            [
              26.4030600039161,
              -28.9891950039462
            ],
            [
              26.3661799984082,
              -28.9625000031726
            ],
            [
              26.3349799994275,
              -28.9011700041923
            ],
            [
              26.2806700040175,
              -28.940369997977
            ],
            [
              26.2338199982943,
              -28.8808999993355
            ],
            [
              26.1652799959751,
              -28.8545700010047
            ],
            [
              26.0999268933115,
              -28.7683681518687
            ],
            [
              26.1488800166995,
              -28.7607305793527
            ],
            [
              26.0983759054237,
              -28.6650594536308
            ],
            [
              26.0425399601511,
              -28.6666156602844
            ],
            [
              26.0130659454371,
              -28.7150560666841
            ],
            [
              26.0330538932226,
              -28.7407745781842
            ],
            [
              26.0200333782379,
              -28.7998571992503
            ],
            [
              25.9265400022194,
              -28.8265299993599
            ],
            [
              25.9307799971992,
              -28.7711300013484
            ],
            [
              25.8786699971227,
              -28.7600599989698
            ],
            [
              25.8541300030972,
              -28.8156700003701
            ],
            [
              25.8563100091996,
              -28.8676300034219
            ],
            [
              25.7452600016478,
              -28.9064000025581
            ],
            [
              25.7193599979656,
              -29.0062900008828
            ],
            [
              25.7609199989589,
              -29.025799998571
            ],
            [
              25.7313400027389,
              -29.077020007967
            ],
            [
              25.7412399997262,
              -29.2260400002458
            ],
            [
              25.8415000034225,
              -29.2322800011211
            ],
            [
              25.9055400005707,
              -29.2543099999066
            ],
            [
              25.9148500009268,
              -29.3060799977936
            ],
            [
              25.9926399891442,
              -29.2731099981279
            ],
            [
              25.9927000018037,
              -29.2732899902408
            ],
            [
              26.0235100070812,
              -29.33931999732
            ],
            [
              25.9594200022314,
              -29.3654599967813
            ],
            [
              25.9794199991337,
              -29.4016400005856
            ],
            [
              26.0323049989766,
              -29.4170949992347
            ],
            [
              26.0777700028834,
              -29.4796900061887
            ],
            [
              26.163440000156,
              -29.4677799974489
            ],
            [
              26.2241900092616,
              -29.4795799939215
            ],
            [
              26.2841000084087,
              -29.5250699935853
            ],
            [
              26.2853099931617,
              -29.5981899921744
            ],
            [
              26.3882099971937,
              -29.6173300051756
            ],
            [
              26.4201300023978,
              -29.5727399993514
            ],
            [
              26.454190004665,
              -29.5847999979215
            ],
            [
              26.5510899991042,
              -29.5717600000239
            ],
            [
              26.5620700000306,
              -29.6479200021064
            ],
            [
              26.6269800022254,
              -29.6345300042562
            ],
            [
              26.6363800004367,
              -29.7003900007979
            ],
            [
              26.6602100021899,
              -29.7268300042013
            ],
            [
              26.715499996028,
              -29.7112199984042
            ],
            [
              26.7803400021894,
              -29.7390200033704
            ],
            [
              26.7332999993955,
              -29.8421900009677
            ],
            [
              26.8239500005921,
              -29.964710000566
            ],
            [
              26.8689600095968,
              -29.993769992591
            ],
            [
              26.8151700102878,
              -30.0303799928424
            ],
            [
              26.9467999902274,
              -30.1085699896133
            ],
            [
              26.9913000116863,
              -30.1118499942818
            ],
            [
              27.0653799870968,
              -30.0757899951121
            ],
            [
              27.0919500000925,
              -30.0267699972375
            ],
            [
              27.2163600041109,
              -29.9829700008648
            ],
            [
              27.0965799968694,
              -29.7299299960725
            ],
            [
              27.0139100021449,
              -29.6617500013614
            ],
            [
              27.1274300030923,
              -29.5746700029183
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Mangaung",
        "Code": "MAN",
        "Parent_cod": "FS",
        "Area": 988631
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              28.9842199959561,
              -26.2369300102118
            ],
            [
              29.0332620011405,
              -26.2257600032215
            ],
            [
              29.0658000042668,
              -26.3142900037806
            ],
            [
              29.102230003412,
              -26.3297600031216
            ],
            [
              29.1235900018772,
              -26.3842899969857
            ],
            [
              29.173069996683,
              -26.3488899958766
            ],
            [
              29.2606199988139,
              -26.3623600037112
            ],
            [
              29.335469998042,
              -26.3483300024277
            ],
            [
              29.3665729988449,
              -26.2921079970863
            ],
            [
              29.3406900004432,
              -26.2450800029398
            ],
            [
              29.3481600031817,
              -26.2317799957502
            ],
            [
              29.3879699999157,
              -26.2049000008343
            ],
            [
              29.3910399966986,
              -26.1441900016671
            ],
            [
              29.3336700031681,
              -26.0952200016018
            ],
            [
              29.4024479993758,
              -26.063212007628
            ],
            [
              29.3297599973261,
              -25.9869200030557
            ],
            [
              29.3649200008574,
              -25.9429800002268
            ],
            [
              29.3755299982109,
              -25.9133200021164
            ],
            [
              29.3510400028939,
              -25.899280001271
            ],
            [
              29.3279799979785,
              -25.7917199963806
            ],
            [
              29.2920099957648,
              -25.7950500033549
            ],
            [
              29.2891299960525,
              -25.7453599979654
            ],
            [
              29.2425200031957,
              -25.7087599981753
            ],
            [
              29.1172700000105,
              -25.6565000001748
            ],
            [
              29.0415499984338,
              -25.7080300013834
            ],
            [
              29.008290003381,
              -25.6605700017042
            ],
            [
              28.968829999405,
              -25.6733099983577
            ],
            [
              28.9506729975609,
              -25.7282730031965
            ],
            [
              28.981310002055,
              -25.7425400019195
            ],
            [
              28.9381699992461,
              -25.8232849960058
            ],
            [
              28.9410700016793,
              -25.8772900034309
            ],
            [
              29.0267099966691,
              -25.9166500009967
            ],
            [
              28.9536600013081,
              -25.9747800025951
            ],
            [
              28.9249299957228,
              -26.0238300018531
            ],
            [
              28.9195840001015,
              -26.1000049992313
            ],
            [
              28.9993500012016,
              -26.1208700036477
            ],
            [
              29.0202899955869,
              -26.1931699985965
            ],
            [
              28.9842199959561,
              -26.2369300102118
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Emalahleni Local Municipality",
        "Code": "MP312",
        "Parent_cod": "DC31",
        "Area": 267761
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              28.8736269717074,
              -28.7707119002339
            ],
            [
              28.8962299789304,
              -28.6947399823642
            ],
            [
              28.942769955,
              -28.6509000289999
            ],
            [
              28.9739909766023,
              -28.5745600394142
            ],
            [
              29.09631997,
              -28.545090034
            ],
            [
              29.1349999677743,
              -28.5662999669699
            ],
            [
              29.2162499570001,
              -28.5190499539999
            ],
            [
              29.1914999787411,
              -28.4937799780635
            ],
            [
              29.2487499710002,
              -28.424899967
            ],
            [
              29.2900999697378,
              -28.4378900338979
            ],
            [
              29.3755599770001,
              -28.3721099709999
            ],
            [
              29.4143099681305,
              -28.3759100157346
            ],
            [
              29.4375799728375,
              -28.3211299689728
            ],
            [
              29.5099200442747,
              -28.2654399369035
            ],
            [
              29.5199899969408,
              -28.2205500017812
            ],
            [
              29.5640000029978,
              -28.1891300016482
            ],
            [
              29.405129998051,
              -28.0780000020984
            ],
            [
              29.380470002089,
              -28.1202599958022
            ],
            [
              29.3144599986301,
              -28.0728100028793
            ],
            [
              29.3111399984123,
              -28.0115400003707
            ],
            [
              29.2708300038017,
              -27.9967200040249
            ],
            [
              29.1611300009489,
              -28.011769999286
            ],
            [
              29.1176399972881,
              -28.0489499979441
            ],
            [
              29.0659199981094,
              -28.0221700013444
            ],
            [
              29.0068700044472,
              -28.0207600001738
            ],
            [
              28.9989099997967,
              -28.0745400017196
            ],
            [
              28.8791099970288,
              -28.1376699892786
            ],
            [
              28.7697700008848,
              -28.1245799998671
            ],
            [
              28.7276499974495,
              -28.15581000203
            ],
            [
              28.7157299972416,
              -28.2355200032455
            ],
            [
              28.6550400097886,
              -28.2518700026984
            ],
            [
              28.6314099956748,
              -28.3429999990507
            ],
            [
              28.5827550002431,
              -28.3913249981501
            ],
            [
              28.5823700022738,
              -28.4494200017316
            ],
            [
              28.6518000033675,
              -28.4965399992215
            ],
            [
              28.6314800069967,
              -28.5825099977381
            ],
            [
              28.6823599980156,
              -28.5904100041183
            ],
            [
              28.7046099970537,
              -28.6713099981579
            ],
            [
              28.7949599970063,
              -28.6997500002623
            ],
            [
              28.8077800018457,
              -28.7708700001503
            ],
            [
              28.8736269717074,
              -28.7707119002339
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Maluti a Phofung Local Municipality",
        "Code": "FS194",
        "Parent_cod": "DC19",
        "Area": 433772
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              28.9842199959561,
              -26.2369300102118
            ],
            [
              29.0202899955869,
              -26.1931699985965
            ],
            [
              28.9993500012016,
              -26.1208700036477
            ],
            [
              28.9195840001015,
              -26.1000049992313
            ],
            [
              28.9249299957228,
              -26.0238300018531
            ],
            [
              28.9536600013081,
              -25.9747800025951
            ],
            [
              29.0267099966691,
              -25.9166500009967
            ],
            [
              28.9410700016793,
              -25.8772900034309
            ],
            [
              28.8889600016029,
              -25.8803299988303
            ],
            [
              28.8850499957607,
              -25.9743999985611
            ],
            [
              28.8648399972682,
              -26.0012699957137
            ],
            [
              28.7938600038362,
              -26.0045700004051
            ],
            [
              28.6322600033965,
              -25.9707799970991
            ],
            [
              28.590949996845,
              -26.0024799939565
            ],
            [
              28.5789399969833,
              -26.0595900033759
            ],
            [
              28.5030549967907,
              -26.0638000032675
            ],
            [
              28.4905000041719,
              -26.1263920019893
            ],
            [
              28.5271500026705,
              -26.1787400040479
            ],
            [
              28.5305399989218,
              -26.2253099959595
            ],
            [
              28.6222900031812,
              -26.248379998638
            ],
            [
              28.6269000017338,
              -26.2924399971081
            ],
            [
              28.7101200101304,
              -26.3412400019245
            ],
            [
              28.8050800023403,
              -26.3065900021268
            ],
            [
              28.8384400029039,
              -26.3407500027104
            ],
            [
              28.8675600021924,
              -26.3276500002473
            ],
            [
              28.8863400030887,
              -26.2577100026145
            ],
            [
              28.9395099962894,
              -26.2658099957347
            ],
            [
              28.9842199959561,
              -26.2369300102118
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Victor Khanye Local Municipality",
        "Code": "MP311",
        "Parent_cod": "DC31",
        "Area": 156778
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              27.7886600178456,
              -28.2479809942275
            ],
            [
              27.83758000931,
              -28.2294199899405
            ],
            [
              27.9927100090598,
              -28.2319899897462
            ],
            [
              28.0391299895574,
              -28.2137799872565
            ],
            [
              28.0279900010378,
              -28.1767499982138
            ],
            [
              28.1136499996478,
              -28.1301100021748
            ],
            [
              28.1816350015542,
              -28.1081820035965
            ],
            [
              28.2218299971567,
              -28.1285299985606
            ],
            [
              28.2776099992022,
              -28.1191799990577
            ],
            [
              28.3204199975849,
              -28.0597299959425
            ],
            [
              28.4151700043923,
              -28.0480199982243
            ],
            [
              28.4471800011562,
              -27.9912700036077
            ],
            [
              28.4858200005926,
              -28.0365200020964
            ],
            [
              28.5668799984132,
              -28.0177999976717
            ],
            [
              28.6352090008948,
              -28.0305819980608
            ],
            [
              28.7281900043653,
              -28.0228599971911
            ],
            [
              28.7379599998542,
              -27.9760999992156
            ],
            [
              28.7214200024312,
              -27.918229997916
            ],
            [
              28.7679299969718,
              -27.8887099999665
            ],
            [
              28.7672499997877,
              -27.8121800006065
            ],
            [
              28.7812099987425,
              -27.7720099971636
            ],
            [
              28.7443899986995,
              -27.7285699994059
            ],
            [
              28.7811199999881,
              -27.6870999980664
            ],
            [
              28.7380899995539,
              -27.635119998589
            ],
            [
              28.7429200909894,
              -27.5990485843246
            ],
            [
              28.6749700043622,
              -27.5904800021503
            ],
            [
              28.6255099969888,
              -27.6114300041913
            ],
            [
              28.5975499972346,
              -27.5624399996062
            ],
            [
              28.5111500040694,
              -27.5968899973754
            ],
            [
              28.46712999935,
              -27.5627500004122
            ],
            [
              28.4747539965997,
              -27.5327729966764
            ],
            [
              28.412650003295,
              -27.5103899969009
            ],
            [
              28.2580400041429,
              -27.5721800018055
            ],
            [
              28.2508899990743,
              -27.4977900004081
            ],
            [
              28.1886899959466,
              -27.4817800031446
            ],
            [
              28.0568700027485,
              -27.5642199989538
            ],
            [
              28.0077819963421,
              -27.5638039995548
            ],
            [
              27.9886000002898,
              -27.6322099956947
            ],
            [
              27.9197700025836,
              -27.6426099986525
            ],
            [
              27.8380899968559,
              -27.6726219986064
            ],
            [
              27.8628400005656,
              -27.7895200042448
            ],
            [
              27.8725999991906,
              -27.9337799991476
            ],
            [
              27.8229799970293,
              -27.9336899985946
            ],
            [
              27.7783099983078,
              -27.910370008669
            ],
            [
              27.7377199979796,
              -27.9281700039425
            ],
            [
              27.6953999979117,
              -28.0026200027109
            ],
            [
              27.7034599990798,
              -28.0403899997986
            ],
            [
              27.7599400019296,
              -28.0619100029443
            ],
            [
              27.7620999963178,
              -28.1508500008269
            ],
            [
              27.8005800009663,
              -28.156840000066
            ],
            [
              27.7886600178456,
              -28.2479809942275
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Nketoana Local Municipality",
        "Code": "FS193",
        "Parent_cod": "DC19",
        "Area": 560452
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              29.2263699985766,
              -31.2983299988304
            ],
            [
              29.284530003357,
              -31.1851400023092
            ],
            [
              29.3449099900041,
              -31.165309997958
            ],
            [
              29.3827600042709,
              -31.1087900103507
            ],
            [
              29.4373600031617,
              -31.1006800032795
            ],
            [
              29.4330200017717,
              -31.0499099930517
            ],
            [
              29.40639999996,
              -31.0023799982383
            ],
            [
              29.4636299960275,
              -30.950759997376
            ],
            [
              29.5114100023698,
              -30.9298700079944
            ],
            [
              29.5622999983463,
              -30.8825000007744
            ],
            [
              29.5308899968759,
              -30.8128900075678
            ],
            [
              29.5554900035609,
              -30.7896899961963
            ],
            [
              29.554329988738,
              -30.7405899973305
            ],
            [
              29.5222011330759,
              -30.6990148319689
            ],
            [
              29.4836300010237,
              -30.7008399970681
            ],
            [
              29.4517899977103,
              -30.7492500009867
            ],
            [
              29.4606700016194,
              -30.7851199976898
            ],
            [
              29.392459997431,
              -30.8367899972605
            ],
            [
              29.2708800034095,
              -30.8692699968129
            ],
            [
              29.215230001963,
              -30.8723299967319
            ],
            [
              29.1655600010932,
              -30.8191600044307
            ],
            [
              29.1218200020915,
              -30.8487499984136
            ],
            [
              29.0683099986076,
              -30.8551299976512
            ],
            [
              29.0864200594382,
              -30.9462890618907
            ],
            [
              29.1450290678373,
              -30.9714298246266
            ],
            [
              29.1091156006045,
              -31.0350379943079
            ],
            [
              29.0647500008119,
              -31.0379300017681
            ],
            [
              29.0647380020572,
              -31.0379474198375
            ],
            [
              29.1323099957097,
              -31.0914399989567
            ],
            [
              29.1482200036502,
              -31.1549399990817
            ],
            [
              29.207600010732,
              -31.1799700004151
            ],
            [
              29.1792400033235,
              -31.2083399983922
            ],
            [
              29.1905799956703,
              -31.2746740042018
            ],
            [
              29.2263699985766,
              -31.2983299988304
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Ntabankulu Local Municipality",
        "Code": "EC444",
        "Parent_cod": "DC44",
        "Area": 138452,
        "detail": "Ntabankulu Local Municipality is a local municipality in Alfred Nzo District Municipality in the Wild Coast Region of the Eastern Cape Province in South Africa.\n",
        "link_to_webpage": "https://www.ntabankulu.gov.za/about/",
        "image": "https://corruptionwatch-my.sharepoint.com/:i:/g/personal/nontobekog_corruptionwatch_org_za/EUgjlMo7g5hKvFbIu7TsRX0BPdjOh_o0BbCmNTg_99kt0g?e=MJgtQy",
        "image_alt": ""
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              28.1016599890173,
              -28.7671499985735
            ],
            [
              28.1685099997367,
              -28.7052599971511
            ],
            [
              28.352819996146,
              -28.7002499972395
            ],
            [
              28.4132400161139,
              -28.6274199859436
            ],
            [
              28.4720899843653,
              -28.6053699826385
            ],
            [
              28.5684199839951,
              -28.6082899841954
            ],
            [
              28.6314800069967,
              -28.5825099977381
            ],
            [
              28.6518000033675,
              -28.4965399992215
            ],
            [
              28.5823700022738,
              -28.4494200017316
            ],
            [
              28.5827550002431,
              -28.3913249981501
            ],
            [
              28.6314099956748,
              -28.3429999990507
            ],
            [
              28.6550400097886,
              -28.2518700026984
            ],
            [
              28.7157299972416,
              -28.2355200032455
            ],
            [
              28.7276499974495,
              -28.15581000203
            ],
            [
              28.7697700008848,
              -28.1245799998671
            ],
            [
              28.8047499979141,
              -28.0198299995548
            ],
            [
              28.7520619810756,
              -28.0073127577775
            ],
            [
              28.7379599998542,
              -27.9760999992156
            ],
            [
              28.7281900043653,
              -28.0228599971911
            ],
            [
              28.6352090008948,
              -28.0305819980608
            ],
            [
              28.5668799984132,
              -28.0177999976717
            ],
            [
              28.4858200005926,
              -28.0365200020964
            ],
            [
              28.4471800011562,
              -27.9912700036077
            ],
            [
              28.4151700043923,
              -28.0480199982243
            ],
            [
              28.3204199975849,
              -28.0597299959425
            ],
            [
              28.2776099992022,
              -28.1191799990577
            ],
            [
              28.2218299971567,
              -28.1285299985606
            ],
            [
              28.1816350015542,
              -28.1081820035965
            ],
            [
              28.1136499996478,
              -28.1301100021748
            ],
            [
              28.0279900010378,
              -28.1767499982138
            ],
            [
              28.0391299895574,
              -28.2137799872565
            ],
            [
              27.9927100090598,
              -28.2319899897462
            ],
            [
              27.83758000931,
              -28.2294199899405
            ],
            [
              27.7886600178456,
              -28.2479809942275
            ],
            [
              27.83058000936,
              -28.2831199940924
            ],
            [
              27.8272299915709,
              -28.3234299896023
            ],
            [
              27.8605099983378,
              -28.361190003316
            ],
            [
              27.8085200001979,
              -28.4582400019744
            ],
            [
              27.8460400019446,
              -28.4762200037501
            ],
            [
              27.8338859981404,
              -28.5508370030252
            ],
            [
              27.9013500003024,
              -28.5558500030751
            ],
            [
              27.9593199981194,
              -28.5769900030861
            ],
            [
              28.0399999901075,
              -28.6248599928943
            ],
            [
              28.0606476526671,
              -28.7275362393059
            ],
            [
              28.1016599890173,
              -28.7671499985735
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Dihlabeng Local Municipality",
        "Code": "FS192",
        "Parent_cod": "DC19",
        "Area": 486774
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              30.0476400002858,
              -31.2475599966964
            ],
            [
              30.1938597940001,
              -31.0812602019999
            ],
            [
              30.1427599827871,
              -31.0228200271225
            ],
            [
              30.1463500368248,
              -30.9310699698032
            ],
            [
              30.0927099706886,
              -30.8622299680385
            ],
            [
              29.9747999620002,
              -30.838079956
            ],
            [
              29.9611649800001,
              -30.823169972
            ],
            [
              29.9468699721716,
              -30.7699499699152
            ],
            [
              29.8526099825647,
              -30.7616000273194
            ],
            [
              29.7705700366779,
              -30.7185999707121
            ],
            [
              29.7079299593002,
              -30.7047899606881
            ],
            [
              29.675369982139,
              -30.669939978647
            ],
            [
              29.5995099732068,
              -30.6895199696708
            ],
            [
              29.5722000410002,
              -30.6551499729999
            ],
            [
              29.5435502956097,
              -30.6471865301342
            ],
            [
              29.5222011330759,
              -30.6990148319689
            ],
            [
              29.554329988738,
              -30.7405899973305
            ],
            [
              29.5554900035609,
              -30.7896899961963
            ],
            [
              29.5308899968759,
              -30.8128900075678
            ],
            [
              29.5622999983463,
              -30.8825000007744
            ],
            [
              29.5114100023698,
              -30.9298700079944
            ],
            [
              29.6097599980256,
              -30.9832100027394
            ],
            [
              29.5843000020435,
              -31.0380300090776
            ],
            [
              29.7260200012222,
              -31.0868699995508
            ],
            [
              29.7616800017307,
              -31.1193300035767
            ],
            [
              29.8464600002289,
              -31.1351200005875
            ],
            [
              29.9054499983188,
              -31.1798700020989
            ],
            [
              30.0476400002858,
              -31.2475599966964
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Mbizana Local Municipality",
        "Code": "EC443",
        "Parent_cod": "DC44",
        "Area": 241549,
        "detail": "Mbizana Local Municipality, situated in the Eastern Cape Province along the R61 road connecting KwaZulu-Natal’s South Coast to the N2 highway, includes a main town and surrounding villages. Covering an area of approximately 2,806 km², it has a population of about 246,516 people living in 46,730 households. The municipality is culturally diverse, home to tribes such as the Xhosa, Mpondo, Sotho, and Nguni, with the Mpondo tribe—whose unique dialect, isiMpondo, blends isiXhosa and isiZulu—being the majority. With women constituting 54% of the population, Mbizana promotes their active involvement in key decision-making roles within municipal institutions to reflect this demographic reality.\n",
        "link_to_webpage": "https://www.winniemmlm.gov.za/",
        "image": "https://corruptionwatch-my.sharepoint.com/:i:/g/personal/nontobekog_corruptionwatch_org_za/EXqKfUfPXXRMkgzEC_icxTsB5Gj4hfeGGImV5bc3BfWDxw?e=PJ4Gu3",
        "image_alt": ""
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              27.6502499977392,
              -29.1099800008764
            ],
            [
              27.676160000084,
              -29.066349997954
            ],
            [
              27.6824400019046,
              -29.0065600007434
            ],
            [
              27.716229998016,
              -29.0044399992065
            ],
            [
              27.730769996738,
              -28.9457100104086
            ],
            [
              27.8329399985821,
              -28.9063300002293
            ],
            [
              27.8889199963608,
              -28.9164799997521
            ],
            [
              27.9159600031517,
              -28.8651499951761
            ],
            [
              28.0284300006441,
              -28.8739499980939
            ],
            [
              28.0505999986911,
              -28.8197999983712
            ],
            [
              28.1016599890173,
              -28.7671499985735
            ],
            [
              28.0606476526671,
              -28.7275362393059
            ],
            [
              28.0399999901075,
              -28.6248599928943
            ],
            [
              27.9593199981194,
              -28.5769900030861
            ],
            [
              27.9013500003024,
              -28.5558500030751
            ],
            [
              27.8338859981404,
              -28.5508370030252
            ],
            [
              27.8460400019446,
              -28.4762200037501
            ],
            [
              27.8085200001979,
              -28.4582400019744
            ],
            [
              27.8605099983378,
              -28.361190003316
            ],
            [
              27.8272299915709,
              -28.3234299896023
            ],
            [
              27.83058000936,
              -28.2831199940924
            ],
            [
              27.7886600178456,
              -28.2479809942275
            ],
            [
              27.8005800009663,
              -28.156840000066
            ],
            [
              27.7620999963178,
              -28.1508500008269
            ],
            [
              27.7599400019296,
              -28.0619100029443
            ],
            [
              27.7034599990798,
              -28.0403899997986
            ],
            [
              27.6549700013645,
              -28.0599299916757
            ],
            [
              27.6890100000115,
              -28.0961600031816
            ],
            [
              27.653760004021,
              -28.1265899972305
            ],
            [
              27.6598499997777,
              -28.1841200026359
            ],
            [
              27.5962900031811,
              -28.1759899991391
            ],
            [
              27.6111599991347,
              -28.2414600028768
            ],
            [
              27.5696200017617,
              -28.2825299956628
            ],
            [
              27.3878699993011,
              -28.2140800019905
            ],
            [
              27.3262399981774,
              -28.2264599991296
            ],
            [
              27.2768314392197,
              -28.2827789999508
            ],
            [
              27.2659087880602,
              -28.3770049061515
            ],
            [
              27.2889697750352,
              -28.4575383266324
            ],
            [
              27.2711874028764,
              -28.5097248823974
            ],
            [
              27.2122120997086,
              -28.5779882640471
            ],
            [
              27.2127099985677,
              -28.6264900024116
            ],
            [
              27.1900799963948,
              -28.6676399970881
            ],
            [
              27.1966400039331,
              -28.7335199990486
            ],
            [
              27.1702400023743,
              -28.7597300026375
            ],
            [
              27.1863050021742,
              -28.8052629988882
            ],
            [
              27.2681099965791,
              -28.8386399966385
            ],
            [
              27.3175559988104,
              -28.8389189969142
            ],
            [
              27.4017700017842,
              -28.8707899998586
            ],
            [
              27.4783599976158,
              -28.8733000031926
            ],
            [
              27.5276699998707,
              -29.012838997122
            ],
            [
              27.5921999980315,
              -29.0320499990082
            ],
            [
              27.6132300010638,
              -29.0888300040014
            ],
            [
              27.6502499977392,
              -29.1099800008764
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Setsoto Local Municipality",
        "Code": "FS191",
        "Parent_cod": "DC19",
        "Area": 543116
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              28.6411130762075,
              -30.7729163486106
            ],
            [
              28.6579899974405,
              -30.8115299970117
            ],
            [
              28.7298399941205,
              -30.8441200016367
            ],
            [
              28.8362499990383,
              -30.9418600042358
            ],
            [
              28.8739599978557,
              -31.0055199991486
            ],
            [
              28.8645800041639,
              -31.05141000197
            ],
            [
              28.9057299988404,
              -31.077709998018
            ],
            [
              28.9789399970833,
              -31.0250199981743
            ],
            [
              29.0429900018871,
              -31.0104100043182
            ],
            [
              29.0647500008119,
              -31.0379300017681
            ],
            [
              29.0647380020572,
              -31.0379474198375
            ],
            [
              29.0647500008119,
              -31.0379300017681
            ],
            [
              29.1091156006045,
              -31.0350379943079
            ],
            [
              29.1450290678373,
              -30.9714298246266
            ],
            [
              29.0864200594382,
              -30.9462890618907
            ],
            [
              29.0683099986076,
              -30.8551299976512
            ],
            [
              29.1218200020915,
              -30.8487499984136
            ],
            [
              29.1655600010932,
              -30.8191600044307
            ],
            [
              29.215230001963,
              -30.8723299967319
            ],
            [
              29.2708800034095,
              -30.8692699968129
            ],
            [
              29.392459997431,
              -30.8367899972605
            ],
            [
              29.4606700016194,
              -30.7851199976898
            ],
            [
              29.4517899977103,
              -30.7492500009867
            ],
            [
              29.4836300010237,
              -30.7008399970681
            ],
            [
              29.5222011330759,
              -30.6990148319689
            ],
            [
              29.5435502956097,
              -30.6471865301342
            ],
            [
              29.512359972,
              -30.618219983
            ],
            [
              29.3728000377915,
              -30.648960034578
            ],
            [
              29.2613299757978,
              -30.6211599765516
            ],
            [
              29.1352500008868,
              -30.6051399779276
            ],
            [
              29.0842702822477,
              -30.6123288373059
            ],
            [
              28.9561405878179,
              -30.5724777082796
            ],
            [
              28.9462589963557,
              -30.6488409994126
            ],
            [
              28.9246770011428,
              -30.687298995852
            ],
            [
              28.8603009983924,
              -30.6857539992476
            ],
            [
              28.7593630003023,
              -30.5882100029892
            ],
            [
              28.699170003393,
              -30.5825639971306
            ],
            [
              28.6559069967106,
              -30.6499930021752
            ],
            [
              28.5603699976773,
              -30.6552600022473
            ],
            [
              28.5498500008769,
              -30.6924300040414
            ],
            [
              28.5957500023607,
              -30.7191200009872
            ],
            [
              28.6411130762075,
              -30.7729163486106
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Umzimvubu Local Municipality",
        "Code": "EC442",
        "Parent_cod": "DC44",
        "Area": 257890,
        "detail": "Umzimvubu Local Municipality, situated within the Alfred Nzo District of the Eastern Cape Province, covers an area of 2,506 km². A 2009 study by the Alfred Nzo District Municipality reported 59,924 households in the area. Predominantly rural, most of the population resides in dispersed, low-density traditional settlements, except in the two urban centers of Mount Ayliff and Mount Frere.\n",
        "link_to_webpage": "https://www.umzimvubu.gov.za/",
        "image": "https://corruptionwatch-my.sharepoint.com/:i:/g/personal/nontobekog_corruptionwatch_org_za/EbpKh9Y4kfdOv7rtJx0qmvUBzQwAPLudW1lX7OfXfNERjA?e=IQkRFe",
        "image_alt": ""
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              29.1352500008868,
              -30.6051399779276
            ],
            [
              29.19835997,
              -30.4623399689999
            ],
            [
              29.1967699816494,
              -30.4343900348722
            ],
            [
              29.3050099756299,
              -30.3798599501765
            ],
            [
              29.3018599650001,
              -30.320119957
            ],
            [
              29.1881099725972,
              -30.2887399677752
            ],
            [
              29.1371699707177,
              -30.2623399716123
            ],
            [
              29.1322099686152,
              -30.2163599700365
            ],
            [
              29.1036899727141,
              -30.1805400358939
            ],
            [
              29.117240037,
              -30.100189968
            ],
            [
              29.044949978,
              -30.012969982
            ],
            [
              29.0147399716724,
              -30.0017999698927
            ],
            [
              28.9853300039766,
              -30.0313699989263
            ],
            [
              28.878940002679,
              -30.069820001292
            ],
            [
              28.858790000658,
              -30.0882299968168
            ],
            [
              28.689889998125,
              -30.1242899986844
            ],
            [
              28.6676099968039,
              -30.1407100022647
            ],
            [
              28.5682499986385,
              -30.1228600010882
            ],
            [
              28.451470002039,
              -30.1578399981174
            ],
            [
              28.3998000033675,
              -30.1436800016307
            ],
            [
              28.3651000030628,
              -30.1686200042098
            ],
            [
              28.3402900028814,
              -30.2346100022498
            ],
            [
              28.3057099982179,
              -30.2550800019405
            ],
            [
              28.2364300013435,
              -30.2599399967334
            ],
            [
              28.215359997366,
              -30.3068099988823
            ],
            [
              28.2527800007965,
              -30.3233200021164
            ],
            [
              28.268770003433,
              -30.373729996642
            ],
            [
              28.4808400038632,
              -30.4222999971471
            ],
            [
              28.5361800054029,
              -30.4672600002488
            ],
            [
              28.5769699933705,
              -30.4371799980584
            ],
            [
              28.6160299968868,
              -30.4722400041729
            ],
            [
              28.569840000016,
              -30.4962900061789
            ],
            [
              28.5405500081764,
              -30.5889899993889
            ],
            [
              28.5603699976773,
              -30.6552600022473
            ],
            [
              28.6559069967106,
              -30.6499930021752
            ],
            [
              28.699170003393,
              -30.5825639971306
            ],
            [
              28.7593630003023,
              -30.5882100029892
            ],
            [
              28.8603009983924,
              -30.6857539992476
            ],
            [
              28.9246770011428,
              -30.687298995852
            ],
            [
              28.9462589963557,
              -30.6488409994126
            ],
            [
              28.9561405878179,
              -30.5724777082796
            ],
            [
              29.0842702822477,
              -30.6123288373059
            ],
            [
              29.1352500008868,
              -30.6051399779276
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Matatiele Local Municipality",
        "Code": "EC441",
        "Parent_cod": "DC44",
        "Area": 435231,
        "detail": "Matatiele Local Municipality (MLM) is located within the Alfred Nzo District Municipality. It is bordered to the north by Lesotho, to the northeast by KwaZulu-Natal (KZN), and to the southwest by Elundini Municipality. Covering an area of 4,352 km², MLM accounts for 58% of the Alfred Nzo District's total geographical area.\n",
        "link_to_webpage": "https://www.matatiele.gov.za/about-us/",
        "image": "https://corruptionwatch-my.sharepoint.com/:i:/g/personal/nontobekog_corruptionwatch_org_za/EUqMhZSxlXdDsIuVc0n4Yk8BPXsA-yzP2rMMRHMo1qDFOA?e=8yNwrA",
        "image_alt": ""
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              27.761289999434,
              -26.4191500010717
            ],
            [
              27.7518640027216,
              -26.3619950030669
            ],
            [
              27.8115899969808,
              -26.3644750032188
            ],
            [
              27.8136799962349,
              -26.2856499978491
            ],
            [
              27.7534800008014,
              -26.2580399989467
            ],
            [
              27.717761278160513,
              -26.221987971367835
            ],
            [
              27.7147900017572,
              -26.2150699958836
            ],
            [
              27.718269996763,
              -26.1989299989203
            ],
            [
              27.7195699946596,
              -26.1547700030332
            ],
            [
              27.7212500028854,
              -26.1407200044246
            ],
            [
              27.7065800035643,
              -26.1155700011546
            ],
            [
              27.5512300017632,
              -26.1047200071226
            ],
            [
              27.5357300010387,
              -26.0793249961516
            ],
            [
              27.4673400038382,
              -26.0922699986614
            ],
            [
              27.4899570000156,
              -26.1279709992622
            ],
            [
              27.4686300030723,
              -26.2173699904326
            ],
            [
              27.4694800018007,
              -26.2255299971116
            ],
            [
              27.4819099976483,
              -26.2844400014049
            ],
            [
              27.5260600029668,
              -26.3025700002053
            ],
            [
              27.5478499969798,
              -26.3432800015708
            ],
            [
              27.5372800005716,
              -26.4058599997391
            ],
            [
              27.5413899661741,
              -26.4171540340314
            ],
            [
              27.5570900013026,
              -26.4563799993374
            ],
            [
              27.629908003052,
              -26.4527370004122
            ],
            [
              27.6071500030702,
              -26.4916000011391
            ],
            [
              27.604370000775,
              -26.5919600022523
            ],
            [
              27.5796000006396,
              -26.6075299990102
            ],
            [
              27.6679299982708,
              -26.6105499970846
            ],
            [
              27.6759799998771,
              -26.5243499996527
            ],
            [
              27.7101300026975,
              -26.5300099935663
            ],
            [
              27.7096699976723,
              -26.4546700041173
            ],
            [
              27.761289999434,
              -26.4191500010717
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Rand West City Local Municipality",
        "Code": "GT485",
        "Parent_cod": "DC48",
        "Area": 111472
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              27.5796000006396,
              -26.6075299990102
            ],
            [
              27.604370000775,
              -26.5919600022523
            ],
            [
              27.6071500030702,
              -26.4916000011391
            ],
            [
              27.629908003052,
              -26.4527370004122
            ],
            [
              27.5570900013026,
              -26.4563799993374
            ],
            [
              27.5413899661741,
              -26.4171540340314
            ],
            [
              27.5372800005716,
              -26.4058599997391
            ],
            [
              27.5478499969798,
              -26.3432800015708
            ],
            [
              27.5260600029668,
              -26.3025700002053
            ],
            [
              27.4819099976483,
              -26.2844400014049
            ],
            [
              27.4694800018007,
              -26.2255299971116
            ],
            [
              27.4686300030723,
              -26.2173699904326
            ],
            [
              27.4899570000156,
              -26.1279709992622
            ],
            [
              27.4673400038382,
              -26.0922699986614
            ],
            [
              27.4252200004028,
              -26.0893899989492
            ],
            [
              27.4194400036533,
              -26.1174999957282
            ],
            [
              27.3617200002778,
              -26.1156699985715
            ],
            [
              27.3582599927045,
              -26.1546100001514
            ],
            [
              27.2914099981729,
              -26.1446200044096
            ],
            [
              27.3300710003764,
              -26.2818149990629
            ],
            [
              27.330048002913,
              -26.2818260022682
            ],
            [
              27.2348100005811,
              -26.3382699953639
            ],
            [
              27.1879519998849,
              -26.3778629991781
            ],
            [
              27.2248499990283,
              -26.4439699999155
            ],
            [
              27.2314210016779,
              -26.5054809955514
            ],
            [
              27.158760002672,
              -26.525419998634
            ],
            [
              27.1826370029954,
              -26.5746199958161
            ],
            [
              27.2283599972161,
              -26.5710500011566
            ],
            [
              27.2418699979021,
              -26.6364600003287
            ],
            [
              27.3783499982539,
              -26.6106799976837
            ],
            [
              27.4257590009772,
              -26.6494680003479
            ],
            [
              27.454829998006,
              -26.6303300018281
            ],
            [
              27.5690900016023,
              -26.6471600036312
            ],
            [
              27.5796000006396,
              -26.6075299990102
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Merafong City Local Municipality",
        "Code": "GT484",
        "Parent_cod": "DC48",
        "Area": 163005
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              27.718269996763,
              -26.1989299989203
            ],
            [
              27.779685002361,
              -26.1962199917591
            ],
            [
              27.7813400031387,
              -26.1925999983912
            ],
            [
              27.8105999998901,
              -26.1820800006914
            ],
            [
              27.8388100030792,
              -26.1202199997531
            ],
            [
              27.8353100026545,
              -26.0846300015733
            ],
            [
              27.9002199958562,
              -26.04679999992
            ],
            [
              27.9004799970542,
              -26.0458100028294
            ],
            [
              27.9235300042064,
              -25.9983100022048
            ],
            [
              27.8975899905856,
              -25.9543600007134
            ],
            [
              27.9321199983393,
              -25.9163000010442
            ],
            [
              27.8937980000777,
              -25.9056810032757
            ],
            [
              27.8982000007295,
              -25.8597400043976
            ],
            [
              27.8587399967535,
              -25.8188199987439
            ],
            [
              27.8314700000405,
              -25.8601729982851
            ],
            [
              27.7445499972846,
              -25.8946200031106
            ],
            [
              27.742700002803,
              -25.8502399988768
            ],
            [
              27.6849299998197,
              -25.8754000008094
            ],
            [
              27.6466000011891,
              -25.814139996064
            ],
            [
              27.6435499990332,
              -25.7959199976097
            ],
            [
              27.532289997985,
              -25.849960001253
            ],
            [
              27.4619470006536,
              -25.8676060011161
            ],
            [
              27.4570099969139,
              -25.9818499976792
            ],
            [
              27.4252200004028,
              -26.0893899989492
            ],
            [
              27.4673400038382,
              -26.0922699986614
            ],
            [
              27.5357300010387,
              -26.0793249961516
            ],
            [
              27.5512300017632,
              -26.1047200071226
            ],
            [
              27.7065800035643,
              -26.1155700011546
            ],
            [
              27.7212500028854,
              -26.1407200044246
            ],
            [
              27.7195699946596,
              -26.1547700030332
            ],
            [
              27.718269996763,
              -26.1989299989203
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Mogale City Local Municipality",
        "Code": "GT481",
        "Parent_cod": "DC48",
        "Area": 134467
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              26.5060160024367,
              -25.5018909992701
            ],
            [
              26.5354399995564,
              -25.4696499981488
            ],
            [
              26.594739001104,
              -25.4698500019759
            ],
            [
              26.6082599969013,
              -25.5243799967394
            ],
            [
              26.6527600030718,
              -25.522289999284
            ],
            [
              26.6486900024417,
              -25.4476100007009
            ],
            [
              26.687510002085,
              -25.393569997957
            ],
            [
              26.7605199956013,
              -25.3592000029777
            ],
            [
              26.8532300027625,
              -25.374115999254
            ],
            [
              27.0075200033455,
              -25.3744699975923
            ],
            [
              27.0033600021624,
              -25.3899900037356
            ],
            [
              27.0570899978052,
              -25.385580000017
            ],
            [
              27.1329267277863,
              -25.3574534970812
            ],
            [
              27.1885199981994,
              -25.3682199980545
            ],
            [
              27.2564820026424,
              -25.3374449979882
            ],
            [
              27.364950000842,
              -25.325390003246
            ],
            [
              27.4279799981784,
              -25.2896600049053
            ],
            [
              27.4901999968324,
              -25.1972099998416
            ],
            [
              27.4869000011342,
              -25.0784199977846
            ],
            [
              27.4245999996902,
              -25.0689100025946
            ],
            [
              27.3369500001424,
              -25.0878199968953
            ],
            [
              27.3135999998402,
              -25.0420899969558
            ],
            [
              27.2034680004479,
              -25.0331829980968
            ],
            [
              27.2260920023441,
              -24.9639370018911
            ],
            [
              27.1834199986341,
              -24.9485200022963
            ],
            [
              27.1540499968099,
              -24.9789600031016
            ],
            [
              27.1453584943991,
              -24.9509949581507
            ],
            [
              27.1011500025706,
              -24.9000400032435
            ],
            [
              27.0412199989039,
              -24.8869700030632
            ],
            [
              27.0263299993301,
              -24.7186300020728
            ],
            [
              26.975909998048,
              -24.7206700017191
            ],
            [
              26.9807200022263,
              -24.7757699975872
            ],
            [
              26.9433200024162,
              -24.7813700031231
            ],
            [
              26.7795400030688,
              -24.837690003091
            ],
            [
              26.7512599957522,
              -24.8829599989048
            ],
            [
              26.6993000007944,
              -24.8672900038306
            ],
            [
              26.6220100032591,
              -24.8098600039359
            ],
            [
              26.5664500023658,
              -24.8198999992855
            ],
            [
              26.4582800017207,
              -24.8094700021388
            ],
            [
              26.4421299980011,
              -24.9354699976423
            ],
            [
              26.455109999427,
              -24.9528499969298
            ],
            [
              26.4181099991771,
              -25.0467999947239
            ],
            [
              26.3849800038242,
              -25.0593400028388
            ],
            [
              26.4226799976838,
              -25.1325449990524
            ],
            [
              26.4050200016718,
              -25.28592999927
            ],
            [
              26.4660400007454,
              -25.2906699993209
            ],
            [
              26.4356400017847,
              -25.3947900011575
            ],
            [
              26.4343000038421,
              -25.3982800029197
            ],
            [
              26.4326399992366,
              -25.4026200043097
            ],
            [
              26.419300000095,
              -25.4776400041828
            ],
            [
              26.5060160024367,
              -25.5018909992701
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Moses Kotane Local Municipality",
        "Code": "NW375",
        "Parent_cod": "DC37",
        "Area": 572623
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              30.9811899430615,
              -29.2692599401941
            ],
            [
              30.9847299426327,
              -29.2241099400216
            ],
            [
              30.9278099428746,
              -29.1794599404238
            ],
            [
              30.8678689431972,
              -29.1543289398286
            ],
            [
              30.8679399428741,
              -29.1542400652267
            ],
            [
              30.9367199427712,
              -29.0801999396754
            ],
            [
              31.02377994299,
              -29.0788300653552
            ],
            [
              30.9801799432498,
              -28.9698899392693
            ],
            [
              30.922079943035,
              -28.9484199393287
            ],
            [
              30.9192199433458,
              -28.9084899388595
            ],
            [
              30.9933499444444,
              -28.856479938898
            ],
            [
              30.9867999427632,
              -28.8051200642395
            ],
            [
              30.8331099428696,
              -28.7716999386012
            ],
            [
              30.8231699431384,
              -28.7428199386892
            ],
            [
              30.7708599437315,
              -28.7226800639337
            ],
            [
              30.7457099431594,
              -28.7657699394311
            ],
            [
              30.6990739428083,
              -28.7719359386926
            ],
            [
              30.6819689427126,
              -28.7996950640758
            ],
            [
              30.6252819429075,
              -28.8047599388201
            ],
            [
              30.5639900679874,
              -28.8793399390869
            ],
            [
              30.4518499436201,
              -28.8807799389429
            ],
            [
              30.3639699433583,
              -28.9428700638024
            ],
            [
              30.3277416459604,
              -28.9467126007059
            ],
            [
              30.3002510820002,
              -28.955970043
            ],
            [
              30.3425681929678,
              -29.0502605653728
            ],
            [
              30.3090493180002,
              -29.09782519
            ],
            [
              30.3636099429446,
              -29.1230299398797
            ],
            [
              30.3358700680002,
              -29.163850065
            ],
            [
              30.3760299428277,
              -29.1861799400521
            ],
            [
              30.4187999429632,
              -29.2626999398502
            ],
            [
              30.522809943,
              -29.2200199399999
            ],
            [
              30.5787799430001,
              -29.258110065
            ],
            [
              30.6603399426345,
              -29.2242399397214
            ],
            [
              30.7665800680001,
              -29.198020065
            ],
            [
              30.8061099430002,
              -29.2223500649999
            ],
            [
              30.8277599425675,
              -29.2650700653312
            ],
            [
              30.8771899430001,
              -29.27558994
            ],
            [
              30.9811899430615,
              -29.2692599401941
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Umvoti Local Municipality",
        "Code": "KZN245",
        "Parent_cod": "DC24",
        "Area": 270471
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              30.3277416459604,
              -28.9467126007059
            ],
            [
              30.3639699433583,
              -28.9428700638024
            ],
            [
              30.4518499436201,
              -28.8807799389429
            ],
            [
              30.5639900679874,
              -28.8793399390869
            ],
            [
              30.6252819429075,
              -28.8047599388201
            ],
            [
              30.6819689427126,
              -28.7996950640758
            ],
            [
              30.6990739428083,
              -28.7719359386926
            ],
            [
              30.6501099430195,
              -28.7207299389355
            ],
            [
              30.6844899429566,
              -28.6635599393397
            ],
            [
              30.6703159431264,
              -28.6425520641264
            ],
            [
              30.6152099433842,
              -28.6264000639118
            ],
            [
              30.6023499429955,
              -28.5708499393732
            ],
            [
              30.6817399429442,
              -28.5408499390734
            ],
            [
              30.6444899428566,
              -28.4633899390944
            ],
            [
              30.5900599428122,
              -28.4278199391388
            ],
            [
              30.6356499425909,
              -28.4079800638289
            ],
            [
              30.5307699425789,
              -28.3344099392672
            ],
            [
              30.5057299425828,
              -28.2626899386896
            ],
            [
              30.4491599427773,
              -28.2818900641751
            ],
            [
              30.3519499430002,
              -28.266459939
            ],
            [
              30.2335949430001,
              -28.4087099389999
            ],
            [
              30.3377700679344,
              -28.4739200640596
            ],
            [
              30.300659943002,
              -28.5340999389609
            ],
            [
              30.2207299442316,
              -28.5733199390639
            ],
            [
              30.2339699432583,
              -28.6211899387646
            ],
            [
              30.2786099432944,
              -28.6837999392157
            ],
            [
              30.2675299430001,
              -28.731019939
            ],
            [
              30.2832269430001,
              -28.811147939
            ],
            [
              30.2681299429425,
              -28.9053099388026
            ],
            [
              30.2874699426838,
              -28.9148999385813
            ],
            [
              30.3277416459604,
              -28.9467126007059
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Msinga Local Municipality",
        "Code": "KZN244",
        "Parent_cod": "DC24",
        "Area": 237515
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              27.1698499996778,
              -26.0802299974164
            ],
            [
              27.1651660004106,
              -25.9920839965791
            ],
            [
              27.188174002928,
              -25.9313089971124
            ],
            [
              27.1737999992706,
              -25.8849399982823
            ],
            [
              27.2081700023438,
              -25.8547699973375
            ],
            [
              27.1326700010198,
              -25.8092999976967
            ],
            [
              27.1197709988325,
              -25.7522340028969
            ],
            [
              27.1671000005646,
              -25.720329996632
            ],
            [
              27.1585100001365,
              -25.6684799977536
            ],
            [
              27.0668619969836,
              -25.5332130029776
            ],
            [
              27.0407500042094,
              -25.466069996733
            ],
            [
              27.0150600021175,
              -25.4631499960754
            ],
            [
              27.0033600021624,
              -25.3899900037356
            ],
            [
              27.0075200033455,
              -25.3744699975923
            ],
            [
              26.8532300027625,
              -25.374115999254
            ],
            [
              26.7605199956013,
              -25.3592000029777
            ],
            [
              26.687510002085,
              -25.393569997957
            ],
            [
              26.6486900024417,
              -25.4476100007009
            ],
            [
              26.6527600030718,
              -25.522289999284
            ],
            [
              26.6082599969013,
              -25.5243799967394
            ],
            [
              26.594739001104,
              -25.4698500019759
            ],
            [
              26.5354399995564,
              -25.4696499981488
            ],
            [
              26.5060160024367,
              -25.5018909992701
            ],
            [
              26.5112300027625,
              -25.6552199996033
            ],
            [
              26.4846900019421,
              -25.6774900031611
            ],
            [
              26.4623699996758,
              -25.7453699957287
            ],
            [
              26.5800300062798,
              -25.7826799958851
            ],
            [
              26.6436800034295,
              -25.8379849994082
            ],
            [
              26.6435299983108,
              -25.868000001299
            ],
            [
              26.7074820507561,
              -25.9224401969574
            ],
            [
              26.7705500021809,
              -25.9523299997297
            ],
            [
              26.7635800036143,
              -25.9910900100959
            ],
            [
              26.807079998743,
              -26.0840299990852
            ],
            [
              26.8479299993701,
              -26.0596999985561
            ],
            [
              26.9174299955978,
              -26.0711300004491
            ],
            [
              26.9747999990208,
              -26.0650500006569
            ],
            [
              27.0537800043438,
              -26.100689999344
            ],
            [
              27.1420299991852,
              -26.100689999344
            ],
            [
              27.1698499996778,
              -26.0802299974164
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Kgetlengrivier Local Municipality",
        "Code": "NW374",
        "Parent_cod": "DC37",
        "Area": 397315
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              30.2940199803378,
              -23.3856800221153
            ],
            [
              30.3286399661616,
              -23.3775800298944
            ],
            [
              30.3691499726932,
              -23.3101600279628
            ],
            [
              30.3349799743464,
              -23.2494400328312
            ],
            [
              30.4035069706702,
              -23.2342440281394
            ],
            [
              30.4270199730933,
              -23.2578600290171
            ],
            [
              30.4875699711772,
              -23.2442400313523
            ],
            [
              30.5626599733791,
              -23.1756900312699
            ],
            [
              30.6522299706367,
              -23.1574200260133
            ],
            [
              30.7280499723284,
              -23.0723100311829
            ],
            [
              30.8045999726107,
              -23.1044200280618
            ],
            [
              30.8310999733851,
              -23.093600029118
            ],
            [
              30.8802699709825,
              -23.1505500275617
            ],
            [
              30.9295798113592,
              -23.1394346561844
            ],
            [
              30.966876983586,
              -23.1741275788246
            ],
            [
              31.0518665313154,
              -23.1748104097725
            ],
            [
              31.1566581729364,
              -23.1880664832815
            ],
            [
              31.2069454189959,
              -23.2195949551431
            ],
            [
              31.2573928828753,
              -23.2037296300184
            ],
            [
              31.3748779299726,
              -23.138339995994
            ],
            [
              31.4118709559799,
              -23.0911064150291
            ],
            [
              31.5343723297193,
              -23.1875648504375
            ],
            [
              31.5614232425886,
              -23.2242827954147
            ],
            [
              31.5635999904473,
              -23.1982299978161
            ],
            [
              31.4752555640931,
              -22.9255938124045
            ],
            [
              31.344895727256,
              -22.5345331130127
            ],
            [
              31.1785430912907,
              -22.6720027920951
            ],
            [
              31.0703372958296,
              -22.8021221160428
            ],
            [
              30.977773665922,
              -22.8196716312407
            ],
            [
              31.0134389355585,
              -22.7278199640201
            ],
            [
              30.8894799622305,
              -22.7128400376376
            ],
            [
              30.8940815683098,
              -22.7632166844024
            ],
            [
              30.8223566106691,
              -22.7826208867445
            ],
            [
              30.7754208536895,
              -22.8295173892161
            ],
            [
              30.7211252959956,
              -22.8464440654413
            ],
            [
              30.6581235175864,
              -22.941118959972
            ],
            [
              30.6006479427484,
              -22.9788910587753
            ],
            [
              30.5053974137597,
              -23.0014252732577
            ],
            [
              30.4783603315641,
              -23.0632864136371
            ],
            [
              30.4100799428351,
              -23.0947200591834
            ],
            [
              30.357790942598,
              -23.1173380590042
            ],
            [
              30.2379119433815,
              -23.1242820590698
            ],
            [
              30.2080616541221,
              -23.1494005222163
            ],
            [
              30.1897814001915,
              -23.1582148747166
            ],
            [
              30.2016189001921,
              -23.2005122298555
            ],
            [
              30.2452729303015,
              -23.2537290183794
            ],
            [
              30.1596464916923,
              -23.2563126159344
            ],
            [
              30.1516067369614,
              -23.3137996796114
            ],
            [
              30.2343099733267,
              -23.3084500309441
            ],
            [
              30.268560961919,
              -23.3244090411443
            ],
            [
              30.2940199803378,
              -23.3856800221153
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Collins Chabane Local Municipality",
        "Code": "LIM345",
        "Parent_cod": "DC34",
        "Area": 500324
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              26.2481100016753,
              -26.5873199987189
            ],
            [
              26.3337000060505,
              -26.5551599896417
            ],
            [
              26.3849714188959,
              -26.5005871457801
            ],
            [
              26.4604011732756,
              -26.4838395956208
            ],
            [
              26.4584399983073,
              -26.4351300041463
            ],
            [
              26.483649998049,
              -26.3864199980844
            ],
            [
              26.558440781417,
              -26.3404183938937
            ],
            [
              26.5346899991442,
              -26.2641900010677
            ],
            [
              26.586130000699,
              -26.2451999967824
            ],
            [
              26.5457799970493,
              -26.1726999980064
            ],
            [
              26.6296400088793,
              -26.1361300013984
            ],
            [
              26.6176510027916,
              -26.0648670021104
            ],
            [
              26.7092399978277,
              -26.0475599989947
            ],
            [
              26.7331100014255,
              -26.1015700003552
            ],
            [
              26.807079998743,
              -26.0840299990852
            ],
            [
              26.7635800036143,
              -25.9910900100959
            ],
            [
              26.7705500021809,
              -25.9523299997297
            ],
            [
              26.7074820507561,
              -25.9224401969574
            ],
            [
              26.6435299983108,
              -25.868000001299
            ],
            [
              26.6436800034295,
              -25.8379849994082
            ],
            [
              26.5800300062798,
              -25.7826799958851
            ],
            [
              26.4623699996758,
              -25.7453699957287
            ],
            [
              26.4463700010748,
              -25.7693299980809
            ],
            [
              26.3904199983843,
              -25.7576399967884
            ],
            [
              26.3963800016358,
              -25.692889999274
            ],
            [
              26.2977025223536,
              -25.6675001926797
            ],
            [
              26.2582923848857,
              -25.7749497113601
            ],
            [
              26.1850047580632,
              -25.756553753353
            ],
            [
              26.1845200027959,
              -25.674620001212
            ],
            [
              26.1092449965594,
              -25.7021099981778
            ],
            [
              26.0716600017078,
              -25.7679700037126
            ],
            [
              26.1151507823828,
              -25.8305544508272
            ],
            [
              26.0793373890094,
              -25.8827228645685
            ],
            [
              26.022920708324,
              -25.8379616152363
            ],
            [
              25.988158003689,
              -25.8650673076101
            ],
            [
              25.9075000001249,
              -25.8576600029068
            ],
            [
              25.9245699977073,
              -25.9115799974189
            ],
            [
              25.8019000010842,
              -25.9000599958721
            ],
            [
              25.8054300028923,
              -25.9517400021993
            ],
            [
              25.7873500028004,
              -26.0196099970037
            ],
            [
              25.7383000026431,
              -26.0472199959061
            ],
            [
              25.7666630029953,
              -26.0851660029086
            ],
            [
              25.7441200003378,
              -26.1673300003792
            ],
            [
              25.7122289946725,
              -26.2284939638254
            ],
            [
              25.722779997399,
              -26.256920001257
            ],
            [
              25.8268999992356,
              -26.2003599974159
            ],
            [
              25.8891800033545,
              -26.3205100091296
            ],
            [
              25.8667600027719,
              -26.3599000008843
            ],
            [
              25.8983699999756,
              -26.4229600014029
            ],
            [
              25.947990002137,
              -26.4004100002213
            ],
            [
              26.0152399962289,
              -26.448830001903
            ],
            [
              26.1019999970024,
              -26.4617700023836
            ],
            [
              26.103160002832,
              -26.5784000019584
            ],
            [
              26.2481100016753,
              -26.5873199987189
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Ditsobotla Local Municipality",
        "Code": "NW384",
        "Parent_cod": "DC38",
        "Area": 638705
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              29.2678099652578,
              -23.2386400303131
            ],
            [
              29.315549971554,
              -23.2515300275886
            ],
            [
              29.3579699708375,
              -23.2388100291595
            ],
            [
              29.4405099721576,
              -23.246330029707
            ],
            [
              29.4277499718837,
              -23.2800300279634
            ],
            [
              29.5918599702615,
              -23.2682600310756
            ],
            [
              29.6220799699147,
              -23.3284100286998
            ],
            [
              29.6004300390151,
              -23.3720100293393
            ],
            [
              29.6167499714341,
              -23.3964500313438
            ],
            [
              29.7418699731208,
              -23.4352500282661
            ],
            [
              29.8095999713616,
              -23.4265700281842
            ],
            [
              29.8668399813801,
              -23.4374100199564
            ],
            [
              29.9651599720551,
              -23.378180027886
            ],
            [
              29.9971599719552,
              -23.3374500291954
            ],
            [
              30.0376999816688,
              -23.3387100216502
            ],
            [
              30.1467599720951,
              -23.341400027889
            ],
            [
              30.1516067369614,
              -23.3137996796114
            ],
            [
              30.1596464916923,
              -23.2563126159344
            ],
            [
              30.2452729303015,
              -23.2537290183794
            ],
            [
              30.2016189001921,
              -23.2005122298555
            ],
            [
              30.1897814001915,
              -23.1582148747166
            ],
            [
              30.2080616541221,
              -23.1494005222163
            ],
            [
              30.2379119433815,
              -23.1242820590698
            ],
            [
              30.357790942598,
              -23.1173380590042
            ],
            [
              30.4100799428351,
              -23.0947200591834
            ],
            [
              30.3553299433223,
              -23.027190057575
            ],
            [
              30.1647999433628,
              -22.9250100588671
            ],
            [
              30.1873699427686,
              -22.8846900592988
            ],
            [
              30.2053899427916,
              -22.782580058423
            ],
            [
              30.2692599428922,
              -22.7240500590629
            ],
            [
              30.3237199434208,
              -22.6532200590584
            ],
            [
              30.2881699425888,
              -22.653650059103
            ],
            [
              30.1884799426953,
              -22.6936100591568
            ],
            [
              30.1056199428062,
              -22.7039800589325
            ],
            [
              29.9859499424359,
              -22.6929599338538
            ],
            [
              29.9281699416895,
              -22.6648100584374
            ],
            [
              29.8846799416261,
              -22.7102200589085
            ],
            [
              29.7985099419803,
              -22.7580700585863
            ],
            [
              29.7878799419058,
              -22.7004200584389
            ],
            [
              29.7482499417815,
              -22.680130058955
            ],
            [
              29.6188399419099,
              -22.6594499335676
            ],
            [
              29.5385299418034,
              -22.6151000584209
            ],
            [
              29.3686799422256,
              -22.6519700589711
            ],
            [
              29.308779941741,
              -22.6020400587017
            ],
            [
              29.209359941708,
              -22.6627800592523
            ],
            [
              29.2047199417719,
              -22.7126399339858
            ],
            [
              29.2448999420787,
              -22.7352600589045
            ],
            [
              29.2229199420018,
              -22.8074300586503
            ],
            [
              29.1669699420093,
              -22.9177900586643
            ],
            [
              29.1833300003792,
              -22.9735500004322
            ],
            [
              29.2463499999526,
              -22.9383899995988
            ],
            [
              29.2574500001174,
              -22.9925200001978
            ],
            [
              29.2844899997137,
              -23.0023199997681
            ],
            [
              29.3101500004222,
              -23.0738000000699
            ],
            [
              29.2517299998396,
              -23.1070700000804
            ],
            [
              29.2678099652578,
              -23.2386400303131
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Makhado Local Municipality",
        "Code": "LIM344",
        "Parent_cod": "DC34",
        "Area": 760506
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              25.7122289946725,
              -26.2284939638254
            ],
            [
              25.7441200003378,
              -26.1673300003792
            ],
            [
              25.7666630029953,
              -26.0851660029086
            ],
            [
              25.7383000026431,
              -26.0472199959061
            ],
            [
              25.7873500028004,
              -26.0196099970037
            ],
            [
              25.8054300028923,
              -25.9517400021993
            ],
            [
              25.8019000010842,
              -25.9000599958721
            ],
            [
              25.9245699977073,
              -25.9115799974189
            ],
            [
              25.9075000001249,
              -25.8576600029068
            ],
            [
              25.988158003689,
              -25.8650673076101
            ],
            [
              26.022920708324,
              -25.8379616152363
            ],
            [
              26.0793373890094,
              -25.8827228645685
            ],
            [
              26.1151507823828,
              -25.8305544508272
            ],
            [
              26.0716600017078,
              -25.7679700037126
            ],
            [
              26.1092449965594,
              -25.7021099981778
            ],
            [
              26.095410003369,
              -25.6177799988478
            ],
            [
              25.8869399989818,
              -25.6753099970586
            ],
            [
              25.8455999991407,
              -25.6656399980874
            ],
            [
              25.8165132100167,
              -25.5729635122562
            ],
            [
              25.8134399972581,
              -25.5665400020194
            ],
            [
              25.7965529991217,
              -25.5249679995735
            ],
            [
              25.7406699986216,
              -25.5138500021759
            ],
            [
              25.629790000708,
              -25.5378200031906
            ],
            [
              25.5808799989129,
              -25.6387999879291
            ],
            [
              25.5136600071037,
              -25.6843399979925
            ],
            [
              25.3393270004408,
              -25.7692839968589
            ],
            [
              25.3290009990969,
              -25.8320979986236
            ],
            [
              25.2648158657596,
              -25.8705408891506
            ],
            [
              25.4061400031587,
              -25.954729997991
            ],
            [
              25.5010200006726,
              -26.0617999955732
            ],
            [
              25.4579800033745,
              -26.1034299997946
            ],
            [
              25.4305100028344,
              -26.1593599988648
            ],
            [
              25.4691000035624,
              -26.1670199995732
            ],
            [
              25.4728199961459,
              -26.2298500011766
            ],
            [
              25.4715500014315,
              -26.230569999306
            ],
            [
              25.4223499961555,
              -26.2707500014114
            ],
            [
              25.5028799929174,
              -26.3801100011756
            ],
            [
              25.5549100000964,
              -26.3623600046105
            ],
            [
              25.5460199966256,
              -26.3276699957736
            ],
            [
              25.5890950000343,
              -26.3058300030521
            ],
            [
              25.6552599953526,
              -26.2966399983372
            ],
            [
              25.7122289946725,
              -26.2284939638254
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Mafikeng Local Municipality",
        "Code": "NW383",
        "Parent_cod": "DC38",
        "Area": 364586
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              30.6703159431264,
              -28.6425520641264
            ],
            [
              30.7324399427493,
              -28.6651999394257
            ],
            [
              30.7885199433408,
              -28.6288800640637
            ],
            [
              30.8213599433068,
              -28.5816299391703
            ],
            [
              30.7592099433843,
              -28.5421299387456
            ],
            [
              30.8039619431892,
              -28.5178259394155
            ],
            [
              30.8326599428022,
              -28.4637299385857
            ],
            [
              30.9654199433758,
              -28.40632006372
            ],
            [
              30.9609599427472,
              -28.340944064317
            ],
            [
              30.9421999427733,
              -28.3123299390753
            ],
            [
              31.0015199425913,
              -28.26015993893
            ],
            [
              31.047564942668,
              -28.2000920637977
            ],
            [
              30.9941099426198,
              -28.1540759391532
            ],
            [
              30.9503599431569,
              -28.1435900644298
            ],
            [
              30.9139999427432,
              -28.1701600639357
            ],
            [
              30.8639099431894,
              -28.116839938812
            ],
            [
              30.7900399432888,
              -28.1414599392247
            ],
            [
              30.6868999425784,
              -28.1292999387411
            ],
            [
              30.6127899433012,
              -28.0351999394256
            ],
            [
              30.6844400683545,
              -27.9710899390494
            ],
            [
              30.6358500678266,
              -27.9330399380427
            ],
            [
              30.6021400680002,
              -27.933599938
            ],
            [
              30.569700067804,
              -28.0089500643939
            ],
            [
              30.5698299430002,
              -28.042399939
            ],
            [
              30.5361699430001,
              -28.0921499389999
            ],
            [
              30.5419999430001,
              -28.124560064
            ],
            [
              30.513659943,
              -28.1712999389999
            ],
            [
              30.5419499428356,
              -28.198219938799
            ],
            [
              30.5057299425828,
              -28.2626899386896
            ],
            [
              30.5307699425789,
              -28.3344099392672
            ],
            [
              30.6356499425909,
              -28.4079800638289
            ],
            [
              30.5900599428122,
              -28.4278199391388
            ],
            [
              30.6444899428566,
              -28.4633899390944
            ],
            [
              30.6817399429442,
              -28.5408499390734
            ],
            [
              30.6023499429955,
              -28.5708499393732
            ],
            [
              30.6152099433842,
              -28.6264000639118
            ],
            [
              30.6703159431264,
              -28.6425520641264
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Nqutu Local Municipality",
        "Code": "KZN242",
        "Parent_cod": "DC24",
        "Area": 196226
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              30.2335949430001,
              -28.4087099389999
            ],
            [
              30.3519499430002,
              -28.266459939
            ],
            [
              30.4491599427773,
              -28.2818900641751
            ],
            [
              30.5057299425828,
              -28.2626899386896
            ],
            [
              30.5419499428356,
              -28.198219938799
            ],
            [
              30.513659943,
              -28.1712999389999
            ],
            [
              30.5419999430001,
              -28.124560064
            ],
            [
              30.5361699430001,
              -28.0921499389999
            ],
            [
              30.5698299430002,
              -28.042399939
            ],
            [
              30.569700067804,
              -28.0089500643939
            ],
            [
              30.432390943,
              -27.973680064
            ],
            [
              30.3862100680001,
              -27.9305599379999
            ],
            [
              30.2965399430002,
              -27.9309399379999
            ],
            [
              30.2923369430001,
              -27.9511939389999
            ],
            [
              30.2452619430002,
              -27.995296939
            ],
            [
              30.255839943,
              -28.0778899389998
            ],
            [
              30.1977199430001,
              -28.071520064
            ],
            [
              30.180889943,
              -28.1459599389999
            ],
            [
              30.1237999430001,
              -28.129429939
            ],
            [
              30.132089943,
              -28.1774399389999
            ],
            [
              30.015649942,
              -28.1530799389999
            ],
            [
              29.9904299420001,
              -28.184929939
            ],
            [
              29.9767939419869,
              -28.2395879390321
            ],
            [
              30.0654099420001,
              -28.305130064
            ],
            [
              30.0754799430002,
              -28.357839939
            ],
            [
              30.1356399430002,
              -28.340529939
            ],
            [
              30.1781249427119,
              -28.4396629393931
            ],
            [
              30.2335949430001,
              -28.4087099389999
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Endumeni Local Municipality",
        "Code": "KZN241",
        "Parent_cod": "DC24",
        "Area": 161023
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              30.4100799428351,
              -23.0947200591834
            ],
            [
              30.4783603315641,
              -23.0632864136371
            ],
            [
              30.5053974137597,
              -23.0014252732577
            ],
            [
              30.6006479427484,
              -22.9788910587753
            ],
            [
              30.6581235175864,
              -22.941118959972
            ],
            [
              30.7211252959956,
              -22.8464440654413
            ],
            [
              30.7754208536895,
              -22.8295173892161
            ],
            [
              30.8223566106691,
              -22.7826208867445
            ],
            [
              30.8940815683098,
              -22.7632166844024
            ],
            [
              30.8894799622305,
              -22.7128400376376
            ],
            [
              30.9312499819012,
              -22.641240029104
            ],
            [
              30.9892299675889,
              -22.6082600235812
            ],
            [
              30.9581199781545,
              -22.5489400192664
            ],
            [
              30.9974432051399,
              -22.4953360294341
            ],
            [
              30.8887548046905,
              -22.4803215052332
            ],
            [
              30.8765878803265,
              -22.5032604614011
            ],
            [
              30.8172528879105,
              -22.5006363565825
            ],
            [
              30.7876936516408,
              -22.5926049752394
            ],
            [
              30.7614099432144,
              -22.6295000587807
            ],
            [
              30.7199744569557,
              -22.6469074217401
            ],
            [
              30.6768930395822,
              -22.6134891271214
            ],
            [
              30.5646076926909,
              -22.6429873093168
            ],
            [
              30.4352824800025,
              -22.6596077241171
            ],
            [
              30.3960499433502,
              -22.6248900593287
            ],
            [
              30.3237199434208,
              -22.6532200590584
            ],
            [
              30.2692599428922,
              -22.7240500590629
            ],
            [
              30.2053899427916,
              -22.782580058423
            ],
            [
              30.1873699427686,
              -22.8846900592988
            ],
            [
              30.1647999433628,
              -22.9250100588671
            ],
            [
              30.3553299433223,
              -23.027190057575
            ],
            [
              30.4100799428351,
              -23.0947200591834
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Thulamela Local Municipality",
        "Code": "LIM343",
        "Parent_cod": "DC34",
        "Area": 264167
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              25.6656299951282,
              -26.962720001127
            ],
            [
              25.6919199997082,
              -26.9415599965965
            ],
            [
              25.8097099988174,
              -26.9011799987579
            ],
            [
              25.8333100016553,
              -26.9361599957872
            ],
            [
              25.9136699977722,
              -26.9068199971452
            ],
            [
              26.0041899992691,
              -26.8551899976202
            ],
            [
              26.0767600021725,
              -26.8623300049257
            ],
            [
              26.1150599994195,
              -26.7710499971596
            ],
            [
              26.188969999366,
              -26.7337799979485
            ],
            [
              26.1854100015703,
              -26.7105999991905
            ],
            [
              26.2723600003138,
              -26.6914400023542
            ],
            [
              26.2757899966111,
              -26.6446500011965
            ],
            [
              26.2481100016753,
              -26.5873199987189
            ],
            [
              26.103160002832,
              -26.5784000019584
            ],
            [
              26.1019999970024,
              -26.4617700023836
            ],
            [
              26.0152399962289,
              -26.448830001903
            ],
            [
              25.947990002137,
              -26.4004100002213
            ],
            [
              25.8983699999756,
              -26.4229600014029
            ],
            [
              25.8667600027719,
              -26.3599000008843
            ],
            [
              25.8891800033545,
              -26.3205100091296
            ],
            [
              25.8268999992356,
              -26.2003599974159
            ],
            [
              25.722779997399,
              -26.256920001257
            ],
            [
              25.7122289946725,
              -26.2284939638254
            ],
            [
              25.6552599953526,
              -26.2966399983372
            ],
            [
              25.5890950000343,
              -26.3058300030521
            ],
            [
              25.5460199966256,
              -26.3276699957736
            ],
            [
              25.5549100000964,
              -26.3623600046105
            ],
            [
              25.5028799929174,
              -26.3801100011756
            ],
            [
              25.4223499961555,
              -26.2707500014114
            ],
            [
              25.3720999964178,
              -26.3388000027179
            ],
            [
              25.2973399968435,
              -26.3217500006619
            ],
            [
              25.2249399963838,
              -26.385759997326
            ],
            [
              25.2254199978347,
              -26.4560699994309
            ],
            [
              25.1695899970808,
              -26.5199299981708
            ],
            [
              25.1769190823498,
              -26.5583293021555
            ],
            [
              25.2267050022341,
              -26.6147662778414
            ],
            [
              25.1476499979491,
              -26.7140199968254
            ],
            [
              25.12001212456,
              -26.7972479921012
            ],
            [
              25.1483252494108,
              -26.8005801178781
            ],
            [
              25.1941980796777,
              -26.857581672656
            ],
            [
              25.2574900000635,
              -26.8022499961403
            ],
            [
              25.3207799967994,
              -26.8862599969013
            ],
            [
              25.3826799977837,
              -26.8616599983103
            ],
            [
              25.3985200015969,
              -26.8552899959365
            ],
            [
              25.4926099986525,
              -26.9178700021988
            ],
            [
              25.583119432216,
              -26.943860413827
            ],
            [
              25.6658100016304,
              -26.8991339988349
            ],
            [
              25.6656299951282,
              -26.962720001127
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Tswaing Local Municipality",
        "Code": "NW382",
        "Parent_cod": "DC38",
        "Area": 588534
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              25.1695899970808,
              -26.5199299981708
            ],
            [
              25.2254199978347,
              -26.4560699994309
            ],
            [
              25.2249399963838,
              -26.385759997326
            ],
            [
              25.2973399968435,
              -26.3217500006619
            ],
            [
              25.3720999964178,
              -26.3388000027179
            ],
            [
              25.4223499961555,
              -26.2707500014114
            ],
            [
              25.4715500014315,
              -26.230569999306
            ],
            [
              25.4728199961459,
              -26.2298500011766
            ],
            [
              25.4691000035624,
              -26.1670199995732
            ],
            [
              25.4305100028344,
              -26.1593599988648
            ],
            [
              25.4579800033745,
              -26.1034299997946
            ],
            [
              25.5010200006726,
              -26.0617999955732
            ],
            [
              25.4061400031587,
              -25.954729997991
            ],
            [
              25.2648158657596,
              -25.8705408891506
            ],
            [
              25.3290009990969,
              -25.8320979986236
            ],
            [
              25.3393270004408,
              -25.7692839968589
            ],
            [
              25.1701199972401,
              -25.7659100004461
            ],
            [
              25.0357300042364,
              -25.7227500084061
            ],
            [
              24.8872600013481,
              -25.8074200018316
            ],
            [
              24.7963200029658,
              -25.8246299986754
            ],
            [
              24.7296700041674,
              -25.8040900029513
            ],
            [
              24.6858699988015,
              -25.8233300007789
            ],
            [
              24.6088999989359,
              -25.8006499998976
            ],
            [
              24.5651100012256,
              -25.7712700003102
            ],
            [
              24.4852750023396,
              -25.7493899976502
            ],
            [
              24.4650699977822,
              -25.7901700040424
            ],
            [
              24.6670300014335,
              -25.9212500026854
            ],
            [
              24.6538799993626,
              -25.9593200019165
            ],
            [
              24.7338500008769,
              -26.0395700010546
            ],
            [
              24.7528500029254,
              -26.0766799982832
            ],
            [
              24.7624700022888,
              -26.0932999966974
            ],
            [
              24.8170799989429,
              -26.1987899996587
            ],
            [
              24.7641799984083,
              -26.2052500007868
            ],
            [
              24.8317399996014,
              -26.3269500003422
            ],
            [
              24.8578500003772,
              -26.3949999998501
            ],
            [
              24.9007300001895,
              -26.3634500000174
            ],
            [
              24.9302099998916,
              -26.4206300000744
            ],
            [
              24.9912000029778,
              -26.3909399915873
            ],
            [
              25.0251900029164,
              -26.4454899908704
            ],
            [
              25.066202999369,
              -26.5502950000142
            ],
            [
              25.1695899970808,
              -26.5199299981708
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Ratlou Local Municipality",
        "Code": "NW381",
        "Parent_cod": "DC38",
        "Area": 488356
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              30.3237199434208,
              -22.6532200590584
            ],
            [
              30.3960499433502,
              -22.6248900593287
            ],
            [
              30.4352824800025,
              -22.6596077241171
            ],
            [
              30.5646076926909,
              -22.6429873093168
            ],
            [
              30.6768930395822,
              -22.6134891271214
            ],
            [
              30.7199744569557,
              -22.6469074217401
            ],
            [
              30.7614099432144,
              -22.6295000587807
            ],
            [
              30.7876936516408,
              -22.5926049752394
            ],
            [
              30.8172528879105,
              -22.5006363565825
            ],
            [
              30.8765878803265,
              -22.5032604614011
            ],
            [
              30.8887548046905,
              -22.4803215052332
            ],
            [
              30.9974432051399,
              -22.4953360294341
            ],
            [
              30.9581199781545,
              -22.5489400192664
            ],
            [
              30.9892299675889,
              -22.6082600235812
            ],
            [
              30.9312499819012,
              -22.641240029104
            ],
            [
              30.8894799622305,
              -22.7128400376376
            ],
            [
              31.0134389355585,
              -22.7278199640201
            ],
            [
              30.977773665922,
              -22.8196716312407
            ],
            [
              31.0703372958296,
              -22.8021221160428
            ],
            [
              31.1785430912907,
              -22.6720027920951
            ],
            [
              31.344895727256,
              -22.5345331130127
            ],
            [
              31.3092300016633,
              -22.4275599904012
            ],
            [
              31.2736800044287,
              -22.3747600016728
            ],
            [
              31.2208695107194,
              -22.3698100252125
            ],
            [
              31.1619999984013,
              -22.3284199996832
            ],
            [
              31.0941099990772,
              -22.3486899964462
            ],
            [
              30.9996799989328,
              -22.3164199912895
            ],
            [
              30.8391700019941,
              -22.2920800010911
            ],
            [
              30.7040499960106,
              -22.317089997905
            ],
            [
              30.6668900009729,
              -22.3103899991991
            ],
            [
              30.6260899432963,
              -22.336340058247
            ],
            [
              30.4918899428666,
              -22.316590057585
            ],
            [
              30.3790099426548,
              -22.3513000565523
            ],
            [
              30.2828799432548,
              -22.3540100583175
            ],
            [
              30.2275399426143,
              -22.2949800565843
            ],
            [
              30.1215699426987,
              -22.3086700565778
            ],
            [
              30.0198499418214,
              -22.2334400578124
            ],
            [
              29.9231199417319,
              -22.1891800582131
            ],
            [
              29.8052299416085,
              -22.1655000579813
            ],
            [
              29.7735899421222,
              -22.1414200581891
            ],
            [
              29.6770399422396,
              -22.1389700576221
            ],
            [
              29.6544299418884,
              -22.1250300577909
            ],
            [
              29.6054299422381,
              -22.1556900579498
            ],
            [
              29.5410099419553,
              -22.1522700576171
            ],
            [
              29.5279599417979,
              -22.1780000579562
            ],
            [
              29.4721799415511,
              -22.1655900576351
            ],
            [
              29.3319899418824,
              -22.2041700579018
            ],
            [
              29.217199941724,
              -22.1783100578629
            ],
            [
              29.1549999421937,
              -22.2145200576545
            ],
            [
              29.0369399423245,
              -22.2163100565638
            ],
            [
              28.9665799406118,
              -22.307540058427
            ],
            [
              28.9714499412618,
              -22.3769800581831
            ],
            [
              28.9232789618546,
              -22.4570350384363
            ],
            [
              28.9035099414307,
              -22.5126800576384
            ],
            [
              28.9329100660467,
              -22.521060058275
            ],
            [
              28.9791100660767,
              -22.5811300594047
            ],
            [
              29.1073399422845,
              -22.5392500580437
            ],
            [
              29.1658799421057,
              -22.5531200582441
            ],
            [
              29.209359941708,
              -22.6627800592523
            ],
            [
              29.308779941741,
              -22.6020400587017
            ],
            [
              29.3686799422256,
              -22.6519700589711
            ],
            [
              29.5385299418034,
              -22.6151000584209
            ],
            [
              29.6188399419099,
              -22.6594499335676
            ],
            [
              29.7482499417815,
              -22.680130058955
            ],
            [
              29.7878799419058,
              -22.7004200584389
            ],
            [
              29.7985099419803,
              -22.7580700585863
            ],
            [
              29.8846799416261,
              -22.7102200589085
            ],
            [
              29.9281699416895,
              -22.6648100584374
            ],
            [
              29.9859499424359,
              -22.6929599338538
            ],
            [
              30.1056199428062,
              -22.7039800589325
            ],
            [
              30.1884799426953,
              -22.6936100591568
            ],
            [
              30.2881699425888,
              -22.653650059103
            ],
            [
              30.3237199434208,
              -22.6532200590584
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Musina Local Municipality",
        "Code": "LIM341",
        "Parent_cod": "DC34",
        "Area": 1034651
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              19.8814157760173,
              -29.7770297210447
            ],
            [
              19.6590800063372,
              -29.7930199997731
            ],
            [
              19.5748200003428,
              -29.7252900033309
            ],
            [
              19.6108999977367,
              -29.680859995892
            ],
            [
              19.5859699983169,
              -29.6099200007074
            ],
            [
              19.7621699957487,
              -29.5820400019445
            ],
            [
              19.7669899958916,
              -29.5399700008148
            ],
            [
              19.740250002036,
              -29.4286099897592
            ],
            [
              19.7053200001179,
              -29.4009300074139
            ],
            [
              19.6569900052846,
              -29.3210300019331
            ],
            [
              19.6013199957213,
              -29.2718500011766
            ],
            [
              19.5766900002434,
              -29.0946819986752
            ],
            [
              19.6810500068523,
              -28.9926000017886
            ],
            [
              19.7795100057822,
              -28.8764200067779
            ],
            [
              19.6662299970168,
              -28.8297900040054
            ],
            [
              19.6191100040235,
              -28.6905600099365
            ],
            [
              19.5092899983348,
              -28.5965400008203
            ],
            [
              19.4896800032296,
              -28.6819900014374
            ],
            [
              19.4053999981115,
              -28.7362600003987
            ],
            [
              19.2697900019071,
              -28.7420299957876
            ],
            [
              19.2398200020914,
              -28.8058000002698
            ],
            [
              19.2848700021489,
              -28.908559996047
            ],
            [
              19.2298800059576,
              -28.9122799976237
            ],
            [
              19.1966600028569,
              -28.9470199988738
            ],
            [
              19.1182899959866,
              -28.9694399985571
            ],
            [
              19.0059299990702,
              -28.9242700037576
            ],
            [
              18.9836099950053,
              -28.8788400032635
            ],
            [
              18.9356400041829,
              -28.8572399964286
            ],
            [
              18.7286700042174,
              -28.8317000030527
            ],
            [
              18.5327800061923,
              -28.8682499987384
            ],
            [
              18.5120800039891,
              -28.889480003799
            ],
            [
              18.5430400062913,
              -28.9616000021384
            ],
            [
              18.606329996732,
              -28.9640299972865
            ],
            [
              18.6195200051442,
              -29.0180700054264
            ],
            [
              18.5955100022848,
              -29.1384899981149
            ],
            [
              18.6429499983438,
              -29.2180100013604
            ],
            [
              18.6322800063173,
              -29.3540699967329
            ],
            [
              18.6510000026481,
              -29.4217299962423
            ],
            [
              18.7486700002204,
              -29.4180600005685
            ],
            [
              18.737040005292,
              -29.4923000049413
            ],
            [
              18.7766495170616,
              -29.4835762177682
            ],
            [
              18.770210265991,
              -29.5938796998882
            ],
            [
              18.7272701258157,
              -29.67334937977
            ],
            [
              18.7610893247126,
              -29.6756401059061
            ],
            [
              18.7991790766531,
              -29.7605209345934
            ],
            [
              18.8084506993403,
              -29.8316707613965
            ],
            [
              18.8662083834102,
              -29.8455636223633
            ],
            [
              18.8591594702334,
              -29.9466094968308
            ],
            [
              18.9082908626332,
              -30.0638504031736
            ],
            [
              19.0119094852346,
              -30.0740699769478
            ],
            [
              19.010570526009,
              -30.1645698552146
            ],
            [
              19.0913105009788,
              -30.3096599576409
            ],
            [
              19.0831100032241,
              -30.3424300011436
            ],
            [
              19.1357800003468,
              -30.3769199953615
            ],
            [
              19.1871600054299,
              -30.2985000059705
            ],
            [
              19.2981399989619,
              -30.2540799989927
            ],
            [
              19.3683799960401,
              -30.2963599999141
            ],
            [
              19.4648200088364,
              -30.3179299999694
            ],
            [
              19.5337899986096,
              -30.3169800047234
            ],
            [
              19.6501499947265,
              -30.3789700053614
            ],
            [
              19.7522799983233,
              -30.3941999990307
            ],
            [
              19.803914096958,
              -30.3855023713373
            ],
            [
              19.9420046472967,
              -30.3112699986115
            ],
            [
              20.0220599980705,
              -30.3137100023147
            ],
            [
              20.0022800023203,
              -30.2792700050067
            ],
            [
              20.0263500025506,
              -30.238669995224
            ],
            [
              19.8780731758364,
              -30.2282971679799
            ],
            [
              19.839409490056,
              -30.1464133336084
            ],
            [
              19.8881570841821,
              -30.0936892998213
            ],
            [
              19.84622464695,
              -30.0326758729931
            ],
            [
              19.7607198506406,
              -30.0215204898786
            ],
            [
              19.7464268588125,
              -29.9800474919981
            ],
            [
              19.8168852427598,
              -29.9522386116226
            ],
            [
              19.7862812209017,
              -29.8755575828162
            ],
            [
              19.8814157760173,
              -29.7770297210447
            ]
          ]
        ]
      },
      "properties": {
        "Name": "KhÃ¢i-Ma Local Municipality",
        "Code": "NC067",
        "Parent_cod": "DC6",
        "Area": 1571455
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              21.1883099978082,
              -32.5030499946615
            ],
            [
              21.2694799971042,
              -32.4502900005831
            ],
            [
              21.3030100109034,
              -32.4024400018046
            ],
            [
              21.4083999966625,
              -32.3687700004351
            ],
            [
              21.4756400028839,
              -32.3314500016163
            ],
            [
              21.5190799997422,
              -32.3370299990351
            ],
            [
              21.5618099989323,
              -32.3147300021878
            ],
            [
              21.5360099998617,
              -32.2292200095958
            ],
            [
              21.6445799982684,
              -32.2087100008658
            ],
            [
              21.6916499952511,
              -32.2485700017042
            ],
            [
              21.7358900002233,
              -32.2050200006725
            ],
            [
              21.7806199972151,
              -32.2509299999194
            ],
            [
              21.8551099978282,
              -32.2755099948903
            ],
            [
              21.9246000061854,
              -32.2619600013529
            ],
            [
              21.9362050026588,
              -32.2228800041089
            ],
            [
              21.9959200018067,
              -32.2029800037242
            ],
            [
              22.0164399903133,
              -32.1142599953025
            ],
            [
              22.0695600000939,
              -32.0814499994179
            ],
            [
              22.1199500008919,
              -32.076970000565
            ],
            [
              22.0741249947727,
              -32.0179150021755
            ],
            [
              22.0949800041239,
              -32.0010599992195
            ],
            [
              22.0713300025776,
              -31.9392999965975
            ],
            [
              22.1014399980575,
              -31.8987199949317
            ],
            [
              22.1665999991907,
              -31.8930899988044
            ],
            [
              22.1768800029099,
              -31.8207199979296
            ],
            [
              22.2040100003613,
              -31.7640300015833
            ],
            [
              22.1797300003393,
              -31.7816900002932
            ],
            [
              22.116139996064,
              -31.7584200000828
            ],
            [
              22.0495800023153,
              -31.7699799989777
            ],
            [
              21.9440600006686,
              -31.6822399979775
            ],
            [
              21.9155150027153,
              -31.6457150007467
            ],
            [
              21.9497100013155,
              -31.6009799972291
            ],
            [
              22.0116599956124,
              -31.5904499999674
            ],
            [
              21.9619499973945,
              -31.5122000040269
            ],
            [
              21.9198899958266,
              -31.4911599996343
            ],
            [
              21.8654799940066,
              -31.4973200049143
            ],
            [
              21.8498799967645,
              -31.4564399984071
            ],
            [
              21.9327800065921,
              -31.4342399980775
            ],
            [
              21.8801600009833,
              -31.3995200040449
            ],
            [
              21.8144900051097,
              -31.3977699988863
            ],
            [
              21.822829999405,
              -31.3535100010856
            ],
            [
              21.7624000032576,
              -31.2714000007094
            ],
            [
              21.6147550024415,
              -31.2499009976329
            ],
            [
              21.6218599937438,
              -31.1513599940684
            ],
            [
              21.7022149968247,
              -31.1647550020417
            ],
            [
              21.670689992749,
              -31.0975999907469
            ],
            [
              21.5880899958566,
              -31.0619200019065
            ],
            [
              21.5672499997877,
              -31.0969200007574
            ],
            [
              21.5098200007924,
              -31.0572200045995
            ],
            [
              21.5255500004322,
              -31.0034800013011
            ],
            [
              21.4830300001345,
              -30.9938600010382
            ],
            [
              21.5019799971792,
              -30.9148099960844
            ],
            [
              21.4696100009008,
              -30.8752399951296
            ],
            [
              21.4933100002564,
              -30.8281400021594
            ],
            [
              21.4476899981949,
              -30.7842000002298
            ],
            [
              21.4834399929613,
              -30.7460799995923
            ],
            [
              21.4209200047545,
              -30.7285900042252
            ],
            [
              21.3815200053441,
              -30.6992399970282
            ],
            [
              21.3364200002829,
              -30.6383199962707
            ],
            [
              21.2709149976291,
              -30.5894699981419
            ],
            [
              21.3081100005761,
              -30.5435599988948
            ],
            [
              21.2652199994035,
              -30.474439998607
            ],
            [
              21.2514857149938,
              -30.3970233630377
            ],
            [
              21.1426174456386,
              -30.4265168795503
            ],
            [
              21.0820621730309,
              -30.4018373440182
            ],
            [
              21.0559628418117,
              -30.4850856387912
            ],
            [
              20.9254259428531,
              -30.5000341572505
            ],
            [
              20.9101014547184,
              -30.5197684863265
            ],
            [
              20.9385354340631,
              -30.6166529278903
            ],
            [
              20.8847816162787,
              -30.612907683243
            ],
            [
              20.7992926183597,
              -30.6363219311122
            ],
            [
              20.7899863699751,
              -30.5882346417153
            ],
            [
              20.6910087689396,
              -30.6400380107456
            ],
            [
              20.6155600910255,
              -30.6549133891416
            ],
            [
              20.6094972682844,
              -30.7368488427998
            ],
            [
              20.5732849401479,
              -30.7845941649886
            ],
            [
              20.5315194917312,
              -30.7061026938842
            ],
            [
              20.4539298023185,
              -30.7656780687877
            ],
            [
              20.4122699990613,
              -30.7581600026819
            ],
            [
              20.3831599993346,
              -30.8152599981503
            ],
            [
              20.4593200023163,
              -30.8989300030172
            ],
            [
              20.3898799989629,
              -30.9567649937095
            ],
            [
              20.3511900044153,
              -31.0909399965835
            ],
            [
              20.4030799979436,
              -31.1855200009473
            ],
            [
              20.4605299960625,
              -31.1767999981214
            ],
            [
              20.5474299969968,
              -31.2015300063047
            ],
            [
              20.5915800068119,
              -31.3106299985755
            ],
            [
              20.5462700019591,
              -31.3315300001093
            ],
            [
              20.5793199954215,
              -31.4152399951296
            ],
            [
              20.5276899985947,
              -31.4248499958306
            ],
            [
              20.5641399986621,
              -31.4940999994154
            ],
            [
              20.6241500033201,
              -31.5200999978166
            ],
            [
              20.5576000010392,
              -31.6047800042937
            ],
            [
              20.6104949968467,
              -31.6574640002633
            ],
            [
              20.5624749992219,
              -31.7227530028488
            ],
            [
              20.6210400019945,
              -31.7658099982328
            ],
            [
              20.6484300042414,
              -31.8445000009742
            ],
            [
              20.5593399976428,
              -31.852660001358
            ],
            [
              20.4755899971807,
              -31.8406099969537
            ],
            [
              20.4746899988445,
              -31.8061599928893
            ],
            [
              20.3718599989399,
              -31.8220400030436
            ],
            [
              20.3176499973495,
              -31.8640900050497
            ],
            [
              20.3267100032641,
              -31.9035499937372
            ],
            [
              20.280049992813,
              -32.0124100037186
            ],
            [
              20.3109599973061,
              -32.0325700017042
            ],
            [
              20.2773481505967,
              -32.0837896810489
            ],
            [
              20.1647200064232,
              -32.0873599967664
            ],
            [
              20.1518300019531,
              -32.186519994702
            ],
            [
              20.1663600011132,
              -32.2274900035608
            ],
            [
              20.2408400030637,
              -32.2241899961713
            ],
            [
              20.2541699981469,
              -32.3108499986285
            ],
            [
              20.216030004681,
              -32.3031599947379
            ],
            [
              20.1635200041449,
              -32.3510200056687
            ],
            [
              20.1704500017662,
              -32.3808699972526
            ],
            [
              20.1320200012222,
              -32.421120002586
            ],
            [
              20.0796900035908,
              -32.3974999943293
            ],
            [
              20.0968099998817,
              -32.5029599968064
            ],
            [
              20.1227899982599,
              -32.5569800040239
            ],
            [
              20.1411900023168,
              -32.6437399958041
            ],
            [
              20.1917199996783,
              -32.6857600000239
            ],
            [
              20.1876099972036,
              -32.7526700027184
            ],
            [
              20.2190400031936,
              -32.7847399950547
            ],
            [
              20.2998999962878,
              -32.8049599994044
            ],
            [
              20.3800499989084,
              -32.9018499996777
            ],
            [
              20.438599994694,
              -32.9400600035663
            ],
            [
              20.4992999889034,
              -32.9416299932296
            ],
            [
              20.5612300002643,
              -32.8809699990661
            ],
            [
              20.5921000038121,
              -32.9264699991911
            ],
            [
              20.7311700021939,
              -32.9449949946232
            ],
            [
              20.7442100000914,
              -32.9128899961764
            ],
            [
              20.798560000044,
              -32.8947499996128
            ],
            [
              20.8324299998447,
              -32.8173700033229
            ],
            [
              20.8303399996913,
              -32.7845700016042
            ],
            [
              20.7921999999301,
              -32.7350300121253
            ],
            [
              20.8441000038122,
              -32.6624399948098
            ],
            [
              20.9627799998971,
              -32.6392999969973
            ],
            [
              21.0602899963863,
              -32.6555000021234
            ],
            [
              21.1569799973291,
              -32.6289399940855
            ],
            [
              21.1401100017752,
              -32.5897699935902
            ],
            [
              21.1883099978082,
              -32.5030499946615
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Karoo Hoogland Local Municipality",
        "Code": "NC066",
        "Parent_cod": "DC6",
        "Area": 3023045
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              28.4133200018167,
              -27.0068599996892
            ],
            [
              28.4858500028754,
              -26.9711099977282
            ],
            [
              28.5496899979951,
              -27.0416000000399
            ],
            [
              28.5854700022389,
              -27.0358600042357
            ],
            [
              28.646920004055,
              -26.9530399971981
            ],
            [
              28.8108599981904,
              -27.0386100042482
            ],
            [
              28.8440272470598,
              -27.038667574349
            ],
            [
              28.851600002738,
              -26.9230199995732
            ],
            [
              28.9179400016298,
              -26.8430400002958
            ],
            [
              28.921739996104,
              -26.7976100016003
            ],
            [
              28.8826999971072,
              -26.7574100030691
            ],
            [
              28.9321399990617,
              -26.71104999656
            ],
            [
              28.897497628213,
              -26.6239778770773
            ],
            [
              28.9110800009414,
              -26.5899499967949
            ],
            [
              28.8526300007739,
              -26.5675599993944
            ],
            [
              28.8367899969608,
              -26.5363800040339
            ],
            [
              28.7639100031442,
              -26.5180099995618
            ],
            [
              28.6416200006625,
              -26.5075699956587
            ],
            [
              28.63815000342,
              -26.5473099990572
            ],
            [
              28.5849099988974,
              -26.5385600020424
            ],
            [
              28.5276599992097,
              -26.5022099966939
            ],
            [
              28.5329799990277,
              -26.577899995988
            ],
            [
              28.4832500007869,
              -26.6183800002367
            ],
            [
              28.400099997417,
              -26.6550450003265
            ],
            [
              28.3939699989163,
              -26.7167500004122
            ],
            [
              28.406850002026,
              -26.7617100026145
            ],
            [
              28.3194100040685,
              -26.7926699977222
            ],
            [
              28.325010000611,
              -26.8410700038775
            ],
            [
              28.2442800000221,
              -26.8847799996972
            ],
            [
              28.300429999345,
              -26.9401600021823
            ],
            [
              28.3921500004222,
              -26.93142000383
            ],
            [
              28.4286900028414,
              -26.9903499973544
            ],
            [
              28.4133200018167,
              -27.0068599996892
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Dipaleseng Local Municipality",
        "Code": "MP306",
        "Parent_cod": "DC30",
        "Area": 260740
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              19.8814157760173,
              -29.7770297210447
            ],
            [
              19.7862812209017,
              -29.8755575828162
            ],
            [
              19.8168852427598,
              -29.9522386116226
            ],
            [
              19.7464268588125,
              -29.9800474919981
            ],
            [
              19.7607198506406,
              -30.0215204898786
            ],
            [
              19.84622464695,
              -30.0326758729931
            ],
            [
              19.8881570841821,
              -30.0936892998213
            ],
            [
              19.839409490056,
              -30.1464133336084
            ],
            [
              19.8780731758364,
              -30.2282971679799
            ],
            [
              20.0263500025506,
              -30.238669995224
            ],
            [
              20.0022800023203,
              -30.2792700050067
            ],
            [
              20.0220599980705,
              -30.3137100023147
            ],
            [
              19.9420046472967,
              -30.3112699986115
            ],
            [
              19.803914096958,
              -30.3855023713373
            ],
            [
              19.7522799983233,
              -30.3941999990307
            ],
            [
              19.6501499947265,
              -30.3789700053614
            ],
            [
              19.5337899986096,
              -30.3169800047234
            ],
            [
              19.4648200088364,
              -30.3179299999694
            ],
            [
              19.3683799960401,
              -30.2963599999141
            ],
            [
              19.2981399989619,
              -30.2540799989927
            ],
            [
              19.1871600054299,
              -30.2985000059705
            ],
            [
              19.1357800003468,
              -30.3769199953615
            ],
            [
              19.0831100032241,
              -30.3424300011436
            ],
            [
              19.0059700063108,
              -30.4970299998346
            ],
            [
              18.9514799990028,
              -30.744439998607
            ],
            [
              18.9604699998906,
              -30.8661100003762
            ],
            [
              18.8753900091416,
              -30.8870599997191
            ],
            [
              18.9844900023118,
              -30.9458100029293
            ],
            [
              18.9117700095783,
              -30.9789299969218
            ],
            [
              18.9034700018391,
              -31.0417799949508
            ],
            [
              18.9476000044367,
              -31.1129100042932
            ],
            [
              18.944460002627,
              -31.2373199984191
            ],
            [
              18.9664199972851,
              -31.2844900027114
            ],
            [
              19.0130100018102,
              -31.3056800032295
            ],
            [
              18.9801300017982,
              -31.3552399900335
            ],
            [
              19.0308799994125,
              -31.3895399943751
            ],
            [
              19.042989999389,
              -31.4249699995658
            ],
            [
              19.0196800009314,
              -31.4992500039845
            ],
            [
              19.085420002731,
              -31.5269300007189
            ],
            [
              19.090520001397,
              -31.5977799998471
            ],
            [
              19.0705099977383,
              -31.6240500026055
            ],
            [
              19.0655600032916,
              -31.7063099991072
            ],
            [
              19.0946599962619,
              -31.7502100009907
            ],
            [
              19.0862700023587,
              -31.7944800001518
            ],
            [
              19.0304599971313,
              -31.8336199992635
            ],
            [
              19.0262200012521,
              -31.8766399992366
            ],
            [
              19.1424500021659,
              -31.9120800021903
            ],
            [
              19.1996799991327,
              -31.9047700023336
            ],
            [
              19.2107099996668,
              -31.9480399967484
            ],
            [
              19.2896799964347,
              -31.8630399979975
            ],
            [
              19.2648400011651,
              -31.9657399937057
            ],
            [
              19.3233499969048,
              -31.9848000012191
            ],
            [
              19.3629699956688,
              -32.0428400022642
            ],
            [
              19.3958499956808,
              -32.015110003224
            ],
            [
              19.5151900051146,
              -32.11519999998
            ],
            [
              19.4752200045996,
              -32.1462899875928
            ],
            [
              19.5013899982498,
              -32.179869999201
            ],
            [
              19.4914999999251,
              -32.2523700060708
            ],
            [
              19.4090800023403,
              -32.2900799976937
            ],
            [
              19.4302000041269,
              -32.3657099987174
            ],
            [
              19.4963700032731,
              -32.4748199977447
            ],
            [
              19.4868050028486,
              -32.5654399957592
            ],
            [
              19.5282499958407,
              -32.6732399982273
            ],
            [
              19.6049500003423,
              -32.6294599982803
            ],
            [
              19.607119998789,
              -32.5453800005866
            ],
            [
              19.6218500035749,
              -32.4706200010122
            ],
            [
              19.7302400017747,
              -32.442360000014
            ],
            [
              19.8027000023033,
              -32.3937000016537
            ],
            [
              19.8178000106621,
              -32.3607199970301
            ],
            [
              19.8738899946276,
              -32.3832000021784
            ],
            [
              19.9374900029613,
              -32.3772799980734
            ],
            [
              20.0386199991137,
              -32.2964400032036
            ],
            [
              20.0536099997018,
              -32.252310000606
            ],
            [
              20.0969600041009,
              -32.2502399986769
            ],
            [
              20.1518300019531,
              -32.186519994702
            ],
            [
              20.1647200064232,
              -32.0873599967664
            ],
            [
              20.2773481505967,
              -32.0837896810489
            ],
            [
              20.3109599973061,
              -32.0325700017042
            ],
            [
              20.280049992813,
              -32.0124100037186
            ],
            [
              20.3267100032641,
              -31.9035499937372
            ],
            [
              20.3176499973495,
              -31.8640900050497
            ],
            [
              20.3718599989399,
              -31.8220400030436
            ],
            [
              20.4746899988445,
              -31.8061599928893
            ],
            [
              20.4755899971807,
              -31.8406099969537
            ],
            [
              20.5593399976428,
              -31.852660001358
            ],
            [
              20.6484300042414,
              -31.8445000009742
            ],
            [
              20.6210400019945,
              -31.7658099982328
            ],
            [
              20.5624749992219,
              -31.7227530028488
            ],
            [
              20.6104949968467,
              -31.6574640002633
            ],
            [
              20.5576000010392,
              -31.6047800042937
            ],
            [
              20.6241500033201,
              -31.5200999978166
            ],
            [
              20.5641399986621,
              -31.4940999994154
            ],
            [
              20.5276899985947,
              -31.4248499958306
            ],
            [
              20.5793199954215,
              -31.4152399951296
            ],
            [
              20.5462700019591,
              -31.3315300001093
            ],
            [
              20.5915800068119,
              -31.3106299985755
            ],
            [
              20.5474299969968,
              -31.2015300063047
            ],
            [
              20.4605299960625,
              -31.1767999981214
            ],
            [
              20.4030799979436,
              -31.1855200009473
            ],
            [
              20.3511900044153,
              -31.0909399965835
            ],
            [
              20.3898799989629,
              -30.9567649937095
            ],
            [
              20.4593200023163,
              -30.8989300030172
            ],
            [
              20.3831599993346,
              -30.8152599981503
            ],
            [
              20.4122699990613,
              -30.7581600026819
            ],
            [
              20.4539298023185,
              -30.7656780687877
            ],
            [
              20.5315194917312,
              -30.7061026938842
            ],
            [
              20.5732849401479,
              -30.7845941649886
            ],
            [
              20.6094972682844,
              -30.7368488427998
            ],
            [
              20.6155600910255,
              -30.6549133891416
            ],
            [
              20.6910087689396,
              -30.6400380107456
            ],
            [
              20.7899863699751,
              -30.5882346417153
            ],
            [
              20.7992926183597,
              -30.6363219311122
            ],
            [
              20.8847816162787,
              -30.612907683243
            ],
            [
              20.9385354340631,
              -30.6166529278903
            ],
            [
              20.9101014547184,
              -30.5197684863265
            ],
            [
              20.9254259428531,
              -30.5000341572505
            ],
            [
              21.0559628418117,
              -30.4850856387912
            ],
            [
              21.0820621730309,
              -30.4018373440182
            ],
            [
              21.1426174456386,
              -30.4265168795503
            ],
            [
              21.2514857149938,
              -30.3970233630377
            ],
            [
              21.2198099971338,
              -30.3329300028173
            ],
            [
              21.0729100000965,
              -30.3322499966399
            ],
            [
              21.0748800046086,
              -30.3025699949093
            ],
            [
              21.1430600011182,
              -30.256230004611
            ],
            [
              21.1652400032236,
              -30.0856500001474
            ],
            [
              21.2429800008264,
              -30.0390899943078
            ],
            [
              21.3052600058447,
              -29.9804099952251
            ],
            [
              21.1541300016982,
              -29.8726200004126
            ],
            [
              21.272040002744,
              -29.7362799993224
            ],
            [
              21.2755999951437,
              -29.6871599950377
            ],
            [
              21.1953999938147,
              -29.63724999659
            ],
            [
              20.9615199984492,
              -29.7962300048108
            ],
            [
              20.8985600034414,
              -29.8503199963707
            ],
            [
              20.8575800004167,
              -29.8585600013429
            ],
            [
              20.8037500001624,
              -29.9422999950487
            ],
            [
              20.7548099969839,
              -29.982650005893
            ],
            [
              20.7081399950647,
              -29.9856300039215
            ],
            [
              20.6263899978002,
              -29.8631700088887
            ],
            [
              20.6368499981289,
              -29.7521400013599
            ],
            [
              20.6614100038687,
              -29.6430699987813
            ],
            [
              20.59447000069,
              -29.6348400005655
            ],
            [
              20.519840010708,
              -29.7190199938775
            ],
            [
              20.4368400052621,
              -29.6158499989782
            ],
            [
              20.3858300010537,
              -29.6037699958885
            ],
            [
              20.2733799999871,
              -29.643549996635
            ],
            [
              20.1567100003663,
              -29.652509997938
            ],
            [
              20.1752099973436,
              -29.7643799983382
            ],
            [
              20.1045699989064,
              -29.8279399940355
            ],
            [
              20.0461400068558,
              -29.8617699982868
            ],
            [
              19.995640000086,
              -29.8667300012885
            ],
            [
              19.8814157760173,
              -29.7770297210447
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Hantam Local Municipality",
        "Code": "NC065",
        "Parent_cod": "DC6",
        "Area": 3908482
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              29.4188599989898,
              -27.2545200000979
            ],
            [
              29.4925800009663,
              -27.1946899938481
            ],
            [
              29.550400002658,
              -27.1856100014004
            ],
            [
              29.5727699964382,
              -27.1053799968893
            ],
            [
              29.6202300042114,
              -27.07455000328
            ],
            [
              29.6652299992651,
              -26.9432299998646
            ],
            [
              29.6574300001944,
              -26.869300002593
            ],
            [
              29.7502400038731,
              -26.8318499959804
            ],
            [
              29.7985400117123,
              -26.8484499988683
            ],
            [
              29.8429599998042,
              -26.7994600041758
            ],
            [
              29.8699100069413,
              -26.6501500003222
            ],
            [
              29.8226440018193,
              -26.6693659961438
            ],
            [
              29.6403500030503,
              -26.6279099990472
            ],
            [
              29.6395799981185,
              -26.5297340024223
            ],
            [
              29.6191699948994,
              -26.5290599983202
            ],
            [
              29.5683100012056,
              -26.5615500037296
            ],
            [
              29.4868300002044,
              -26.553310003254
            ],
            [
              29.4563200042649,
              -26.5915500040295
            ],
            [
              29.4593800032846,
              -26.6467099972685
            ],
            [
              29.3254900009628,
              -26.6612600018475
            ],
            [
              29.2909979922636,
              -26.6400599981704
            ],
            [
              29.2237999987709,
              -26.6583300034269
            ],
            [
              29.241399997412,
              -26.7168400000659
            ],
            [
              29.1251500009718,
              -26.707419997335
            ],
            [
              29.0231099988274,
              -26.6816199991635
            ],
            [
              28.9912000003798,
              -26.6859699974174
            ],
            [
              28.9921100036737,
              -26.608890000573
            ],
            [
              28.897497628213,
              -26.6239778770773
            ],
            [
              28.9321399990617,
              -26.71104999656
            ],
            [
              28.8826999971072,
              -26.7574100030691
            ],
            [
              28.921739996104,
              -26.7976100016003
            ],
            [
              28.9179400016298,
              -26.8430400002958
            ],
            [
              28.851600002738,
              -26.9230199995732
            ],
            [
              28.8440272470598,
              -27.038667574349
            ],
            [
              28.9547700012346,
              -27.0114600022773
            ],
            [
              29.0151413993562,
              -27.0099578439794
            ],
            [
              29.0572300002643,
              -27.0092999997951
            ],
            [
              29.0610300010338,
              -27.0717500027604
            ],
            [
              29.0860100027594,
              -27.1152599983502
            ],
            [
              29.1363699985766,
              -27.1542200035502
            ],
            [
              29.223870001999,
              -27.1447000034024
            ],
            [
              29.2298099944357,
              -27.1672299991651
            ],
            [
              29.3314699997408,
              -27.2101000030127
            ],
            [
              29.3395799996173,
              -27.2527300029872
            ],
            [
              29.4188599989898,
              -27.2545200000979
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Lekwa Local Municipality",
        "Code": "MP305",
        "Parent_cod": "DC30",
        "Area": 459435
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              17.7575800030148,
              -31.1519699997157
            ],
            [
              17.834419998684,
              -31.1765199995983
            ],
            [
              17.8113200009173,
              -31.0925400002207
            ],
            [
              17.9264099987225,
              -31.0113900027465
            ],
            [
              17.8779200019066,
              -30.9486500007969
            ],
            [
              17.8802999983463,
              -30.9239399989318
            ],
            [
              17.9933799987879,
              -30.9187400037482
            ],
            [
              17.9948399986671,
              -30.8192200000029
            ],
            [
              18.0064790030036,
              -30.7912399957292
            ],
            [
              18.089179997359,
              -30.7878699959035
            ],
            [
              18.1691800038541,
              -30.848559998645
            ],
            [
              18.2135399999711,
              -30.8104399917122
            ],
            [
              18.2641699992461,
              -30.8183199935728
            ],
            [
              18.3710399992965,
              -30.6596299969268
            ],
            [
              18.3711500025706,
              -30.5920900002533
            ],
            [
              18.4137599989249,
              -30.5273499996027
            ],
            [
              18.4836199946671,
              -30.5219099951501
            ],
            [
              18.5021500011217,
              -30.4444200018816
            ],
            [
              18.5701200032356,
              -30.4302599982004
            ],
            [
              18.6551495411184,
              -30.5567092985952
            ],
            [
              18.7587108607177,
              -30.5678691864138
            ],
            [
              18.7958699978022,
              -30.6248600041858
            ],
            [
              18.7945003510104,
              -30.6676197052851
            ],
            [
              18.8629703519003,
              -30.7171192171781
            ],
            [
              18.9514799990028,
              -30.744439998607
            ],
            [
              19.0059700063108,
              -30.4970299998346
            ],
            [
              19.0831100032241,
              -30.3424300011436
            ],
            [
              19.0913105009788,
              -30.3096599576409
            ],
            [
              19.010570526009,
              -30.1645698552146
            ],
            [
              19.0119094852346,
              -30.0740699769478
            ],
            [
              18.9082908626332,
              -30.0638504031736
            ],
            [
              18.8591594702334,
              -29.9466094968308
            ],
            [
              18.8662083834102,
              -29.8455636223633
            ],
            [
              18.8084506993403,
              -29.8316707613965
            ],
            [
              18.7255964946825,
              -29.8641086394022
            ],
            [
              18.6054899966661,
              -29.8604100021198
            ],
            [
              18.5618896479889,
              -29.8930492401302
            ],
            [
              18.4936599729294,
              -29.9180793763621
            ],
            [
              18.3671200046845,
              -29.9348000008194
            ],
            [
              18.333249994092,
              -29.8955999944441
            ],
            [
              18.2190247933596,
              -29.9110093516003
            ],
            [
              18.2088037923612,
              -30.0005538827555
            ],
            [
              18.1271900001184,
              -30.0165099998366
            ],
            [
              18.0000100023598,
              -30.0658999940894
            ],
            [
              17.9591099958297,
              -30.0286899994439
            ],
            [
              17.8877800078411,
              -30.0386499947015
            ],
            [
              17.8636000034374,
              -30.0666899963463
            ],
            [
              17.7791099976283,
              -30.054319996071
            ],
            [
              17.732490003411,
              -30.0207199997281
            ],
            [
              17.6038799945662,
              -30.0124900024117
            ],
            [
              17.5616500004472,
              -30.0471499981739
            ],
            [
              17.5192399953296,
              -29.9498700006
            ],
            [
              17.4391299990502,
              -30.0330899991041
            ],
            [
              17.3961300008989,
              -30.0189399949848
            ],
            [
              17.3122400047724,
              -30.0928399971681
            ],
            [
              17.2472400002259,
              -30.0031800047534
            ],
            [
              17.1810000023483,
              -30.0617300014384
            ],
            [
              17.1823199993685,
              -30.0923600074084
            ],
            [
              17.2234199980345,
              -30.1650899979051
            ],
            [
              17.2583100008059,
              -30.2564600044257
            ],
            [
              17.2737900024067,
              -30.3346000042867
            ],
            [
              17.3077300018382,
              -30.3775899938831
            ],
            [
              17.3707499951162,
              -30.4993400002408
            ],
            [
              17.4423499955559,
              -30.5963000010442
            ],
            [
              17.4339600052501,
              -30.6207800021953
            ],
            [
              17.5235899971807,
              -30.7355500023307
            ],
            [
              17.5333999990108,
              -30.7749500017412
            ],
            [
              17.5953299932846,
              -30.900010000661
            ],
            [
              17.6794199896409,
              -30.9991000007644
            ],
            [
              17.7035399966735,
              -31.064499998576
            ],
            [
              17.7575800030148,
              -31.1519699997157
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Kamiesberg Local Municipality",
        "Code": "NC064",
        "Parent_cod": "DC6",
        "Area": 1420843
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              29.8991399770001,
              -27.385490028
            ],
            [
              29.9118899877328,
              -27.3671400179974
            ],
            [
              29.9150199870001,
              -27.3598599819999
            ],
            [
              29.9784699869004,
              -27.3729900179749
            ],
            [
              30.0162419858789,
              -27.3975890201172
            ],
            [
              30.0682899785997,
              -27.365870020585
            ],
            [
              30.1502399859866,
              -27.3922499861479
            ],
            [
              30.1980799840002,
              -27.3551800229999
            ],
            [
              30.2799300158576,
              -27.3685899760465
            ],
            [
              30.2824899860001,
              -27.3144399829999
            ],
            [
              30.3676099880002,
              -27.26742998
            ],
            [
              30.426449989,
              -27.2698300189999
            ],
            [
              30.448269997962,
              -27.3277399376479
            ],
            [
              30.52704999676,
              -27.31574998997
            ],
            [
              30.5022600028969,
              -27.2835499988333
            ],
            [
              30.5669100029943,
              -27.1695100026844
            ],
            [
              30.4997400017997,
              -27.1708900015723
            ],
            [
              30.4484899991142,
              -27.2071999987809
            ],
            [
              30.3990100043083,
              -27.2070799968444
            ],
            [
              30.3280699947345,
              -27.1839200017067
            ],
            [
              30.3154599995794,
              -27.1462600006984
            ],
            [
              30.3805800105591,
              -27.117039995899
            ],
            [
              30.3994799990028,
              -27.021520001247
            ],
            [
              30.3606780091828,
              -26.9700490000612
            ],
            [
              30.295749998064,
              -27.0161600013829
            ],
            [
              30.2711199971901,
              -27.0095100022848
            ],
            [
              30.2719400008304,
              -26.9508699960534
            ],
            [
              30.2437000025531,
              -26.85984999668
            ],
            [
              30.2507600007735,
              -26.8247599963767
            ],
            [
              30.1889800017258,
              -26.8169800009263
            ],
            [
              30.1379400006306,
              -26.8348200043397
            ],
            [
              30.111160004031,
              -26.7363200017666
            ],
            [
              29.9948100011807,
              -26.6977200041749
            ],
            [
              29.9637599992246,
              -26.7706700021188
            ],
            [
              29.9212699976124,
              -26.7784899976153
            ],
            [
              29.9210298111769,
              -26.7786312901019
            ],
            [
              29.8429599998042,
              -26.7994600041758
            ],
            [
              29.7985400117123,
              -26.8484499988683
            ],
            [
              29.7502400038731,
              -26.8318499959804
            ],
            [
              29.6574300001944,
              -26.869300002593
            ],
            [
              29.6652299992651,
              -26.9432299998646
            ],
            [
              29.6202300042114,
              -27.07455000328
            ],
            [
              29.5727699964382,
              -27.1053799968893
            ],
            [
              29.550400002658,
              -27.1856100014004
            ],
            [
              29.4925800009663,
              -27.1946899938481
            ],
            [
              29.4188599989898,
              -27.2545200000979
            ],
            [
              29.4629499988435,
              -27.2871399989118
            ],
            [
              29.4689899958917,
              -27.3242000037272
            ],
            [
              29.6189100017952,
              -27.5060200022213
            ],
            [
              29.7042699991611,
              -27.4894000029078
            ],
            [
              29.6992900024317,
              -27.4503399993914
            ],
            [
              29.7586799856928,
              -27.442570015194
            ],
            [
              29.8106899865537,
              -27.4447699808499
            ],
            [
              29.8401899988694,
              -27.3789899817023
            ],
            [
              29.8991399770001,
              -27.385490028
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Dr Pixley Ka Isaka Seme Local Municipality",
        "Code": "MP304",
        "Parent_cod": "DC30",
        "Area": 522721
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              31.2743299800001,
              -27.243170021
            ],
            [
              31.1505500018811,
              -27.2020800027899
            ],
            [
              31.0613299973815,
              -27.0962900057791
            ],
            [
              30.9847599970762,
              -27.0369800019255
            ],
            [
              30.9583260029427,
              -26.9921289975551
            ],
            [
              30.9735599949978,
              -26.90821000189
            ],
            [
              30.9074199999331,
              -26.8599299985705
            ],
            [
              30.8872849986039,
              -26.8035849992482
            ],
            [
              30.8132199987041,
              -26.8444800037491
            ],
            [
              30.7907999981215,
              -26.7122899970857
            ],
            [
              30.7918099997318,
              -26.5691099989273
            ],
            [
              30.8002600017977,
              -26.5040599992695
            ],
            [
              30.7179199962109,
              -26.4857900012075
            ],
            [
              30.7268099987825,
              -26.5085899968308
            ],
            [
              30.6663019981387,
              -26.5404089991759
            ],
            [
              30.6294500002174,
              -26.5050399976977
            ],
            [
              30.5610600030168,
              -26.5057200029757
            ],
            [
              30.4689500010417,
              -26.5585999998901
            ],
            [
              30.5434725400257,
              -26.6437455224379
            ],
            [
              30.544490003311,
              -26.7123500025505
            ],
            [
              30.5130300040315,
              -26.7339900004381
            ],
            [
              30.3894900023618,
              -26.7677400027988
            ],
            [
              30.3868599970912,
              -26.7681299956028
            ],
            [
              30.3404199967855,
              -26.7748999984361
            ],
            [
              30.3227500039096,
              -26.8242400020745
            ],
            [
              30.2507600007735,
              -26.8247599963767
            ],
            [
              30.2437000025531,
              -26.85984999668
            ],
            [
              30.2719400008304,
              -26.9508699960534
            ],
            [
              30.2711199971901,
              -27.0095100022848
            ],
            [
              30.295749998064,
              -27.0161600013829
            ],
            [
              30.3606780091828,
              -26.9700490000612
            ],
            [
              30.3994799990028,
              -27.021520001247
            ],
            [
              30.3805800105591,
              -27.117039995899
            ],
            [
              30.3154599995794,
              -27.1462600006984
            ],
            [
              30.3280699947345,
              -27.1839200017067
            ],
            [
              30.3990100043083,
              -27.2070799968444
            ],
            [
              30.4484899991142,
              -27.2071999987809
            ],
            [
              30.4997400017997,
              -27.1708900015723
            ],
            [
              30.5669100029943,
              -27.1695100026844
            ],
            [
              30.5022600028969,
              -27.2835499988333
            ],
            [
              30.52704999676,
              -27.31574998997
            ],
            [
              30.5877399887096,
              -27.3229499811567
            ],
            [
              30.6606199906202,
              -27.2879200097006
            ],
            [
              30.7067999897278,
              -27.2832899868434
            ],
            [
              30.7909899817023,
              -27.3184500209517
            ],
            [
              30.8296799888404,
              -27.3501499818361
            ],
            [
              30.897629990032,
              -27.30919001121
            ],
            [
              30.8978099866416,
              -27.3089899831012
            ],
            [
              30.9557899894165,
              -27.3597099829293
            ],
            [
              31.1009599876134,
              -27.3357600206085
            ],
            [
              31.1408650238018,
              -27.3626599795743
            ],
            [
              31.1658699916069,
              -27.368520013288
            ],
            [
              31.2743299800001,
              -27.243170021
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Mkhondo Local Municipality",
        "Code": "MP303",
        "Parent_cod": "DC30",
        "Area": 490052
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              18.8084506993403,
              -29.8316707613965
            ],
            [
              18.7991790766531,
              -29.7605209345934
            ],
            [
              18.7610893247126,
              -29.6756401059061
            ],
            [
              18.7272701258157,
              -29.67334937977
            ],
            [
              18.770210265991,
              -29.5938796998882
            ],
            [
              18.7766495170616,
              -29.4835762177682
            ],
            [
              18.737040005292,
              -29.4923000049413
            ],
            [
              18.7486700002204,
              -29.4180600005685
            ],
            [
              18.6510000026481,
              -29.4217299962423
            ],
            [
              18.6322800063173,
              -29.3540699967329
            ],
            [
              18.6429499983438,
              -29.2180100013604
            ],
            [
              18.5955100022848,
              -29.1384899981149
            ],
            [
              18.6195200051442,
              -29.0180700054264
            ],
            [
              18.606329996732,
              -28.9640299972865
            ],
            [
              18.5430400062913,
              -28.9616000021384
            ],
            [
              18.5120800039891,
              -28.889480003799
            ],
            [
              18.4234699970428,
              -28.9008200033404
            ],
            [
              18.3508200030408,
              -28.8807500023107
            ],
            [
              18.2773371549857,
              -28.8814409109692
            ],
            [
              18.193829999355,
              -28.915270003308
            ],
            [
              18.0792400003258,
              -28.8699300069642
            ],
            [
              18.046069994135,
              -28.8742699930657
            ],
            [
              17.9722399978776,
              -28.7916199983642
            ],
            [
              17.9256500023458,
              -28.7688399955693
            ],
            [
              17.7357700062808,
              -28.756699996008
            ],
            [
              17.6984500146565,
              -28.7462300042113
            ],
            [
              17.6474500028155,
              -28.7737600003237
            ],
            [
              17.6186799980835,
              -28.7641600072785
            ],
            [
              17.5988600031866,
              -28.6946499970996
            ],
            [
              17.4936699960735,
              -28.6927899958615
            ],
            [
              17.4187089953239,
              -28.7219810020216
            ],
            [
              17.3490090006649,
              -28.7944569942948
            ],
            [
              17.4622069975549,
              -28.854527002619
            ],
            [
              17.4604599997293,
              -29.0276800061274
            ],
            [
              17.5405899960315,
              -29.3376300003242
            ],
            [
              17.5653400033385,
              -29.3978600043357
            ],
            [
              17.5208500057232,
              -29.4374300052905
            ],
            [
              17.468120004035,
              -29.4199799991776
            ],
            [
              17.369809999432,
              -29.4178399931212
            ],
            [
              17.3264200003828,
              -29.4043300050257
            ],
            [
              17.3574499987185,
              -29.3279500017912
            ],
            [
              17.2998899973256,
              -29.3044799941563
            ],
            [
              17.2382100010907,
              -29.2406700004202
            ],
            [
              17.1672599982504,
              -29.2728499951311
            ],
            [
              17.174830004701,
              -29.3027199984292
            ],
            [
              17.0916199985641,
              -29.3338300022527
            ],
            [
              17.1039600001539,
              -29.3753100013555
            ],
            [
              17.0867700006351,
              -29.4436999967574
            ],
            [
              17.0372900022319,
              -29.500720011919
            ],
            [
              16.9946099999516,
              -29.5150050015796
            ],
            [
              17.0007299988904,
              -29.5759600021523
            ],
            [
              17.0340400061414,
              -29.6165299970617
            ],
            [
              17.076659994863,
              -29.8154000012091
            ],
            [
              17.1125499996828,
              -29.9145100004361
            ],
            [
              17.1551199977897,
              -29.9757999948738
            ],
            [
              17.1810000023483,
              -30.0617300014384
            ],
            [
              17.2472400002259,
              -30.0031800047534
            ],
            [
              17.3122400047724,
              -30.0928399971681
            ],
            [
              17.3961300008989,
              -30.0189399949848
            ],
            [
              17.4391299990502,
              -30.0330899991041
            ],
            [
              17.5192399953296,
              -29.9498700006
            ],
            [
              17.5616500004472,
              -30.0471499981739
            ],
            [
              17.6038799945662,
              -30.0124900024117
            ],
            [
              17.732490003411,
              -30.0207199997281
            ],
            [
              17.7791099976283,
              -30.054319996071
            ],
            [
              17.8636000034374,
              -30.0666899963463
            ],
            [
              17.8877800078411,
              -30.0386499947015
            ],
            [
              17.9591099958297,
              -30.0286899994439
            ],
            [
              18.0000100023598,
              -30.0658999940894
            ],
            [
              18.1271900001184,
              -30.0165099998366
            ],
            [
              18.2088037923612,
              -30.0005538827555
            ],
            [
              18.2190247933596,
              -29.9110093516003
            ],
            [
              18.333249994092,
              -29.8955999944441
            ],
            [
              18.3671200046845,
              -29.9348000008194
            ],
            [
              18.4936599729294,
              -29.9180793763621
            ],
            [
              18.5618896479889,
              -29.8930492401302
            ],
            [
              18.6054899966661,
              -29.8604100021198
            ],
            [
              18.7255964946825,
              -29.8641086394022
            ],
            [
              18.8084506993403,
              -29.8316707613965
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Nama Khoi Local Municipality",
        "Code": "NC062",
        "Parent_cod": "DC6",
        "Area": 1799041
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              26.4146400010353,
              -28.0921300025975
            ],
            [
              26.4726300042714,
              -28.0782899965861
            ],
            [
              26.5096799951357,
              -27.9932200036003
            ],
            [
              26.5054800011012,
              -27.9520899972555
            ],
            [
              26.5487600031717,
              -27.873959998755
            ],
            [
              26.5557099972186,
              -27.7905300049557
            ],
            [
              26.5152200033005,
              -27.7869699999655
            ],
            [
              26.5608799910188,
              -27.7240800018906
            ],
            [
              26.6362999994454,
              -27.6590800009413
            ],
            [
              26.741930000769,
              -27.693630003322
            ],
            [
              26.8366299998746,
              -27.6229600017026
            ],
            [
              26.8577100016153,
              -27.5860000032975
            ],
            [
              26.7633200114095,
              -27.5642500093304
            ],
            [
              26.7536799994325,
              -27.5140000023981
            ],
            [
              26.7897199967805,
              -27.510839987975
            ],
            [
              26.7463199999681,
              -27.3953400000409
            ],
            [
              26.6990300018331,
              -27.4007800017956
            ],
            [
              26.6959799996773,
              -27.3497599971261
            ],
            [
              26.7379899998387,
              -27.3449000032325
            ],
            [
              26.7275899896863,
              -27.2308100002812
            ],
            [
              26.6830999983663,
              -27.1902600008983
            ],
            [
              26.6352499968899,
              -27.1715699996558
            ],
            [
              26.5754100000715,
              -27.1833199983192
            ],
            [
              26.5216199989638,
              -27.1043899997986
            ],
            [
              26.4736299991252,
              -27.1537599994244
            ],
            [
              26.4199000025831,
              -27.1713599971661
            ],
            [
              26.4432799988729,
              -27.2170200019715
            ],
            [
              26.4967699978372,
              -27.2649599950077
            ],
            [
              26.4230900040005,
              -27.4068699993509
            ],
            [
              26.3451600012331,
              -27.3854299980959
            ],
            [
              26.3083999976618,
              -27.4177600006235
            ],
            [
              26.2677499999626,
              -27.4163099976083
            ],
            [
              26.2204100031192,
              -27.473000003847
            ],
            [
              26.2272400024242,
              -27.5134099958746
            ],
            [
              26.1255100001864,
              -27.5647800103892
            ],
            [
              26.0749599992046,
              -27.6210299990352
            ],
            [
              26.0550599988199,
              -27.6700600027669
            ],
            [
              26.0758400002158,
              -27.7106500030951
            ],
            [
              26.1254760004171,
              -27.8185669992676
            ],
            [
              26.1629400031787,
              -27.8602500023357
            ],
            [
              26.2174000028079,
              -27.8830800002418
            ],
            [
              26.1831600003337,
              -27.9418499980789
            ],
            [
              26.188231002159,
              -28.0013180029234
            ],
            [
              26.3350100008109,
              -28.0527199982292
            ],
            [
              26.3546699973226,
              -28.0860200023212
            ],
            [
              26.4146400010353,
              -28.0921300025975
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Nala Local Municipality",
        "Code": "FS185",
        "Parent_cod": "DC18",
        "Area": 412879
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              30.2507600007735,
              -26.8247599963767
            ],
            [
              30.3227500039096,
              -26.8242400020745
            ],
            [
              30.3404199967855,
              -26.7748999984361
            ],
            [
              30.3868599970912,
              -26.7681299956028
            ],
            [
              30.3894900023618,
              -26.7677400027988
            ],
            [
              30.5130300040315,
              -26.7339900004381
            ],
            [
              30.544490003311,
              -26.7123500025505
            ],
            [
              30.5434725400257,
              -26.6437455224379
            ],
            [
              30.4689500010417,
              -26.5585999998901
            ],
            [
              30.5610600030168,
              -26.5057200029757
            ],
            [
              30.6294500002174,
              -26.5050399976977
            ],
            [
              30.6663019981387,
              -26.5404089991759
            ],
            [
              30.7268099987825,
              -26.5085899968308
            ],
            [
              30.7179199962109,
              -26.4857900012075
            ],
            [
              30.6986900123342,
              -26.4445700033029
            ],
            [
              30.7486800027799,
              -26.3745100037336
            ],
            [
              30.7555209971963,
              -26.3327730035712
            ],
            [
              30.6885799966696,
              -26.306110000676
            ],
            [
              30.6107300038866,
              -26.3169500041394
            ],
            [
              30.624160002682,
              -26.2587700029332
            ],
            [
              30.5927599998742,
              -26.2079900030361
            ],
            [
              30.4795599965966,
              -26.2253600027619
            ],
            [
              30.3580200044197,
              -26.170690000643
            ],
            [
              30.2094699987415,
              -26.2201300025975
            ],
            [
              30.0618549966109,
              -26.2096030009777
            ],
            [
              30.0489100021948,
              -26.192359999914
            ],
            [
              29.9690600017178,
              -26.2433600009632
            ],
            [
              29.9411000019636,
              -26.216639999936
            ],
            [
              29.8446999982064,
              -26.2216299971266
            ],
            [
              29.8046899976453,
              -26.1895100033839
            ],
            [
              29.7588400029639,
              -26.2254100023697
            ],
            [
              29.7153599970663,
              -26.2038499991781
            ],
            [
              29.6676299984257,
              -26.2446400024341
            ],
            [
              29.5942800009213,
              -26.2397899982098
            ],
            [
              29.5403500005521,
              -26.2538799977637
            ],
            [
              29.4702900018821,
              -26.3032099964441
            ],
            [
              29.4686699982219,
              -26.3524900027115
            ],
            [
              29.5661800019056,
              -26.4427500039095
            ],
            [
              29.6034000024082,
              -26.4350000107419
            ],
            [
              29.6279899951423,
              -26.4744299962473
            ],
            [
              29.6288999984362,
              -26.4806500006969
            ],
            [
              29.6191699948994,
              -26.5290599983202
            ],
            [
              29.6395799981185,
              -26.5297340024223
            ],
            [
              29.6403500030503,
              -26.6279099990472
            ],
            [
              29.8226440018193,
              -26.6693659961438
            ],
            [
              29.8699100069413,
              -26.6501500003222
            ],
            [
              29.8429599998042,
              -26.7994600041758
            ],
            [
              29.9210298111769,
              -26.7786312901019
            ],
            [
              29.9212699976124,
              -26.7784899976153
            ],
            [
              29.9637599992246,
              -26.7706700021188
            ],
            [
              29.9948100011807,
              -26.6977200041749
            ],
            [
              30.111160004031,
              -26.7363200017666
            ],
            [
              30.1379400006306,
              -26.8348200043397
            ],
            [
              30.1889800017258,
              -26.8169800009263
            ],
            [
              30.2507600007735,
              -26.8247599963767
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Msukaligwa Local Municipality",
        "Code": "MP302",
        "Parent_cod": "DC30",
        "Area": 600341
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              27.3878699993011,
              -28.2140800019905
            ],
            [
              27.3700500013065,
              -28.1702699988613
            ],
            [
              27.4067900003583,
              -28.1049900011875
            ],
            [
              27.4717999990708,
              -28.1070900062988
            ],
            [
              27.433770000785,
              -28.0497599957272
            ],
            [
              27.3634500000176,
              -28.0014599878881
            ],
            [
              27.358982001718,
              -27.9324529991066
            ],
            [
              27.3007700044322,
              -27.9606600021573
            ],
            [
              27.2922099981929,
              -27.9229799966295
            ],
            [
              27.1927799967994,
              -27.8997499991631
            ],
            [
              27.157790002007,
              -27.9333399977427
            ],
            [
              27.0525000028729,
              -27.8593100039534
            ],
            [
              27.040869998052,
              -27.8090600042158
            ],
            [
              27.0771500001724,
              -27.789149997974
            ],
            [
              27.044769998037,
              -27.749099997367
            ],
            [
              26.9699400042278,
              -27.6944499988683
            ],
            [
              26.9744899991142,
              -27.6429099998965
            ],
            [
              27.0163299968319,
              -27.598240001175
            ],
            [
              26.9663100032042,
              -27.5625399979225
            ],
            [
              26.950050003405,
              -27.5225000031726
            ],
            [
              26.8703599977158,
              -27.5337899968109
            ],
            [
              26.8577100016153,
              -27.5860000032975
            ],
            [
              26.8366299998746,
              -27.6229600017026
            ],
            [
              26.741930000769,
              -27.693630003322
            ],
            [
              26.6362999994454,
              -27.6590800009413
            ],
            [
              26.5608799910188,
              -27.7240800018906
            ],
            [
              26.5152200033005,
              -27.7869699999655
            ],
            [
              26.5557099972186,
              -27.7905300049557
            ],
            [
              26.5487600031717,
              -27.873959998755
            ],
            [
              26.5054800011012,
              -27.9520899972555
            ],
            [
              26.5096799951357,
              -27.9932200036003
            ],
            [
              26.4726300042714,
              -28.0782899965861
            ],
            [
              26.4146400010353,
              -28.0921300025975
            ],
            [
              26.4083000018437,
              -28.1239199991086
            ],
            [
              26.4670799983433,
              -28.2121800007065
            ],
            [
              26.416980002825,
              -28.2298200002927
            ],
            [
              26.4051115346697,
              -28.2787905966087
            ],
            [
              26.4231500013715,
              -28.3126999966076
            ],
            [
              26.5380000015988,
              -28.2909900053844
            ],
            [
              26.6096699989713,
              -28.3052399916323
            ],
            [
              26.6393710016705,
              -28.2181440032431
            ],
            [
              26.6888599977907,
              -28.2346400022342
            ],
            [
              26.74118999812,
              -28.2857900003082
            ],
            [
              26.7675300032071,
              -28.2290500025555
            ],
            [
              26.876839996169,
              -28.1689450034091
            ],
            [
              26.8850400037932,
              -28.2228100016802
            ],
            [
              26.9632899970357,
              -28.2762000032276
            ],
            [
              26.9785500010817,
              -28.3451600006335
            ],
            [
              26.9490800018407,
              -28.3827899993589
            ],
            [
              27.0749700021639,
              -28.4076900000934
            ],
            [
              27.106459997431,
              -28.4017800027448
            ],
            [
              27.1373100027545,
              -28.4766700020189
            ],
            [
              27.1874400005556,
              -28.4822900039804
            ],
            [
              27.1567300007889,
              -28.5582900031811
            ],
            [
              27.2122120997086,
              -28.5779882640471
            ],
            [
              27.2711874028764,
              -28.5097248823974
            ],
            [
              27.2889697750352,
              -28.4575383266324
            ],
            [
              27.2659087880602,
              -28.3770049061515
            ],
            [
              27.2768314392197,
              -28.2827789999508
            ],
            [
              27.3262399981774,
              -28.2264599991296
            ],
            [
              27.3878699993011,
              -28.2140800019905
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Matjhabeng Local Municipality",
        "Code": "FS184",
        "Parent_cod": "DC18",
        "Area": 569040
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              30.8002600017977,
              -26.5040599992695
            ],
            [
              30.831010003409,
              -26.4111700008948
            ],
            [
              30.8918600009383,
              -26.3208200009423
            ],
            [
              30.9614379962665,
              -26.2617320001317
            ],
            [
              31.0710399963988,
              -26.0673100005561
            ],
            [
              31.1127500016114,
              -25.9825699958086
            ],
            [
              31.1265700031033,
              -25.9211499971747
            ],
            [
              31.0556909972417,
              -25.9239209981555
            ],
            [
              31.0395199988489,
              -25.8662600028967
            ],
            [
              30.9680999968175,
              -25.9347600042707
            ],
            [
              30.8498600003388,
              -25.9263400035883
            ],
            [
              30.8230599983203,
              -25.8765199975997
            ],
            [
              30.7736499986486,
              -25.861939990738
            ],
            [
              30.7326500009968,
              -25.741350001901
            ],
            [
              30.6466299947785,
              -25.7124200086764
            ],
            [
              30.6111900089118,
              -25.7190200009722
            ],
            [
              30.5586400083298,
              -25.7682599990997
            ],
            [
              30.5192999990957,
              -25.728550000682
            ],
            [
              30.4863799981384,
              -25.7621999984311
            ],
            [
              30.5148500016263,
              -25.7879100041433
            ],
            [
              30.3811499963752,
              -25.8868999960379
            ],
            [
              30.3311099982279,
              -25.8805400013199
            ],
            [
              30.2990500018562,
              -25.926379997339
            ],
            [
              30.2434400022544,
              -25.8721100100688
            ],
            [
              30.2703999990608,
              -25.8253700013245
            ],
            [
              30.2137500018612,
              -25.8040199988238
            ],
            [
              30.2008299987055,
              -25.8364299960475
            ],
            [
              30.1497099957198,
              -25.8297199995783
            ],
            [
              30.0866880032488,
              -25.8602939975699
            ],
            [
              29.9898800031597,
              -25.8836599968113
            ],
            [
              29.9437500036598,
              -25.9056600014079
            ],
            [
              29.8617900012076,
              -25.8624500025655
            ],
            [
              29.830569996808,
              -25.9219299998696
            ],
            [
              29.8769599984052,
              -25.96521000194
            ],
            [
              29.8657899986096,
              -26.0139299985706
            ],
            [
              29.8110599991197,
              -26.1052999987959
            ],
            [
              29.8046899976453,
              -26.1895100033839
            ],
            [
              29.8446999982064,
              -26.2216299971266
            ],
            [
              29.9411000019636,
              -26.216639999936
            ],
            [
              29.9690600017178,
              -26.2433600009632
            ],
            [
              30.0489100021948,
              -26.192359999914
            ],
            [
              30.0618549966109,
              -26.2096030009777
            ],
            [
              30.2094699987415,
              -26.2201300025975
            ],
            [
              30.3580200044197,
              -26.170690000643
            ],
            [
              30.4795599965966,
              -26.2253600027619
            ],
            [
              30.5927599998742,
              -26.2079900030361
            ],
            [
              30.624160002682,
              -26.2587700029332
            ],
            [
              30.6107300038866,
              -26.3169500041394
            ],
            [
              30.6885799966696,
              -26.306110000676
            ],
            [
              30.7555209971963,
              -26.3327730035712
            ],
            [
              30.7486800027799,
              -26.3745100037336
            ],
            [
              30.6986900123342,
              -26.4445700033029
            ],
            [
              30.7179199962109,
              -26.4857900012075
            ],
            [
              30.8002600017977,
              -26.5040599992695
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Chief Albert Luthuli Local Municipality",
        "Code": "MP301",
        "Parent_cod": "DC30",
        "Area": 555329
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              26.4146400010353,
              -28.0921300025975
            ],
            [
              26.3546699973226,
              -28.0860200023212
            ],
            [
              26.3350100008109,
              -28.0527199982292
            ],
            [
              26.188231002159,
              -28.0013180029234
            ],
            [
              26.1831600003337,
              -27.9418499980789
            ],
            [
              26.2174000028079,
              -27.8830800002418
            ],
            [
              26.1629400031787,
              -27.8602500023357
            ],
            [
              26.1254760004171,
              -27.8185669992676
            ],
            [
              26.0758400002158,
              -27.7106500030951
            ],
            [
              26.0261900029663,
              -27.7346999970073
            ],
            [
              26.0031799976588,
              -27.7080500001074
            ],
            [
              26.0022899979851,
              -27.6488899932785
            ],
            [
              25.9268799972141,
              -27.6038700008998
            ],
            [
              25.8526099968539,
              -27.6209800003267
            ],
            [
              25.8302399958791,
              -27.5661900025666
            ],
            [
              25.6774200019316,
              -27.6307899967609
            ],
            [
              25.65780000007,
              -27.6948599970912
            ],
            [
              25.5966099985526,
              -27.6550699967828
            ],
            [
              25.555830002053,
              -27.6866599975608
            ],
            [
              25.479430003292,
              -27.6933800007863
            ],
            [
              25.3640299965871,
              -27.7505400008204
            ],
            [
              25.3235299968119,
              -27.793790000608
            ],
            [
              25.3492100011407,
              -27.8502400011751
            ],
            [
              25.4194500000175,
              -27.9190600011181
            ],
            [
              25.5174699993411,
              -27.9863600020124
            ],
            [
              25.6260700009298,
              -28.0387699961384
            ],
            [
              25.5863899958017,
              -28.1057199970802
            ],
            [
              25.6596900026916,
              -28.135600002638
            ],
            [
              25.7070100040085,
              -28.1278199990937
            ],
            [
              25.7336900031911,
              -28.1782300017132
            ],
            [
              25.6878099981329,
              -28.2142399967784
            ],
            [
              25.7640599998692,
              -28.2531299996497
            ],
            [
              25.7068100001814,
              -28.2775300034069
            ],
            [
              25.7232999988959,
              -28.3612400020244
            ],
            [
              25.7648999999351,
              -28.4148200006425
            ],
            [
              25.8433899979501,
              -28.479919999908
            ],
            [
              25.9445499990832,
              -28.5271299961524
            ],
            [
              25.9951499996727,
              -28.49738999795
            ],
            [
              26.0331299992501,
              -28.5057999909768
            ],
            [
              26.0335699988564,
              -28.5862699993609
            ],
            [
              26.1478999975868,
              -28.55789999329
            ],
            [
              26.2190689997346,
              -28.4688469982903
            ],
            [
              26.2456899988944,
              -28.4897099999165
            ],
            [
              26.2880400012451,
              -28.4685899972305
            ],
            [
              26.320170000845,
              -28.4196699967729
            ],
            [
              26.4348599990898,
              -28.3689199991586
            ],
            [
              26.4231500013715,
              -28.3126999966076
            ],
            [
              26.4051115346697,
              -28.2787905966087
            ],
            [
              26.416980002825,
              -28.2298200002927
            ],
            [
              26.4670799983433,
              -28.2121800007065
            ],
            [
              26.4083000018437,
              -28.1239199991086
            ],
            [
              26.4146400010353,
              -28.0921300025975
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Tswelopele Local Municipality",
        "Code": "FS183",
        "Parent_cod": "DC18",
        "Area": 653346
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              24.8018269997163,
              -28.8282580044033
            ],
            [
              24.8110400009953,
              -28.9130799967444
            ],
            [
              24.869149998074,
              -28.8946699931257
            ],
            [
              24.9593000022933,
              -28.9448600035862
            ],
            [
              25.0059399983323,
              -28.908100000015
            ],
            [
              25.0855599998941,
              -28.9076100008008
            ],
            [
              25.1121900003683,
              -28.961339997343
            ],
            [
              25.1701900013675,
              -28.9474099988724
            ],
            [
              25.2405699977073,
              -28.9071600016327
            ],
            [
              25.3346800001819,
              -28.8946799989828
            ],
            [
              25.3900399972481,
              -28.9168200019416
            ],
            [
              25.4577600031217,
              -28.8964999992755
            ],
            [
              25.5293700031232,
              -28.8525300013585
            ],
            [
              25.6259700026136,
              -28.8939799981783
            ],
            [
              25.7452600016478,
              -28.9064000025581
            ],
            [
              25.8563100091996,
              -28.8676300034219
            ],
            [
              25.8541300030972,
              -28.8156700003701
            ],
            [
              25.8786699971227,
              -28.7600599989698
            ],
            [
              25.9769499967451,
              -28.615439997358
            ],
            [
              26.0335699988564,
              -28.5862699993609
            ],
            [
              26.0331299992501,
              -28.5057999909768
            ],
            [
              25.9951499996727,
              -28.49738999795
            ],
            [
              25.9445499990832,
              -28.5271299961524
            ],
            [
              25.8433899979501,
              -28.479919999908
            ],
            [
              25.7648999999351,
              -28.4148200006425
            ],
            [
              25.7232999988959,
              -28.3612400020244
            ],
            [
              25.7068100001814,
              -28.2775300034069
            ],
            [
              25.7640599998692,
              -28.2531299996497
            ],
            [
              25.6878099981329,
              -28.2142399967784
            ],
            [
              25.7336900031911,
              -28.1782300017132
            ],
            [
              25.7070100040085,
              -28.1278199990937
            ],
            [
              25.6596900026916,
              -28.135600002638
            ],
            [
              25.5863899958017,
              -28.1057199970802
            ],
            [
              25.6260700009298,
              -28.0387699961384
            ],
            [
              25.5174699993411,
              -27.9863600020124
            ],
            [
              25.4194500000175,
              -27.9190600011181
            ],
            [
              25.3492100011407,
              -27.8502400011751
            ],
            [
              25.3235299968119,
              -27.793790000608
            ],
            [
              25.2774100031691,
              -27.7953199956213
            ],
            [
              25.238070002029,
              -27.8370499990581
            ],
            [
              25.2497200023762,
              -27.8686499975993
            ],
            [
              25.2009400011802,
              -27.886589999329
            ],
            [
              25.0906000020885,
              -27.9840299988853
            ],
            [
              25.1049399969833,
              -28.0166899905506
            ],
            [
              25.0746500093905,
              -28.0642499957407
            ],
            [
              25.0280800003917,
              -28.0734800023002
            ],
            [
              24.9645699944097,
              -28.2507399991516
            ],
            [
              24.9266799980835,
              -28.2468999947389
            ],
            [
              24.8903299972316,
              -28.3102300014134
            ],
            [
              24.9376199890712,
              -28.3249199899655
            ],
            [
              24.8993299958827,
              -28.430469999291
            ],
            [
              24.8468900012725,
              -28.5037699980869
            ],
            [
              24.8678199978946,
              -28.5170599976208
            ],
            [
              24.8277299963423,
              -28.6269599971061
            ],
            [
              24.9018400001159,
              -28.6480300010836
            ],
            [
              24.8018269997163,
              -28.8282580044033
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Tokologo Local Municipality",
        "Code": "FS182",
        "Parent_cod": "DC18",
        "Area": 931650
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              27.2122120997086,
              -28.5779882640471
            ],
            [
              27.1567300007889,
              -28.5582900031811
            ],
            [
              27.1874400005556,
              -28.4822900039804
            ],
            [
              27.1373100027545,
              -28.4766700020189
            ],
            [
              27.106459997431,
              -28.4017800027448
            ],
            [
              27.0749700021639,
              -28.4076900000934
            ],
            [
              26.9490800018407,
              -28.3827899993589
            ],
            [
              26.9785500010817,
              -28.3451600006335
            ],
            [
              26.9632899970357,
              -28.2762000032276
            ],
            [
              26.8850400037932,
              -28.2228100016802
            ],
            [
              26.876839996169,
              -28.1689450034091
            ],
            [
              26.7675300032071,
              -28.2290500025555
            ],
            [
              26.74118999812,
              -28.2857900003082
            ],
            [
              26.6888599977907,
              -28.2346400022342
            ],
            [
              26.6393710016705,
              -28.2181440032431
            ],
            [
              26.6096699989713,
              -28.3052399916323
            ],
            [
              26.5380000015988,
              -28.2909900053844
            ],
            [
              26.4231500013715,
              -28.3126999966076
            ],
            [
              26.4348599990898,
              -28.3689199991586
            ],
            [
              26.320170000845,
              -28.4196699967729
            ],
            [
              26.2880400012451,
              -28.4685899972305
            ],
            [
              26.2456899988944,
              -28.4897099999165
            ],
            [
              26.2190689997346,
              -28.4688469982903
            ],
            [
              26.1478999975868,
              -28.55789999329
            ],
            [
              26.0335699988564,
              -28.5862699993609
            ],
            [
              25.9769499967451,
              -28.615439997358
            ],
            [
              25.8786699971227,
              -28.7600599989698
            ],
            [
              25.9307799971992,
              -28.7711300013484
            ],
            [
              25.9265400022194,
              -28.8265299993599
            ],
            [
              26.0200333782379,
              -28.7998571992503
            ],
            [
              26.0330538932226,
              -28.7407745781842
            ],
            [
              26.0130659454371,
              -28.7150560666841
            ],
            [
              26.0425399601511,
              -28.6666156602844
            ],
            [
              26.0983759054237,
              -28.6650594536308
            ],
            [
              26.1488800166995,
              -28.7607305793527
            ],
            [
              26.0999268933115,
              -28.7683681518687
            ],
            [
              26.1652799959751,
              -28.8545700010047
            ],
            [
              26.2338199982943,
              -28.8808999993355
            ],
            [
              26.2806700040175,
              -28.940369997977
            ],
            [
              26.3349799994275,
              -28.9011700041923
            ],
            [
              26.3661799984082,
              -28.9625000031726
            ],
            [
              26.4030600039161,
              -28.9891950039462
            ],
            [
              26.4719300016683,
              -28.9480299995848
            ],
            [
              26.5173500017013,
              -28.983119999888
            ],
            [
              26.566949999343,
              -28.9680800041888
            ],
            [
              26.6343400007905,
              -29.0596500001474
            ],
            [
              26.7163900037957,
              -29.0723799981384
            ],
            [
              26.7790200078671,
              -29.0158199915993
            ],
            [
              26.7526900104357,
              -29.003049992663
            ],
            [
              26.8181300109912,
              -28.9271399931162
            ],
            [
              26.8537299997398,
              -28.8862800037191
            ],
            [
              26.9110899973055,
              -28.7683300017282
            ],
            [
              26.9469900025866,
              -28.7502600011981
            ],
            [
              27.02968000273,
              -28.7438899988243
            ],
            [
              27.0462699988615,
              -28.7699099972486
            ],
            [
              27.1521700000455,
              -28.7566000003897
            ],
            [
              27.1863050021742,
              -28.8052629988882
            ],
            [
              27.1702400023743,
              -28.7597300026375
            ],
            [
              27.1966400039331,
              -28.7335199990486
            ],
            [
              27.1900799963948,
              -28.6676399970881
            ],
            [
              27.2127099985677,
              -28.6264900024116
            ],
            [
              27.2122120997086,
              -28.5779882640471
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Masilonyana Local Municipality",
        "Code": "FS181",
        "Parent_cod": "DC18",
        "Area": 661782
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              27.5690900016023,
              -26.6471600036312
            ],
            [
              27.454829998006,
              -26.6303300018281
            ],
            [
              27.4257590009772,
              -26.6494680003479
            ],
            [
              27.3783499982539,
              -26.6106799976837
            ],
            [
              27.2418699979021,
              -26.6364600003287
            ],
            [
              27.2283599972161,
              -26.5710500011566
            ],
            [
              27.1826370029954,
              -26.5746199958161
            ],
            [
              27.158760002672,
              -26.525419998634
            ],
            [
              27.2314210016779,
              -26.5054809955514
            ],
            [
              27.2248499990283,
              -26.4439699999155
            ],
            [
              27.1879519998849,
              -26.3778629991781
            ],
            [
              27.2348100005811,
              -26.3382699953639
            ],
            [
              27.330048002913,
              -26.2818260022682
            ],
            [
              27.3300710003764,
              -26.2818149990629
            ],
            [
              27.2914099981729,
              -26.1446200044096
            ],
            [
              27.3582599927045,
              -26.1546100001514
            ],
            [
              27.3617200002778,
              -26.1156699985715
            ],
            [
              27.3262399981774,
              -26.1007200088214
            ],
            [
              27.1698499996778,
              -26.0802299974164
            ],
            [
              27.1420299991852,
              -26.100689999344
            ],
            [
              27.0537800043438,
              -26.100689999344
            ],
            [
              26.9747999990208,
              -26.0650500006569
            ],
            [
              26.9174299955978,
              -26.0711300004491
            ],
            [
              26.8479299993701,
              -26.0596999985561
            ],
            [
              26.807079998743,
              -26.0840299990852
            ],
            [
              26.7331100014255,
              -26.1015700003552
            ],
            [
              26.7092399978277,
              -26.0475599989947
            ],
            [
              26.6176510027916,
              -26.0648670021104
            ],
            [
              26.6296400088793,
              -26.1361300013984
            ],
            [
              26.5457799970493,
              -26.1726999980064
            ],
            [
              26.586130000699,
              -26.2451999967824
            ],
            [
              26.5346899991442,
              -26.2641900010677
            ],
            [
              26.558440781417,
              -26.3404183938937
            ],
            [
              26.483649998049,
              -26.3864199980844
            ],
            [
              26.4584399983073,
              -26.4351300041463
            ],
            [
              26.4604011732756,
              -26.4838395956208
            ],
            [
              26.5303799937417,
              -26.5180699978321
            ],
            [
              26.5648400036633,
              -26.5018099971336
            ],
            [
              26.6311900012176,
              -26.5159799985781
            ],
            [
              26.6946699968229,
              -26.5586800017806
            ],
            [
              26.7047599989749,
              -26.6124800006515
            ],
            [
              26.7830100003113,
              -26.6110900040004
            ],
            [
              26.7803300044262,
              -26.6896999958581
            ],
            [
              26.8119599971562,
              -26.689149999273
            ],
            [
              26.7943472218469,
              -26.7672272930051
            ],
            [
              26.8441231061965,
              -26.7729296063163
            ],
            [
              26.8502224297214,
              -26.816509534987
            ],
            [
              26.897990002037,
              -26.8289300034168
            ],
            [
              26.8664400022044,
              -26.9190600031166
            ],
            [
              26.9086800003817,
              -26.9457100000165
            ],
            [
              26.9472200095958,
              -26.8920099985625
            ],
            [
              27.0139299976713,
              -26.9320500023057
            ],
            [
              27.1134300022928,
              -26.9263599971161
            ],
            [
              27.1736600009083,
              -26.9675900017772
            ],
            [
              27.2191600019326,
              -26.9443599962168
            ],
            [
              27.306050003305,
              -26.853339995944
            ],
            [
              27.3894850000328,
              -26.906384999568
            ],
            [
              27.4185899968309,
              -26.9238600014379
            ],
            [
              27.4760400012451,
              -26.8834900013624
            ],
            [
              27.5117500022608,
              -26.8365100031341
            ],
            [
              27.5173599965666,
              -26.7819700007149
            ],
            [
              27.5825899973305,
              -26.7689000014339
            ],
            [
              27.5904299973466,
              -26.7383600032115
            ],
            [
              27.5690900016023,
              -26.6471600036312
            ]
          ]
        ]
      },
      "properties": {
        "Name": "JB Marks Local Municipality",
        "Code": "NW405",
        "Parent_cod": "DC40",
        "Area": 639800
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              26.4199000025831,
              -27.1713599971661
            ],
            [
              26.3906100026495,
              -27.1808850020412
            ],
            [
              26.3010899969059,
              -27.0305299985606
            ],
            [
              26.2702499974395,
              -27.0409099969987
            ],
            [
              26.2294900036608,
              -26.9696400000859
            ],
            [
              26.1395799961199,
              -26.9773899932535
            ],
            [
              26.1906400017347,
              -26.9083199979695
            ],
            [
              26.1294100001714,
              -26.8691200032855
            ],
            [
              26.0767600021725,
              -26.8623300049257
            ],
            [
              26.0041899992691,
              -26.8551899976202
            ],
            [
              25.9136699977722,
              -26.9068199971452
            ],
            [
              25.8333100016553,
              -26.9361599957872
            ],
            [
              25.8097099988174,
              -26.9011799987579
            ],
            [
              25.6919199997082,
              -26.9415599965965
            ],
            [
              25.6656299951282,
              -26.962720001127
            ],
            [
              25.6321900079625,
              -26.988569998007
            ],
            [
              25.6871099973285,
              -27.0979699987165
            ],
            [
              25.6163299987305,
              -27.1429000004346
            ],
            [
              25.6537100102089,
              -27.2228399987669
            ],
            [
              25.6743750566636,
              -27.222110529877
            ],
            [
              25.7723000003448,
              -27.2092519998798
            ],
            [
              25.7989800004268,
              -27.2818900023217
            ],
            [
              25.8060399968484,
              -27.2906099961544
            ],
            [
              25.8248019888208,
              -27.3630420025864
            ],
            [
              25.7970300004342,
              -27.3906499986984
            ],
            [
              25.8049799956303,
              -27.4463599966165
            ],
            [
              25.7386699999206,
              -27.469160001233
            ],
            [
              25.7537200032756,
              -27.5344899976153
            ],
            [
              25.8348200011422,
              -27.5117900012075
            ],
            [
              25.8302399958791,
              -27.5661900025666
            ],
            [
              25.8526099968539,
              -27.6209800003267
            ],
            [
              25.9268799972141,
              -27.6038700008998
            ],
            [
              26.0022899979851,
              -27.6488899932785
            ],
            [
              26.0031799976588,
              -27.7080500001074
            ],
            [
              26.0261900029663,
              -27.7346999970073
            ],
            [
              26.0758400002158,
              -27.7106500030951
            ],
            [
              26.0550599988199,
              -27.6700600027669
            ],
            [
              26.0749599992046,
              -27.6210299990352
            ],
            [
              26.1255100001864,
              -27.5647800103892
            ],
            [
              26.2272400024242,
              -27.5134099958746
            ],
            [
              26.2204100031192,
              -27.473000003847
            ],
            [
              26.2677499999626,
              -27.4163099976083
            ],
            [
              26.3083999976618,
              -27.4177600006235
            ],
            [
              26.3451600012331,
              -27.3854299980959
            ],
            [
              26.4230900040005,
              -27.4068699993509
            ],
            [
              26.4967699978372,
              -27.2649599950077
            ],
            [
              26.4432799988729,
              -27.2170200019715
            ],
            [
              26.4199000025831,
              -27.1713599971661
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Maquassi Hills Local Municipality",
        "Code": "NW404",
        "Parent_cod": "DC40",
        "Area": 467062
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              26.5216199989638,
              -27.1043899997986
            ],
            [
              26.5856199969653,
              -27.1060299998845
            ],
            [
              26.5818200033905,
              -27.0531199997881
            ],
            [
              26.621069996783,
              -27.0027200030256
            ],
            [
              26.6718200015919,
              -26.9957300008388
            ],
            [
              26.8050200017717,
              -26.9319799990777
            ],
            [
              26.8664400022044,
              -26.9190600031166
            ],
            [
              26.897990002037,
              -26.8289300034168
            ],
            [
              26.8502224297214,
              -26.816509534987
            ],
            [
              26.8441231061965,
              -26.7729296063163
            ],
            [
              26.7943472218469,
              -26.7672272930051
            ],
            [
              26.8119599971562,
              -26.689149999273
            ],
            [
              26.7803300044262,
              -26.6896999958581
            ],
            [
              26.7830100003113,
              -26.6110900040004
            ],
            [
              26.7047599989749,
              -26.6124800006515
            ],
            [
              26.6946699968229,
              -26.5586800017806
            ],
            [
              26.6311900012176,
              -26.5159799985781
            ],
            [
              26.5648400036633,
              -26.5018099971336
            ],
            [
              26.5303799937417,
              -26.5180699978321
            ],
            [
              26.4604011732756,
              -26.4838395956208
            ],
            [
              26.3849714188959,
              -26.5005871457801
            ],
            [
              26.3337000060505,
              -26.5551599896417
            ],
            [
              26.2481100016753,
              -26.5873199987189
            ],
            [
              26.2757899966111,
              -26.6446500011965
            ],
            [
              26.2723600003138,
              -26.6914400023542
            ],
            [
              26.1854100015703,
              -26.7105999991905
            ],
            [
              26.188969999366,
              -26.7337799979485
            ],
            [
              26.1150599994195,
              -26.7710499971596
            ],
            [
              26.0767600021725,
              -26.8623300049257
            ],
            [
              26.1294100001714,
              -26.8691200032855
            ],
            [
              26.1906400017347,
              -26.9083199979695
            ],
            [
              26.1395799961199,
              -26.9773899932535
            ],
            [
              26.2294900036608,
              -26.9696400000859
            ],
            [
              26.2702499974395,
              -27.0409099969987
            ],
            [
              26.3010899969059,
              -27.0305299985606
            ],
            [
              26.3906100026495,
              -27.1808850020412
            ],
            [
              26.4199000025831,
              -27.1713599971661
            ],
            [
              26.4736299991252,
              -27.1537599994244
            ],
            [
              26.5216199989638,
              -27.1043899997986
            ]
          ]
        ]
      },
      "properties": {
        "Name": "City of Matlosana Local Municipality",
        "Code": "NW403",
        "Parent_cod": "DC40",
        "Area": 360224
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              22.7145799957703,
              -27.5491599951376
            ],
            [
              22.7005100061319,
              -27.6870500002572
            ],
            [
              22.8016899973955,
              -27.7928699986515
            ],
            [
              22.8193199956213,
              -27.8316099991021
            ],
            [
              22.7395499952362,
              -27.8507300048857
            ],
            [
              22.7887084356458,
              -27.8901546906864
            ],
            [
              22.7149761012661,
              -27.8950702617832
            ],
            [
              22.727434176646,
              -27.9303502780428
            ],
            [
              22.642420000083,
              -27.9397199978796
            ],
            [
              22.6740300008839,
              -27.9843600051101
            ],
            [
              22.7728099956848,
              -27.9841400057566
            ],
            [
              22.9330899946076,
              -27.8879499990932
            ],
            [
              22.9915500024307,
              -27.8980400138355
            ],
            [
              23.0230499990583,
              -27.8579899997386
            ],
            [
              23.097749994067,
              -27.8887700000355
            ],
            [
              23.0854800073965,
              -27.8448299981059
            ],
            [
              23.160249999338,
              -27.7285699976073
            ],
            [
              23.288570002004,
              -27.7142100026894
            ],
            [
              23.2741000029128,
              -27.6613399981423
            ],
            [
              23.2648700044471,
              -27.5190799992426
            ],
            [
              23.307429993999,
              -27.5146700000204
            ],
            [
              23.3727239959157,
              -27.4644609967775
            ],
            [
              23.3136199979646,
              -27.3519100000464
            ],
            [
              23.2718025620001,
              -27.378535728
            ],
            [
              23.2158500038746,
              -27.4191899982198
            ],
            [
              23.1229900059841,
              -27.4064699961933
            ],
            [
              22.9955099950001,
              -27.40741
            ],
            [
              22.8374200010001,
              -27.3904200009999
            ],
            [
              22.8487599997742,
              -27.4587800063921
            ],
            [
              22.844540001,
              -27.543719994
            ],
            [
              22.7145799957703,
              -27.5491599951376
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Gamagara Local Municipality",
        "Code": "NC453",
        "Parent_cod": "DC45",
        "Area": 264791
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              24.111000001449,
              -27.7389800010262
            ],
            [
              24.0933399964437,
              -27.7049100063916
            ],
            [
              24.1186200039101,
              -27.6217399976028
            ],
            [
              24.0506100008509,
              -27.6027299968918
            ],
            [
              24.057510003384,
              -27.4294199996333
            ],
            [
              24.0862700013595,
              -27.3534900036607
            ],
            [
              24.014949996745,
              -27.3236700062658
            ],
            [
              23.9869800000001,
              -27.3645999949999
            ],
            [
              24.001879999,
              -27.42
            ],
            [
              23.9365599979456,
              -27.4108199980444
            ],
            [
              23.884229996717,
              -27.4487399975528
            ],
            [
              23.9214799977038,
              -27.4942900017821
            ],
            [
              23.8145999998901,
              -27.4787999943242
            ],
            [
              23.7670699987815,
              -27.5532399989268
            ],
            [
              23.6714800018007,
              -27.5161299998995
            ],
            [
              23.610819998644,
              -27.4724400050021
            ],
            [
              23.6065067760001,
              -27.42748146
            ],
            [
              23.5640436850001,
              -27.335002883
            ],
            [
              23.5274511119793,
              -27.340882492433
            ],
            [
              23.4762162116089,
              -27.2918416114012
            ],
            [
              23.3941215176939,
              -27.2991197006136
            ],
            [
              23.1780919980001,
              -27.1358310049999
            ],
            [
              23.116909998,
              -27.201080001
            ],
            [
              23.132359992,
              -27.236959998
            ],
            [
              23.2718025620001,
              -27.378535728
            ],
            [
              23.3136199979646,
              -27.3519100000464
            ],
            [
              23.3727239959157,
              -27.4644609967775
            ],
            [
              23.307429993999,
              -27.5146700000204
            ],
            [
              23.2648700044471,
              -27.5190799992426
            ],
            [
              23.2741000029128,
              -27.6613399981423
            ],
            [
              23.288570002004,
              -27.7142100026894
            ],
            [
              23.160249999338,
              -27.7285699976073
            ],
            [
              23.0854800073965,
              -27.8448299981059
            ],
            [
              23.097749994067,
              -27.8887700000355
            ],
            [
              23.1122100016903,
              -27.9627800045935
            ],
            [
              23.2202900098762,
              -27.9542800020204
            ],
            [
              23.3043600071087,
              -27.9365300000594
            ],
            [
              23.362025980115,
              -27.9421671314079
            ],
            [
              23.4165500015813,
              -27.9158499978791
            ],
            [
              23.4438999983863,
              -27.9551800003567
            ],
            [
              23.5809300043163,
              -27.8793100008558
            ],
            [
              23.644100000015,
              -27.8334899985645
            ],
            [
              24.111000001449,
              -27.7389800010262
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Ga-Segonyana Local Municipality",
        "Code": "NC452",
        "Parent_cod": "DC45",
        "Area": 449480
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              23.2718025620001,
              -27.378535728
            ],
            [
              23.132359992,
              -27.236959998
            ],
            [
              23.116909998,
              -27.201080001
            ],
            [
              23.1780919980001,
              -27.1358310049999
            ],
            [
              23.3941215176939,
              -27.2991197006136
            ],
            [
              23.4762162116089,
              -27.2918416114012
            ],
            [
              23.5274511119793,
              -27.340882492433
            ],
            [
              23.5640436850001,
              -27.335002883
            ],
            [
              23.6065067760001,
              -27.42748146
            ],
            [
              23.610819998644,
              -27.4724400050021
            ],
            [
              23.6714800018007,
              -27.5161299998995
            ],
            [
              23.7670699987815,
              -27.5532399989268
            ],
            [
              23.8145999998901,
              -27.4787999943242
            ],
            [
              23.9214799977038,
              -27.4942900017821
            ],
            [
              23.884229996717,
              -27.4487399975528
            ],
            [
              23.9365599979456,
              -27.4108199980444
            ],
            [
              24.001879999,
              -27.42
            ],
            [
              23.9869800000001,
              -27.3645999949999
            ],
            [
              24.014949996745,
              -27.3236700062658
            ],
            [
              23.8964699936953,
              -27.2526599988599
            ],
            [
              23.973559999994,
              -27.0963799982383
            ],
            [
              24.03745,
              -27.053699999
            ],
            [
              24.026019999,
              -26.999289997
            ],
            [
              23.970370001,
              -26.8942000019999
            ],
            [
              23.9160700036278,
              -26.8582899975853
            ],
            [
              23.8695000009243,
              -26.8567499976142
            ],
            [
              23.8532300040001,
              -26.8901400029999
            ],
            [
              23.7607500020001,
              -26.8409600009999
            ],
            [
              23.6465300020001,
              -26.807480002
            ],
            [
              23.4871300026476,
              -26.7397090051664
            ],
            [
              23.5837500000001,
              -26.617149998
            ],
            [
              23.4629599978057,
              -26.5310899984047
            ],
            [
              23.2664100017203,
              -26.4853999994104
            ],
            [
              23.2820500026056,
              -26.3394700030382
            ],
            [
              23.2217400038981,
              -26.2712700011096
            ],
            [
              23.3109799949309,
              -26.1418499998776
            ],
            [
              23.2519200026061,
              -26.1138300036517
            ],
            [
              23.2158199988939,
              -26.1157300040365
            ],
            [
              23.2321499970001,
              -26.052690003
            ],
            [
              23.3538819966569,
              -26.0894780057054
            ],
            [
              23.387359998,
              -26.00616
            ],
            [
              23.3205499970001,
              -25.992839996
            ],
            [
              23.086910001,
              -25.982559996
            ],
            [
              23.088140003,
              -26.0435699999999
            ],
            [
              23.0648000030001,
              -26.099059995
            ],
            [
              22.98704,
              -26.089979996
            ],
            [
              22.9811499985736,
              -26.1525600000439
            ],
            [
              22.9070599990001,
              -26.145920002
            ],
            [
              22.899290004,
              -26.213630001
            ],
            [
              22.84187,
              -26.393300003
            ],
            [
              22.8031599968364,
              -26.4536800007314
            ],
            [
              22.7088000008195,
              -26.4107899986595
            ],
            [
              22.7029400020001,
              -26.119850006
            ],
            [
              22.6321700058411,
              -26.1212800009712
            ],
            [
              22.5795800000001,
              -26.158369992
            ],
            [
              22.5574099990001,
              -26.221759995
            ],
            [
              22.4742400000001,
              -26.1997100049999
            ],
            [
              22.4222099950001,
              -26.223240003
            ],
            [
              22.405969999,
              -26.264400007
            ],
            [
              22.3624399980001,
              -26.290740001
            ],
            [
              22.3667800000001,
              -26.319170003
            ],
            [
              22.2472500050001,
              -26.347040003
            ],
            [
              22.192790013,
              -26.395850002
            ],
            [
              22.2002400000001,
              -26.4247800009999
            ],
            [
              22.1331400030001,
              -26.526060005
            ],
            [
              22.048230006,
              -26.635049995
            ],
            [
              21.9531299980001,
              -26.668709997
            ],
            [
              21.8233100040001,
              -26.65984
            ],
            [
              21.7873900000001,
              -26.676060004
            ],
            [
              21.7928699990001,
              -26.769629999
            ],
            [
              21.8310399966985,
              -26.7977800040438
            ],
            [
              21.8723500030001,
              -26.860149998
            ],
            [
              21.9171399886196,
              -26.9586899942478
            ],
            [
              21.9516300070001,
              -26.948810012
            ],
            [
              21.9994600049753,
              -27.0247900063537
            ],
            [
              21.9994900036608,
              -27.1102499984386
            ],
            [
              22.124309996,
              -27.0735599989999
            ],
            [
              22.1506099920001,
              -27.030939995
            ],
            [
              22.209400003,
              -27.0944500009999
            ],
            [
              22.251680004,
              -27.039929995
            ],
            [
              22.3247800037942,
              -27.0776899933985
            ],
            [
              22.3413399949448,
              -27.2611100036237
            ],
            [
              22.396400005,
              -27.27818
            ],
            [
              22.4877899937133,
              -27.2788899970757
            ],
            [
              22.6204300000001,
              -27.263070001
            ],
            [
              22.6520899909603,
              -27.2369099920025
            ],
            [
              22.6856700050001,
              -27.267329998
            ],
            [
              22.6530500019561,
              -27.314049997909
            ],
            [
              22.6816499979491,
              -27.3477499988633
            ],
            [
              22.6691300040001,
              -27.450710003
            ],
            [
              22.7197599990001,
              -27.4563699939999
            ],
            [
              22.7145799957703,
              -27.5491599951376
            ],
            [
              22.844540001,
              -27.543719994
            ],
            [
              22.8487599997742,
              -27.4587800063921
            ],
            [
              22.8374200010001,
              -27.3904200009999
            ],
            [
              22.9955099950001,
              -27.40741
            ],
            [
              23.1229900059841,
              -27.4064699961933
            ],
            [
              23.2158500038746,
              -27.4191899982198
            ],
            [
              23.2718025620001,
              -27.378535728
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Joe Morolong Local Municipality",
        "Code": "NC451",
        "Parent_cod": "DC45",
        "Area": 2017975
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              29.1863000006446,
              -31.9496299981259
            ],
            [
              29.15128000267,
              -31.9390200016716
            ],
            [
              29.0964800008514,
              -31.8791299980509
            ],
            [
              29.0250999997652,
              -31.8644799951556
            ],
            [
              28.9832899962364,
              -31.8201200044346
            ],
            [
              28.9494600009783,
              -31.8351600001338
            ],
            [
              28.8879099999466,
              -31.7572100009407
            ],
            [
              28.905880003959,
              -31.7207800017957
            ],
            [
              28.820739998752,
              -31.6865999966924
            ],
            [
              28.8378499981789,
              -31.6261800010063
            ],
            [
              28.812939998782,
              -31.5075299982109
            ],
            [
              28.7546799965847,
              -31.4859599972561
            ],
            [
              28.6590899987045,
              -31.4494700007399
            ],
            [
              28.6254999992256,
              -31.4713799966895
            ],
            [
              28.5272100000415,
              -31.493799997272
            ],
            [
              28.4050199958761,
              -31.5028799978136
            ],
            [
              28.3823199985691,
              -31.4805500049787
            ],
            [
              28.3812650011789,
              -31.480000001199
            ],
            [
              28.3634099970738,
              -31.5022300029122
            ],
            [
              28.3811000025631,
              -31.5580099968639
            ],
            [
              28.3255500003323,
              -31.5864499980689
            ],
            [
              28.3090100020101,
              -31.61831999737
            ],
            [
              28.3120899983548,
              -31.6886500030951
            ],
            [
              28.3441400032586,
              -31.7169599956073
            ],
            [
              28.3238600006385,
              -31.7907600003736
            ],
            [
              28.3519699983168,
              -31.8286500002972
            ],
            [
              28.427450011309,
              -31.8702299968169
            ],
            [
              28.4651899971207,
              -31.9678200023912
            ],
            [
              28.564780001396,
              -31.9823200001678
            ],
            [
              28.5978199961959,
              -31.9717300001393
            ],
            [
              28.6611000041619,
              -32.0091600031316
            ],
            [
              28.7127700028334,
              -32.0076600023072
            ],
            [
              28.7821999967325,
              -32.0459999996003
            ],
            [
              28.8675199931532,
              -31.9602900022818
            ],
            [
              28.9258700030982,
              -31.9446199991137
            ],
            [
              29.0934100031692,
              -32.0593499983037
            ],
            [
              29.1863000006446,
              -31.9496299981259
            ]
          ]
        ]
      },
      "properties": {
        "Name": "King Sabata Dalindyebo Local Municipality",
        "Code": "EC157",
        "Parent_cod": "DC15",
        "Area": 301893,
        "detail": "King Sabata Dalindyebo Local Municipality (KSD LM) is a Category B municipality located within the OR Tambo District Municipality in the Eastern Cape Province of South Africa. Covering an area of 3,027 km², it is the largest of the five municipalities in the district, accounting for approximately 25% of the district’s geographical area.\n",
        "link_to_webpage": "https://ksd.gov.za/about/",
        "image": "https://corruptionwatch-my.sharepoint.com/:i:/g/personal/nontobekog_corruptionwatch_org_za/Efuh2nQPsDFMncyG7Xs505wBBNvOWy_ms45JyPWf-hulRA?e=UXQKOL",
        "image_alt": "https://en.wikipedia.org/wiki/King_Sabata_Dalindyebo_Local_Municipality#/media/File:King_Sabata_Dalindyebo_CoA.png"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              29.3570499420001,
              -29.1342499399999
            ],
            [
              29.4199829100001,
              -29.1492061609998
            ],
            [
              29.4736100670002,
              -29.0917479399999
            ],
            [
              29.540569942,
              -28.937549939
            ],
            [
              29.5810699420001,
              -28.9411199389999
            ],
            [
              29.6318699420001,
              -28.868699939
            ],
            [
              29.6771500670001,
              -28.866379939
            ],
            [
              29.7384299420001,
              -28.791759939
            ],
            [
              29.761249942,
              -28.737949939
            ],
            [
              29.6699799420001,
              -28.7471599389999
            ],
            [
              29.6188299420002,
              -28.6953100639999
            ],
            [
              29.5677120167963,
              -28.665980470922
            ],
            [
              29.578769942,
              -28.6396299389999
            ],
            [
              29.6699799420001,
              -28.562320064
            ],
            [
              29.6103829420001,
              -28.532850939
            ],
            [
              29.5656499420001,
              -28.570809939
            ],
            [
              29.4918809417521,
              -28.5287999391658
            ],
            [
              29.5194599419229,
              -28.4718199393387
            ],
            [
              29.4854199420002,
              -28.402649939
            ],
            [
              29.4382699417044,
              -28.4231199391338
            ],
            [
              29.3755599770001,
              -28.3721099709999
            ],
            [
              29.2900999697378,
              -28.4378900338979
            ],
            [
              29.2487499710002,
              -28.424899967
            ],
            [
              29.1914999787411,
              -28.4937799780635
            ],
            [
              29.2162499570001,
              -28.5190499539999
            ],
            [
              29.1349999677743,
              -28.5662999669699
            ],
            [
              29.09631997,
              -28.545090034
            ],
            [
              28.9739909766023,
              -28.5745600394142
            ],
            [
              28.942769955,
              -28.6509000289999
            ],
            [
              28.8962299789304,
              -28.6947399823642
            ],
            [
              28.8736269717074,
              -28.7707119002339
            ],
            [
              28.9438100660001,
              -28.7826599389999
            ],
            [
              28.939220066,
              -28.8599999389999
            ],
            [
              28.9748900660001,
              -28.8929399389999
            ],
            [
              29.074789942,
              -28.9187799389999
            ],
            [
              29.1514899420002,
              -28.987649939
            ],
            [
              29.2154900670001,
              -29.02628994
            ],
            [
              29.259249942,
              -29.09045994
            ],
            [
              29.3078199420001,
              -29.07662994
            ],
            [
              29.3570499420001,
              -29.1342499399999
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Okhahlamba Local Municipality",
        "Code": "KZN235",
        "Parent_cod": "DC23",
        "Area": 397104
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              28.7546799965847,
              -31.4859599972561
            ],
            [
              28.8578299986556,
              -31.4803100011057
            ],
            [
              28.8623700029733,
              -31.4208999989358
            ],
            [
              28.8907800018956,
              -31.3150100036087
            ],
            [
              28.9260400037432,
              -31.3173099972585
            ],
            [
              28.9798000016688,
              -31.2869600042008
            ],
            [
              29.0429400031787,
              -31.3221440016443
            ],
            [
              29.09396399814,
              -31.2986980014116
            ],
            [
              29.1555750001862,
              -31.3193320032693
            ],
            [
              29.1905799956703,
              -31.2746740042018
            ],
            [
              29.1792400033235,
              -31.2083399983922
            ],
            [
              29.207600010732,
              -31.1799700004151
            ],
            [
              29.1482200036502,
              -31.1549399990817
            ],
            [
              29.1323099957097,
              -31.0914399989567
            ],
            [
              29.0647380020572,
              -31.0379474198375
            ],
            [
              29.0647500008119,
              -31.0379300017681
            ],
            [
              29.0429900018871,
              -31.0104100043182
            ],
            [
              28.9789399970833,
              -31.0250199981743
            ],
            [
              28.9057299988404,
              -31.077709998018
            ],
            [
              28.8645800041639,
              -31.05141000197
            ],
            [
              28.8739599978557,
              -31.0055199991486
            ],
            [
              28.8362499990383,
              -30.9418600042358
            ],
            [
              28.7298399941205,
              -30.8441200016367
            ],
            [
              28.6579899974405,
              -30.8115299970117
            ],
            [
              28.6411130762075,
              -30.7729163486106
            ],
            [
              28.6386100003513,
              -30.9209299986205
            ],
            [
              28.5916499976493,
              -30.9311100013255
            ],
            [
              28.5772499981889,
              -30.9929100030941
            ],
            [
              28.5259200008074,
              -31.0488599976907
            ],
            [
              28.5395799994175,
              -31.0903899964012
            ],
            [
              28.6009800097197,
              -31.0882300020129
            ],
            [
              28.675480000002,
              -31.1349700035628
            ],
            [
              28.6822699983618,
              -31.179260000049
            ],
            [
              28.61938999805,
              -31.236869999251
            ],
            [
              28.5480999966177,
              -31.235390002047
            ],
            [
              28.4978000062653,
              -31.2502700038576
            ],
            [
              28.4559899937433,
              -31.3068399991666
            ],
            [
              28.4992599980505,
              -31.3326299986755
            ],
            [
              28.4905900038257,
              -31.366789999259
            ],
            [
              28.4439800019755,
              -31.3864699975922
            ],
            [
              28.3823199985691,
              -31.4805500049787
            ],
            [
              28.4050199958761,
              -31.5028799978136
            ],
            [
              28.5272100000415,
              -31.493799997272
            ],
            [
              28.6254999992256,
              -31.4713799966895
            ],
            [
              28.6590899987045,
              -31.4494700007399
            ],
            [
              28.7546799965847,
              -31.4859599972561
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Mhlontlo Local Municipality",
        "Code": "EC156",
        "Parent_cod": "DC15",
        "Area": 288027,
        "detail": "Mhlontlo Local Municipality is a Category B4 rural municipality encompassing the towns of Qumbu and Tsolo. It is located in the northeastern part of the Eastern Cape Province, along the N2 route between Mthatha and Mt. Frere, and the R396 between Tsolo and Maclear. The municipality covers an area of 2,614 km², with a population density of 73.3 people per km².\n",
        "link_to_webpage": "https://mhlontlolm.gov.za/about-us-2/",
        "image": "https://corruptionwatch-my.sharepoint.com/:i:/g/personal/nontobekog_corruptionwatch_org_za/EROOV65LCsZNu0cyia0UrugBF7N1_aHia-_O9OZyOQj1Vw?e=Sy5fMS",
        "image_alt": "https://www.google.com/url?sa=i&amp;url=https%3A%2F%2Fwww.facebook.com%2Fp%2FKumkani-Mhlontlo-Local-Municipality-100069267337173%2F&amp;psig=AOvVaw2-lkh_D61411rGrKVHLpnT&amp;ust=1753342007028000&amp;source=images&amp;cd=vfe&amp;opi=89978449&amp;ved=2ahUKEwjAl6GNutKOAxVFckEAHdQXI_kQjRx6BAgAEBo"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              29.1863000006446,
              -31.9496299981259
            ],
            [
              29.3279600015528,
              -31.8077600028219
            ],
            [
              29.2546800000819,
              -31.7756499996477
            ],
            [
              29.2466299885831,
              -31.6866499963002
            ],
            [
              29.2768700008499,
              -31.6293300005791
            ],
            [
              29.2634699971427,
              -31.5880700017291
            ],
            [
              29.2948100025796,
              -31.5374799989027
            ],
            [
              29.2711699907026,
              -31.3952600027469
            ],
            [
              29.2294199998332,
              -31.3934399961589
            ],
            [
              29.2263699985766,
              -31.2983299988304
            ],
            [
              29.1905799956703,
              -31.2746740042018
            ],
            [
              29.1555750001862,
              -31.3193320032693
            ],
            [
              29.09396399814,
              -31.2986980014116
            ],
            [
              29.0429400031787,
              -31.3221440016443
            ],
            [
              28.9798000016688,
              -31.2869600042008
            ],
            [
              28.9260400037432,
              -31.3173099972585
            ],
            [
              28.8907800018956,
              -31.3150100036087
            ],
            [
              28.8623700029733,
              -31.4208999989358
            ],
            [
              28.8578299986556,
              -31.4803100011057
            ],
            [
              28.7546799965847,
              -31.4859599972561
            ],
            [
              28.812939998782,
              -31.5075299982109
            ],
            [
              28.8378499981789,
              -31.6261800010063
            ],
            [
              28.820739998752,
              -31.6865999966924
            ],
            [
              28.905880003959,
              -31.7207800017957
            ],
            [
              28.8879099999466,
              -31.7572100009407
            ],
            [
              28.9494600009783,
              -31.8351600001338
            ],
            [
              28.9832899962364,
              -31.8201200044346
            ],
            [
              29.0250999997652,
              -31.8644799951556
            ],
            [
              29.0964800008514,
              -31.8791299980509
            ],
            [
              29.15128000267,
              -31.9390200016716
            ],
            [
              29.1863000006446,
              -31.9496299981259
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Nyandeni Local Municipality",
        "Code": "EC155",
        "Parent_cod": "DC15",
        "Area": 247401,
        "detail": "Nyandeni Local Municipality is a Category B municipality located within the OR Tambo District in the Eastern Cape Province. It lies approximately 30 km south of Mthatha and 50 km north of Port St Johns. The municipality is bordered by Mhlontlo to the north, King Sabata Dalindyebo to the west, Port St Johns to the east, and the Indian Ocean to the south. Its eastern boundary includes a 20 km stretch of coastline, while the Umzimvubu River forms part of its western edge.\n",
        "link_to_webpage": "https://www.nyandenilm.gov.za/about-us",
        "image": "https://corruptionwatch-my.sharepoint.com/:i:/g/personal/nontobekog_corruptionwatch_org_za/ERsUCdSabfZJjzD_WNFDVoABXaq22HLZI14gHSsmDwbkKg?e=eam5qC",
        "image_alt": "https://www.dailydispatch.co.za/news/2023-09-06-nyandeni-municipality-to-host-investor-summit/"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              30.8717099989173,
              -24.5385000032725
            ],
            [
              30.9543300111212,
              -24.5212799996722
            ],
            [
              30.9593199984192,
              -24.58207000073
            ],
            [
              31.2261800109987,
              -24.5560100022598
            ],
            [
              31.2536600021074,
              -24.4991200011871
            ],
            [
              31.2032400008254,
              -24.4264599914354
            ],
            [
              31.1599500000925,
              -24.4374099981729
            ],
            [
              31.1599699974175,
              -24.3755700017541
            ],
            [
              31.2420299981859,
              -24.3654300008938
            ],
            [
              31.2000599989698,
              -24.3049499916488
            ],
            [
              31.1525200063932,
              -24.3186699948243
            ],
            [
              31.0560200043198,
              -24.321889996726
            ],
            [
              31.0499399982324,
              -24.1873199972201
            ],
            [
              31.1072699989114,
              -24.1457300011386
            ],
            [
              31.120569998007,
              -24.090259999899
            ],
            [
              31.0634300015934,
              -24.09145999858
            ],
            [
              31.0126699981219,
              -24.1294199936377
            ],
            [
              30.9402100002913,
              -24.0530399993964
            ],
            [
              30.8462600015978,
              -24.0983200001678
            ],
            [
              30.7760499969099,
              -24.092389999199
            ],
            [
              30.6755099973885,
              -24.1459299968718
            ],
            [
              30.4801412203412,
              -23.980877788679
            ],
            [
              30.4533321441632,
              -23.9582524809672
            ],
            [
              30.4058897981756,
              -24.0312208547586
            ],
            [
              30.4493730083577,
              -24.0641181802098
            ],
            [
              30.4236764933755,
              -24.107465294188
            ],
            [
              30.3802999976468,
              -24.0693499988034
            ],
            [
              30.3215299998097,
              -24.129690000693
            ],
            [
              30.3616399977878,
              -24.1682800023202
            ],
            [
              30.2753299970818,
              -24.2129600068988
            ],
            [
              30.3371899971208,
              -24.2340300108763
            ],
            [
              30.3662150001223,
              -24.2830949973362
            ],
            [
              30.4092000038771,
              -24.3336299976263
            ],
            [
              30.518180001406,
              -24.4056399971881
            ],
            [
              30.5335299979111,
              -24.4397099981178
            ],
            [
              30.6183300000295,
              -24.4330299958376
            ],
            [
              30.6418299973565,
              -24.4508600005886
            ],
            [
              30.7589799993276,
              -24.4602199987539
            ],
            [
              30.7992800033695,
              -24.4988900022718
            ],
            [
              30.8717099989173,
              -24.5385000032725
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Maruleng Local Municipality",
        "Code": "LIM335",
        "Parent_cod": "DC33",
        "Area": 356262
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              29.3279600015528,
              -31.8077600028219
            ],
            [
              29.3567200013271,
              -31.7585199966005
            ],
            [
              29.4027699998357,
              -31.7342000037272
            ],
            [
              29.4222600010982,
              -31.6916899975953
            ],
            [
              29.5018699959037,
              -31.6647099971686
            ],
            [
              29.6239100030443,
              -31.5860099975633
            ],
            [
              29.6909799996273,
              -31.5281999954334
            ],
            [
              29.6010100019101,
              -31.4661099955799
            ],
            [
              29.5988500003273,
              -31.4414499996178
            ],
            [
              29.5371500031702,
              -31.4248899976752
            ],
            [
              29.5086700010198,
              -31.3409299956227
            ],
            [
              29.3871699918017,
              -31.3291900037156
            ],
            [
              29.3449599968065,
              -31.3031400030087
            ],
            [
              29.2711699907026,
              -31.3952600027469
            ],
            [
              29.2948100025796,
              -31.5374799989027
            ],
            [
              29.2634699971427,
              -31.5880700017291
            ],
            [
              29.2768700008499,
              -31.6293300005791
            ],
            [
              29.2466299885831,
              -31.6866499963002
            ],
            [
              29.2546800000819,
              -31.7756499996477
            ],
            [
              29.3279600015528,
              -31.8077600028219
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Port St Johns Local Municipality",
        "Code": "EC154",
        "Parent_cod": "DC15",
        "Area": 129120,
        "detail": "Port St. Johns Local Municipality is a Category B municipality in the OR Tambo District of the Eastern Cape Province, South Africa. It is named after its main town, Port St. Johns, which is located along the Wild Coast—an area known for its scenic, rugged coastline stretching approximately 270 km.\n",
        "link_to_webpage": "https://psjmunicipality.gov.za/za/",
        "image": "https://corruptionwatch-my.sharepoint.com/:i:/g/personal/nontobekog_corruptionwatch_org_za/EYDMhSee3ilPkPk0S6JWzw0Blph5zBmw6HI2Iqp9CHFs6A?e=lG2TMw",
        "image_alt": "https://en.wikipedia.org/wiki/Port_St._Johns_Local_Municipality#/media/File:Port_St._Johns_CoA.png"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              31.0634300015934,
              -24.09145999858
            ],
            [
              31.133779997449,
              -24.0736999970572
            ],
            [
              31.1942500080315,
              -24.0311499989732
            ],
            [
              31.2347000010043,
              -24.0575699969577
            ],
            [
              31.2522800032196,
              -24.0977300026375
            ],
            [
              31.4280499979091,
              -24.0545000001748
            ],
            [
              31.440939998782,
              -24.0209800030247
            ],
            [
              31.5425599968464,
              -24.0539900036357
            ],
            [
              31.5946999992056,
              -24.0563699982768
            ],
            [
              31.6208899991742,
              -24.0232500015863
            ],
            [
              31.6659800019756,
              -24.016699999905
            ],
            [
              31.6837199998781,
              -24.0595300037066
            ],
            [
              31.7358100026296,
              -24.0460800003916
            ],
            [
              31.7674799981034,
              -23.984619999913
            ],
            [
              31.8838346630393,
              -23.984594453771
            ],
            [
              31.880720001427,
              -23.9550500023557
            ],
            [
              31.7691800027549,
              -23.8878000001698
            ],
            [
              31.6973900043453,
              -23.7218899934284
            ],
            [
              31.6905499991832,
              -23.6294400027538
            ],
            [
              31.6658400036133,
              -23.5914399995563
            ],
            [
              31.561020000073,
              -23.4819599969563
            ],
            [
              31.5507300012885,
              -23.4102800018206
            ],
            [
              31.5612020732172,
              -23.2269299057904
            ],
            [
              31.5240173342327,
              -23.2151794430769
            ],
            [
              31.4910182945586,
              -23.2515125267816
            ],
            [
              31.4364204405509,
              -23.2731781013882
            ],
            [
              31.3179550173102,
              -23.3009777070555
            ],
            [
              31.3019428248016,
              -23.3780803677148
            ],
            [
              31.2383098599122,
              -23.3400306697795
            ],
            [
              31.1735401150842,
              -23.3501853943405
            ],
            [
              31.1433715818331,
              -23.5318660743598
            ],
            [
              31.1009807592547,
              -23.5969505306424
            ],
            [
              31.1444800007515,
              -23.6488500030252
            ],
            [
              31.0782999966476,
              -23.6460299997846
            ],
            [
              31.0083500021509,
              -23.6761900029662
            ],
            [
              30.9713699983268,
              -23.6648699989513
            ],
            [
              30.8689800043238,
              -23.6872200043997
            ],
            [
              30.759670003268,
              -23.6973499913091
            ],
            [
              30.7156599963119,
              -23.648100002613
            ],
            [
              30.6249300004192,
              -23.5967000020034
            ],
            [
              30.6135210021926,
              -23.6332080002489
            ],
            [
              30.4920499979091,
              -23.7137599971262
            ],
            [
              30.5255899986796,
              -23.7270999962678
            ],
            [
              30.531499996028,
              -23.8049499971446
            ],
            [
              30.5857199989788,
              -23.8473700027234
            ],
            [
              30.5550180031784,
              -23.8909140043777
            ],
            [
              30.5573800041838,
              -23.9414799962048
            ],
            [
              30.5208845137094,
              -23.9766116063405
            ],
            [
              30.4801412203412,
              -23.980877788679
            ],
            [
              30.6755099973885,
              -24.1459299968718
            ],
            [
              30.7760499969099,
              -24.092389999199
            ],
            [
              30.8462600015978,
              -24.0983200001678
            ],
            [
              30.9402100002913,
              -24.0530399993964
            ],
            [
              31.0126699981219,
              -24.1294199936377
            ],
            [
              31.0634300015934,
              -24.09145999858
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Ba-Phalaborwa Local Municipality",
        "Code": "LIM334",
        "Parent_cod": "DC33",
        "Area": 748964
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              27.532289997985,
              -25.849960001253
            ],
            [
              27.5156199918692,
              -25.775367003984
            ],
            [
              27.501219998704,
              -25.6378499998775
            ],
            [
              27.5704100040186,
              -25.6312900076277
            ],
            [
              27.573390002047,
              -25.6654599987798
            ],
            [
              27.6465199992986,
              -25.6501600009832
            ],
            [
              27.6197099986176,
              -25.4750300034319
            ],
            [
              27.5846400028339,
              -25.4290400022943
            ],
            [
              27.519299998796,
              -25.4199399972331
            ],
            [
              27.5211500013715,
              -25.3414400005556
            ],
            [
              27.471009996814,
              -25.2866300000744
            ],
            [
              27.4279799981784,
              -25.2896600049053
            ],
            [
              27.364950000842,
              -25.325390003246
            ],
            [
              27.2564820026424,
              -25.3374449979882
            ],
            [
              27.1885199981994,
              -25.3682199980545
            ],
            [
              27.1329267277863,
              -25.3574534970812
            ],
            [
              27.0570899978052,
              -25.385580000017
            ],
            [
              27.0033600021624,
              -25.3899900037356
            ],
            [
              27.0150600021175,
              -25.4631499960754
            ],
            [
              27.0407500042094,
              -25.466069996733
            ],
            [
              27.0668619969836,
              -25.5332130029776
            ],
            [
              27.1585100001365,
              -25.6684799977536
            ],
            [
              27.1671000005646,
              -25.720329996632
            ],
            [
              27.1197709988325,
              -25.7522340028969
            ],
            [
              27.1326700010198,
              -25.8092999976967
            ],
            [
              27.2081700023438,
              -25.8547699973375
            ],
            [
              27.1737999992706,
              -25.8849399982823
            ],
            [
              27.188174002928,
              -25.9313089971124
            ],
            [
              27.1651660004106,
              -25.9920839965791
            ],
            [
              27.1698499996778,
              -26.0802299974164
            ],
            [
              27.3262399981774,
              -26.1007200088214
            ],
            [
              27.3617200002778,
              -26.1156699985715
            ],
            [
              27.4194400036533,
              -26.1174999957282
            ],
            [
              27.4252200004028,
              -26.0893899989492
            ],
            [
              27.4570099969139,
              -25.9818499976792
            ],
            [
              27.4619470006536,
              -25.8676060011161
            ],
            [
              27.532289997985,
              -25.849960001253
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Rustenburg Local Municipality",
        "Code": "NW373",
        "Parent_cod": "DC37",
        "Area": 341612
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              29.6909799996273,
              -31.5281999954334
            ],
            [
              29.7591899957218,
              -31.4523900013974
            ],
            [
              29.8344599990298,
              -31.4432500025855
            ],
            [
              29.9072799963748,
              -31.390840001265
            ],
            [
              30.0078700035978,
              -31.298040010638
            ],
            [
              30.0476400002858,
              -31.2475599966964
            ],
            [
              29.9054499983188,
              -31.1798700020989
            ],
            [
              29.8464600002289,
              -31.1351200005875
            ],
            [
              29.7616800017307,
              -31.1193300035767
            ],
            [
              29.7260200012222,
              -31.0868699995508
            ],
            [
              29.5843000020435,
              -31.0380300090776
            ],
            [
              29.6097599980256,
              -30.9832100027394
            ],
            [
              29.5114100023698,
              -30.9298700079944
            ],
            [
              29.4636299960275,
              -30.950759997376
            ],
            [
              29.40639999996,
              -31.0023799982383
            ],
            [
              29.4330200017717,
              -31.0499099930517
            ],
            [
              29.4373600031617,
              -31.1006800032795
            ],
            [
              29.3827600042709,
              -31.1087900103507
            ],
            [
              29.3449099900041,
              -31.165309997958
            ],
            [
              29.284530003357,
              -31.1851400023092
            ],
            [
              29.2263699985766,
              -31.2983299988304
            ],
            [
              29.2294199998332,
              -31.3934399961589
            ],
            [
              29.2711699907026,
              -31.3952600027469
            ],
            [
              29.3449599968065,
              -31.3031400030087
            ],
            [
              29.3871699918017,
              -31.3291900037156
            ],
            [
              29.5086700010198,
              -31.3409299956227
            ],
            [
              29.5371500031702,
              -31.4248899976752
            ],
            [
              29.5988500003273,
              -31.4414499996178
            ],
            [
              29.6010100019101,
              -31.4661099955799
            ],
            [
              29.6909799996273,
              -31.5281999954334
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Ingquza Hill Local Municipality",
        "Code": "EC153",
        "Parent_cod": "DC15",
        "Area": 247683,
        "detail": "Ingquza Hill Local Municipality, previously called Qaukeni Local Municipality, is a Category B municipality located within the OR Tambo District in the Eastern Cape Province of South Africa. The name change reflects efforts to align municipal identities with local heritage.",
        "link_to_webpage": "https://municipalities.co.za/overview/1035/ingquza-hill-local-municipality",
        "image": "https://corruptionwatch-my.sharepoint.com/:i:/g/personal/nontobekog_corruptionwatch_org_za/EdsfrGmNpfRBsL6ibkysA3gBgR3QnREaUT-eH3WFOh--ow?e=zv5yCw",
        "image_alt": ""
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              30.3215299998097,
              -24.129690000693
            ],
            [
              30.3802999976468,
              -24.0693499988034
            ],
            [
              30.4236764933755,
              -24.107465294188
            ],
            [
              30.4493730083577,
              -24.0641181802098
            ],
            [
              30.4058897981756,
              -24.0312208547586
            ],
            [
              30.4533321441632,
              -23.9582524809672
            ],
            [
              30.4801412203412,
              -23.980877788679
            ],
            [
              30.5208845137094,
              -23.9766116063405
            ],
            [
              30.5573800041838,
              -23.9414799962048
            ],
            [
              30.5550180031784,
              -23.8909140043777
            ],
            [
              30.5857199989788,
              -23.8473700027234
            ],
            [
              30.531499996028,
              -23.8049499971446
            ],
            [
              30.5255899986796,
              -23.7270999962678
            ],
            [
              30.4920499979091,
              -23.7137599971262
            ],
            [
              30.6135210021926,
              -23.6332080002489
            ],
            [
              30.6249300004192,
              -23.5967000020034
            ],
            [
              30.6018799941664,
              -23.5621000009142
            ],
            [
              30.5627799968994,
              -23.552449999268
            ],
            [
              30.4747900023568,
              -23.569079997244
            ],
            [
              30.4179199977098,
              -23.5213899986494
            ],
            [
              30.3725100044332,
              -23.566830003202
            ],
            [
              30.3676699979721,
              -23.624050000607
            ],
            [
              30.3060699991312,
              -23.6315599970962
            ],
            [
              30.2598300026525,
              -23.6715100002862
            ],
            [
              30.2012499946916,
              -23.7536699993709
            ],
            [
              30.0499000001849,
              -23.7062400019744
            ],
            [
              30.025420002631,
              -23.6247200000279
            ],
            [
              29.9611200042848,
              -23.6600700024286
            ],
            [
              29.8879200029058,
              -23.6794199963357
            ],
            [
              29.8883799998372,
              -23.7416000021384
            ],
            [
              29.9281799988079,
              -23.7976799982333
            ],
            [
              29.8865200003978,
              -23.8551199958911
            ],
            [
              29.8965499970848,
              -23.8987199956313
            ],
            [
              29.8544400004057,
              -23.921904998217
            ],
            [
              29.8637499989634,
              -23.951380001286
            ],
            [
              29.9974700006401,
              -24.0006600003587
            ],
            [
              30.0431049979973,
              -23.9724899981149
            ],
            [
              30.0745499965851,
              -24.0120199972251
            ],
            [
              30.2156200008623,
              -24.0856999991555
            ],
            [
              30.2382600007985,
              -24.1392699991112
            ],
            [
              30.2948900006731,
              -24.0958700031981
            ],
            [
              30.3215299998097,
              -24.129690000693
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Greater Tzaneen Local Municipality",
        "Code": "LIM333",
        "Parent_cod": "DC33",
        "Area": 289624
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              27.8982000007295,
              -25.8597400043976
            ],
            [
              27.9601699968479,
              -25.8159899977401
            ],
            [
              27.949325995898,
              -25.7597800019455
            ],
            [
              27.9794700010397,
              -25.7514500018161
            ],
            [
              27.9481900001684,
              -25.6952100037386
            ],
            [
              27.9805600117352,
              -25.6328000071147
            ],
            [
              27.9576300002243,
              -25.5926199969153
            ],
            [
              27.990763163889,
              -25.5457076070204
            ],
            [
              27.9934920001557,
              -25.5465750022346
            ],
            [
              28.0034249995641,
              -25.4933719994182
            ],
            [
              28.0054850037299,
              -25.4886900011426
            ],
            [
              28.0001600009833,
              -25.4334399992565
            ],
            [
              27.9925899999286,
              -25.4254699977421
            ],
            [
              27.9741900102608,
              -25.4361199960409
            ],
            [
              27.9726800098746,
              -25.4371299967519
            ],
            [
              27.9456399958892,
              -25.4067000027029
            ],
            [
              27.9707599968763,
              -25.3629499897502
            ],
            [
              27.9130821932886,
              -25.3128458573504
            ],
            [
              27.831360961739,
              -25.2096203895693
            ],
            [
              27.8450129356985,
              -25.1724855296834
            ],
            [
              27.8906099951552,
              -25.1487800003966
            ],
            [
              27.8645999953935,
              -25.0805400002208
            ],
            [
              27.824360004011,
              -25.1108800018106
            ],
            [
              27.8048399995664,
              -25.0183600016127
            ],
            [
              27.821660002707,
              -24.9745800016657
            ],
            [
              27.7591400028089,
              -24.9689100009957
            ],
            [
              27.6846699986216,
              -24.9858399930212
            ],
            [
              27.5974900027614,
              -24.9848699995508
            ],
            [
              27.5940400019446,
              -25.0294400008553
            ],
            [
              27.5435999961429,
              -25.0958799980634
            ],
            [
              27.4869000011342,
              -25.0784199977846
            ],
            [
              27.4901999968324,
              -25.1972099998416
            ],
            [
              27.4279799981784,
              -25.2896600049053
            ],
            [
              27.471009996814,
              -25.2866300000744
            ],
            [
              27.5211500013715,
              -25.3414400005556
            ],
            [
              27.519299998796,
              -25.4199399972331
            ],
            [
              27.5846400028339,
              -25.4290400022943
            ],
            [
              27.6197099986176,
              -25.4750300034319
            ],
            [
              27.6465199992986,
              -25.6501600009832
            ],
            [
              27.573390002047,
              -25.6654599987798
            ],
            [
              27.5704100040186,
              -25.6312900076277
            ],
            [
              27.501219998704,
              -25.6378499998775
            ],
            [
              27.5156199918692,
              -25.775367003984
            ],
            [
              27.532289997985,
              -25.849960001253
            ],
            [
              27.6435499990332,
              -25.7959199976097
            ],
            [
              27.6466000011891,
              -25.814139996064
            ],
            [
              27.6849299998197,
              -25.8754000008094
            ],
            [
              27.742700002803,
              -25.8502399988768
            ],
            [
              27.7445499972846,
              -25.8946200031106
            ],
            [
              27.8314700000405,
              -25.8601729982851
            ],
            [
              27.8587399967535,
              -25.8188199987439
            ],
            [
              27.8982000007295,
              -25.8597400043976
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Local Municipality of Madibeng",
        "Code": "NW372",
        "Parent_cod": "DC37",
        "Area": 372009
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              28.8440272470598,
              -27.038667574349
            ],
            [
              28.8108599981904,
              -27.0386100042482
            ],
            [
              28.646920004055,
              -26.9530399971981
            ],
            [
              28.5854700022389,
              -27.0358600042357
            ],
            [
              28.5496899979951,
              -27.0416000000399
            ],
            [
              28.4858500028754,
              -26.9711099977282
            ],
            [
              28.4133200018167,
              -27.0068599996892
            ],
            [
              28.3129299984207,
              -27.0367600097666
            ],
            [
              28.3159300000695,
              -27.0912100044381
            ],
            [
              28.2886600042559,
              -27.1161800003067
            ],
            [
              28.2642399968784,
              -27.186220002551
            ],
            [
              28.2870800006416,
              -27.2041200033354
            ],
            [
              28.2273599985651,
              -27.2876100017001
            ],
            [
              28.2832399980275,
              -27.3596899972955
            ],
            [
              28.2508899990743,
              -27.4977900004081
            ],
            [
              28.2580400041429,
              -27.5721800018055
            ],
            [
              28.412650003295,
              -27.5103899969009
            ],
            [
              28.4747539965997,
              -27.5327729966764
            ],
            [
              28.46712999935,
              -27.5627500004122
            ],
            [
              28.5111500040694,
              -27.5968899973754
            ],
            [
              28.5975499972346,
              -27.5624399996062
            ],
            [
              28.6255099969888,
              -27.6114300041913
            ],
            [
              28.6749700043622,
              -27.5904800021503
            ],
            [
              28.7429200909894,
              -27.5990485843246
            ],
            [
              28.7456199996633,
              -27.533699999855
            ],
            [
              28.7739199998082,
              -27.5314599999789
            ],
            [
              28.7855358124279,
              -27.4624938961763
            ],
            [
              28.8807506563178,
              -27.4435005194334
            ],
            [
              28.9264349077449,
              -27.4022305408067
            ],
            [
              28.9160353112807,
              -27.3460874123042
            ],
            [
              28.9373626706508,
              -27.287685393666
            ],
            [
              28.9670295719572,
              -27.2800102231932
            ],
            [
              28.9787386325819,
              -27.2063063280746
            ],
            [
              29.005649566874,
              -27.1669006350562
            ],
            [
              28.9965190891847,
              -27.0796604160953
            ],
            [
              29.0151413993562,
              -27.0099578439794
            ],
            [
              28.9547700012346,
              -27.0114600022773
            ],
            [
              28.8440272470598,
              -27.038667574349
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Mafube Local Municipality",
        "Code": "FS205",
        "Parent_cod": "DC20",
        "Area": 397656
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              29.9611200042848,
              -23.6600700024286
            ],
            [
              30.025420002631,
              -23.6247200000279
            ],
            [
              30.0499000001849,
              -23.7062400019744
            ],
            [
              30.2012499946916,
              -23.7536699993709
            ],
            [
              30.2598300026525,
              -23.6715100002862
            ],
            [
              30.3060699991312,
              -23.6315599970962
            ],
            [
              30.3676699979721,
              -23.624050000607
            ],
            [
              30.3725100044332,
              -23.566830003202
            ],
            [
              30.4179199977098,
              -23.5213899986494
            ],
            [
              30.4747900023568,
              -23.569079997244
            ],
            [
              30.5627799968994,
              -23.552449999268
            ],
            [
              30.6018799941664,
              -23.5621000009142
            ],
            [
              30.6249300004192,
              -23.5967000020034
            ],
            [
              30.6889100010957,
              -23.4554199970352
            ],
            [
              30.617409998073,
              -23.3889899975902
            ],
            [
              30.5793899984497,
              -23.4388899973754
            ],
            [
              30.4826400010353,
              -23.3418600032365
            ],
            [
              30.4508300000046,
              -23.3709599971062
            ],
            [
              30.405840002714,
              -23.3678599971412
            ],
            [
              30.3374099973735,
              -23.4239500062877
            ],
            [
              30.2940199803378,
              -23.3856800221153
            ],
            [
              30.268560961919,
              -23.3244090411443
            ],
            [
              30.2343099733267,
              -23.3084500309441
            ],
            [
              30.1516067369614,
              -23.3137996796114
            ],
            [
              30.1467599720951,
              -23.341400027889
            ],
            [
              30.0376999816688,
              -23.3387100216502
            ],
            [
              30.0432599979506,
              -23.4256500028453
            ],
            [
              30.005999997402,
              -23.4478100031291
            ],
            [
              30.0473470038612,
              -23.5352370022858
            ],
            [
              30.0364399982074,
              -23.5729699985665
            ],
            [
              29.9490199957762,
              -23.6276999980564
            ],
            [
              29.9611200042848,
              -23.6600700024286
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Greater Letaba Local Municipality",
        "Code": "LIM332",
        "Parent_cod": "DC33",
        "Area": 189585
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              27.9707599968763,
              -25.3629499897502
            ],
            [
              28.0059029969258,
              -25.3644229893295
            ],
            [
              28.009463001916,
              -25.3676649976415
            ],
            [
              28.0112800020704,
              -25.3693199921239
            ],
            [
              28.0447300031871,
              -25.4017399952046
            ],
            [
              28.2980600033665,
              -25.3393399963438
            ],
            [
              28.2981600007834,
              -25.3103700021739
            ],
            [
              28.2462700009598,
              -25.2128550036555
            ],
            [
              28.2111899984197,
              -25.1980699972325
            ],
            [
              28.1357199993785,
              -25.2056399982873
            ],
            [
              28.1289700019641,
              -25.1456899901009
            ],
            [
              28.0943499963552,
              -25.1484699995907
            ],
            [
              28.0838500040744,
              -25.1003699955787
            ],
            [
              28.1539300000695,
              -25.0867800010961
            ],
            [
              28.198270003358,
              -25.1275900007778
            ],
            [
              28.2597599971262,
              -25.0504500002673
            ],
            [
              28.1252199909099,
              -25.0048000022183
            ],
            [
              28.1200100042584,
              -24.9794699906475
            ],
            [
              28.0378499970797,
              -24.9838300037516
            ],
            [
              27.9835599980954,
              -24.9578499981788
            ],
            [
              27.9464699981919,
              -25.0012199999031
            ],
            [
              27.821660002707,
              -24.9745800016657
            ],
            [
              27.8048399995664,
              -25.0183600016127
            ],
            [
              27.824360004011,
              -25.1108800018106
            ],
            [
              27.8645999953935,
              -25.0805400002208
            ],
            [
              27.8906099951552,
              -25.1487800003966
            ],
            [
              27.8450129356985,
              -25.1724855296834
            ],
            [
              27.831360961739,
              -25.2096203895693
            ],
            [
              27.9130821932886,
              -25.3128458573504
            ],
            [
              27.9707599968763,
              -25.3629499897502
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Moretele Local Municipality",
        "Code": "NW371",
        "Parent_cod": "DC37",
        "Area": 149786
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              28.2442800000221,
              -26.8847799996972
            ],
            [
              28.2015500017312,
              -26.9100899986545
            ],
            [
              28.1713300020779,
              -26.8837100007159
            ],
            [
              28.1191300032471,
              -26.8892800120628
            ],
            [
              28.1148100063768,
              -26.8443799982383
            ],
            [
              28.0801599975859,
              -26.8346900109353
            ],
            [
              28.0081800012062,
              -26.7701499988234
            ],
            [
              28.0004899982149,
              -26.7033200007175
            ],
            [
              27.9409600013031,
              -26.6758999988858
            ],
            [
              27.8736400030837,
              -26.7476300008238
            ],
            [
              27.8461800012062,
              -26.7461499964252
            ],
            [
              27.8458609999853,
              -26.7462389987308
            ],
            [
              27.8057500037597,
              -26.7507300007889
            ],
            [
              27.8050000033476,
              -26.7507300007888
            ],
            [
              27.7476600031067,
              -26.785889998025
            ],
            [
              27.7163060006215,
              -26.7616770001934
            ],
            [
              27.6804699982918,
              -26.8289699881744
            ],
            [
              27.7104599990299,
              -26.8422700025585
            ],
            [
              27.7727000031027,
              -26.9249499959455
            ],
            [
              27.8026700002204,
              -26.9971900016172
            ],
            [
              27.8689199985591,
              -26.9813700023237
            ],
            [
              27.8733929961898,
              -26.9384210101214
            ],
            [
              27.9286099893596,
              -26.9660109919137
            ],
            [
              27.9736699997707,
              -27.0424300023427
            ],
            [
              28.0657300030373,
              -27.046560001243
            ],
            [
              28.1043499988534,
              -27.0860399926515
            ],
            [
              28.1267500030103,
              -27.1378599982403
            ],
            [
              28.2642399968784,
              -27.186220002551
            ],
            [
              28.2886600042559,
              -27.1161800003067
            ],
            [
              28.3159300000695,
              -27.0912100044381
            ],
            [
              28.3129299984207,
              -27.0367600097666
            ],
            [
              28.4133200018167,
              -27.0068599996892
            ],
            [
              28.4286900028414,
              -26.9903499973544
            ],
            [
              28.3921500004222,
              -26.93142000383
            ],
            [
              28.300429999345,
              -26.9401600021823
            ],
            [
              28.2442800000221,
              -26.8847799996972
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Metsimaholo Local Municipality",
        "Code": "FS204",
        "Parent_cod": "DC20",
        "Area": 171710
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              30.6249300004192,
              -23.5967000020034
            ],
            [
              30.7156599963119,
              -23.648100002613
            ],
            [
              30.759670003268,
              -23.6973499913091
            ],
            [
              30.8689800043238,
              -23.6872200043997
            ],
            [
              30.9713699983268,
              -23.6648699989513
            ],
            [
              31.0083500021509,
              -23.6761900029662
            ],
            [
              31.0782999966476,
              -23.6460299997846
            ],
            [
              31.1444800007515,
              -23.6488500030252
            ],
            [
              31.1009807592547,
              -23.5969505306424
            ],
            [
              31.1433715818331,
              -23.5318660743598
            ],
            [
              31.1735401150842,
              -23.3501853943405
            ],
            [
              31.2383098599122,
              -23.3400306697795
            ],
            [
              31.3019428248016,
              -23.3780803677148
            ],
            [
              31.3179550173102,
              -23.3009777070555
            ],
            [
              31.4364204405509,
              -23.2731781013882
            ],
            [
              31.4910182945586,
              -23.2515125267816
            ],
            [
              31.5240173342327,
              -23.2151794430769
            ],
            [
              31.5612020732172,
              -23.2269299057904
            ],
            [
              31.5614232425886,
              -23.2242827954147
            ],
            [
              31.5343723297193,
              -23.1875648504375
            ],
            [
              31.4118709559799,
              -23.0911064150291
            ],
            [
              31.3748779299726,
              -23.138339995994
            ],
            [
              31.2573928828753,
              -23.2037296300184
            ],
            [
              31.2069454189959,
              -23.2195949551431
            ],
            [
              31.1566581729364,
              -23.1880664832815
            ],
            [
              31.0518665313154,
              -23.1748104097725
            ],
            [
              30.966876983586,
              -23.1741275788246
            ],
            [
              30.9295798113592,
              -23.1394346561844
            ],
            [
              30.8802699709825,
              -23.1505500275617
            ],
            [
              30.8310999733851,
              -23.093600029118
            ],
            [
              30.8045999726107,
              -23.1044200280618
            ],
            [
              30.7280499723284,
              -23.0723100311829
            ],
            [
              30.6522299706367,
              -23.1574200260133
            ],
            [
              30.5626599733791,
              -23.1756900312699
            ],
            [
              30.4875699711772,
              -23.2442400313523
            ],
            [
              30.4270199730933,
              -23.2578600290171
            ],
            [
              30.4035069706702,
              -23.2342440281394
            ],
            [
              30.3349799743464,
              -23.2494400328312
            ],
            [
              30.3691499726932,
              -23.3101600279628
            ],
            [
              30.3286399661616,
              -23.3775800298944
            ],
            [
              30.2940199803378,
              -23.3856800221153
            ],
            [
              30.3374099973735,
              -23.4239500062877
            ],
            [
              30.405840002714,
              -23.3678599971412
            ],
            [
              30.4508300000046,
              -23.3709599971062
            ],
            [
              30.4826400010353,
              -23.3418600032365
            ],
            [
              30.5793899984497,
              -23.4388899973754
            ],
            [
              30.617409998073,
              -23.3889899975902
            ],
            [
              30.6889100010957,
              -23.4554199970352
            ],
            [
              30.6249300004192,
              -23.5967000020034
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Greater Giyani Local Municipality",
        "Code": "LIM331",
        "Parent_cod": "DC33",
        "Area": 416665
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              28.2642399968784,
              -27.186220002551
            ],
            [
              28.1267500030103,
              -27.1378599982403
            ],
            [
              28.1043499988534,
              -27.0860399926515
            ],
            [
              28.0657300030373,
              -27.046560001243
            ],
            [
              27.9736699997707,
              -27.0424300023427
            ],
            [
              27.9286099893596,
              -26.9660109919137
            ],
            [
              27.8733929961898,
              -26.9384210101214
            ],
            [
              27.8689199985591,
              -26.9813700023237
            ],
            [
              27.8026700002204,
              -26.9971900016172
            ],
            [
              27.7727000031027,
              -26.9249499959455
            ],
            [
              27.7104599990299,
              -26.8422700025585
            ],
            [
              27.6804699982918,
              -26.8289699881744
            ],
            [
              27.7163060006215,
              -26.7616770001934
            ],
            [
              27.6613699979271,
              -26.7731900032161
            ],
            [
              27.5904299973466,
              -26.7383600032115
            ],
            [
              27.5825899973305,
              -26.7689000014339
            ],
            [
              27.5173599965666,
              -26.7819700007149
            ],
            [
              27.5117500022608,
              -26.8365100031341
            ],
            [
              27.4760400012451,
              -26.8834900013624
            ],
            [
              27.4185899968309,
              -26.9238600014379
            ],
            [
              27.3894850000328,
              -26.906384999568
            ],
            [
              27.3515299998097,
              -26.942309997908
            ],
            [
              27.3408100000815,
              -27.0193000022932
            ],
            [
              27.3899199967106,
              -27.1113800019855
            ],
            [
              27.3740800009913,
              -27.1498099998316
            ],
            [
              27.3937500015614,
              -27.2383499990532
            ],
            [
              27.3787099968689,
              -27.2913000000949
            ],
            [
              27.2145100024348,
              -27.2785799998671
            ],
            [
              27.1702599979006,
              -27.3167600032715
            ],
            [
              27.1717900019071,
              -27.3975900021768
            ],
            [
              27.2320799978937,
              -27.4746199994134
            ],
            [
              27.2977799996473,
              -27.4642099986925
            ],
            [
              27.3110700009798,
              -27.4882399961788
            ],
            [
              27.4434200024312,
              -27.48291999726
            ],
            [
              27.4532399984273,
              -27.5211800007564
            ],
            [
              27.435974999047,
              -27.5704660010052
            ],
            [
              27.4785700001055,
              -27.6312099927469
            ],
            [
              27.5768099996818,
              -27.6185400002208
            ],
            [
              27.6394299987954,
              -27.6815599988948
            ],
            [
              27.566809998083,
              -27.7380400017447
            ],
            [
              27.5826590032105,
              -27.777693003829
            ],
            [
              27.6333710017703,
              -27.8031710006411
            ],
            [
              27.7417599972262,
              -27.806370000675
            ],
            [
              27.8027800043937,
              -27.786219998654
            ],
            [
              27.8628400005656,
              -27.7895200042448
            ],
            [
              27.8380899968559,
              -27.6726219986064
            ],
            [
              27.9197700025836,
              -27.6426099986525
            ],
            [
              27.9886000002898,
              -27.6322099956947
            ],
            [
              28.0077819963421,
              -27.5638039995548
            ],
            [
              28.0568700027485,
              -27.5642199989538
            ],
            [
              28.1886899959466,
              -27.4817800031446
            ],
            [
              28.2508899990743,
              -27.4977900004081
            ],
            [
              28.2832399980275,
              -27.3596899972955
            ],
            [
              28.2273599985651,
              -27.2876100017001
            ],
            [
              28.2870800006416,
              -27.2041200033354
            ],
            [
              28.2642399968784,
              -27.186220002551
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Ngwathe Local Municipality",
        "Code": "FS203",
        "Parent_cod": "DC20",
        "Area": 705501
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              28.897497628213,
              -26.6239778770773
            ],
            [
              28.9921100036737,
              -26.608890000573
            ],
            [
              28.9912000003798,
              -26.6859699974174
            ],
            [
              29.0231099988274,
              -26.6816199991635
            ],
            [
              29.1251500009718,
              -26.707419997335
            ],
            [
              29.241399997412,
              -26.7168400000659
            ],
            [
              29.2237999987709,
              -26.6583300034269
            ],
            [
              29.2909979922636,
              -26.6400599981704
            ],
            [
              29.3254900009628,
              -26.6612600018475
            ],
            [
              29.4593800032846,
              -26.6467099972685
            ],
            [
              29.4563200042649,
              -26.5915500040295
            ],
            [
              29.4868300002044,
              -26.553310003254
            ],
            [
              29.5683100012056,
              -26.5615500037296
            ],
            [
              29.6191699948994,
              -26.5290599983202
            ],
            [
              29.6288999984362,
              -26.4806500006969
            ],
            [
              29.6279899951423,
              -26.4744299962473
            ],
            [
              29.6034000024082,
              -26.4350000107419
            ],
            [
              29.5661800019056,
              -26.4427500039095
            ],
            [
              29.4686699982219,
              -26.3524900027115
            ],
            [
              29.4702900018821,
              -26.3032099964441
            ],
            [
              29.5403500005521,
              -26.2538799977637
            ],
            [
              29.5602259980315,
              -26.2092079962519
            ],
            [
              29.4934499961205,
              -26.169549999333
            ],
            [
              29.4555499993331,
              -26.2114000029078
            ],
            [
              29.3879699999157,
              -26.2049000008343
            ],
            [
              29.3481600031817,
              -26.2317799957502
            ],
            [
              29.3406900004432,
              -26.2450800029398
            ],
            [
              29.3665729988449,
              -26.2921079970863
            ],
            [
              29.335469998042,
              -26.3483300024277
            ],
            [
              29.2606199988139,
              -26.3623600037112
            ],
            [
              29.173069996683,
              -26.3488899958766
            ],
            [
              29.1235900018772,
              -26.3842899969857
            ],
            [
              29.102230003412,
              -26.3297600031216
            ],
            [
              29.0658000042668,
              -26.3142900037806
            ],
            [
              29.0332620011405,
              -26.2257600032215
            ],
            [
              28.9842199959561,
              -26.2369300102118
            ],
            [
              28.9395099962894,
              -26.2658099957347
            ],
            [
              28.8863400030887,
              -26.2577100026145
            ],
            [
              28.8675600021924,
              -26.3276500002473
            ],
            [
              28.8384400029039,
              -26.3407500027104
            ],
            [
              28.8612899981349,
              -26.3985699963083
            ],
            [
              28.7899300006691,
              -26.4264500031651
            ],
            [
              28.7639100031442,
              -26.5180099995618
            ],
            [
              28.8367899969608,
              -26.5363800040339
            ],
            [
              28.8526300007739,
              -26.5675599993944
            ],
            [
              28.9110800009414,
              -26.5899499967949
            ],
            [
              28.897497628213,
              -26.6239778770773
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Govan Mbeki Local Municipality",
        "Code": "MP307",
        "Parent_cod": "DC30",
        "Area": 295469
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              30.2675299430001,
              -28.731019939
            ],
            [
              30.2786099432944,
              -28.6837999392157
            ],
            [
              30.2339699432583,
              -28.6211899387646
            ],
            [
              30.2207299442316,
              -28.5733199390639
            ],
            [
              30.300659943002,
              -28.5340999389609
            ],
            [
              30.3377700679344,
              -28.4739200640596
            ],
            [
              30.2335949430001,
              -28.4087099389999
            ],
            [
              30.1781249427119,
              -28.4396629393931
            ],
            [
              30.1356399430002,
              -28.340529939
            ],
            [
              30.0754799430002,
              -28.357839939
            ],
            [
              30.0654099420001,
              -28.305130064
            ],
            [
              29.9767939419869,
              -28.2395879390321
            ],
            [
              29.9904299420001,
              -28.184929939
            ],
            [
              29.8831437188077,
              -28.1956047516579
            ],
            [
              29.8140841538607,
              -28.2150348688641
            ],
            [
              29.7887027270002,
              -28.1742505569999
            ],
            [
              29.7275999418839,
              -28.1256499385938
            ],
            [
              29.6632899340001,
              -28.142020045
            ],
            [
              29.6263399694141,
              -28.1857399703233
            ],
            [
              29.6197650268346,
              -28.2412199603329
            ],
            [
              29.5099200442747,
              -28.2654399369035
            ],
            [
              29.4375799728375,
              -28.3211299689728
            ],
            [
              29.4143099681305,
              -28.3759100157346
            ],
            [
              29.3755599770001,
              -28.3721099709999
            ],
            [
              29.4382699417044,
              -28.4231199391338
            ],
            [
              29.4854199420002,
              -28.402649939
            ],
            [
              29.5194599419229,
              -28.4718199393387
            ],
            [
              29.4918809417521,
              -28.5287999391658
            ],
            [
              29.5656499420001,
              -28.570809939
            ],
            [
              29.6103829420001,
              -28.532850939
            ],
            [
              29.6699799420001,
              -28.562320064
            ],
            [
              29.578769942,
              -28.6396299389999
            ],
            [
              29.5677120167963,
              -28.665980470922
            ],
            [
              29.6188299420002,
              -28.6953100639999
            ],
            [
              29.6699799420001,
              -28.7471599389999
            ],
            [
              29.761249942,
              -28.737949939
            ],
            [
              29.8478600665888,
              -28.743899939031
            ],
            [
              29.8291399416552,
              -28.6986399391819
            ],
            [
              29.881630067,
              -28.6694999389999
            ],
            [
              29.9306299418185,
              -28.6818299392003
            ],
            [
              29.9950299420001,
              -28.6428199389999
            ],
            [
              30.0433300668292,
              -28.7057499388086
            ],
            [
              30.1440799429352,
              -28.7456799392777
            ],
            [
              30.190659943,
              -28.7503699389999
            ],
            [
              30.2675299430001,
              -28.731019939
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Alfred Duma Local Municipality",
        "Code": "KZN238",
        "Parent_cod": "DC23",
        "Area": 376441
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              29.5067999420001,
              -29.33977994
            ],
            [
              29.5786299420002,
              -29.3355200649999
            ],
            [
              29.5692989660001,
              -29.2892121429998
            ],
            [
              29.6097400670001,
              -29.2486499399999
            ],
            [
              29.652099942,
              -29.2970799399999
            ],
            [
              29.7537900670002,
              -29.2832599399998
            ],
            [
              29.755719942,
              -29.20693994
            ],
            [
              29.854859942,
              -29.2180799399998
            ],
            [
              29.9268999420002,
              -29.12184994
            ],
            [
              30.0279899420001,
              -29.059320065
            ],
            [
              30.071779943,
              -29.011880064
            ],
            [
              30.0861799430002,
              -28.966530064
            ],
            [
              30.2296299430001,
              -28.984039939
            ],
            [
              30.2236899430002,
              -28.945749939
            ],
            [
              30.2874699426838,
              -28.9148999385813
            ],
            [
              30.2681299429425,
              -28.9053099388026
            ],
            [
              30.2832269430001,
              -28.811147939
            ],
            [
              30.2675299430001,
              -28.731019939
            ],
            [
              30.190659943,
              -28.7503699389999
            ],
            [
              30.1440799429352,
              -28.7456799392777
            ],
            [
              30.0433300668292,
              -28.7057499388086
            ],
            [
              29.9950299420001,
              -28.6428199389999
            ],
            [
              29.9306299418185,
              -28.6818299392003
            ],
            [
              29.881630067,
              -28.6694999389999
            ],
            [
              29.8291399416552,
              -28.6986399391819
            ],
            [
              29.8478600665888,
              -28.743899939031
            ],
            [
              29.761249942,
              -28.737949939
            ],
            [
              29.7384299420001,
              -28.791759939
            ],
            [
              29.6771500670001,
              -28.866379939
            ],
            [
              29.6318699420001,
              -28.868699939
            ],
            [
              29.5810699420001,
              -28.9411199389999
            ],
            [
              29.540569942,
              -28.937549939
            ],
            [
              29.4736100670002,
              -29.0917479399999
            ],
            [
              29.4199829100001,
              -29.1492061609998
            ],
            [
              29.3570499420001,
              -29.1342499399999
            ],
            [
              29.3566299420001,
              -29.20131994
            ],
            [
              29.407429942,
              -29.2115599399999
            ],
            [
              29.4369599420001,
              -29.26455994
            ],
            [
              29.455459942,
              -29.3412499399999
            ],
            [
              29.5067999420001,
              -29.33977994
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Inkosi Langalibalele Local Municipality",
        "Code": "KZN237",
        "Parent_cod": "DC23",
        "Area": 339864
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              30.5407999428631,
              -29.6182300646657
            ],
            [
              30.4811499430001,
              -29.5953899399999
            ],
            [
              30.4316599430002,
              -29.5434300649999
            ],
            [
              30.3646799428252,
              -29.5428799398573
            ],
            [
              30.2583999430031,
              -29.580039940291
            ],
            [
              30.1954574568962,
              -29.6131068697862
            ],
            [
              30.1060999430001,
              -29.6296899399999
            ],
            [
              30.0771499429156,
              -29.6706299396199
            ],
            [
              30.0691999430001,
              -29.7240400649999
            ],
            [
              29.9803320547805,
              -29.7194044360658
            ],
            [
              29.9574130650001,
              -29.780812339
            ],
            [
              30.0453613570001,
              -29.8299619079999
            ],
            [
              30.0923549426266,
              -29.7472800650229
            ],
            [
              30.1533799428302,
              -29.7214300654451
            ],
            [
              30.2412099425848,
              -29.7313899401935
            ],
            [
              30.3724499430001,
              -29.7268199399999
            ],
            [
              30.3995399430002,
              -29.74862994
            ],
            [
              30.4953599428071,
              -29.7054599396244
            ],
            [
              30.4660399432888,
              -29.672200065081
            ],
            [
              30.4919699429586,
              -29.6255699400006
            ],
            [
              30.5407999428631,
              -29.6182300646657
            ]
          ]
        ]
      },
      "properties": {
        "Name": "The Msunduzi Local Municipality",
        "Code": "KZN225",
        "Parent_cod": "DC22",
        "Area": 75109
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              30.1060999430001,
              -29.6296899399999
            ],
            [
              30.0175800670001,
              -29.5898399399999
            ],
            [
              30.0061899420001,
              -29.53643994
            ],
            [
              29.9189099418405,
              -29.5336199400081
            ],
            [
              29.8216399420001,
              -29.4566899399999
            ],
            [
              29.6893735280001,
              -29.4033449869999
            ],
            [
              29.6132800410001,
              -29.408469922
            ],
            [
              29.5067999420001,
              -29.33977994
            ],
            [
              29.455459942,
              -29.3412499399999
            ],
            [
              29.4033899420001,
              -29.44401994
            ],
            [
              29.3293499420001,
              -29.4701600649999
            ],
            [
              29.2998455207542,
              -29.4989355186592
            ],
            [
              29.399520874,
              -29.524938583
            ],
            [
              29.49370888,
              -29.5868603249999
            ],
            [
              29.592859924646,
              -29.5773600298415
            ],
            [
              29.7028197170002,
              -29.6357434479999
            ],
            [
              29.6872406005733,
              -29.6755599978956
            ],
            [
              29.7634254329375,
              -29.6741823606274
            ],
            [
              29.918522931,
              -29.7674807449999
            ],
            [
              29.9574130650001,
              -29.780812339
            ],
            [
              29.9803320547805,
              -29.7194044360658
            ],
            [
              30.0691999430001,
              -29.7240400649999
            ],
            [
              30.0771499429156,
              -29.6706299396199
            ],
            [
              30.1060999430001,
              -29.6296899399999
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Impendle Local Municipality",
        "Code": "KZN224",
        "Parent_cod": "DC22",
        "Area": 160964
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              25.5893300018781,
              -31.4853100023547
            ],
            [
              25.6656700032681,
              -31.4609999991507
            ],
            [
              25.706090002052,
              -31.4751199937927
            ],
            [
              25.7692599968514,
              -31.4441400031586
            ],
            [
              25.8230300024328,
              -31.4658799975637
            ],
            [
              25.8565700023039,
              -31.4536599961119
            ],
            [
              25.965890002022,
              -31.4767699997357
            ],
            [
              26.0023467434075,
              -31.4101645128819
            ],
            [
              25.9992299989653,
              -31.3348700021488
            ],
            [
              26.0331900038157,
              -31.3321800004067
            ],
            [
              26.1263100002064,
              -31.2786800027799
            ],
            [
              26.1302299957178,
              -31.2655600029917
            ],
            [
              26.2034199993336,
              -31.2772399993265
            ],
            [
              26.2370099979131,
              -31.2243200005675
            ],
            [
              26.2988600001888,
              -31.2168499969298
            ],
            [
              26.3361299994,
              -31.249409999272
            ],
            [
              26.3586499982989,
              -31.1964999991756
            ],
            [
              26.426300000045,
              -31.1847400027489
            ],
            [
              26.4271300023478,
              -31.2229999990507
            ],
            [
              26.5210299942389,
              -31.2072799971741
            ],
            [
              26.6287400042479,
              -31.2293899978501
            ],
            [
              26.6873800005866,
              -31.1925900014274
            ],
            [
              26.7086999999052,
              -31.2771000000649
            ],
            [
              26.6666800019806,
              -31.3213600005636
            ],
            [
              26.6636700016693,
              -31.3725599982453
            ],
            [
              26.6126600028569,
              -31.3719799912835
            ],
            [
              26.6333200014169,
              -31.45524999659
            ],
            [
              26.7432300058602,
              -31.4172600001489
            ],
            [
              26.8468699990512,
              -31.4358500030751
            ],
            [
              26.8822799979236,
              -31.3780199964257
            ],
            [
              26.9346449962696,
              -31.3439699991161
            ],
            [
              27.0171400018098,
              -31.3610249960067
            ],
            [
              27.047469999341,
              -31.3445499988833
            ],
            [
              27.0865599979456,
              -31.3974600061743
            ],
            [
              27.1307899961615,
              -31.4266000009891
            ],
            [
              27.1751799981584,
              -31.367779997249
            ],
            [
              27.275999996203,
              -31.3397599992246
            ],
            [
              27.2965700032032,
              -31.2915800023152
            ],
            [
              27.2421799978087,
              -31.2599400019296
            ],
            [
              27.1952999978966,
              -31.283430000594
            ],
            [
              27.1651299888579,
              -31.2597800071416
            ],
            [
              27.1687499993131,
              -31.1601500019211
            ],
            [
              27.2178300017532,
              -31.1459899982398
            ],
            [
              27.1587300003892,
              -31.0519699972176
            ],
            [
              27.1411799995574,
              -31.0018899981248
            ],
            [
              27.1734499984187,
              -30.9753099972586
            ],
            [
              27.1311100019251,
              -30.905224998335
            ],
            [
              27.1797999962728,
              -30.8026400016347
            ],
            [
              27.1191000029628,
              -30.7828099990822
            ],
            [
              27.1071199981895,
              -30.6317700026835
            ],
            [
              27.034309991413,
              -30.5998599961418
            ],
            [
              26.947899998686,
              -30.6076399996862
            ],
            [
              26.9430100016103,
              -30.662149998024
            ],
            [
              26.8476799968344,
              -30.6838699969028
            ],
            [
              26.8141400041579,
              -30.6426700026185
            ],
            [
              26.7166700014194,
              -30.6764400023042
            ],
            [
              26.7162499973395,
              -30.6768699969528
            ],
            [
              26.6294500037147,
              -30.6938799980634
            ],
            [
              26.481230003362,
              -30.6276299988253
            ],
            [
              26.490230002013,
              -30.5960100029593
            ],
            [
              26.4251800023552,
              -30.5652399977276
            ],
            [
              26.3489100041933,
              -30.5949699990661
            ],
            [
              26.2806099985526,
              -30.5783599984151
            ],
            [
              26.2596499987485,
              -30.5407200010272
            ],
            [
              26.1938300022529,
              -30.5279799971791
            ],
            [
              26.1625599991447,
              -30.4834899968658
            ],
            [
              26.097999998701,
              -30.5165000055707
            ],
            [
              26.0511100082203,
              -30.5229699936702
            ],
            [
              26.0508300069992,
              -30.5230699955838
            ],
            [
              25.9730899896114,
              -30.5393899927539
            ],
            [
              25.8512299988654,
              -30.6293300043762
            ],
            [
              25.7998299982558,
              -30.6347900016572
            ],
            [
              25.7789000007345,
              -30.6758799998621
            ],
            [
              25.7001399956643,
              -30.6795099999865
            ],
            [
              25.6715600041909,
              -30.6408799983132
            ],
            [
              25.6308599996893,
              -30.6593500002023
            ],
            [
              25.6030899970058,
              -30.5943900001983
            ],
            [
              25.5562800003218,
              -30.6166299996747
            ],
            [
              25.4670999967675,
              -30.6242100110831
            ],
            [
              25.4564800043487,
              -30.6370000037471
            ],
            [
              25.4802000019286,
              -30.7789099999964
            ],
            [
              25.5248500024257,
              -30.7963999989608
            ],
            [
              25.5216299978262,
              -30.8331800007564
            ],
            [
              25.471289999334,
              -30.8698400006155
            ],
            [
              25.5175900003782,
              -30.9033899982498
            ],
            [
              25.5109499981439,
              -30.9557200003777
            ],
            [
              25.4750199995733,
              -30.9838800003617
            ],
            [
              25.4867500009118,
              -31.0369100041934
            ],
            [
              25.4463899985996,
              -31.1002000018286
            ],
            [
              25.3845600008434,
              -31.1509700012645
            ],
            [
              25.3862100013905,
              -31.217840003913
            ],
            [
              25.4794099978732,
              -31.2372500023857
            ],
            [
              25.5575299986106,
              -31.2779900069333
            ],
            [
              25.5121199972401,
              -31.3460099987624
            ],
            [
              25.5644999962779,
              -31.358469997792
            ],
            [
              25.5917100037137,
              -31.4188699970527
            ],
            [
              25.5893300018781,
              -31.4853100023547
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Walter Sisulu Local Municipality",
        "Code": "EC145",
        "Parent_cod": "DC14",
        "Area": 1326893,
        "detail": "Walter Sisulu Local Municipality is a Category B municipality in the western part of the Joe Gqabi District, Eastern Cape. Located south of the Orange River and Gariep Dam, it borders both the Northern Cape and Free State provinces. It is the largest municipality in the district, covering half of its area, and was formed in 2016 through the merger of the Gariep and Maletswai municipalities.\nThe region features mountainous terrain, hills, and valleys, with diverse vegetation that includes the nationally significant Eastern Mixed Nama Karoo biome. The local economy is largely driven by stock farming, particularly sheep farming, and the area's rivers and streams are known for trout fishing.\n",
        "link_to_webpage": "https://www.wslm.gov.za/",
        "image": "https://corruptionwatch-my.sharepoint.com/:i:/g/personal/nontobekog_corruptionwatch_org_za/EVQlTMB1cJhMmx-XdUgGnskB49L38nxFy-EAIyKRMmW_oQ?e=7nbGYn",
        "image_alt": ""
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              30.2874699426838,
              -28.9148999385813
            ],
            [
              30.2236899430002,
              -28.945749939
            ],
            [
              30.2296299430001,
              -28.984039939
            ],
            [
              30.0861799430002,
              -28.966530064
            ],
            [
              30.071779943,
              -29.011880064
            ],
            [
              30.0279899420001,
              -29.059320065
            ],
            [
              29.9268999420002,
              -29.12184994
            ],
            [
              29.854859942,
              -29.2180799399998
            ],
            [
              29.755719942,
              -29.20693994
            ],
            [
              29.7537900670002,
              -29.2832599399998
            ],
            [
              29.652099942,
              -29.2970799399999
            ],
            [
              29.6097400670001,
              -29.2486499399999
            ],
            [
              29.5692989660001,
              -29.2892121429998
            ],
            [
              29.5786299420002,
              -29.3355200649999
            ],
            [
              29.5067999420001,
              -29.33977994
            ],
            [
              29.6132800410001,
              -29.408469922
            ],
            [
              29.6893735280001,
              -29.4033449869999
            ],
            [
              29.8416899420001,
              -29.35795994
            ],
            [
              29.8924699420001,
              -29.35247494
            ],
            [
              29.9306899418874,
              -29.3190699403254
            ],
            [
              30.0055870670002,
              -29.33847194
            ],
            [
              30.0117799419909,
              -29.2967100648176
            ],
            [
              30.0566199420001,
              -29.2878599399999
            ],
            [
              30.1227399426943,
              -29.2451099398718
            ],
            [
              30.2082289430001,
              -29.25164094
            ],
            [
              30.2213899430001,
              -29.292090065
            ],
            [
              30.2762999428881,
              -29.3091499397179
            ],
            [
              30.3358700680002,
              -29.163850065
            ],
            [
              30.3636099429446,
              -29.1230299398797
            ],
            [
              30.3090493180002,
              -29.09782519
            ],
            [
              30.3425681929678,
              -29.0502605653728
            ],
            [
              30.3002510820002,
              -28.955970043
            ],
            [
              30.3277416459604,
              -28.9467126007059
            ],
            [
              30.2874699426838,
              -28.9148999385813
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Mpofana Local Municipality",
        "Code": "KZN223",
        "Parent_cod": "DC22",
        "Area": 175521
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              30.1060999430001,
              -29.6296899399999
            ],
            [
              30.1954574568962,
              -29.6131068697862
            ],
            [
              30.2583999430031,
              -29.580039940291
            ],
            [
              30.3646799428252,
              -29.5428799398573
            ],
            [
              30.3565901426211,
              -29.4853017631658
            ],
            [
              30.3195299426528,
              -29.4435100653372
            ],
            [
              30.3195299426528,
              -29.4398899397689
            ],
            [
              30.306099942958,
              -29.40222993966
            ],
            [
              30.327219942946,
              -29.3376399396314
            ],
            [
              30.2762999428881,
              -29.3091499397179
            ],
            [
              30.2213899430001,
              -29.292090065
            ],
            [
              30.2082289430001,
              -29.25164094
            ],
            [
              30.1227399426943,
              -29.2451099398718
            ],
            [
              30.0566199420001,
              -29.2878599399999
            ],
            [
              30.0117799419909,
              -29.2967100648176
            ],
            [
              30.0055870670002,
              -29.33847194
            ],
            [
              29.9306899418874,
              -29.3190699403254
            ],
            [
              29.8924699420001,
              -29.35247494
            ],
            [
              29.8416899420001,
              -29.35795994
            ],
            [
              29.6893735280001,
              -29.4033449869999
            ],
            [
              29.8216399420001,
              -29.4566899399999
            ],
            [
              29.9189099418405,
              -29.5336199400081
            ],
            [
              30.0061899420001,
              -29.53643994
            ],
            [
              30.0175800670001,
              -29.5898399399999
            ],
            [
              30.1060999430001,
              -29.6296899399999
            ]
          ]
        ]
      },
      "properties": {
        "Name": "uMngeni Local Municipality",
        "Code": "KZN222",
        "Parent_cod": "DC22",
        "Area": 152076
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              30.727179943,
              -29.5709399399999
            ],
            [
              30.7025199430001,
              -29.56112994
            ],
            [
              30.7477500678114,
              -29.4670699404253
            ],
            [
              30.793549943,
              -29.44954994
            ],
            [
              30.880389943,
              -29.3676699399999
            ],
            [
              30.854649943,
              -29.322220065
            ],
            [
              30.8771899430001,
              -29.27558994
            ],
            [
              30.8277599425675,
              -29.2650700653312
            ],
            [
              30.8061099430002,
              -29.2223500649999
            ],
            [
              30.7665800680001,
              -29.198020065
            ],
            [
              30.6603399426345,
              -29.2242399397214
            ],
            [
              30.5787799430001,
              -29.258110065
            ],
            [
              30.522809943,
              -29.2200199399999
            ],
            [
              30.4187999429632,
              -29.2626999398502
            ],
            [
              30.3760299428277,
              -29.1861799400521
            ],
            [
              30.3358700680002,
              -29.163850065
            ],
            [
              30.2762999428881,
              -29.3091499397179
            ],
            [
              30.327219942946,
              -29.3376399396314
            ],
            [
              30.306099942958,
              -29.40222993966
            ],
            [
              30.3195299426528,
              -29.4398899397689
            ],
            [
              30.3195299426528,
              -29.4435100653372
            ],
            [
              30.3565901426211,
              -29.4853017631658
            ],
            [
              30.3646799428252,
              -29.5428799398573
            ],
            [
              30.4316599430002,
              -29.5434300649999
            ],
            [
              30.4811499430001,
              -29.5953899399999
            ],
            [
              30.5407999428631,
              -29.6182300646657
            ],
            [
              30.530729943,
              -29.58253994
            ],
            [
              30.5687399425943,
              -29.5473999396555
            ],
            [
              30.6180599426124,
              -29.5499600649051
            ],
            [
              30.6737529430002,
              -29.6199020649999
            ],
            [
              30.7260899430001,
              -29.606040065
            ],
            [
              30.727179943,
              -29.5709399399999
            ]
          ]
        ]
      },
      "properties": {
        "Name": "uMshwathi Local Municipality",
        "Code": "KZN221",
        "Parent_cod": "DC22",
        "Area": 186585
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              28.1176800002318,
              -30.6686699974224
            ],
            [
              28.0845700022039,
              -30.6539800007764
            ],
            [
              28.0037499929678,
              -30.658990000688
            ],
            [
              27.9405200007975,
              -30.6441099988773
            ],
            [
              27.9183500027505,
              -30.6025899988294
            ],
            [
              27.7816699985716,
              -30.617299999995
            ],
            [
              27.7419100014454,
              -30.603900002583
            ],
            [
              27.6934099978732,
              -30.5448099989822
            ],
            [
              27.6236000008394,
              -30.5062000009293
            ],
            [
              27.6044000039571,
              -30.4494599968813
            ],
            [
              27.5340199977248,
              -30.3843599976158
            ],
            [
              27.4749599964068,
              -30.3564799997521
            ],
            [
              27.4645899957318,
              -30.3140299999845
            ],
            [
              27.3773500034,
              -30.3271199956912
            ],
            [
              27.4030099942159,
              -30.3929700043622
            ],
            [
              27.3445899972306,
              -30.3973300012785
            ],
            [
              27.2935399983723,
              -30.4567500012116
            ],
            [
              27.2844899992141,
              -30.5034000031076
            ],
            [
              27.2294599993795,
              -30.4991900113099
            ],
            [
              27.1884500021659,
              -30.5237900018071
            ],
            [
              27.0013099957598,
              -30.5414999956283
            ],
            [
              27.0003100009059,
              -30.5441700018441
            ],
            [
              27.034309991413,
              -30.5998599961418
            ],
            [
              27.1071199981895,
              -30.6317700026835
            ],
            [
              27.1191000029628,
              -30.7828099990822
            ],
            [
              27.1797999962728,
              -30.8026400016347
            ],
            [
              27.1311100019251,
              -30.905224998335
            ],
            [
              27.1734499984187,
              -30.9753099972586
            ],
            [
              27.1411799995574,
              -31.0018899981248
            ],
            [
              27.1587300003892,
              -31.0519699972176
            ],
            [
              27.2178300017532,
              -31.1459899982398
            ],
            [
              27.1687499993131,
              -31.1601500019211
            ],
            [
              27.1651299888579,
              -31.2597800071416
            ],
            [
              27.1952999978966,
              -31.283430000594
            ],
            [
              27.2421799978087,
              -31.2599400019296
            ],
            [
              27.2965700032032,
              -31.2915800023152
            ],
            [
              27.275999996203,
              -31.3397599992246
            ],
            [
              27.3445799985681,
              -31.380259999899
            ],
            [
              27.3626250006434,
              -31.4223000023432
            ],
            [
              27.4084600018276,
              -31.4184599988298
            ],
            [
              27.442959997406,
              -31.3774100015703
            ],
            [
              27.451310002055,
              -31.2571900019171
            ],
            [
              27.4907000028029,
              -31.2525900011276
            ],
            [
              27.5695599971962,
              -31.2090899979051
            ],
            [
              27.6241200032356,
              -31.2240299970866
            ],
            [
              27.7365199992986,
              -31.2350499998575
            ],
            [
              27.7600200038202,
              -31.2036499970497
            ],
            [
              27.8081299903068,
              -31.2147699972375
            ],
            [
              27.8717900014074,
              -31.2032799988728
            ],
            [
              27.931252005076,
              -31.2340140006456
            ],
            [
              27.9684800005516,
              -31.1985300010587
            ],
            [
              27.9854900016623,
              -31.1519900033359
            ],
            [
              27.9815750009856,
              -31.0765150013662
            ],
            [
              28.0639399978327,
              -31.0125699978071
            ],
            [
              28.0511399966136,
              -30.974329997931
            ],
            [
              28.0786199958162,
              -30.913060002617
            ],
            [
              28.1321300001994,
              -30.8353000022932
            ],
            [
              28.1204200015819,
              -30.7781699964481
            ],
            [
              28.1622900015823,
              -30.6927900026564
            ],
            [
              28.1176800002318,
              -30.6686699974224
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Senqu Local Municipality",
        "Code": "EC142",
        "Parent_cod": "DC14",
        "Area": 732942,
        "detail": "Senqu Local Municipality is a Category B municipality located in the Joe Gqabi District of the Eastern Cape Province. It borders Lesotho to the north, Chris Hani District to the south, Elundini to the east, and Walter Sisulu to the west. Covering a third of the district’s geographical area, it is one of three municipalities in the district.\nSenqu was formed through the amalgamation of the former municipalities of Lady Grey, Barkly East, Sterkspruit, Rossouw, and Rhodes, reflecting a history of regional integration.\n",
        "link_to_webpage": "https://senqu.gov.za/",
        "image": "https://corruptionwatch-my.sharepoint.com/:i:/g/personal/nontobekog_corruptionwatch_org_za/Ea0CY7onIUhPqxyXpfYFP3YBwcMex4NsXewgjc-yzrsOfA?e=yfWHl2",
        "image_alt": ""
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              28.3823199985691,
              -31.4805500049787
            ],
            [
              28.4439800019755,
              -31.3864699975922
            ],
            [
              28.4905900038257,
              -31.366789999259
            ],
            [
              28.4992599980505,
              -31.3326299986755
            ],
            [
              28.4559899937433,
              -31.3068399991666
            ],
            [
              28.4978000062653,
              -31.2502700038576
            ],
            [
              28.5480999966177,
              -31.235390002047
            ],
            [
              28.61938999805,
              -31.236869999251
            ],
            [
              28.6822699983618,
              -31.179260000049
            ],
            [
              28.675480000002,
              -31.1349700035628
            ],
            [
              28.6009800097197,
              -31.0882300020129
            ],
            [
              28.5395799994175,
              -31.0903899964012
            ],
            [
              28.5259200008074,
              -31.0488599976907
            ],
            [
              28.5772499981889,
              -30.9929100030941
            ],
            [
              28.5916499976493,
              -30.9311100013255
            ],
            [
              28.6386100003513,
              -30.9209299986205
            ],
            [
              28.6411130762075,
              -30.7729163486106
            ],
            [
              28.5957500023607,
              -30.7191200009872
            ],
            [
              28.5498500008769,
              -30.6924300040414
            ],
            [
              28.5603699976773,
              -30.6552600022473
            ],
            [
              28.5405500081764,
              -30.5889899993889
            ],
            [
              28.569840000016,
              -30.4962900061789
            ],
            [
              28.6160299968868,
              -30.4722400041729
            ],
            [
              28.5769699933705,
              -30.4371799980584
            ],
            [
              28.5361800054029,
              -30.4672600002488
            ],
            [
              28.4808400038632,
              -30.4222999971471
            ],
            [
              28.268770003433,
              -30.373729996642
            ],
            [
              28.2576500023457,
              -30.4163800011361
            ],
            [
              28.1795599966965,
              -30.4389199883667
            ],
            [
              28.1555899956818,
              -30.4718299906615
            ],
            [
              28.1773500035998,
              -30.5224100029192
            ],
            [
              28.1507399923568,
              -30.5842999971471
            ],
            [
              28.1141300010987,
              -30.599030001933
            ],
            [
              28.1176800002318,
              -30.6686699974224
            ],
            [
              28.1622900015823,
              -30.6927900026564
            ],
            [
              28.1204200015819,
              -30.7781699964481
            ],
            [
              28.1321300001994,
              -30.8353000022932
            ],
            [
              28.0786199958162,
              -30.913060002617
            ],
            [
              28.0511399966136,
              -30.974329997931
            ],
            [
              28.0639399978327,
              -31.0125699978071
            ],
            [
              27.9815750009856,
              -31.0765150013662
            ],
            [
              27.9854900016623,
              -31.1519900033359
            ],
            [
              27.9684800005516,
              -31.1985300010587
            ],
            [
              27.931252005076,
              -31.2340140006456
            ],
            [
              27.9885199912046,
              -31.2404099997217
            ],
            [
              28.0807699996358,
              -31.323750001961
            ],
            [
              28.1212199926087,
              -31.300120004035
            ],
            [
              28.216159997386,
              -31.3128000033175
            ],
            [
              28.2538199983942,
              -31.3339900011376
            ],
            [
              28.2607000036023,
              -31.3704399967085
            ],
            [
              28.2937699925912,
              -31.4166999968074
            ],
            [
              28.3812650011789,
              -31.480000001199
            ],
            [
              28.3823199985691,
              -31.4805500049787
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Elundini Local Municipality",
        "Code": "EC141",
        "Parent_cod": "DC14",
        "Area": 501881,
        "detail": "Elundini Local Municipality (ELM) is a Category B municipality in the north-eastern part of the Eastern Cape, within the Joe Gqabi District. It borders Alfred Nzo District to the north, Chris Hani to the south, OR Tambo to the east, and Lesotho and Senqu to the west. It is the smallest of the three municipalities in the district, comprising about 25% of its geographical area.\nElundini is known for its scenic landscapes, fertile soils, and high rainfall, offering strong potential for economic growth and improved living standards. Employment is mainly found in urban areas and commercial farming, with agriculture, commercial, and service sectors being key employers. Rural areas suffer from low employment due to weak economic foundations and a reliance on subsistence activities with minimal surplus for trade.\n",
        "link_to_webpage": "https://www.elundini.gov.za/about-us/",
        "image": "https://corruptionwatch-my.sharepoint.com/:i:/g/personal/nontobekog_corruptionwatch_org_za/EYYxobruWVdKvzdNOlGrJDkBBPxoXXuGoaml4mKt_ffTig?e=MxjvYT",
        "image_alt": ""
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              27.8628400005656,
              -27.7895200042448
            ],
            [
              27.8027800043937,
              -27.786219998654
            ],
            [
              27.7417599972262,
              -27.806370000675
            ],
            [
              27.6333710017703,
              -27.8031710006411
            ],
            [
              27.5826590032105,
              -27.777693003829
            ],
            [
              27.566809998083,
              -27.7380400017447
            ],
            [
              27.6394299987954,
              -27.6815599988948
            ],
            [
              27.5768099996818,
              -27.6185400002208
            ],
            [
              27.4785700001055,
              -27.6312099927469
            ],
            [
              27.435974999047,
              -27.5704660010052
            ],
            [
              27.4532399984273,
              -27.5211800007564
            ],
            [
              27.4434200024312,
              -27.48291999726
            ],
            [
              27.3110700009798,
              -27.4882399961788
            ],
            [
              27.2977799996473,
              -27.4642099986925
            ],
            [
              27.2320799978937,
              -27.4746199994134
            ],
            [
              27.1717900019071,
              -27.3975900021768
            ],
            [
              27.1702599979006,
              -27.3167600032715
            ],
            [
              27.2145100024348,
              -27.2785799998671
            ],
            [
              27.3787099968689,
              -27.2913000000949
            ],
            [
              27.3937500015614,
              -27.2383499990532
            ],
            [
              27.3740800009913,
              -27.1498099998316
            ],
            [
              27.3899199967106,
              -27.1113800019855
            ],
            [
              27.3408100000815,
              -27.0193000022932
            ],
            [
              27.3515299998097,
              -26.942309997908
            ],
            [
              27.3894850000328,
              -26.906384999568
            ],
            [
              27.306050003305,
              -26.853339995944
            ],
            [
              27.2191600019326,
              -26.9443599962168
            ],
            [
              27.1736600009083,
              -26.9675900017772
            ],
            [
              27.1134300022928,
              -26.9263599971161
            ],
            [
              27.0139299976713,
              -26.9320500023057
            ],
            [
              26.9472200095958,
              -26.8920099985625
            ],
            [
              26.9086800003817,
              -26.9457100000165
            ],
            [
              26.8664400022044,
              -26.9190600031166
            ],
            [
              26.8050200017717,
              -26.9319799990777
            ],
            [
              26.6718200015919,
              -26.9957300008388
            ],
            [
              26.621069996783,
              -27.0027200030256
            ],
            [
              26.5818200033905,
              -27.0531199997881
            ],
            [
              26.5856199969653,
              -27.1060299998845
            ],
            [
              26.5216199989638,
              -27.1043899997986
            ],
            [
              26.5754100000715,
              -27.1833199983192
            ],
            [
              26.6352499968899,
              -27.1715699996558
            ],
            [
              26.6830999983663,
              -27.1902600008983
            ],
            [
              26.7275899896863,
              -27.2308100002812
            ],
            [
              26.7379899998387,
              -27.3449000032325
            ],
            [
              26.6959799996773,
              -27.3497599971261
            ],
            [
              26.6990300018331,
              -27.4007800017956
            ],
            [
              26.7463199999681,
              -27.3953400000409
            ],
            [
              26.7897199967805,
              -27.510839987975
            ],
            [
              26.7536799994325,
              -27.5140000023981
            ],
            [
              26.7633200114095,
              -27.5642500093304
            ],
            [
              26.8577100016153,
              -27.5860000032975
            ],
            [
              26.8703599977158,
              -27.5337899968109
            ],
            [
              26.950050003405,
              -27.5225000031726
            ],
            [
              26.9663100032042,
              -27.5625399979225
            ],
            [
              27.0163299968319,
              -27.598240001175
            ],
            [
              26.9744899991142,
              -27.6429099998965
            ],
            [
              26.9699400042278,
              -27.6944499988683
            ],
            [
              27.044769998037,
              -27.749099997367
            ],
            [
              27.0771500001724,
              -27.789149997974
            ],
            [
              27.040869998052,
              -27.8090600042158
            ],
            [
              27.0525000028729,
              -27.8593100039534
            ],
            [
              27.157790002007,
              -27.9333399977427
            ],
            [
              27.1927799967994,
              -27.8997499991631
            ],
            [
              27.2922099981929,
              -27.9229799966295
            ],
            [
              27.3007700044322,
              -27.9606600021573
            ],
            [
              27.358982001718,
              -27.9324529991066
            ],
            [
              27.3634500000176,
              -28.0014599878881
            ],
            [
              27.433770000785,
              -28.0497599957272
            ],
            [
              27.4717999990708,
              -28.1070900062988
            ],
            [
              27.4067900003583,
              -28.1049900011875
            ],
            [
              27.3700500013065,
              -28.1702699988613
            ],
            [
              27.3878699993011,
              -28.2140800019905
            ],
            [
              27.5696200017617,
              -28.2825299956628
            ],
            [
              27.6111599991347,
              -28.2414600028768
            ],
            [
              27.5962900031811,
              -28.1759899991391
            ],
            [
              27.6598499997777,
              -28.1841200026359
            ],
            [
              27.653760004021,
              -28.1265899972305
            ],
            [
              27.6890100000115,
              -28.0961600031816
            ],
            [
              27.6549700013645,
              -28.0599299916757
            ],
            [
              27.7034599990798,
              -28.0403899997986
            ],
            [
              27.6953999979117,
              -28.0026200027109
            ],
            [
              27.7377199979796,
              -27.9281700039425
            ],
            [
              27.7783099983078,
              -27.910370008669
            ],
            [
              27.8229799970293,
              -27.9336899985946
            ],
            [
              27.8725999991906,
              -27.9337799991476
            ],
            [
              27.8628400005656,
              -27.7895200042448
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Moqhaka Local Municipality",
        "Code": "FS201",
        "Parent_cod": "DC20",
        "Area": 792457
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              22.7705450018504,
              -34.0274499990182
            ],
            [
              22.9702599973011,
              -34.0860700079244
            ],
            [
              23.1641199979396,
              -34.0830500008568
            ],
            [
              23.168739996054,
              -34.0062500016362
            ],
            [
              23.210710003364,
              -33.9628899985746
            ],
            [
              23.2290100028095,
              -33.8783499967549
            ],
            [
              23.0764599997292,
              -33.8085800015658
            ],
            [
              22.8765500042794,
              -33.8159599965565
            ],
            [
              22.8002799980236,
              -33.8411800030546
            ],
            [
              22.7774399996564,
              -33.9275500002323
            ],
            [
              22.7268500004273,
              -33.9247800001968
            ],
            [
              22.7175499996328,
              -33.9985700000054
            ],
            [
              22.7705450018504,
              -34.0274499990182
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Knysna Local Municipality",
        "Code": "WC048",
        "Parent_cod": "DC4",
        "Area": 110877
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              23.1641199979396,
              -34.0830500008568
            ],
            [
              23.2863900039955,
              -34.1017199975798
            ],
            [
              23.3755199998482,
              -34.0981600006835
            ],
            [
              23.3844600020275,
              -34.0400600022672
            ],
            [
              23.4378799977637,
              -34.0086400030337
            ],
            [
              23.5293699999256,
              -33.9997400017996
            ],
            [
              23.5618999990858,
              -33.9818700041973
            ],
            [
              23.6470199997732,
              -33.9805600004436
            ],
            [
              23.6345899958317,
              -33.9520500041043
            ],
            [
              23.6552299979661,
              -33.8873899972505
            ],
            [
              23.703299998796,
              -33.8640600005686
            ],
            [
              23.5619499977942,
              -33.8289399979825
            ],
            [
              23.5179200043048,
              -33.7856200030607
            ],
            [
              23.4680499987085,
              -33.8074800003017
            ],
            [
              23.3950399961989,
              -33.7926399994364
            ],
            [
              23.3254800017008,
              -33.7991300037466
            ],
            [
              23.334410006117,
              -33.8565600027419
            ],
            [
              23.2290100028095,
              -33.8783499967549
            ],
            [
              23.210710003364,
              -33.9628899985746
            ],
            [
              23.168739996054,
              -34.0062500016362
            ],
            [
              23.1641199979396,
              -34.0830500008568
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Bitou Local Municipality",
        "Code": "WC047",
        "Parent_cod": "DC4",
        "Area": 99186
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              27.3773500034,
              -30.3271199956912
            ],
            [
              27.3890500015564,
              -30.2935500007319
            ],
            [
              27.3658599969414,
              -30.2579399980324
            ],
            [
              27.3941499939271,
              -30.1424699970927
            ],
            [
              27.3268900011727,
              -30.148120001337
            ],
            [
              27.2965400000211,
              -30.0561099958796
            ],
            [
              27.2240800021905,
              -30.0057599978256
            ],
            [
              27.2163600041109,
              -29.9829700008648
            ],
            [
              27.0919500000925,
              -30.0267699972375
            ],
            [
              27.0653799870968,
              -30.0757899951121
            ],
            [
              26.9913000116863,
              -30.1118499942818
            ],
            [
              26.9467999902274,
              -30.1085699896133
            ],
            [
              26.8151700102878,
              -30.0303799928424
            ],
            [
              26.8689600095968,
              -29.993769992591
            ],
            [
              26.8239500005921,
              -29.964710000566
            ],
            [
              26.7332999993955,
              -29.8421900009677
            ],
            [
              26.7803400021894,
              -29.7390200033704
            ],
            [
              26.715499996028,
              -29.7112199984042
            ],
            [
              26.6602100021899,
              -29.7268300042013
            ],
            [
              26.6363800004367,
              -29.7003900007979
            ],
            [
              26.6269800022254,
              -29.6345300042562
            ],
            [
              26.5620700000306,
              -29.6479200021064
            ],
            [
              26.5510899991042,
              -29.5717600000239
            ],
            [
              26.454190004665,
              -29.5847999979215
            ],
            [
              26.4201300023978,
              -29.5727399993514
            ],
            [
              26.3822599988999,
              -29.6161400042578
            ],
            [
              26.4243099991073,
              -29.661220001202
            ],
            [
              26.3868100018801,
              -29.7405900002283
            ],
            [
              26.3107099845782,
              -29.7784299951481
            ],
            [
              26.3156500091407,
              -29.8007099928718
            ],
            [
              26.2503200073626,
              -29.8343699928808
            ],
            [
              26.2524600008285,
              -29.8795699962582
            ],
            [
              26.1914099985726,
              -29.9388400000659
            ],
            [
              26.229950008686,
              -29.9712900054293
            ],
            [
              26.2602000043268,
              -30.0356800043287
            ],
            [
              26.2031300030473,
              -30.0863000022433
            ],
            [
              26.1447999976218,
              -30.1663200033654
            ],
            [
              26.1671199998882,
              -30.2723200019665
            ],
            [
              26.1429899968909,
              -30.3078500027754
            ],
            [
              26.2021600023822,
              -30.3348800028098
            ],
            [
              26.2549700041624,
              -30.3872299923701
            ],
            [
              26.2590299989353,
              -30.4264199973849
            ],
            [
              26.3235700029534,
              -30.5024300024427
            ],
            [
              26.2806099985526,
              -30.5783599984151
            ],
            [
              26.3489100041933,
              -30.5949699990661
            ],
            [
              26.4251800023552,
              -30.5652399977276
            ],
            [
              26.490230002013,
              -30.5960100029593
            ],
            [
              26.481230003362,
              -30.6276299988253
            ],
            [
              26.6294500037147,
              -30.6938799980634
            ],
            [
              26.7162499973395,
              -30.6768699969528
            ],
            [
              26.7166700014194,
              -30.6764400023042
            ],
            [
              26.8141400041579,
              -30.6426700026185
            ],
            [
              26.8476799968344,
              -30.6838699969028
            ],
            [
              26.9430100016103,
              -30.662149998024
            ],
            [
              26.947899998686,
              -30.6076399996862
            ],
            [
              27.034309991413,
              -30.5998599961418
            ],
            [
              27.0003100009059,
              -30.5441700018441
            ],
            [
              27.0013099957598,
              -30.5414999956283
            ],
            [
              27.1884500021659,
              -30.5237900018071
            ],
            [
              27.2294599993795,
              -30.4991900113099
            ],
            [
              27.2844899992141,
              -30.5034000031076
            ],
            [
              27.2935399983723,
              -30.4567500012116
            ],
            [
              27.3445899972306,
              -30.3973300012785
            ],
            [
              27.4030099942159,
              -30.3929700043622
            ],
            [
              27.3773500034,
              -30.3271199956912
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Mohokare Local Municipality",
        "Code": "FS163",
        "Parent_cod": "DC16",
        "Area": 877576
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              24.1524599951327,
              -31.7886099983527
            ],
            [
              24.0709400021794,
              -31.8070899971056
            ],
            [
              24.0285199966006,
              -31.7301700013444
            ],
            [
              23.963060001418,
              -31.7066700067154
            ],
            [
              23.9486599992596,
              -31.773330000579
            ],
            [
              23.9158699971027,
              -31.8219999976018
            ],
            [
              23.8786300019731,
              -31.8336800047284
            ],
            [
              23.8085200018966,
              -31.7636599980104
            ],
            [
              23.8476200018616,
              -31.7292199971051
            ],
            [
              23.7564899956169,
              -31.6957100022148
            ],
            [
              23.7151300002494,
              -31.6470400042927
            ],
            [
              23.6394800019006,
              -31.6600999959181
            ],
            [
              23.5745299996599,
              -31.6891699973974
            ],
            [
              23.496109996779,
              -31.7026899994438
            ],
            [
              23.4231400051072,
              -31.6821400023592
            ],
            [
              23.4070899979051,
              -31.7138000000699
            ],
            [
              23.3451100112181,
              -31.7108899980749
            ],
            [
              23.3024200003828,
              -31.7301499986235
            ],
            [
              23.2634400041529,
              -31.7783400013899
            ],
            [
              23.2623599966167,
              -31.8153900012475
            ],
            [
              23.2303699989763,
              -31.8756900030911
            ],
            [
              23.1394499952211,
              -31.9515399989717
            ],
            [
              23.0876199990637,
              -31.9722900007829
            ],
            [
              23.0525899988294,
              -31.9397800007464
            ],
            [
              23.0673899996488,
              -31.8907399956543
            ],
            [
              22.9758300023528,
              -31.8608299986055
            ],
            [
              22.9019500010917,
              -31.8757699977871
            ],
            [
              22.858970002064,
              -31.8182900000834
            ],
            [
              22.7768799999121,
              -31.8569100003962
            ],
            [
              22.7351000049613,
              -31.79937999589
            ],
            [
              22.6515299966121,
              -31.8216700021688
            ],
            [
              22.5783400010902,
              -31.805510000686
            ],
            [
              22.619070003378,
              -31.7246500012965
            ],
            [
              22.566139996064,
              -31.7131699997955
            ],
            [
              22.56481498982,
              -31.6779199948119
            ],
            [
              22.4957600006236,
              -31.6703399959939
            ],
            [
              22.3122900015823,
              -31.5834600022773
            ],
            [
              22.2729199999581,
              -31.5925400010202
            ],
            [
              22.2601000023133,
              -31.6624700008898
            ],
            [
              22.2040100003613,
              -31.7640300015833
            ],
            [
              22.1768800029099,
              -31.8207199979296
            ],
            [
              22.1665999991907,
              -31.8930899988044
            ],
            [
              22.1014399980575,
              -31.8987199949317
            ],
            [
              22.0713300025776,
              -31.9392999965975
            ],
            [
              22.0949800041239,
              -32.0010599992195
            ],
            [
              22.0741249947727,
              -32.0179150021755
            ],
            [
              22.1199500008919,
              -32.076970000565
            ],
            [
              22.0695600000939,
              -32.0814499994179
            ],
            [
              22.0164399903133,
              -32.1142599953025
            ],
            [
              21.9959200018067,
              -32.2029800037242
            ],
            [
              21.9362050026588,
              -32.2228800041089
            ],
            [
              21.9246000061854,
              -32.2619600013529
            ],
            [
              21.8551099978282,
              -32.2755099948903
            ],
            [
              21.7806199972151,
              -32.2509299999194
            ],
            [
              21.7358900002233,
              -32.2050200006725
            ],
            [
              21.6916499952511,
              -32.2485700017042
            ],
            [
              21.6445799982684,
              -32.2087100008658
            ],
            [
              21.5360099998617,
              -32.2292200095958
            ],
            [
              21.5618099989323,
              -32.3147300021878
            ],
            [
              21.5190799997422,
              -32.3370299990351
            ],
            [
              21.4756400028839,
              -32.3314500016163
            ],
            [
              21.4083999966625,
              -32.3687700004351
            ],
            [
              21.3030100109034,
              -32.4024400018046
            ],
            [
              21.2694799971042,
              -32.4502900005831
            ],
            [
              21.1883099978082,
              -32.5030499946615
            ],
            [
              21.2505300027574,
              -32.5479100012455
            ],
            [
              21.352240001375,
              -32.6577299988403
            ],
            [
              21.426580004064,
              -32.667129997951
            ],
            [
              21.4321099973785,
              -32.756729996592
            ],
            [
              21.4797600031216,
              -32.786599997192
            ],
            [
              21.5247300039865,
              -32.7590600006185
            ],
            [
              21.5771399981125,
              -32.7595099988873
            ],
            [
              21.6911800005566,
              -32.7143900009977
            ],
            [
              21.6828000017187,
              -32.6843599993145
            ],
            [
              21.7177600023222,
              -32.6416499983487
            ],
            [
              21.7604300032421,
              -32.6584399992066
            ],
            [
              21.9459399992317,
              -32.6098000035673
            ],
            [
              22.0334199972352,
              -32.5549299976212
            ],
            [
              22.0365900013275,
              -32.5996700013694
            ],
            [
              22.0718500112691,
              -32.6427199973299
            ],
            [
              22.0650199957762,
              -32.7105599970462
            ],
            [
              22.1241699976473,
              -32.7328399983672
            ],
            [
              22.1913799997872,
              -32.7906100013505
            ],
            [
              22.2172800043688,
              -32.7441499974244
            ],
            [
              22.3013299970818,
              -32.7399100024446
            ],
            [
              22.3213400007405,
              -32.8206100079455
            ],
            [
              22.3839999999001,
              -32.8708300062996
            ],
            [
              22.4556800031297,
              -32.8765300011586
            ],
            [
              22.6646399977378,
              -32.928799996023
            ],
            [
              22.7831500021709,
              -32.9305999989908
            ],
            [
              22.8354000006096,
              -33.0377399998011
            ],
            [
              22.9340900002534,
              -33.0216599993094
            ],
            [
              22.9692500037846,
              -32.9933700032231
            ],
            [
              22.9487500009118,
              -32.9500400006455
            ],
            [
              23.0036800042288,
              -32.8982800023202
            ],
            [
              23.0074399968584,
              -32.8728199991436
            ],
            [
              23.098009997963,
              -32.8736900086869
            ],
            [
              23.1164200015818,
              -32.8579900041353
            ],
            [
              23.0893500006021,
              -32.799179997259
            ],
            [
              23.1493299957827,
              -32.7667399977527
            ],
            [
              23.3786200007125,
              -32.8250199963757
            ],
            [
              23.3977369973646,
              -32.7634800029997
            ],
            [
              23.3516000074344,
              -32.7637900029063
            ],
            [
              23.3013099977583,
              -32.6517899992091
            ],
            [
              23.3072899983348,
              -32.6116499980489
            ],
            [
              23.2881550008526,
              -32.5512099978431
            ],
            [
              23.2444700043872,
              -32.5132299991651
            ],
            [
              23.2475400020695,
              -32.4653299980809
            ],
            [
              23.221610003299,
              -32.425039999896
            ],
            [
              23.3073299992801,
              -32.3959200024061
            ],
            [
              23.3330500036548,
              -32.3511399977127
            ],
            [
              23.409850001976,
              -32.3891999991805
            ],
            [
              23.4489599979056,
              -32.3232699976122
            ],
            [
              23.6651499985736,
              -32.3442299983157
            ],
            [
              23.6488700023487,
              -32.2980199960259
            ],
            [
              23.670450001966,
              -32.2376700035677
            ],
            [
              23.7470700009798,
              -32.2006800100743
            ],
            [
              23.7978500008769,
              -32.1940700029282
            ],
            [
              23.851080006737,
              -32.2425199996982
            ],
            [
              23.8922999974469,
              -32.2549499964451
            ],
            [
              23.9611499987735,
              -32.2065200041948
            ],
            [
              24.0305299939641,
              -32.1934799982033
            ],
            [
              24.0380299998847,
              -32.1581300038965
            ],
            [
              24.1001299957028,
              -32.1640000002997
            ],
            [
              24.1355299968119,
              -32.1231400010102
            ],
            [
              24.1096749970035,
              -32.0842899990842
            ],
            [
              24.1408700011496,
              -32.0117099984176
            ],
            [
              24.2224100004212,
              -31.9556400009852
            ],
            [
              24.1641999969324,
              -31.902410003219
            ],
            [
              24.1053800003867,
              -31.9068500020259
            ],
            [
              24.1524599951327,
              -31.7886099983527
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Beaufort West Local Municipality",
        "Code": "WC053",
        "Parent_cod": "DC5",
        "Area": 2191660
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              25.4670999967675,
              -30.6242100110831
            ],
            [
              25.5562800003218,
              -30.6166299996747
            ],
            [
              25.6030899970058,
              -30.5943900001983
            ],
            [
              25.6308599996893,
              -30.6593500002023
            ],
            [
              25.6715600041909,
              -30.6408799983132
            ],
            [
              25.7001399956643,
              -30.6795099999865
            ],
            [
              25.7789000007345,
              -30.6758799998621
            ],
            [
              25.7998299982558,
              -30.6347900016572
            ],
            [
              25.8512299988654,
              -30.6293300043762
            ],
            [
              25.9730899896114,
              -30.5393899927539
            ],
            [
              26.0508300069992,
              -30.5230699955838
            ],
            [
              26.0511100082203,
              -30.5229699936702
            ],
            [
              26.097999998701,
              -30.5165000055707
            ],
            [
              26.1625599991447,
              -30.4834899968658
            ],
            [
              26.1938300022529,
              -30.5279799971791
            ],
            [
              26.2596499987485,
              -30.5407200010272
            ],
            [
              26.2806099985526,
              -30.5783599984151
            ],
            [
              26.3235700029534,
              -30.5024300024427
            ],
            [
              26.2590299989353,
              -30.4264199973849
            ],
            [
              26.2549700041624,
              -30.3872299923701
            ],
            [
              26.2021600023822,
              -30.3348800028098
            ],
            [
              26.1429899968909,
              -30.3078500027754
            ],
            [
              26.1671199998882,
              -30.2723200019665
            ],
            [
              26.1447999976218,
              -30.1663200033654
            ],
            [
              26.2031300030473,
              -30.0863000022433
            ],
            [
              26.2602000043268,
              -30.0356800043287
            ],
            [
              26.229950008686,
              -29.9712900054293
            ],
            [
              26.1914099985726,
              -29.9388400000659
            ],
            [
              26.2524600008285,
              -29.8795699962582
            ],
            [
              26.2503200073626,
              -29.8343699928808
            ],
            [
              26.3156500091407,
              -29.8007099928718
            ],
            [
              26.3107099845782,
              -29.7784299951481
            ],
            [
              26.3868100018801,
              -29.7405900002283
            ],
            [
              26.4243099991073,
              -29.661220001202
            ],
            [
              26.3822599988999,
              -29.6161400042578
            ],
            [
              26.2853099931617,
              -29.5981899921744
            ],
            [
              26.2841000084087,
              -29.5250699935853
            ],
            [
              26.2241900092616,
              -29.4795799939215
            ],
            [
              26.163440000156,
              -29.4677799974489
            ],
            [
              26.0777700028834,
              -29.4796900061887
            ],
            [
              26.0323049989766,
              -29.4170949992347
            ],
            [
              25.9794199991337,
              -29.4016400005856
            ],
            [
              25.9594200022314,
              -29.3654599967813
            ],
            [
              26.0235100070812,
              -29.33931999732
            ],
            [
              25.9927000018037,
              -29.2732899902408
            ],
            [
              25.9926399891442,
              -29.2731099981279
            ],
            [
              25.9148500009268,
              -29.3060799977936
            ],
            [
              25.9055400005707,
              -29.2543099999066
            ],
            [
              25.8415000034225,
              -29.2322800011211
            ],
            [
              25.7412399997262,
              -29.2260400002458
            ],
            [
              25.6113000032925,
              -29.2236800020304
            ],
            [
              25.562775905084,
              -29.2062803813345
            ],
            [
              25.5395499968349,
              -29.2561500038196
            ],
            [
              25.5514900006631,
              -29.2841099882854
            ],
            [
              25.481070003378,
              -29.3073199983192
            ],
            [
              25.4802199956564,
              -29.360870001849
            ],
            [
              25.514469996793,
              -29.3965499996827
            ],
            [
              25.4899999988009,
              -29.4342000029278
            ],
            [
              25.5025200023962,
              -29.484039997248
            ],
            [
              25.4870399971982,
              -29.558379999937
            ],
            [
              25.4274700002404,
              -29.5955199976497
            ],
            [
              25.3943399967935,
              -29.6379599996543
            ],
            [
              25.3342600041959,
              -29.663089999304
            ],
            [
              25.2906399990368,
              -29.5941600041809
            ],
            [
              25.2428799972142,
              -29.5906399992365
            ],
            [
              25.2006799999821,
              -29.6249800000269
            ],
            [
              25.1637100029143,
              -29.533950001991
            ],
            [
              25.0998100032291,
              -29.56517999606
            ],
            [
              25.0133300000795,
              -29.6355500027304
            ],
            [
              24.9537700008849,
              -29.6474300028923
            ],
            [
              24.9557600018227,
              -29.7880199967255
            ],
            [
              24.9755799994175,
              -29.9149099999964
            ],
            [
              24.8988100033791,
              -29.9229100037936
            ],
            [
              24.9025229129022,
              -29.9760992406873
            ],
            [
              24.8691501617506,
              -30.0255508420977
            ],
            [
              24.7984876676718,
              -30.0341701469347
            ],
            [
              24.801960001353,
              -30.0587800020954
            ],
            [
              24.8676899972956,
              -30.1309399977826
            ],
            [
              24.9015600051901,
              -30.208240003873
            ],
            [
              24.9501690056951,
              -30.2248450033942
            ],
            [
              24.9863199946721,
              -30.289969996618
            ],
            [
              25.0349800047234,
              -30.2868700092435
            ],
            [
              25.0356199991636,
              -30.3442099977932
            ],
            [
              25.0937199966805,
              -30.3714599971811
            ],
            [
              25.1519099974484,
              -30.4572999968973
            ],
            [
              25.2099599890623,
              -30.5050900028014
            ],
            [
              25.2371099991272,
              -30.5012299929698
            ],
            [
              25.3071199990887,
              -30.5770799978435
            ],
            [
              25.3765800015658,
              -30.5598899974254
            ],
            [
              25.4670999967675,
              -30.6242100110831
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Kopanong Local Municipality",
        "Code": "FS162",
        "Parent_cod": "DC16",
        "Area": 1564805
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              21.9020799973941,
              -33.3649599882128
            ],
            [
              21.9628799971143,
              -33.366199995933
            ],
            [
              22.1452500002873,
              -33.335410003269
            ],
            [
              22.2139899983398,
              -33.3149599991047
            ],
            [
              22.3912899961364,
              -33.3640900011526
            ],
            [
              22.4647399991517,
              -33.4045199976997
            ],
            [
              22.5818199898007,
              -33.4046800005815
            ],
            [
              22.7744300002443,
              -33.4197400016997
            ],
            [
              22.7357400012001,
              -33.3947699977371
            ],
            [
              22.7392699958137,
              -33.3239800031745
            ],
            [
              22.7733899963513,
              -33.3262599986
            ],
            [
              22.8402200025511,
              -33.2202100012905
            ],
            [
              22.8772080022475,
              -33.1869039969219
            ],
            [
              22.892269998062,
              -33.1416300036217
            ],
            [
              22.9553100012556,
              -33.0731400009102
            ],
            [
              22.9340900002534,
              -33.0216599993094
            ],
            [
              22.8354000006096,
              -33.0377399998011
            ],
            [
              22.7831500021709,
              -32.9305999989908
            ],
            [
              22.6646399977378,
              -32.928799996023
            ],
            [
              22.4556800031297,
              -32.8765300011586
            ],
            [
              22.3839999999001,
              -32.8708300062996
            ],
            [
              22.3213400007405,
              -32.8206100079455
            ],
            [
              22.3013299970818,
              -32.7399100024446
            ],
            [
              22.2172800043688,
              -32.7441499974244
            ],
            [
              22.1913799997872,
              -32.7906100013505
            ],
            [
              22.1241699976473,
              -32.7328399983672
            ],
            [
              22.0650199957762,
              -32.7105599970462
            ],
            [
              22.0718500112691,
              -32.6427199973299
            ],
            [
              22.0365900013275,
              -32.5996700013694
            ],
            [
              22.0334199972352,
              -32.5549299976212
            ],
            [
              21.9459399992317,
              -32.6098000035673
            ],
            [
              21.7604300032421,
              -32.6584399992066
            ],
            [
              21.7177600023222,
              -32.6416499983487
            ],
            [
              21.6828000017187,
              -32.6843599993145
            ],
            [
              21.6911800005566,
              -32.7143900009977
            ],
            [
              21.5771399981125,
              -32.7595099988873
            ],
            [
              21.5247300039865,
              -32.7590600006185
            ],
            [
              21.4797600031216,
              -32.786599997192
            ],
            [
              21.4321099973785,
              -32.756729996592
            ],
            [
              21.4456100003013,
              -32.7919700029133
            ],
            [
              21.4300500013065,
              -32.8490199987739
            ],
            [
              21.4784800016508,
              -32.9022999961478
            ],
            [
              21.4573899931537,
              -32.9274800017007
            ],
            [
              21.395930000769,
              -32.9379199984092
            ],
            [
              21.4428500016264,
              -33.0005100024346
            ],
            [
              21.4834499997177,
              -33.013909998048
            ],
            [
              21.5780900023517,
              -33.1158900028213
            ],
            [
              21.6372699984117,
              -33.1412800027699
            ],
            [
              21.6289599938087,
              -33.3054299922003
            ],
            [
              21.6355600031916,
              -33.358609999352
            ],
            [
              21.611950000792,
              -33.3967999996203
            ],
            [
              21.8272399968285,
              -33.3910400001958
            ],
            [
              21.9020799973941,
              -33.3649599882128
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Prince Albert Local Municipality",
        "Code": "WC052",
        "Parent_cod": "DC5",
        "Area": 815290
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              24.7984876676718,
              -30.0341701469347
            ],
            [
              24.8691501617506,
              -30.0255508420977
            ],
            [
              24.9025229129022,
              -29.9760992406873
            ],
            [
              24.8988100033791,
              -29.9229100037936
            ],
            [
              24.9755799994175,
              -29.9149099999964
            ],
            [
              24.9557600018227,
              -29.7880199967255
            ],
            [
              24.9537700008849,
              -29.6474300028923
            ],
            [
              25.0133300000795,
              -29.6355500027304
            ],
            [
              25.0998100032291,
              -29.56517999606
            ],
            [
              25.1637100029143,
              -29.533950001991
            ],
            [
              25.2006799999821,
              -29.6249800000269
            ],
            [
              25.2428799972142,
              -29.5906399992365
            ],
            [
              25.2906399990368,
              -29.5941600041809
            ],
            [
              25.3342600041959,
              -29.663089999304
            ],
            [
              25.3943399967935,
              -29.6379599996543
            ],
            [
              25.4274700002404,
              -29.5955199976497
            ],
            [
              25.4870399971982,
              -29.558379999937
            ],
            [
              25.5025200023962,
              -29.484039997248
            ],
            [
              25.4899999988009,
              -29.4342000029278
            ],
            [
              25.514469996793,
              -29.3965499996827
            ],
            [
              25.4802199956564,
              -29.360870001849
            ],
            [
              25.481070003378,
              -29.3073199983192
            ],
            [
              25.5514900006631,
              -29.2841099882854
            ],
            [
              25.5395499968349,
              -29.2561500038196
            ],
            [
              25.562775905084,
              -29.2062803813345
            ],
            [
              25.6113000032925,
              -29.2236800020304
            ],
            [
              25.7412399997262,
              -29.2260400002458
            ],
            [
              25.7313400027389,
              -29.077020007967
            ],
            [
              25.7609199989589,
              -29.025799998571
            ],
            [
              25.7193599979656,
              -29.0062900008828
            ],
            [
              25.7452600016478,
              -28.9064000025581
            ],
            [
              25.6259700026136,
              -28.8939799981783
            ],
            [
              25.5293700031232,
              -28.8525300013585
            ],
            [
              25.4577600031217,
              -28.8964999992755
            ],
            [
              25.3900399972481,
              -28.9168200019416
            ],
            [
              25.3346800001819,
              -28.8946799989828
            ],
            [
              25.2405699977073,
              -28.9071600016327
            ],
            [
              25.1701900013675,
              -28.9474099988724
            ],
            [
              25.1121900003683,
              -28.961339997343
            ],
            [
              25.0855599998941,
              -28.9076100008008
            ],
            [
              25.0059399983323,
              -28.908100000015
            ],
            [
              24.9593000022933,
              -28.9448600035862
            ],
            [
              24.869149998074,
              -28.8946699931257
            ],
            [
              24.8110400009953,
              -28.9130799967444
            ],
            [
              24.8018269997163,
              -28.8282580044033
            ],
            [
              24.6917800033445,
              -29.0257199993785
            ],
            [
              24.3466199997132,
              -29.6559299955728
            ],
            [
              24.3486600011581,
              -29.7019899981398
            ],
            [
              24.4115799997173,
              -29.7907399998511
            ],
            [
              24.4700200003228,
              -29.8117800042438
            ],
            [
              24.6079299982709,
              -29.9112600034463
            ],
            [
              24.6677999982713,
              -29.9065099948404
            ],
            [
              24.671299998696,
              -29.9714500002173
            ],
            [
              24.7247399989518,
              -29.9922499980389
            ],
            [
              24.793970003413,
              -29.9989799981284
            ],
            [
              24.7984876676718,
              -30.0341701469347
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Letsemeng Local Municipality",
        "Code": "FS161",
        "Parent_cod": "DC16",
        "Area": 982586
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              21.4321099973785,
              -32.756729996592
            ],
            [
              21.426580004064,
              -32.667129997951
            ],
            [
              21.352240001375,
              -32.6577299988403
            ],
            [
              21.2505300027574,
              -32.5479100012455
            ],
            [
              21.1883099978082,
              -32.5030499946615
            ],
            [
              21.1401100017752,
              -32.5897699935902
            ],
            [
              21.1569799973291,
              -32.6289399940855
            ],
            [
              21.0602899963863,
              -32.6555000021234
            ],
            [
              20.9627799998971,
              -32.6392999969973
            ],
            [
              20.8441000038122,
              -32.6624399948098
            ],
            [
              20.7921999999301,
              -32.7350300121253
            ],
            [
              20.8303399996913,
              -32.7845700016042
            ],
            [
              20.8324299998447,
              -32.8173700033229
            ],
            [
              20.798560000044,
              -32.8947499996128
            ],
            [
              20.7442100000914,
              -32.9128899961764
            ],
            [
              20.7311700021939,
              -32.9449949946232
            ],
            [
              20.5921000038121,
              -32.9264699991911
            ],
            [
              20.5612300002643,
              -32.8809699990661
            ],
            [
              20.4992999889034,
              -32.9416299932296
            ],
            [
              20.438599994694,
              -32.9400600035663
            ],
            [
              20.3949600030018,
              -32.9932399936307
            ],
            [
              20.3837500031602,
              -33.036279999922
            ],
            [
              20.3342600015978,
              -33.0357899998086
            ],
            [
              20.3025499988833,
              -33.0679999932051
            ],
            [
              20.3184900010128,
              -33.1208899959765
            ],
            [
              20.3064400002059,
              -33.1593399992415
            ],
            [
              20.2512499956908,
              -33.1499099969488
            ],
            [
              20.2021799991077,
              -33.1701099976782
            ],
            [
              20.2579699989164,
              -33.1884499908743
            ],
            [
              20.2356200015619,
              -33.262419997185
            ],
            [
              20.2511800005567,
              -33.2915100013854
            ],
            [
              20.2091700012945,
              -33.3797999971721
            ],
            [
              20.3680399990467,
              -33.3662700000605
            ],
            [
              20.335609990109,
              -33.425640001285
            ],
            [
              20.3860799981934,
              -33.4591700042922
            ],
            [
              20.3362200002528,
              -33.4878199908999
            ],
            [
              20.4980199982244,
              -33.4638700033979
            ],
            [
              20.5016600042059,
              -33.4984599977307
            ],
            [
              20.5475999976419,
              -33.5195199958511
            ],
            [
              20.7620000020985,
              -33.4908399898736
            ],
            [
              20.9217999995704,
              -33.4306500011966
            ],
            [
              21.0097100012157,
              -33.4392699958136
            ],
            [
              21.2064199992836,
              -33.4217000003547
            ],
            [
              21.4331000016638,
              -33.394170003343
            ],
            [
              21.5218199929983,
              -33.4144099969238
            ],
            [
              21.611950000792,
              -33.3967999996203
            ],
            [
              21.6355600031916,
              -33.358609999352
            ],
            [
              21.6289599938087,
              -33.3054299922003
            ],
            [
              21.6372699984117,
              -33.1412800027699
            ],
            [
              21.5780900023517,
              -33.1158900028213
            ],
            [
              21.4834499997177,
              -33.013909998048
            ],
            [
              21.4428500016264,
              -33.0005100024346
            ],
            [
              21.395930000769,
              -32.9379199984092
            ],
            [
              21.4573899931537,
              -32.9274800017007
            ],
            [
              21.4784800016508,
              -32.9022999961478
            ],
            [
              21.4300500013065,
              -32.8490199987739
            ],
            [
              21.4456100003013,
              -32.7919700029133
            ],
            [
              21.4321099973785,
              -32.756729996592
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Laingsburg Local Municipality",
        "Code": "WC051",
        "Parent_cod": "DC5",
        "Area": 878448
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              30.5137800680001,
              -30.08713994
            ],
            [
              30.5090799430001,
              -30.0349099399999
            ],
            [
              30.4533400680001,
              -30.013940065
            ],
            [
              30.5030599426623,
              -29.9664399400511
            ],
            [
              30.4930199428161,
              -29.8995600646453
            ],
            [
              30.4623510339731,
              -29.8773566963544
            ],
            [
              30.3946507960002,
              -29.867253957
            ],
            [
              30.4464699428336,
              -29.8106399399812
            ],
            [
              30.3995399430002,
              -29.74862994
            ],
            [
              30.3724499430001,
              -29.7268199399999
            ],
            [
              30.2412099425848,
              -29.7313899401935
            ],
            [
              30.1533799428302,
              -29.7214300654451
            ],
            [
              30.0923549426266,
              -29.7472800650229
            ],
            [
              30.0453613570001,
              -29.8299619079999
            ],
            [
              30.0370499418015,
              -29.8670800650929
            ],
            [
              30.0852699430002,
              -29.9213599399999
            ],
            [
              30.1057599429671,
              -29.9746499400425
            ],
            [
              30.150319942911,
              -29.9821699396909
            ],
            [
              30.2124299427878,
              -30.0173399400861
            ],
            [
              30.2818299430001,
              -30.0044199399999
            ],
            [
              30.3328499426708,
              -30.0347299398348
            ],
            [
              30.3966399426794,
              -30.1023000655955
            ],
            [
              30.4454899426069,
              -30.0843699402205
            ],
            [
              30.5137800680001,
              -30.08713994
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Richmond Local Municipality",
        "Code": "KZN227",
        "Parent_cod": "DC22",
        "Area": 123137
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              30.5961138712582,
              -30.1238988709361
            ],
            [
              30.6752500681362,
              -29.9222209396445
            ],
            [
              30.6213799428302,
              -29.8851399401561
            ],
            [
              30.6206299433173,
              -29.8528200648941
            ],
            [
              30.5759999428431,
              -29.8314999396704
            ],
            [
              30.5864699427337,
              -29.7807299402345
            ],
            [
              30.5693899428915,
              -29.731649939593
            ],
            [
              30.5837509243658,
              -29.6543228306341
            ],
            [
              30.6221699432883,
              -29.6683499396979
            ],
            [
              30.6737529430002,
              -29.6199020649999
            ],
            [
              30.6180599426124,
              -29.5499600649051
            ],
            [
              30.5687399425943,
              -29.5473999396555
            ],
            [
              30.530729943,
              -29.58253994
            ],
            [
              30.5407999428631,
              -29.6182300646657
            ],
            [
              30.4919699429586,
              -29.6255699400006
            ],
            [
              30.4660399432888,
              -29.672200065081
            ],
            [
              30.4953599428071,
              -29.7054599396244
            ],
            [
              30.3995399430002,
              -29.74862994
            ],
            [
              30.4464699428336,
              -29.8106399399812
            ],
            [
              30.3946507960002,
              -29.867253957
            ],
            [
              30.4623510339731,
              -29.8773566963544
            ],
            [
              30.4930199428161,
              -29.8995600646453
            ],
            [
              30.5030599426623,
              -29.9664399400511
            ],
            [
              30.4533400680001,
              -30.013940065
            ],
            [
              30.5090799430001,
              -30.0349099399999
            ],
            [
              30.5137800680001,
              -30.08713994
            ],
            [
              30.5725199433408,
              -30.1406899410879
            ],
            [
              30.5961138712582,
              -30.1238988709361
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Mkhambathini Local Municipality",
        "Code": "KZN226",
        "Parent_cod": "DC22",
        "Area": 86848
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              27.2727616040649,
              -31.9336500166349
            ],
            [
              27.3288499989284,
              -31.8908799967145
            ],
            [
              27.407873005335,
              -31.8959120039358
            ],
            [
              27.4340099965642,
              -31.8096790031834
            ],
            [
              27.3986999960081,
              -31.7256699997707
            ],
            [
              27.4371360022247,
              -31.6766659999359
            ],
            [
              27.4342400035734,
              -31.5967299981908
            ],
            [
              27.4822564335875,
              -31.5860490731062
            ],
            [
              27.4744400003059,
              -31.4812300003641
            ],
            [
              27.598640002734,
              -31.4437199909848
            ],
            [
              27.57744999682,
              -31.3892000020784
            ],
            [
              27.6241200032356,
              -31.2240299970866
            ],
            [
              27.5695599971962,
              -31.2090899979051
            ],
            [
              27.4907000028029,
              -31.2525900011276
            ],
            [
              27.451310002055,
              -31.2571900019171
            ],
            [
              27.442959997406,
              -31.3774100015703
            ],
            [
              27.4084600018276,
              -31.4184599988298
            ],
            [
              27.3626250006434,
              -31.4223000023432
            ],
            [
              27.3445799985681,
              -31.380259999899
            ],
            [
              27.275999996203,
              -31.3397599992246
            ],
            [
              27.1751799981584,
              -31.367779997249
            ],
            [
              27.1307899961615,
              -31.4266000009891
            ],
            [
              27.0865599979456,
              -31.3974600061743
            ],
            [
              27.047469999341,
              -31.3445499988833
            ],
            [
              27.0171400018098,
              -31.3610249960067
            ],
            [
              26.9346449962696,
              -31.3439699991161
            ],
            [
              26.8822799979236,
              -31.3780199964257
            ],
            [
              26.8468699990512,
              -31.4358500030751
            ],
            [
              26.8789300026176,
              -31.4455600101863
            ],
            [
              26.8466499987985,
              -31.5078799990626
            ],
            [
              26.8917139968036,
              -31.5432709988574
            ],
            [
              26.8669099968989,
              -31.5849499972445
            ],
            [
              26.7696499957508,
              -31.6668200081368
            ],
            [
              26.8046200031107,
              -31.70671999733
            ],
            [
              26.8488000017188,
              -31.6918299968568
            ],
            [
              26.9582600006985,
              -31.7810100013104
            ],
            [
              26.980839996069,
              -31.8271600053299
            ],
            [
              27.1059599986551,
              -31.915559997196
            ],
            [
              27.1775900031761,
              -31.9341400032585
            ],
            [
              27.2080400017448,
              -31.9621699981469
            ],
            [
              27.2727616040649,
              -31.9336500166349
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Emalahleni Local Municipality",
        "Code": "EC136",
        "Parent_cod": "DC13",
        "Area": 348423,
        "detail": "Emalahleni Local Municipality is a Category B municipality located within the Chris Hani District in the Eastern Cape province. It consists of 17 wards that serve three main towns: Lady Frere (home to the main municipal offices), Indwe, and Dordrecht. While Indwe and Dordrecht are largely urban and include farms, Lady Frere also serves surrounding villages.\n",
        "link_to_webpage": "https://www.emalahlenilm.gov.za/about/",
        "image": "https://corruptionwatch-my.sharepoint.com/:i:/g/personal/nontobekog_corruptionwatch_org_za/EViM1jqDbVFJixvT9NZFiNABvIBJPtz_LcInBMTtV14lzA?e=cyD0vU",
        "image_alt": "https://www.emalahlenilm.gov.za/"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              29.9611649800001,
              -30.823169972
            ],
            [
              29.982790067,
              -30.828070066
            ],
            [
              30.020999941794,
              -30.7383499407971
            ],
            [
              30.082109943,
              -30.696669941
            ],
            [
              30.072869943,
              -30.6499899409999
            ],
            [
              30.1362900680001,
              -30.624449941
            ],
            [
              30.1616599430001,
              -30.5880999409999
            ],
            [
              30.1180399426893,
              -30.5593300660297
            ],
            [
              30.056959941748,
              -30.4673499414466
            ],
            [
              30.0015999419838,
              -30.4937099411608
            ],
            [
              29.9932299418084,
              -30.5427900659088
            ],
            [
              29.954525398,
              -30.5656303019999
            ],
            [
              29.8937665467888,
              -30.5606959941248
            ],
            [
              29.8133250666985,
              -30.5350949412785
            ],
            [
              29.782159941628,
              -30.5104599410733
            ],
            [
              29.6696999418989,
              -30.5196099412457
            ],
            [
              29.64063994178,
              -30.5620399409904
            ],
            [
              29.5862499417815,
              -30.6170799412862
            ],
            [
              29.5722000410002,
              -30.6551499729999
            ],
            [
              29.5995099732068,
              -30.6895199696708
            ],
            [
              29.675369982139,
              -30.669939978647
            ],
            [
              29.7079299593002,
              -30.7047899606881
            ],
            [
              29.7705700366779,
              -30.7185999707121
            ],
            [
              29.8526099825647,
              -30.7616000273194
            ],
            [
              29.9468699721716,
              -30.7699499699152
            ],
            [
              29.9611649800001,
              -30.823169972
            ]
          ]
        ]
      },
      "properties": {
        "Name": "UMuziwabantu Local Municipality",
        "Code": "KZN214",
        "Parent_cod": "DC21",
        "Area": 108931
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              27.7588329391888,
              -32.3319680650741
            ],
            [
              27.7650199969753,
              -32.2588100026794
            ],
            [
              27.8127700001354,
              -32.1832399990267
            ],
            [
              27.7751900010178,
              -32.1094800032995
            ],
            [
              27.8638199998931,
              -32.0771900008179
            ],
            [
              27.8891100024248,
              -32.0497500025605
            ],
            [
              27.9501999966326,
              -32.0818899999235
            ],
            [
              28.010034441936,
              -32.0363916662424
            ],
            [
              27.9833335883745,
              -31.984285355185
            ],
            [
              28.0102081298014,
              -31.9398422239394
            ],
            [
              28.0168209077587,
              -31.8728504180124
            ],
            [
              27.8791800031546,
              -31.8147300013884
            ],
            [
              27.8000199976248,
              -31.7435800064121
            ],
            [
              27.8010100037087,
              -31.6977999987709
            ],
            [
              27.7584599966316,
              -31.6564900093065
            ],
            [
              27.6944699981919,
              -31.7134200032305
            ],
            [
              27.5620499998077,
              -31.7211099999265
            ],
            [
              27.5381799998072,
              -31.7607600000739
            ],
            [
              27.4856500001474,
              -31.7629700003652
            ],
            [
              27.4959199971102,
              -31.7007299980909
            ],
            [
              27.4371360022247,
              -31.6766659999359
            ],
            [
              27.3986999960081,
              -31.7256699997707
            ],
            [
              27.4340099965642,
              -31.8096790031834
            ],
            [
              27.407873005335,
              -31.8959120039358
            ],
            [
              27.3288499989284,
              -31.8908799967145
            ],
            [
              27.2727616040649,
              -31.9336500166349
            ],
            [
              27.3370181067003,
              -31.9456374093389
            ],
            [
              27.3214147918592,
              -31.9757911280581
            ],
            [
              27.36521000204,
              -32.0482299972165
            ],
            [
              27.4118200029908,
              -32.0989199983591
            ],
            [
              27.3974800000021,
              -32.1361700002453
            ],
            [
              27.4401199977398,
              -32.1838500001773
            ],
            [
              27.4823400003908,
              -32.1628000007194
            ],
            [
              27.5078799982634,
              -32.2307499974144
            ],
            [
              27.5350900003034,
              -32.1974800001019
            ],
            [
              27.6006875872623,
              -32.2134543662259
            ],
            [
              27.6437082419419,
              -32.2785921109372
            ],
            [
              27.7053184363968,
              -32.3244026838368
            ],
            [
              27.7588329391888,
              -32.3319680650741
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Intsika Yethu Local Municipality",
        "Code": "EC135",
        "Parent_cod": "DC13",
        "Area": 284596,
        "detail": "Intsika Yethu Municipality is made up of 21 wards, 2 towns (Cofimvaba and Tsomo), and 214 villages. The majority of the population resides in rural villages scattered throughout the area. The municipality prides itself on having some of the best agricultural resources in the country, supported by three major irrigation schemes: Ncora, Qamata, and Bilatye. The R61 national road passes through the municipality, linking it to the O.R. Tambo and Amathole District Municipalities.\n",
        "link_to_webpage": "https://www.intsikayethu.gov.za/about/",
        "image": "https://corruptionwatch-my.sharepoint.com/:i:/g/personal/nontobekog_corruptionwatch_org_za/ERBf-YxnsNtKs3SPGSNYGxABjDm05xhjXPgIvht8T3wY3A?e=ZxBIYi",
        "image_alt": "https://en.wikipedia.org/wiki/Intsika_Yethu_Local_Municipality#/media/File:Intsika_Yethu_CoA.png"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              30.1362900680001,
              -30.624449941
            ],
            [
              30.168269943,
              -30.6129699409999
            ],
            [
              30.2182599430001,
              -30.6554099409999
            ],
            [
              30.3614599430002,
              -30.616439941
            ],
            [
              30.3986699430001,
              -30.629049941
            ],
            [
              30.4273399430001,
              -30.577869941
            ],
            [
              30.5088299430001,
              -30.5915999409999
            ],
            [
              30.5075449430001,
              -30.539539941
            ],
            [
              30.583549943,
              -30.560709941
            ],
            [
              30.6292999429382,
              -30.5030000656005
            ],
            [
              30.594069943,
              -30.4953799409999
            ],
            [
              30.593749943,
              -30.4952099409999
            ],
            [
              30.5772799430001,
              -30.4033000659999
            ],
            [
              30.5297527257079,
              -30.4064471456192
            ],
            [
              30.48365670889,
              -30.3203540640887
            ],
            [
              30.4575399430001,
              -30.316569941
            ],
            [
              30.3692599426922,
              -30.3426099410959
            ],
            [
              30.3241399430001,
              -30.327909941
            ],
            [
              30.2958229429745,
              -30.368675940742
            ],
            [
              30.2397499427057,
              -30.3739999407446
            ],
            [
              30.2211128215995,
              -30.4370519372971
            ],
            [
              30.1782706256889,
              -30.4578543749794
            ],
            [
              30.1714499430001,
              -30.402590066
            ],
            [
              30.1144899426569,
              -30.4020399405907
            ],
            [
              30.056959941748,
              -30.4673499414466
            ],
            [
              30.1180399426893,
              -30.5593300660297
            ],
            [
              30.1616599430001,
              -30.5880999409999
            ],
            [
              30.1362900680001,
              -30.624449941
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Umzumbe Local Municipality",
        "Code": "KZN213",
        "Parent_cod": "DC21",
        "Area": 122394
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              30.6292999429382,
              -30.5030000656005
            ],
            [
              30.6736899431365,
              -30.4202700663105
            ],
            [
              30.7356799428752,
              -30.3388099412258
            ],
            [
              30.7648679426016,
              -30.2687839414257
            ],
            [
              30.6924319431797,
              -30.1985479409347
            ],
            [
              30.6914505229234,
              -30.1496068163015
            ],
            [
              30.5961138712582,
              -30.1238988709361
            ],
            [
              30.5725199433408,
              -30.1406899410879
            ],
            [
              30.5137800680001,
              -30.08713994
            ],
            [
              30.4454899426069,
              -30.0843699402205
            ],
            [
              30.4166599432019,
              -30.1429300659697
            ],
            [
              30.4361099426198,
              -30.182869940995
            ],
            [
              30.377339942984,
              -30.2223199409125
            ],
            [
              30.3241399430001,
              -30.327909941
            ],
            [
              30.3692599426922,
              -30.3426099410959
            ],
            [
              30.4575399430001,
              -30.316569941
            ],
            [
              30.48365670889,
              -30.3203540640887
            ],
            [
              30.5297527257079,
              -30.4064471456192
            ],
            [
              30.5772799430001,
              -30.4033000659999
            ],
            [
              30.593749943,
              -30.4952099409999
            ],
            [
              30.594069943,
              -30.4953799409999
            ],
            [
              30.6292999429382,
              -30.5030000656005
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Umdoni Local Municipality",
        "Code": "KZN212",
        "Parent_cod": "DC21",
        "Area": 98975
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              26.191329996682,
              -32.2852300006639
            ],
            [
              26.2068899956768,
              -32.1644700030881
            ],
            [
              26.1408499989283,
              -32.1468300044011
            ],
            [
              26.1391900033161,
              -32.1191500013714
            ],
            [
              26.0760000030977,
              -32.1126199961159
            ],
            [
              26.0239099994469,
              -32.0551899971206
            ],
            [
              25.9995300011087,
              -32.0050000019485
            ],
            [
              25.9484099981229,
              -31.9811100028243
            ],
            [
              25.8501599998841,
              -31.9088900007729
            ],
            [
              25.7621699972476,
              -31.897900001184
            ],
            [
              25.7231799969593,
              -31.8636500009467
            ],
            [
              25.6405699987066,
              -31.9026900008428
            ],
            [
              25.6340999989159,
              -31.8396099967039
            ],
            [
              25.5636800007315,
              -31.8029099985975
            ],
            [
              25.5414200030308,
              -31.7674299955978
            ],
            [
              25.427169998097,
              -31.7410999981664
            ],
            [
              25.3603999955634,
              -31.7144900022118
            ],
            [
              25.4148800006117,
              -31.6742499946416
            ],
            [
              25.4544900007131,
              -31.6845999979915
            ],
            [
              25.5283299992302,
              -31.6137499979639
            ],
            [
              25.5058200061884,
              -31.5488699989513
            ],
            [
              25.6173599967665,
              -31.5772600014479
            ],
            [
              25.5893300018781,
              -31.4853100023547
            ],
            [
              25.5917100037137,
              -31.4188699970527
            ],
            [
              25.5644999962779,
              -31.358469997792
            ],
            [
              25.5121199972401,
              -31.3460099987624
            ],
            [
              25.5575299986106,
              -31.2779900069333
            ],
            [
              25.4794099978732,
              -31.2372500023857
            ],
            [
              25.3862100013905,
              -31.217840003913
            ],
            [
              25.3544199967854,
              -31.2359999942044
            ],
            [
              25.2250400027939,
              -31.1952000003797
            ],
            [
              25.1704799976538,
              -31.2391799987579
            ],
            [
              25.130679998683,
              -31.2393999981114
            ],
            [
              25.0584700042873,
              -31.2693800001868
            ],
            [
              25.0056199997632,
              -31.2630999992655
            ],
            [
              24.9419700053115,
              -31.3150699991811
            ],
            [
              24.852990004685,
              -31.328209989999
            ],
            [
              24.7886799977837,
              -31.3894600032765
            ],
            [
              24.7048100025796,
              -31.4005900021269
            ],
            [
              24.6649900008879,
              -31.3836600101014
            ],
            [
              24.5671900009178,
              -31.4186400008354
            ],
            [
              24.5588500012266,
              -31.4818399961188
            ],
            [
              24.5039100019451,
              -31.5684199993834
            ],
            [
              24.522960002702,
              -31.6036899980949
            ],
            [
              24.5062700001604,
              -31.7068300024026
            ],
            [
              24.510420002681,
              -31.7541699983467
            ],
            [
              24.5507100008658,
              -31.7611699991961
            ],
            [
              24.6164600022273,
              -31.7261699967479
            ],
            [
              24.7043999980615,
              -31.744280000022
            ],
            [
              24.7334699977422,
              -31.7872900031311
            ],
            [
              24.8019299981709,
              -31.7849699977671
            ],
            [
              24.8556299987256,
              -31.834884998244
            ],
            [
              24.8992500038846,
              -31.8372700039075
            ],
            [
              24.9391199979895,
              -31.9050499990582
            ],
            [
              24.9244899987146,
              -31.9415900023767
            ],
            [
              24.9506899973455,
              -32.0072699996107
            ],
            [
              24.9380499990083,
              -32.0532600007484
            ],
            [
              24.9671199986891,
              -32.1075099987874
            ],
            [
              24.915539998772,
              -32.1721199979395
            ],
            [
              24.9040199990238,
              -32.2219400039281
            ],
            [
              24.9496099997018,
              -32.2411800017557
            ],
            [
              25.0033149959903,
              -32.2503600006135
            ],
            [
              25.0550500039546,
              -32.2800500010067
            ],
            [
              25.1283100018052,
              -32.2910999979666
            ],
            [
              25.1675600032916,
              -32.3287100002663
            ],
            [
              25.2786299991752,
              -32.3455599975958
            ],
            [
              25.3095500014315,
              -32.3133299915858
            ],
            [
              25.4077099991173,
              -32.374009996564
            ],
            [
              25.3987299959926,
              -32.4130300009338
            ],
            [
              25.4931099983279,
              -32.4104900034109
            ],
            [
              25.5340599963718,
              -32.3944699993909
            ],
            [
              25.5743699990762,
              -32.4577999979715
            ],
            [
              25.6217200017767,
              -32.4567899963612
            ],
            [
              25.6550819979359,
              -32.5069070025561
            ],
            [
              25.7855599993945,
              -32.5379000009843
            ],
            [
              25.7973899909554,
              -32.4772200040999
            ],
            [
              25.8873099971587,
              -32.4868000016187
            ],
            [
              25.8993599970663,
              -32.4329300004192
            ],
            [
              25.9392700002104,
              -32.4060600032665
            ],
            [
              25.9510696117732,
              -32.3640473626956
            ],
            [
              25.9962276536833,
              -32.3544709318879
            ],
            [
              26.05204037936,
              -32.312290049746
            ],
            [
              26.0816400005856,
              -32.3178800026599
            ],
            [
              26.1412850037,
              -32.2717450083254
            ],
            [
              26.191329996682,
              -32.2852300006639
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Inxuba Yethemba Local Municipality",
        "Code": "EC131",
        "Parent_cod": "DC13",
        "Area": 1166350,
        "detail": "The Inxuba Yethemba Local Municipality is a Category B municipality located within the Chris Hani District in the Eastern Cape Province, approximately 240 km north of the Nelson Mandela Metropolitan Municipality. It is one of six municipalities in the district and covers about one-third of its geographical area. Cradock includes the Cradock suburb, as well as the Lingelihle and Michausdal communities. Middelburg consists of the Middelburg suburb, along with the Kwanonzame, Lusaka, and Midros communities.\n",
        "link_to_webpage": "https://iym.gov.za/index.php/municipality/about-iym/",
        "image": "https://corruptionwatch-my.sharepoint.com/:i:/g/personal/nontobekog_corruptionwatch_org_za/EW0CiK34LgFIibE55JBf_a8BQPHTI49g7Z3gIgsLUBeaag?e=Q3LVt3",
        "image_alt": "https://www.google.com/imgres?q=inxuba%20yethmba%20local%20municipality%20image%20reference%20unity%20eastern%20cape&amp;imgurl=x-raw-image%3A%2F%2F%2Fe50e983f5c2574476b0172411be67cf3d924316409c0f107d2b0e1e4716d07ff&amp;imgrefurl=https%3A%2F%2Flg.treasury.gov.za%2Fsupportingdocs%2FEC131%2FEC131_IDP%2520Final_2021_Y_20221206T203026Z_ludwe.pdf&amp;docid=cZeKAsTeU5Rt3M&amp;tbnid=R3QlXD-YDuVSVM&amp;vet=12ahUKEwiO3Z_z382OAxXmX0EAHRdlCAgQM3oECAsQAA..i&amp;w=243&amp;h=490&amp;hcb=2&amp;ved=2ahUKEwiO3Z_z382OAxXmX0EAHRdlCAgQM3oECAsQAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              30.9811899430615,
              -29.2692599401941
            ],
            [
              31.0265100679853,
              -29.2678999404299
            ],
            [
              31.0885299432024,
              -29.3471099401715
            ],
            [
              31.1371699433383,
              -29.2075999403849
            ],
            [
              31.2342849440949,
              -29.180706940373
            ],
            [
              31.2887249437013,
              -29.1640099402066
            ],
            [
              31.2073299439218,
              -29.089100065016
            ],
            [
              31.1754099441136,
              -29.0731299400945
            ],
            [
              31.118280067771,
              -28.9933400637928
            ],
            [
              31.1250599433617,
              -28.9589899393342
            ],
            [
              31.0491799433997,
              -28.9491200642396
            ],
            [
              31.029826943059,
              -28.9015229386327
            ],
            [
              30.9933499444444,
              -28.856479938898
            ],
            [
              30.9192199433458,
              -28.9084899388595
            ],
            [
              30.922079943035,
              -28.9484199393287
            ],
            [
              30.9801799432498,
              -28.9698899392693
            ],
            [
              31.02377994299,
              -29.0788300653552
            ],
            [
              30.9367199427712,
              -29.0801999396754
            ],
            [
              30.8679399428741,
              -29.1542400652267
            ],
            [
              30.8678689431972,
              -29.1543289398286
            ],
            [
              30.9278099428746,
              -29.1794599404238
            ],
            [
              30.9847299426327,
              -29.2241099400216
            ],
            [
              30.9811899430615,
              -29.2692599401941
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Maphumulo Local Municipality",
        "Code": "KZN294",
        "Parent_cod": "DC29",
        "Area": 89591
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              30.727179943,
              -29.5709399399999
            ],
            [
              30.7932199433458,
              -29.5754999395705
            ],
            [
              30.8425099428796,
              -29.6256199396085
            ],
            [
              30.9691599431768,
              -29.5863999404049
            ],
            [
              30.9692799433148,
              -29.5864999396204
            ],
            [
              31.0060699428736,
              -29.5914300653452
            ],
            [
              31.0308199429861,
              -29.5510299397799
            ],
            [
              31.033750925265,
              -29.5496012012343
            ],
            [
              31.0944099427646,
              -29.5380899401985
            ],
            [
              31.0531599425773,
              -29.5131199398333
            ],
            [
              31.07077994304,
              -29.4604800646032
            ],
            [
              31.182675804345,
              -29.3530601147324
            ],
            [
              31.152559944386,
              -29.3258649398151
            ],
            [
              31.1659929442191,
              -29.2583909398899
            ],
            [
              31.254076740749,
              -29.2442291753361
            ],
            [
              31.2342849440949,
              -29.180706940373
            ],
            [
              31.1371699433383,
              -29.2075999403849
            ],
            [
              31.0885299432024,
              -29.3471099401715
            ],
            [
              31.0265100679853,
              -29.2678999404299
            ],
            [
              30.9811899430615,
              -29.2692599401941
            ],
            [
              30.8771899430001,
              -29.27558994
            ],
            [
              30.854649943,
              -29.322220065
            ],
            [
              30.880389943,
              -29.3676699399999
            ],
            [
              30.793549943,
              -29.44954994
            ],
            [
              30.7477500678114,
              -29.4670699404253
            ],
            [
              30.7025199430001,
              -29.56112994
            ],
            [
              30.727179943,
              -29.5709399399999
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Ndwedwe Local Municipality",
        "Code": "KZN293",
        "Parent_cod": "DC29",
        "Area": 107858
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              31.0944099427646,
              -29.5380899401985
            ],
            [
              31.1358399431589,
              -29.5011300650005
            ],
            [
              31.1831299439918,
              -29.5280200648741
            ],
            [
              31.1857549436358,
              -29.5717849400229
            ],
            [
              31.2235199440902,
              -29.5365799398124
            ],
            [
              31.3408199439852,
              -29.3820499398528
            ],
            [
              31.4431493623532,
              -29.2796410699793
            ],
            [
              31.4228309613798,
              -29.230516757942
            ],
            [
              31.375540000071,
              -29.2579600000539
            ],
            [
              31.332460000029,
              -29.2105799995673
            ],
            [
              31.3706999999052,
              -29.1689200002577
            ],
            [
              31.3183209892223,
              -29.1500299996848
            ],
            [
              31.2887249437013,
              -29.1640099402066
            ],
            [
              31.2342849440949,
              -29.180706940373
            ],
            [
              31.254076740749,
              -29.2442291753361
            ],
            [
              31.1659929442191,
              -29.2583909398899
            ],
            [
              31.152559944386,
              -29.3258649398151
            ],
            [
              31.182675804345,
              -29.3530601147324
            ],
            [
              31.07077994304,
              -29.4604800646032
            ],
            [
              31.0531599425773,
              -29.5131199398333
            ],
            [
              31.0944099427646,
              -29.5380899401985
            ]
          ]
        ]
      },
      "properties": {
        "Name": "KwaDukuza Local Municipality",
        "Code": "KZN292",
        "Parent_cod": "DC29",
        "Area": 73997
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              31.4431493623532,
              -29.2796410699793
            ],
            [
              31.5735299438519,
              -29.1657899395541
            ],
            [
              31.6753139440833,
              -29.0548930649629
            ],
            [
              31.5295899437209,
              -29.0566899400886
            ],
            [
              31.4705799438094,
              -29.0230299400796
            ],
            [
              31.4589799439692,
              -28.9916799386782
            ],
            [
              31.3878599440812,
              -28.9968799392577
            ],
            [
              31.3723999443021,
              -29.059449939663
            ],
            [
              31.3183209892223,
              -29.1500299996848
            ],
            [
              31.3706999999052,
              -29.1689200002577
            ],
            [
              31.332460000029,
              -29.2105799995673
            ],
            [
              31.375540000071,
              -29.2579600000539
            ],
            [
              31.4228309613798,
              -29.230516757942
            ],
            [
              31.4431493623532,
              -29.2796410699793
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Mandeni Local Municipality",
        "Code": "KZN291",
        "Parent_cod": "DC29",
        "Area": 55480
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              22.2337499976642,
              -33.8882400040729
            ],
            [
              22.2891100109183,
              -33.8579500083862
            ],
            [
              22.3687800039941,
              -33.7928100009807
            ],
            [
              22.3452699999106,
              -33.7252500060829
            ],
            [
              22.3718000029678,
              -33.6593899915548
            ],
            [
              22.5886899981449,
              -33.6366699978221
            ],
            [
              22.7556599971112,
              -33.640729992595
            ],
            [
              22.7160799992925,
              -33.5316800008314
            ],
            [
              22.7598599992396,
              -33.5307199979295
            ],
            [
              22.728480000052,
              -33.4541599962868
            ],
            [
              22.7744300002443,
              -33.4197400016997
            ],
            [
              22.5818199898007,
              -33.4046800005815
            ],
            [
              22.4647399991517,
              -33.4045199976997
            ],
            [
              22.3912899961364,
              -33.3640900011526
            ],
            [
              22.2139899983398,
              -33.3149599991047
            ],
            [
              22.1452500002873,
              -33.335410003269
            ],
            [
              21.9628799971143,
              -33.366199995933
            ],
            [
              21.9020799973941,
              -33.3649599882128
            ],
            [
              21.9362739977469,
              -33.5249759974443
            ],
            [
              21.927289998035,
              -33.5792400060214
            ],
            [
              21.9350399992966,
              -33.6677000042517
            ],
            [
              21.890030004681,
              -33.712780001196
            ],
            [
              21.837480004099,
              -33.7373099965591
            ],
            [
              21.7227999964227,
              -33.7053199962208
            ],
            [
              21.74003506007,
              -33.7961459272927
            ],
            [
              21.7003500016513,
              -33.8528500007269
            ],
            [
              21.8643800044337,
              -33.8553899991491
            ],
            [
              21.9327800065921,
              -33.86542000393
            ],
            [
              22.1236799984332,
              -33.8463700031731
            ],
            [
              22.2337499976642,
              -33.8882400040729
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Oudtshoorn Local Municipality",
        "Code": "WC045",
        "Parent_cod": "DC4",
        "Area": 354042
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              22.354570000705,
              -34.0544300003442
            ],
            [
              22.4846399986371,
              -34.0512599962517
            ],
            [
              22.5636499990482,
              -33.9961099998766
            ],
            [
              22.7705450018504,
              -34.0274499990182
            ],
            [
              22.7175499996328,
              -33.9985700000054
            ],
            [
              22.7268500004273,
              -33.9247800001968
            ],
            [
              22.7774399996564,
              -33.9275500002323
            ],
            [
              22.8002799980236,
              -33.8411800030546
            ],
            [
              22.8765500042794,
              -33.8159599965565
            ],
            [
              23.0764599997292,
              -33.8085800015658
            ],
            [
              23.2290100028095,
              -33.8783499967549
            ],
            [
              23.334410006117,
              -33.8565600027419
            ],
            [
              23.3254800017008,
              -33.7991300037466
            ],
            [
              23.3950399961989,
              -33.7926399994364
            ],
            [
              23.4300700000305,
              -33.7617599981254
            ],
            [
              23.4399400019295,
              -33.717390000648
            ],
            [
              23.5412700037078,
              -33.6995400003707
            ],
            [
              23.5555299976113,
              -33.6729599977057
            ],
            [
              23.6704400042029,
              -33.6725599981453
            ],
            [
              23.6749800004267,
              -33.6258700123911
            ],
            [
              23.616870003348,
              -33.5702399992766
            ],
            [
              23.6039999989008,
              -33.4964000016587
            ],
            [
              23.4956199975648,
              -33.4434400109477
            ],
            [
              23.3548799986131,
              -33.4411699970977
            ],
            [
              23.2971249981202,
              -33.3886400010352
            ],
            [
              23.1348000038172,
              -33.3876200007624
            ],
            [
              22.9347800032946,
              -33.4291400008104
            ],
            [
              22.7744300002443,
              -33.4197400016997
            ],
            [
              22.728480000052,
              -33.4541599962868
            ],
            [
              22.7598599992396,
              -33.5307199979295
            ],
            [
              22.7160799992925,
              -33.5316800008314
            ],
            [
              22.7556599971112,
              -33.640729992595
            ],
            [
              22.5886899981449,
              -33.6366699978221
            ],
            [
              22.3718000029678,
              -33.6593899915548
            ],
            [
              22.3452699999106,
              -33.7252500060829
            ],
            [
              22.3687800039941,
              -33.7928100009807
            ],
            [
              22.2891100109183,
              -33.8579500083862
            ],
            [
              22.2337499976642,
              -33.8882400040729
            ],
            [
              22.2678600004387,
              -33.9250200040699
            ],
            [
              22.2783199989688,
              -33.9902799900295
            ],
            [
              22.2786500042943,
              -33.9904000000599
            ],
            [
              22.2661600029818,
              -34.0479799969792
            ],
            [
              22.354570000705,
              -34.0544300003442
            ]
          ]
        ]
      },
      "properties": {
        "Name": "George Local Municipality",
        "Code": "WC044",
        "Parent_cod": "DC4",
        "Area": 519101
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              21.8869699966681,
              -34.3435799967194
            ],
            [
              21.9309299968219,
              -34.3041700004451
            ],
            [
              21.9322499992382,
              -34.2451300027474
            ],
            [
              22.0103399958941,
              -34.2110600018177
            ],
            [
              22.1121900081623,
              -34.203809999332
            ],
            [
              22.1118999965876,
              -34.1628600003887
            ],
            [
              22.1259499960955,
              -34.114929997921
            ],
            [
              22.1595299978112,
              -34.0841399962638
            ],
            [
              22.2344699957937,
              -34.0581699974474
            ],
            [
              22.354570000705,
              -34.0544300003442
            ],
            [
              22.2661600029818,
              -34.0479799969792
            ],
            [
              22.2786500042943,
              -33.9904000000599
            ],
            [
              22.2783199989688,
              -33.9902799900295
            ],
            [
              22.2678600004387,
              -33.9250200040699
            ],
            [
              22.2337499976642,
              -33.8882400040729
            ],
            [
              22.1236799984332,
              -33.8463700031731
            ],
            [
              21.9327800065921,
              -33.86542000393
            ],
            [
              21.8643800044337,
              -33.8553899991491
            ],
            [
              21.7003500016513,
              -33.8528500007269
            ],
            [
              21.6513900011477,
              -33.9281899991691
            ],
            [
              21.6666499979991,
              -34.0093600011631
            ],
            [
              21.715360004061,
              -34.0435799991177
            ],
            [
              21.7124314355623,
              -34.1276381675673
            ],
            [
              21.7433765082194,
              -34.1577309230436
            ],
            [
              21.75420000013,
              -34.2195499976342
            ],
            [
              21.7925799983683,
              -34.2861300012985
            ],
            [
              21.8869699966681,
              -34.3435799967194
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Mossel Bay Local Municipality",
        "Code": "WC043",
        "Parent_cod": "DC4",
        "Area": 200104
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              20.8499630016912,
              -34.4034059982882
            ],
            [
              20.9334400039531,
              -34.3659999982012
            ],
            [
              21.0011799972591,
              -34.3649500028403
            ],
            [
              21.134320000068,
              -34.3835499972346
            ],
            [
              21.290709996769,
              -34.4367699972375
            ],
            [
              21.3328799998121,
              -34.4346400051321
            ],
            [
              21.4131300079436,
              -34.4013599983652
            ],
            [
              21.4500899991543,
              -34.367539999971
            ],
            [
              21.5356999990558,
              -34.3563700001753
            ],
            [
              21.6962499978391,
              -34.3949900040854
            ],
            [
              21.8355000018237,
              -34.3752400007254
            ],
            [
              21.8869699966681,
              -34.3435799967194
            ],
            [
              21.7925799983683,
              -34.2861300012985
            ],
            [
              21.75420000013,
              -34.2195499976342
            ],
            [
              21.7433765082194,
              -34.1577309230436
            ],
            [
              21.7124314355623,
              -34.1276381675673
            ],
            [
              21.715360004061,
              -34.0435799991177
            ],
            [
              21.6666499979991,
              -34.0093600011631
            ],
            [
              21.6513900011477,
              -33.9281899991691
            ],
            [
              21.7003500016513,
              -33.8528500007269
            ],
            [
              21.74003506007,
              -33.7961459272927
            ],
            [
              21.648270004757,
              -33.8304099956248
            ],
            [
              21.5482600035964,
              -33.8228400026639
            ],
            [
              21.4233200003178,
              -33.8475899991791
            ],
            [
              21.3710600032166,
              -33.8198999983862
            ],
            [
              21.2162300038117,
              -33.8227700003352
            ],
            [
              21.2103199992686,
              -33.8228699977521
            ],
            [
              21.1917199976798,
              -33.8232099999416
            ],
            [
              21.1856099956049,
              -33.8233199960209
            ],
            [
              21.0846099991522,
              -33.8229199973599
            ],
            [
              20.9915599987949,
              -33.8680000023982
            ],
            [
              20.943380000087,
              -33.8518700022987
            ],
            [
              20.9523499973545,
              -33.9017799989477
            ],
            [
              20.9340399983473,
              -33.9476200030607
            ],
            [
              20.8337900014075,
              -33.9713300028773
            ],
            [
              20.8065800020655,
              -33.9464199962858
            ],
            [
              20.7072700026086,
              -33.9551200008873
            ],
            [
              20.7289500014415,
              -33.9883600004137
            ],
            [
              20.7227300041864,
              -34.0367699962383
            ],
            [
              20.7543000004447,
              -34.0972499973894
            ],
            [
              20.6401000023133,
              -34.0859600037511
            ],
            [
              20.66495000344,
              -34.1884799992525
            ],
            [
              20.6528200007425,
              -34.2235600017926
            ],
            [
              20.599380001386,
              -34.2729100040934
            ],
            [
              20.617760002722,
              -34.3026799973839
            ],
            [
              20.5962899991841,
              -34.3479699968179
            ],
            [
              20.6833799962898,
              -34.3466699989213
            ],
            [
              20.7350500039545,
              -34.3876800033295
            ],
            [
              20.801319998719,
              -34.4081600016827
            ],
            [
              20.8499630016912,
              -34.4034059982882
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Hessequa Local Municipality",
        "Code": "WC042",
        "Parent_cod": "DC4",
        "Area": 573263
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              21.74003506007,
              -33.7961459272927
            ],
            [
              21.7227999964227,
              -33.7053199962208
            ],
            [
              21.837480004099,
              -33.7373099965591
            ],
            [
              21.890030004681,
              -33.712780001196
            ],
            [
              21.9350399992966,
              -33.6677000042517
            ],
            [
              21.927289998035,
              -33.5792400060214
            ],
            [
              21.9362739977469,
              -33.5249759974443
            ],
            [
              21.9020799973941,
              -33.3649599882128
            ],
            [
              21.8272399968285,
              -33.3910400001958
            ],
            [
              21.611950000792,
              -33.3967999996203
            ],
            [
              21.5218199929983,
              -33.4144099969238
            ],
            [
              21.4331000016638,
              -33.394170003343
            ],
            [
              21.2064199992836,
              -33.4217000003547
            ],
            [
              21.0097100012157,
              -33.4392699958136
            ],
            [
              20.9217999995704,
              -33.4306500011966
            ],
            [
              20.7620000020985,
              -33.4908399898736
            ],
            [
              20.5475999976419,
              -33.5195199958511
            ],
            [
              20.5743500000525,
              -33.538760002672
            ],
            [
              20.5032589970051,
              -33.6370000022483
            ],
            [
              20.581589996681,
              -33.622120001337
            ],
            [
              20.5861799997072,
              -33.6672399992265
            ],
            [
              20.6660200024212,
              -33.6219700043122
            ],
            [
              20.7189200038551,
              -33.6406199974148
            ],
            [
              20.8002599992996,
              -33.7150099988124
            ],
            [
              20.9341200002379,
              -33.7246400121268
            ],
            [
              21.0103399987919,
              -33.7565600011431
            ],
            [
              20.943380000087,
              -33.8518700022987
            ],
            [
              20.9915599987949,
              -33.8680000023982
            ],
            [
              21.0846099991522,
              -33.8229199973599
            ],
            [
              21.1856099956049,
              -33.8233199960209
            ],
            [
              21.1917199976798,
              -33.8232099999416
            ],
            [
              21.2103199992686,
              -33.8228699977521
            ],
            [
              21.2162300038117,
              -33.8227700003352
            ],
            [
              21.3710600032166,
              -33.8198999983862
            ],
            [
              21.4233200003178,
              -33.8475899991791
            ],
            [
              21.5482600035964,
              -33.8228400026639
            ],
            [
              21.648270004757,
              -33.8304099956248
            ],
            [
              21.74003506007,
              -33.7961459272927
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Kannaland Local Municipality",
        "Code": "WC041",
        "Parent_cod": "DC4",
        "Area": 476537
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              27.2727616040649,
              -31.9336500166349
            ],
            [
              27.2080400017448,
              -31.9621699981469
            ],
            [
              27.1775900031761,
              -31.9341400032585
            ],
            [
              27.1059599986551,
              -31.915559997196
            ],
            [
              26.980839996069,
              -31.8271600053299
            ],
            [
              26.9582600006985,
              -31.7810100013104
            ],
            [
              26.8488000017188,
              -31.6918299968568
            ],
            [
              26.8046200031107,
              -31.70671999733
            ],
            [
              26.7696499957508,
              -31.6668200081368
            ],
            [
              26.8669099968989,
              -31.5849499972445
            ],
            [
              26.8917139968036,
              -31.5432709988574
            ],
            [
              26.8466499987985,
              -31.5078799990626
            ],
            [
              26.8789300026176,
              -31.4455600101863
            ],
            [
              26.8468699990512,
              -31.4358500030751
            ],
            [
              26.7432300058602,
              -31.4172600001489
            ],
            [
              26.6333200014169,
              -31.45524999659
            ],
            [
              26.6126600028569,
              -31.3719799912835
            ],
            [
              26.6636700016693,
              -31.3725599982453
            ],
            [
              26.6666800019806,
              -31.3213600005636
            ],
            [
              26.7086999999052,
              -31.2771000000649
            ],
            [
              26.6873800005866,
              -31.1925900014274
            ],
            [
              26.6287400042479,
              -31.2293899978501
            ],
            [
              26.5210299942389,
              -31.2072799971741
            ],
            [
              26.4271300023478,
              -31.2229999990507
            ],
            [
              26.426300000045,
              -31.1847400027489
            ],
            [
              26.3586499982989,
              -31.1964999991756
            ],
            [
              26.3361299994,
              -31.249409999272
            ],
            [
              26.2988600001888,
              -31.2168499969298
            ],
            [
              26.2370099979131,
              -31.2243200005675
            ],
            [
              26.2034199993336,
              -31.2772399993265
            ],
            [
              26.1302299957178,
              -31.2655600029917
            ],
            [
              26.1263100002064,
              -31.2786800027799
            ],
            [
              26.0331900038157,
              -31.3321800004067
            ],
            [
              25.9992299989653,
              -31.3348700021488
            ],
            [
              26.0023467434075,
              -31.4101645128819
            ],
            [
              25.965890002022,
              -31.4767699997357
            ],
            [
              25.8565700023039,
              -31.4536599961119
            ],
            [
              25.8230300024328,
              -31.4658799975637
            ],
            [
              25.7692599968514,
              -31.4441400031586
            ],
            [
              25.706090002052,
              -31.4751199937927
            ],
            [
              25.6656700032681,
              -31.4609999991507
            ],
            [
              25.5893300018781,
              -31.4853100023547
            ],
            [
              25.6173599967665,
              -31.5772600014479
            ],
            [
              25.5058200061884,
              -31.5488699989513
            ],
            [
              25.5283299992302,
              -31.6137499979639
            ],
            [
              25.4544900007131,
              -31.6845999979915
            ],
            [
              25.4148800006117,
              -31.6742499946416
            ],
            [
              25.3603999955634,
              -31.7144900022118
            ],
            [
              25.427169998097,
              -31.7410999981664
            ],
            [
              25.5414200030308,
              -31.7674299955978
            ],
            [
              25.5636800007315,
              -31.8029099985975
            ],
            [
              25.6340999989159,
              -31.8396099967039
            ],
            [
              25.6405699987066,
              -31.9026900008428
            ],
            [
              25.7231799969593,
              -31.8636500009467
            ],
            [
              25.7621699972476,
              -31.897900001184
            ],
            [
              25.8501599998841,
              -31.9088900007729
            ],
            [
              25.9484099981229,
              -31.9811100028243
            ],
            [
              25.9995300011087,
              -32.0050000019485
            ],
            [
              26.0239099994469,
              -32.0551899971206
            ],
            [
              26.0760000030977,
              -32.1126199961159
            ],
            [
              26.1391900033161,
              -32.1191500013714
            ],
            [
              26.1408499989283,
              -32.1468300044011
            ],
            [
              26.2068899956768,
              -32.1644700030881
            ],
            [
              26.191329996682,
              -32.2852300006639
            ],
            [
              26.2025200009973,
              -32.3312700014094
            ],
            [
              26.3096200008624,
              -32.3760099961643
            ],
            [
              26.4044699969928,
              -32.363949996695
            ],
            [
              26.5336900123842,
              -32.3601799982083
            ],
            [
              26.5392399940305,
              -32.3859650028825
            ],
            [
              26.6624499975694,
              -32.4279299991701
            ],
            [
              26.7350729993195,
              -32.3908059976986
            ],
            [
              26.7117599998242,
              -32.3400200002228
            ],
            [
              26.775780001446,
              -32.3332799996722
            ],
            [
              26.8449300004193,
              -32.2703899997986
            ],
            [
              26.8929600003039,
              -32.2716100003012
            ],
            [
              26.970180000007,
              -32.1938400004156
            ],
            [
              27.010920000058,
              -32.2225000000749
            ],
            [
              27.0915899996788,
              -32.2209299996198
            ],
            [
              27.1607299990902,
              -32.2384999977766
            ],
            [
              27.2436200021615,
              -32.2819400027289
            ],
            [
              27.3477799968494,
              -32.3117300014384
            ],
            [
              27.3868800022104,
              -32.3588300016033
            ],
            [
              27.4513500030003,
              -32.3522099966939
            ],
            [
              27.4921200017367,
              -32.3066300018731
            ],
            [
              27.4857599980255,
              -32.2525799995673
            ],
            [
              27.5078799982634,
              -32.2307499974144
            ],
            [
              27.4823400003908,
              -32.1628000007194
            ],
            [
              27.4401199977398,
              -32.1838500001773
            ],
            [
              27.3974800000021,
              -32.1361700002453
            ],
            [
              27.4118200029908,
              -32.0989199983591
            ],
            [
              27.36521000204,
              -32.0482299972165
            ],
            [
              27.3214147918592,
              -31.9757911280581
            ],
            [
              27.3370181067003,
              -31.9456374093389
            ],
            [
              27.2727616040649,
              -31.9336500166349
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Enoch Mgijima Local Municipality",
        "Code": "EC139",
        "Parent_cod": "DC13",
        "Area": 1358414,
        "detail": "Enoch Mgijima Local Municipality is situated within the Chris Hani District in the Eastern Cape province of South Africa. It was established following the August 2016 local government elections through the amalgamation of the former Tsolwana, Inkwanca, and Lukhanji municipalities.\n",
        "link_to_webpage": "https://www.enochmgijima.gov.za/",
        "image": "https://corruptionwatch-my.sharepoint.com/:i:/g/personal/nontobekog_corruptionwatch_org_za/EXZG5icj4bpIlpHn5o8YG_UBVHUUPXVe186TWLCpYsHv4g?e=scjdA5",
        "image_alt": "https://governmenthandbook.com/advert-listings/9204/enoch-mgijima-local-municipality/"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              27.4371360022247,
              -31.6766659999359
            ],
            [
              27.4959199971102,
              -31.7007299980909
            ],
            [
              27.4856500001474,
              -31.7629700003652
            ],
            [
              27.5381799998072,
              -31.7607600000739
            ],
            [
              27.5620499998077,
              -31.7211099999265
            ],
            [
              27.6944699981919,
              -31.7134200032305
            ],
            [
              27.7584599966316,
              -31.6564900093065
            ],
            [
              27.7256299971267,
              -31.6079100038436
            ],
            [
              27.746920001357,
              -31.5561899965711
            ],
            [
              27.8605099983378,
              -31.5344399963087
            ],
            [
              27.9718199900006,
              -31.5377300023377
            ],
            [
              28.0484399971083,
              -31.5057699961883
            ],
            [
              28.0752600027469,
              -31.4667800030946
            ],
            [
              28.1569899990893,
              -31.4018999968873
            ],
            [
              28.2607000036023,
              -31.3704399967085
            ],
            [
              28.2538199983942,
              -31.3339900011376
            ],
            [
              28.216159997386,
              -31.3128000033175
            ],
            [
              28.1212199926087,
              -31.300120004035
            ],
            [
              28.0807699996358,
              -31.323750001961
            ],
            [
              27.9885199912046,
              -31.2404099997217
            ],
            [
              27.931252005076,
              -31.2340140006456
            ],
            [
              27.8717900014074,
              -31.2032799988728
            ],
            [
              27.8081299903068,
              -31.2147699972375
            ],
            [
              27.7600200038202,
              -31.2036499970497
            ],
            [
              27.7365199992986,
              -31.2350499998575
            ],
            [
              27.6241200032356,
              -31.2240299970866
            ],
            [
              27.57744999682,
              -31.3892000020784
            ],
            [
              27.598640002734,
              -31.4437199909848
            ],
            [
              27.4744400003059,
              -31.4812300003641
            ],
            [
              27.4822564335875,
              -31.5860490731062
            ],
            [
              27.4342400035734,
              -31.5967299981908
            ],
            [
              27.4371360022247,
              -31.6766659999359
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Sakhisizwe Local Municipality",
        "Code": "EC138",
        "Parent_cod": "DC13",
        "Area": 234507,
        "detail": "Sakhisizwe Local Municipality is a Category B4 municipality (primarily rural, with 61% rural population) located in the Chris Hani District of the Eastern Cape Province. It spans 2,355 km² and comprises the main towns of Cala—where the administrative offices are based—and Khowa, along with surrounding rural villages and farms. As the smallest of the six municipalities in the district, it accounts for only 6% of the district's geographical area. It is bordered by the Joe Gqabi District to the north, Intsika Yethu to the south, Engcobo to the east, and Emalahleni to the west.\n",
        "link_to_webpage": "https://www.slm.gov.za/about-us/about/",
        "image": "https://corruptionwatch-my.sharepoint.com/:i:/g/personal/nontobekog_corruptionwatch_org_za/EXgSbOuwMolKlECsYM_zyDEBaHgagLuGb1IMwrt-UvPnPA?e=IQbZer",
        "image_alt": "https://en.wikipedia.org/wiki/Sakhisizwe_Local_Municipality#/media/File:Sakhisizwe_CoA.png"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              30.1938597940001,
              -31.0812602019999
            ],
            [
              30.2274799430001,
              -31.058289941
            ],
            [
              30.3044700680001,
              -30.941329941
            ],
            [
              30.4045099430001,
              -30.8283000659999
            ],
            [
              30.4680199430002,
              -30.726629941
            ],
            [
              30.5101599430002,
              -30.676999941
            ],
            [
              30.583549943,
              -30.560709941
            ],
            [
              30.5075449430001,
              -30.539539941
            ],
            [
              30.5088299430001,
              -30.5915999409999
            ],
            [
              30.4273399430001,
              -30.577869941
            ],
            [
              30.3986699430001,
              -30.629049941
            ],
            [
              30.3614599430002,
              -30.616439941
            ],
            [
              30.2182599430001,
              -30.6554099409999
            ],
            [
              30.168269943,
              -30.6129699409999
            ],
            [
              30.1362900680001,
              -30.624449941
            ],
            [
              30.072869943,
              -30.6499899409999
            ],
            [
              30.082109943,
              -30.696669941
            ],
            [
              30.020999941794,
              -30.7383499407971
            ],
            [
              29.982790067,
              -30.828070066
            ],
            [
              29.9611649800001,
              -30.823169972
            ],
            [
              29.9747999620002,
              -30.838079956
            ],
            [
              30.0927099706886,
              -30.8622299680385
            ],
            [
              30.1463500368248,
              -30.9310699698032
            ],
            [
              30.1427599827871,
              -31.0228200271225
            ],
            [
              30.1938597940001,
              -31.0812602019999
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Ray Nkonyeni Local Municipality",
        "Code": "KZN216",
        "Parent_cod": "DC21",
        "Area": 148709
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              28.0188488582882,
              -32.0431812931821
            ],
            [
              28.0639877320482,
              -32.0173034667815
            ],
            [
              28.1946800032796,
              -31.9664100012205
            ],
            [
              28.263330000779,
              -31.7913200028158
            ],
            [
              28.3276399977878,
              -31.837739998602
            ],
            [
              28.3519699983168,
              -31.8286500002972
            ],
            [
              28.3238600006385,
              -31.7907600003736
            ],
            [
              28.3441400032586,
              -31.7169599956073
            ],
            [
              28.3120899983548,
              -31.6886500030951
            ],
            [
              28.3090100020101,
              -31.61831999737
            ],
            [
              28.3255500003323,
              -31.5864499980689
            ],
            [
              28.3811000025631,
              -31.5580099968639
            ],
            [
              28.3634099970738,
              -31.5022300029122
            ],
            [
              28.3812650011789,
              -31.480000001199
            ],
            [
              28.2937699925912,
              -31.4166999968074
            ],
            [
              28.2607000036023,
              -31.3704399967085
            ],
            [
              28.1569899990893,
              -31.4018999968873
            ],
            [
              28.0752600027469,
              -31.4667800030946
            ],
            [
              28.0484399971083,
              -31.5057699961883
            ],
            [
              27.9718199900006,
              -31.5377300023377
            ],
            [
              27.8605099983378,
              -31.5344399963087
            ],
            [
              27.746920001357,
              -31.5561899965711
            ],
            [
              27.7256299971267,
              -31.6079100038436
            ],
            [
              27.7584599966316,
              -31.6564900093065
            ],
            [
              27.8010100037087,
              -31.6977999987709
            ],
            [
              27.8000199976248,
              -31.7435800064121
            ],
            [
              27.8791800031546,
              -31.8147300013884
            ],
            [
              28.0168209077587,
              -31.8728504180124
            ],
            [
              28.0102081298014,
              -31.9398422239394
            ],
            [
              27.9833335883745,
              -31.984285355185
            ],
            [
              28.010034441936,
              -32.0363916662424
            ],
            [
              28.0188488582882,
              -32.0431812931821
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Engcobo Local Municipality",
        "Code": "EC137",
        "Parent_cod": "DC13",
        "Area": 248387,
        "detail": "Dr AB Xuma Local Municipality, formerly known as Engcobo Municipality, is a local municipality situated within the Chris Hani District in the Eastern Cape province of South Africa. The name change reflects a move to honour Dr Alfred Bitini Xuma, a prominent South African medical doctor and political leader.\n",
        "link_to_webpage": "https://municipalities.co.za/overview/1021/dr-ab-xuma-local-municipality",
        "image": "https://corruptionwatch-my.sharepoint.com/:i:/g/personal/nontobekog_corruptionwatch_org_za/EU5KqXvHK7JJo4BSQi1gDfgBFdPQW-qFwm1_cUk3by_33g?e=LOTnda",
        "image_alt": "https://en.wikipedia.org/wiki/Dr_AB_Xuma_Local_Municipality#/media/File:Engcobo_CoA.png"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              27.1576100000016,
              -32.8384600001288
            ],
            [
              27.2127199981294,
              -32.7653500011016
            ],
            [
              27.2306199971152,
              -32.7173899963512
            ],
            [
              27.2974399965587,
              -32.676680001281
            ],
            [
              27.3712900009328,
              -32.699760002622
            ],
            [
              27.3957448309593,
              -32.7322708048538
            ],
            [
              27.3700634182921,
              -32.8043418476981
            ],
            [
              27.4561000008144,
              -32.7816299982258
            ],
            [
              27.5152799968744,
              -32.7159400014299
            ],
            [
              27.5364400014049,
              -32.7926199978146
            ],
            [
              27.6741699991462,
              -32.8343500003521
            ],
            [
              27.7630380080976,
              -32.7783499980539
            ],
            [
              27.7826899988444,
              -32.7489400042777
            ],
            [
              27.7281499982239,
              -32.6874800037991
            ],
            [
              27.6779700008149,
              -32.6604399970083
            ],
            [
              27.7291599989348,
              -32.6163200029657
            ],
            [
              27.7296999977567,
              -32.5108700009498
            ],
            [
              27.7879900022368,
              -32.5275700021538
            ],
            [
              27.8939800030747,
              -32.4561500001224
            ],
            [
              27.9149900015873,
              -32.4380600022673
            ],
            [
              27.881769999386,
              -32.3826700020189
            ],
            [
              27.8517500026605,
              -32.4065399957242
            ],
            [
              27.8096299992251,
              -32.380000003897
            ],
            [
              27.726580001366,
              -32.3651399994114
            ],
            [
              27.7588329391888,
              -32.3319680650741
            ],
            [
              27.7053184363968,
              -32.3244026838368
            ],
            [
              27.6437082419419,
              -32.2785921109372
            ],
            [
              27.6006875872623,
              -32.2134543662259
            ],
            [
              27.5350900003034,
              -32.1974800001019
            ],
            [
              27.5078799982634,
              -32.2307499974144
            ],
            [
              27.4857599980255,
              -32.2525799995673
            ],
            [
              27.4921200017367,
              -32.3066300018731
            ],
            [
              27.4513500030003,
              -32.3522099966939
            ],
            [
              27.3868800022104,
              -32.3588300016033
            ],
            [
              27.3477799968494,
              -32.3117300014384
            ],
            [
              27.2436200021615,
              -32.2819400027289
            ],
            [
              27.1607299990902,
              -32.2384999977766
            ],
            [
              27.0915899996788,
              -32.2209299996198
            ],
            [
              27.010920000058,
              -32.2225000000749
            ],
            [
              26.970180000007,
              -32.1938400004156
            ],
            [
              26.8929600003039,
              -32.2716100003012
            ],
            [
              26.8449300004193,
              -32.2703899997986
            ],
            [
              26.775780001446,
              -32.3332799996722
            ],
            [
              26.834320001267,
              -32.4389599988048
            ],
            [
              26.8056199997633,
              -32.4536299999245
            ],
            [
              26.8651500002723,
              -32.5115499999325
            ],
            [
              26.9505700004053,
              -32.5478300002542
            ],
            [
              27.0171000017637,
              -32.5112500031851
            ],
            [
              27.0364300001444,
              -32.5663499999525
            ],
            [
              27.0045149978689,
              -32.6050950006337
            ],
            [
              27.0255700011546,
              -32.6817700021838
            ],
            [
              27.0172300023628,
              -32.7851500022708
            ],
            [
              27.0864699982919,
              -32.8057299989402
            ],
            [
              27.0558899991242,
              -32.838510000636
            ],
            [
              27.1576100000016,
              -32.8384600001288
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Amahlathi Local Municipality",
        "Code": "EC124",
        "Parent_cod": "DC12",
        "Area": 450548,
        "detail": "Amahlathi Local Municipality is a Category B municipality located within the Amathole District in the Eastern Cape Province. It is bordered by Chris Hani District (north), Buffalo City Metro (south), Mnquma and Great Kei (east), and Raymond Mhlaba (west). As one of six municipalities in the district, it serves as an administrative area within the region.\n",
        "link_to_webpage": "https://amahlathi.gov.za/about-us/",
        "image": "https://corruptionwatch-my.sharepoint.com/:i:/g/personal/nontobekog_corruptionwatch_org_za/EYJ-WiZXHthCu-hzxSOnU_UBTPO_q95wyMNAkv4Is3BNug?e=MBGygE",
        "image_alt": "https://web.facebook.com/p/Amahlathi-Local-Municipality-100064445486215/?_rdc=1&amp;_rdr"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              27.7826899988444,
              -32.7489400042777
            ],
            [
              27.8299799978786,
              -32.7802900002832
            ],
            [
              27.882910000696,
              -32.7855000031226
            ],
            [
              27.93211999744,
              -32.7444199963857
            ],
            [
              27.9571778336902,
              -32.7583392245756
            ],
            [
              27.9914599460197,
              -32.8555618337116
            ],
            [
              28.0755299936144,
              -32.9077950004389
            ],
            [
              28.1175800019156,
              -32.8300599976707
            ],
            [
              28.1785500031801,
              -32.7862899972855
            ],
            [
              28.2689700000655,
              -32.7589100035937
            ],
            [
              28.307850003375,
              -32.7255399962738
            ],
            [
              28.3735800002169,
              -32.7048699999505
            ],
            [
              28.3876350026534,
              -32.6796000019384
            ],
            [
              28.3488199987439,
              -32.6239199991086
            ],
            [
              28.3158099981329,
              -32.6329099919025
            ],
            [
              28.2227400013501,
              -32.5780900008528
            ],
            [
              28.1689300038167,
              -32.5681799980085
            ],
            [
              28.1454199997332,
              -32.5095599891022
            ],
            [
              28.0473600003638,
              -32.5363800028349
            ],
            [
              27.9555800019156,
              -32.5065299995598
            ],
            [
              27.8939800030747,
              -32.4561500001224
            ],
            [
              27.7879900022368,
              -32.5275700021538
            ],
            [
              27.7296999977567,
              -32.5108700009498
            ],
            [
              27.7291599989348,
              -32.6163200029657
            ],
            [
              27.6779700008149,
              -32.6604399970083
            ],
            [
              27.7281499982239,
              -32.6874800037991
            ],
            [
              27.7826899988444,
              -32.7489400042777
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Great Kei Local Municipality",
        "Code": "EC123",
        "Parent_cod": "DC12",
        "Area": 169983,
        "detail": "Great Kei Local Municipality is a Category B municipality within the Amathole District in the Eastern Cape Province. It is situated near the former industrial towns of Butterworth, Qonce (King William’s Town), and East London. Bordered by Stutterheim to the north, the Wild Coast to the southeast, the Great Kei River to the east, and Buffalo City to the west, it is the smallest of the six municipalities in the district.\n",
        "link_to_webpage": "https://greatkeilm.gov.za/web/",
        "image": "https://corruptionwatch-my.sharepoint.com/:i:/g/personal/nontobekog_corruptionwatch_org_za/EbyrWDEnDXZHiDTRItlyS-8BLCk6Ly_kJoeYueAomR3vfA?e=J4GcXn",
        "image_alt": "https://en.wikipedia.org/wiki/Great_Kei_Local_Municipality#/media/File:Great_Kei_CoA.png"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              28.6755630020309,
              -32.4485880021346
            ],
            [
              28.5510609928706,
              -32.4208567467414
            ],
            [
              28.5023396373644,
              -32.3922639983848
            ],
            [
              28.4093427356788,
              -32.3894165874055
            ],
            [
              28.4383967247291,
              -32.3418344040345
            ],
            [
              28.3167399996513,
              -32.243499999925
            ],
            [
              28.2818600000391,
              -32.2457300002393
            ],
            [
              28.2350706508899,
              -32.2081591499248
            ],
            [
              28.2513399982424,
              -32.0685100079305
            ],
            [
              28.1871900032162,
              -32.0258399989168
            ],
            [
              28.1365000029728,
              -32.0617399979025
            ],
            [
              28.0612600019476,
              -32.0657000033524
            ],
            [
              28.0188488582882,
              -32.0431812931821
            ],
            [
              28.010034441936,
              -32.0363916662424
            ],
            [
              27.9501999966326,
              -32.0818899999235
            ],
            [
              27.8891100024248,
              -32.0497500025605
            ],
            [
              27.8638199998931,
              -32.0771900008179
            ],
            [
              27.7751900010178,
              -32.1094800032995
            ],
            [
              27.8127700001354,
              -32.1832399990267
            ],
            [
              27.7650199969753,
              -32.2588100026794
            ],
            [
              27.7588329391888,
              -32.3319680650741
            ],
            [
              27.726580001366,
              -32.3651399994114
            ],
            [
              27.8096299992251,
              -32.380000003897
            ],
            [
              27.8517500026605,
              -32.4065399957242
            ],
            [
              27.881769999386,
              -32.3826700020189
            ],
            [
              27.9149900015873,
              -32.4380600022673
            ],
            [
              27.8939800030747,
              -32.4561500001224
            ],
            [
              27.9555800019156,
              -32.5065299995598
            ],
            [
              28.0473600003638,
              -32.5363800028349
            ],
            [
              28.1454199997332,
              -32.5095599891022
            ],
            [
              28.1689300038167,
              -32.5681799980085
            ],
            [
              28.2227400013501,
              -32.5780900008528
            ],
            [
              28.3158099981329,
              -32.6329099919025
            ],
            [
              28.3488199987439,
              -32.6239199991086
            ],
            [
              28.3876350026534,
              -32.6796000019384
            ],
            [
              28.4315099979881,
              -32.633189996721
            ],
            [
              28.5117300029374,
              -32.6031899973205
            ],
            [
              28.6158899976253,
              -32.4926000028878
            ],
            [
              28.6755630020309,
              -32.4485880021346
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Mnquma Local Municipality",
        "Code": "EC122",
        "Parent_cod": "DC12",
        "Area": 313726,
        "detail": "Mnquma Local Municipality is a Category B municipality in the south-eastern part of the Eastern Cape, under the Amathole District Municipality. It was formed by merging the former Butterworth, Ngqamakhwe, and Centane Transitional Regional Councils.\nMnquma borders three other local municipalities, the Chris Hani District, and the Indian Ocean. It is one of six municipalities within the Amathole District.\n",
        "link_to_webpage": "https://www.mnquma.gov.za/",
        "image": "https://corruptionwatch-my.sharepoint.com/:i:/g/personal/nontobekog_corruptionwatch_org_za/EUlbqK3wJKBFuA3NLgZvBvoBm07N-JkSTcr3u-E2ZBXKUQ?e=ceazkF",
        "image_alt": "https://www.mnquma.gov.za/"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              28.6755630020309,
              -32.4485880021346
            ],
            [
              28.8317399970033,
              -32.3054800010012
            ],
            [
              28.8824199985841,
              -32.2798499971796
            ],
            [
              28.9464400011052,
              -32.2048199986439
            ],
            [
              29.0934100031692,
              -32.0593499983037
            ],
            [
              28.9258700030982,
              -31.9446199991137
            ],
            [
              28.8675199931532,
              -31.9602900022818
            ],
            [
              28.7821999967325,
              -32.0459999996003
            ],
            [
              28.7127700028334,
              -32.0076600023072
            ],
            [
              28.6611000041619,
              -32.0091600031316
            ],
            [
              28.5978199961959,
              -31.9717300001393
            ],
            [
              28.564780001396,
              -31.9823200001678
            ],
            [
              28.4651899971207,
              -31.9678200023912
            ],
            [
              28.427450011309,
              -31.8702299968169
            ],
            [
              28.3519699983168,
              -31.8286500002972
            ],
            [
              28.3276399977878,
              -31.837739998602
            ],
            [
              28.263330000779,
              -31.7913200028158
            ],
            [
              28.1946800032796,
              -31.9664100012205
            ],
            [
              28.0639877320482,
              -32.0173034667815
            ],
            [
              28.0188488582882,
              -32.0431812931821
            ],
            [
              28.0612600019476,
              -32.0657000033524
            ],
            [
              28.1365000029728,
              -32.0617399979025
            ],
            [
              28.1871900032162,
              -32.0258399989168
            ],
            [
              28.2513399982424,
              -32.0685100079305
            ],
            [
              28.2350706508899,
              -32.2081591499248
            ],
            [
              28.2818600000391,
              -32.2457300002393
            ],
            [
              28.3167399996513,
              -32.243499999925
            ],
            [
              28.4383967247291,
              -32.3418344040345
            ],
            [
              28.4093427356788,
              -32.3894165874055
            ],
            [
              28.5023396373644,
              -32.3922639983848
            ],
            [
              28.5510609928706,
              -32.4208567467414
            ],
            [
              28.6755630020309,
              -32.4485880021346
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Mbhashe Local Municipality",
        "Code": "EC121",
        "Parent_cod": "DC12",
        "Area": 330251,
        "detail": "Mbhashe Local Municipality is a Category B municipality located in the south-eastern part of the Eastern Cape, within the Amathole District. It is coastal, stretching along the Indian Ocean from the Mncwasa River in the north to the Qhora River in the south.\nThe municipality shares borders with King Sabata Dalindyebo (north-east), Mnquma (south), Ntsika Yethu (south-west), and Ngcobo (west).\n",
        "link_to_webpage": "https://www.mbhashemun.gov.za/",
        "image": "https://corruptionwatch-my.sharepoint.com/:i:/g/personal/nontobekog_corruptionwatch_org_za/EZhtpBiVOq9BrhzfUWJjvyYBj8tAz2Te5sBfoOJ6ebguag?e=AyrLqH",
        "image_alt": "https://www.mbhashemun.gov.za/"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              31.3462299443566,
              -28.7746399392817
            ],
            [
              31.3281699442876,
              -28.7202600638508
            ],
            [
              31.280059944311,
              -28.716419938929
            ],
            [
              31.2371799435996,
              -28.6367599391198
            ],
            [
              31.1987999435626,
              -28.6492300636164
            ],
            [
              31.1585399440633,
              -28.5511149394029
            ],
            [
              31.1063600675632,
              -28.5280699387766
            ],
            [
              31.0181299432425,
              -28.4257700640372
            ],
            [
              30.9654199433758,
              -28.40632006372
            ],
            [
              30.8326599428022,
              -28.4637299385857
            ],
            [
              30.8039619431892,
              -28.5178259394155
            ],
            [
              30.7592099433843,
              -28.5421299387456
            ],
            [
              30.8213599433068,
              -28.5816299391703
            ],
            [
              30.7885199433408,
              -28.6288800640637
            ],
            [
              30.7324399427493,
              -28.6651999394257
            ],
            [
              30.6703159431264,
              -28.6425520641264
            ],
            [
              30.6844899429566,
              -28.6635599393397
            ],
            [
              30.6501099430195,
              -28.7207299389355
            ],
            [
              30.6990739428083,
              -28.7719359386926
            ],
            [
              30.7457099431594,
              -28.7657699394311
            ],
            [
              30.7708599437315,
              -28.7226800639337
            ],
            [
              30.8231699431384,
              -28.7428199386892
            ],
            [
              30.8331099428696,
              -28.7716999386012
            ],
            [
              30.9867999427632,
              -28.8051200642395
            ],
            [
              30.9933499444444,
              -28.856479938898
            ],
            [
              31.029826943059,
              -28.9015229386327
            ],
            [
              31.0779599431969,
              -28.8757699390315
            ],
            [
              31.1227099429096,
              -28.8279500639443
            ],
            [
              31.1644799436945,
              -28.8308900637254
            ],
            [
              31.1842999439874,
              -28.7622499389835
            ],
            [
              31.2197199442202,
              -28.7885599390898
            ],
            [
              31.3074699438829,
              -28.8121099387226
            ],
            [
              31.3462299443566,
              -28.7746399392817
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Nkandla Local Municipality",
        "Code": "KZN286",
        "Parent_cod": "DC28",
        "Area": 182758
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              31.3462299443566,
              -28.7746399392817
            ],
            [
              31.4502199437955,
              -28.7622399394217
            ],
            [
              31.5208799440543,
              -28.7134099386177
            ],
            [
              31.6514830906722,
              -28.703873086074
            ],
            [
              31.7197006203873,
              -28.4980850488859
            ],
            [
              31.7936505050002,
              -28.4831066859999
            ],
            [
              31.811069944,
              -28.431680939
            ],
            [
              31.7410599440002,
              -28.433460064
            ],
            [
              31.7020649438421,
              -28.3714550639
            ],
            [
              31.6706499439399,
              -28.4023999387061
            ],
            [
              31.6258999442271,
              -28.4076800643834
            ],
            [
              31.610439944448,
              -28.3768699385968
            ],
            [
              31.535959944296,
              -28.3943300638813
            ],
            [
              31.5043999440024,
              -28.4719799386232
            ],
            [
              31.4454599437214,
              -28.4771599391798
            ],
            [
              31.4108739441774,
              -28.4585629386287
            ],
            [
              31.3585099440788,
              -28.3939500643439
            ],
            [
              31.3294509440059,
              -28.4491649387109
            ],
            [
              31.2749276114202,
              -28.4836679299309
            ],
            [
              31.2491399438535,
              -28.4622099386378
            ],
            [
              31.1895299441517,
              -28.4993799386333
            ],
            [
              31.1585399440633,
              -28.5511149394029
            ],
            [
              31.1987999435626,
              -28.6492300636164
            ],
            [
              31.2371799435996,
              -28.6367599391198
            ],
            [
              31.280059944311,
              -28.716419938929
            ],
            [
              31.3281699442876,
              -28.7202600638508
            ],
            [
              31.3462299443566,
              -28.7746399392817
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Mthonjaneni Local Municipality",
        "Code": "KZN285",
        "Parent_cod": "DC28",
        "Area": 163862
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              31.8157099442585,
              -28.945739938947
            ],
            [
              31.7858499441197,
              -28.9027400640027
            ],
            [
              31.7161899441107,
              -28.9186600643104
            ],
            [
              31.7664999439174,
              -28.8527199390739
            ],
            [
              31.8322999439874,
              -28.8315599390399
            ],
            [
              31.8177099438588,
              -28.7887399392967
            ],
            [
              31.7543599443561,
              -28.7722599392448
            ],
            [
              31.7593399437836,
              -28.7421199387841
            ],
            [
              31.6927999437624,
              -28.6993000640467
            ],
            [
              31.6514830906722,
              -28.703873086074
            ],
            [
              31.5208799440543,
              -28.7134099386177
            ],
            [
              31.4502199437955,
              -28.7622399394217
            ],
            [
              31.3462299443566,
              -28.7746399392817
            ],
            [
              31.3074699438829,
              -28.8121099387226
            ],
            [
              31.2197199442202,
              -28.7885599390898
            ],
            [
              31.1842999439874,
              -28.7622499389835
            ],
            [
              31.1644799436945,
              -28.8308900637254
            ],
            [
              31.1227099429096,
              -28.8279500639443
            ],
            [
              31.0779599431969,
              -28.8757699390315
            ],
            [
              31.029826943059,
              -28.9015229386327
            ],
            [
              31.0491799433997,
              -28.9491200642396
            ],
            [
              31.1250599433617,
              -28.9589899393342
            ],
            [
              31.118280067771,
              -28.9933400637928
            ],
            [
              31.1754099441136,
              -29.0731299400945
            ],
            [
              31.2073299439218,
              -29.089100065016
            ],
            [
              31.2887249437013,
              -29.1640099402066
            ],
            [
              31.3183209892223,
              -29.1500299996848
            ],
            [
              31.3723999443021,
              -29.059449939663
            ],
            [
              31.3878599440812,
              -28.9968799392577
            ],
            [
              31.4589799439692,
              -28.9916799386782
            ],
            [
              31.4705799438094,
              -29.0230299400796
            ],
            [
              31.5295899437209,
              -29.0566899400886
            ],
            [
              31.6753139440833,
              -29.0548930649629
            ],
            [
              31.7653499439448,
              -28.9654299386407
            ],
            [
              31.8157099442585,
              -28.945739938947
            ]
          ]
        ]
      },
      "properties": {
        "Name": "uMlalazi Local Municipality",
        "Code": "KZN284",
        "Parent_cod": "DC28",
        "Area": 221394
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              31.8157099442585,
              -28.945739938947
            ],
            [
              31.9185399441632,
              -28.9174699392862
            ],
            [
              32.0293399437834,
              -28.8653999392557
            ],
            [
              32.1471193920001,
              -28.7588053969999
            ],
            [
              32.1442199435956,
              -28.702037064359
            ],
            [
              32.0685099440001,
              -28.7034100639999
            ],
            [
              32.0224199439254,
              -28.6464499390135
            ],
            [
              31.9593099437991,
              -28.6640799390378
            ],
            [
              31.9136799439743,
              -28.6287450641333
            ],
            [
              31.8966999440002,
              -28.5715400639999
            ],
            [
              31.7958502730002,
              -28.562392512
            ],
            [
              31.7936505050002,
              -28.4831066859999
            ],
            [
              31.7197006203873,
              -28.4980850488859
            ],
            [
              31.6514830906722,
              -28.703873086074
            ],
            [
              31.6927999437624,
              -28.6993000640467
            ],
            [
              31.7593399437836,
              -28.7421199387841
            ],
            [
              31.7543599443561,
              -28.7722599392448
            ],
            [
              31.8177099438588,
              -28.7887399392967
            ],
            [
              31.8322999439874,
              -28.8315599390399
            ],
            [
              31.7664999439174,
              -28.8527199390739
            ],
            [
              31.7161899441107,
              -28.9186600643104
            ],
            [
              31.7858499441197,
              -28.9027400640027
            ],
            [
              31.8157099442585,
              -28.945739938947
            ]
          ]
        ]
      },
      "properties": {
        "Name": "uMhlathuze Local Municipality",
        "Code": "KZN282",
        "Parent_cod": "DC28",
        "Area": 123285
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              32.1471193920001,
              -28.7588053969999
            ],
            [
              32.2245499450001,
              -28.6862799389999
            ],
            [
              32.2974999450001,
              -28.634200064
            ],
            [
              32.368949945,
              -28.5684000639999
            ],
            [
              32.4147679445852,
              -28.4763929388828
            ],
            [
              32.3371799449985,
              -28.4938600635909
            ],
            [
              32.305199945,
              -28.5185100639999
            ],
            [
              32.2121899439109,
              -28.4589499393882
            ],
            [
              32.1119399440002,
              -28.4362299389999
            ],
            [
              32.0683599436565,
              -28.4566699385668
            ],
            [
              32.0479099439889,
              -28.4077899390544
            ],
            [
              31.9907799440001,
              -28.3885899389998
            ],
            [
              31.9814329440001,
              -28.350419939
            ],
            [
              31.9625299440001,
              -28.406219939
            ],
            [
              31.811069944,
              -28.431680939
            ],
            [
              31.7936505050002,
              -28.4831066859999
            ],
            [
              31.7958502730002,
              -28.562392512
            ],
            [
              31.8966999440002,
              -28.5715400639999
            ],
            [
              31.9136799439743,
              -28.6287450641333
            ],
            [
              31.9593099437991,
              -28.6640799390378
            ],
            [
              32.0224199439254,
              -28.6464499390135
            ],
            [
              32.0685099440001,
              -28.7034100639999
            ],
            [
              32.1442199435956,
              -28.702037064359
            ],
            [
              32.1471193920001,
              -28.7588053969999
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Mfolozi Local Municipality",
        "Code": "KZN281",
        "Parent_cod": "DC28",
        "Area": 130032
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              20.0074600001789,
              -34.0939200021063
            ],
            [
              20.0084999977767,
              -34.0639000098775
            ],
            [
              20.1416900001934,
              -34.0592100013405
            ],
            [
              20.196090003351,
              -34.0399999968024
            ],
            [
              20.2218000009694,
              -34.111100009258
            ],
            [
              20.2913399990418,
              -34.091299999995
            ],
            [
              20.2907600001739,
              -34.0419399990317
            ],
            [
              20.3280199998232,
              -33.9730500039545
            ],
            [
              20.2224600017278,
              -33.9128199981443
            ],
            [
              20.2378500000775,
              -33.9004400010052
            ],
            [
              20.3244299997447,
              -33.9495700030532
            ],
            [
              20.4360400034434,
              -33.9577400083947
            ],
            [
              20.4682500031352,
              -33.8802899989842
            ],
            [
              20.4353499986037,
              -33.8263999995603
            ],
            [
              20.5144700031882,
              -33.8026199983142
            ],
            [
              20.4478899986246,
              -33.773970001814
            ],
            [
              20.4728209998893,
              -33.7291689970516
            ],
            [
              20.4691520042616,
              -33.681952002283
            ],
            [
              20.5032589970051,
              -33.6370000022483
            ],
            [
              20.5743500000525,
              -33.538760002672
            ],
            [
              20.5475999976419,
              -33.5195199958511
            ],
            [
              20.5016600042059,
              -33.4984599977307
            ],
            [
              20.4980199982244,
              -33.4638700033979
            ],
            [
              20.3362200002528,
              -33.4878199908999
            ],
            [
              20.2415309971578,
              -33.5380459967253
            ],
            [
              20.1730600007185,
              -33.5262469967015
            ],
            [
              20.1254143090232,
              -33.5562851408465
            ],
            [
              19.9924838680362,
              -33.5568381690462
            ],
            [
              19.9586999972071,
              -33.5176099968039
            ],
            [
              19.9171000105571,
              -33.5192700014094
            ],
            [
              19.8387899965611,
              -33.5659499983937
            ],
            [
              19.747710000716,
              -33.5302799983232
            ],
            [
              19.6375900018771,
              -33.5365500023807
            ],
            [
              19.6451910025628,
              -33.6046010010353
            ],
            [
              19.6996300012237,
              -33.6379300019679
            ],
            [
              19.7020700013295,
              -33.7184299892526
            ],
            [
              19.6596399970882,
              -33.7750900004032
            ],
            [
              19.6813899982499,
              -33.7993700004251
            ],
            [
              19.5945399978226,
              -33.8541899986695
            ],
            [
              19.5322799982234,
              -33.8784299986455
            ],
            [
              19.5453999980115,
              -33.9156499991481
            ],
            [
              19.5068899982749,
              -33.9717000010541
            ],
            [
              19.5898300009538,
              -34.0123600064091
            ],
            [
              19.6806600041559,
              -34.0091400063062
            ],
            [
              19.7001399959641,
              -34.0464000050562
            ],
            [
              19.9865400049173,
              -34.0781700069402
            ],
            [
              20.0074600001789,
              -34.0939200021063
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Langeberg Local Municipality",
        "Code": "WC026",
        "Parent_cod": "DC2",
        "Area": 451755
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              19.5068899982749,
              -33.9717000010541
            ],
            [
              19.5453999980115,
              -33.9156499991481
            ],
            [
              19.5322799982234,
              -33.8784299986455
            ],
            [
              19.5945399978226,
              -33.8541899986695
            ],
            [
              19.6813899982499,
              -33.7993700004251
            ],
            [
              19.6596399970882,
              -33.7750900004032
            ],
            [
              19.7020700013295,
              -33.7184299892526
            ],
            [
              19.6996300012237,
              -33.6379300019679
            ],
            [
              19.6451910025628,
              -33.6046010010353
            ],
            [
              19.6375900018771,
              -33.5365500023807
            ],
            [
              19.747710000716,
              -33.5302799983232
            ],
            [
              19.8387899965611,
              -33.5659499983937
            ],
            [
              19.9171000105571,
              -33.5192700014094
            ],
            [
              19.9586999972071,
              -33.5176099968039
            ],
            [
              19.9924838680362,
              -33.5568381690462
            ],
            [
              20.1254143090232,
              -33.5562851408465
            ],
            [
              20.1730600007185,
              -33.5262469967015
            ],
            [
              20.2415309971578,
              -33.5380459967253
            ],
            [
              20.3362200002528,
              -33.4878199908999
            ],
            [
              20.3860799981934,
              -33.4591700042922
            ],
            [
              20.335609990109,
              -33.425640001285
            ],
            [
              20.3680399990467,
              -33.3662700000605
            ],
            [
              20.2091700012945,
              -33.3797999971721
            ],
            [
              20.2511800005567,
              -33.2915100013854
            ],
            [
              20.2356200015619,
              -33.262419997185
            ],
            [
              20.2579699989164,
              -33.1884499908743
            ],
            [
              20.2021799991077,
              -33.1701099976782
            ],
            [
              20.0869840027096,
              -33.1932779958827
            ],
            [
              20.0137699988864,
              -33.2387880036633
            ],
            [
              19.9720399972482,
              -33.3167799913035
            ],
            [
              19.9084700010897,
              -33.3626999964076
            ],
            [
              19.830580000167,
              -33.3794200021313
            ],
            [
              19.7544999990757,
              -33.3726400024341
            ],
            [
              19.6686699989214,
              -33.3818600013379
            ],
            [
              19.5806900021419,
              -33.364520003895
            ],
            [
              19.537909997948,
              -33.4264400013049
            ],
            [
              19.473200001379,
              -33.4616500116387
            ],
            [
              19.4053000033925,
              -33.4805099991371
            ],
            [
              19.3785900010278,
              -33.6190900037007
            ],
            [
              19.3113200024162,
              -33.6071000011641
            ],
            [
              19.2394699976423,
              -33.5588400005655
            ],
            [
              19.1853999998102,
              -33.5619900010377
            ],
            [
              19.1693900016473,
              -33.5974899923692
            ],
            [
              19.1070400032935,
              -33.541139997313
            ],
            [
              19.101960000154,
              -33.6067600061693
            ],
            [
              19.1474900043602,
              -33.6561000017136
            ],
            [
              19.1487500076068,
              -33.7022099975933
            ],
            [
              19.1839899977402,
              -33.715390001947
            ],
            [
              19.2140490061567,
              -33.8570679955915
            ],
            [
              19.2438000003698,
              -33.8974499989183
            ],
            [
              19.297400005306,
              -33.889680003929
            ],
            [
              19.3188600011882,
              -33.9471900030162
            ],
            [
              19.4557999975719,
              -33.9998800037591
            ],
            [
              19.5068899982749,
              -33.9717000010541
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Breede Valley Local Municipality",
        "Code": "WC025",
        "Parent_cod": "DC2",
        "Area": 383399
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              20.8499630016912,
              -34.4034059982882
            ],
            [
              20.801319998719,
              -34.4081600016827
            ],
            [
              20.7350500039545,
              -34.3876800033295
            ],
            [
              20.6833799962898,
              -34.3466699989213
            ],
            [
              20.5962899991841,
              -34.3479699968179
            ],
            [
              20.617760002722,
              -34.3026799973839
            ],
            [
              20.599380001386,
              -34.2729100040934
            ],
            [
              20.6528200007425,
              -34.2235600017926
            ],
            [
              20.66495000344,
              -34.1884799992525
            ],
            [
              20.6401000023133,
              -34.0859600037511
            ],
            [
              20.7543000004447,
              -34.0972499973894
            ],
            [
              20.7227300041864,
              -34.0367699962383
            ],
            [
              20.7289500014415,
              -33.9883600004137
            ],
            [
              20.7072700026086,
              -33.9551200008873
            ],
            [
              20.8065800020655,
              -33.9464199962858
            ],
            [
              20.8337900014075,
              -33.9713300028773
            ],
            [
              20.9340399983473,
              -33.9476200030607
            ],
            [
              20.9523499973545,
              -33.9017799989477
            ],
            [
              20.943380000087,
              -33.8518700022987
            ],
            [
              21.0103399987919,
              -33.7565600011431
            ],
            [
              20.9341200002379,
              -33.7246400121268
            ],
            [
              20.8002599992996,
              -33.7150099988124
            ],
            [
              20.7189200038551,
              -33.6406199974148
            ],
            [
              20.6660200024212,
              -33.6219700043122
            ],
            [
              20.5861799997072,
              -33.6672399992265
            ],
            [
              20.581589996681,
              -33.622120001337
            ],
            [
              20.5032589970051,
              -33.6370000022483
            ],
            [
              20.4691520042616,
              -33.681952002283
            ],
            [
              20.4728209998893,
              -33.7291689970516
            ],
            [
              20.4478899986246,
              -33.773970001814
            ],
            [
              20.5144700031882,
              -33.8026199983142
            ],
            [
              20.4353499986037,
              -33.8263999995603
            ],
            [
              20.4682500031352,
              -33.8802899989842
            ],
            [
              20.4360400034434,
              -33.9577400083947
            ],
            [
              20.3244299997447,
              -33.9495700030532
            ],
            [
              20.2378500000775,
              -33.9004400010052
            ],
            [
              20.2224600017278,
              -33.9128199981443
            ],
            [
              20.3280199998232,
              -33.9730500039545
            ],
            [
              20.2907600001739,
              -34.0419399990317
            ],
            [
              20.2913399990418,
              -34.091299999995
            ],
            [
              20.2218000009694,
              -34.111100009258
            ],
            [
              20.196090003351,
              -34.0399999968024
            ],
            [
              20.1416900001934,
              -34.0592100013405
            ],
            [
              20.0084999977767,
              -34.0639000098775
            ],
            [
              20.0074600001789,
              -34.0939200021063
            ],
            [
              19.9657200025761,
              -34.1762700063557
            ],
            [
              19.8804300048409,
              -34.2201100009757
            ],
            [
              19.9400299995848,
              -34.2395500026305
            ],
            [
              20.0324299978462,
              -34.2035999968424
            ],
            [
              20.0655299981109,
              -34.2412699956138
            ],
            [
              20.1339700021139,
              -34.2503800002367
            ],
            [
              20.1485699982068,
              -34.2712000007793
            ],
            [
              20.2448500000275,
              -34.2888899990742
            ],
            [
              20.286330007224,
              -34.3451500016712
            ],
            [
              20.289080000042,
              -34.4177700032829
            ],
            [
              20.3573099997568,
              -34.3884400024042
            ],
            [
              20.3919799968794,
              -34.4262900013824
            ],
            [
              20.4847500014115,
              -34.401319989326
            ],
            [
              20.5317299987405,
              -34.360520002696
            ],
            [
              20.7117699996858,
              -34.412649999198
            ],
            [
              20.8167999967226,
              -34.4288699989512
            ],
            [
              20.8713900050448,
              -34.4524400004056
            ],
            [
              20.8499630016912,
              -34.4034059982882
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Swellendam Local Municipality",
        "Code": "WC034",
        "Parent_cod": "DC3",
        "Area": 383510
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              24.8474107231264,
              -27.9579746651987
            ],
            [
              24.8298400001159,
              -27.9312900003332
            ],
            [
              25.0479099984477,
              -27.6997399964037
            ],
            [
              24.9997200010772,
              -27.6808300039015
            ],
            [
              24.8011699999956,
              -27.7017799969492
            ],
            [
              24.79771999738,
              -27.6561799958102
            ],
            [
              24.7620600049653,
              -27.633240000026
            ],
            [
              24.6922999976468,
              -27.6452199994035
            ],
            [
              24.6748700014494,
              -27.6926399963387
            ],
            [
              24.6954700044372,
              -27.7182500001373
            ],
            [
              24.6586699972226,
              -27.790939993286
            ],
            [
              24.6993200030157,
              -27.8282899970857
            ],
            [
              24.6583100013055,
              -27.8526700026185
            ],
            [
              24.6158199987939,
              -27.9036000013389
            ],
            [
              24.732835663635,
              -27.9202253453234
            ],
            [
              24.7432900027315,
              -27.9669000003347
            ],
            [
              24.7752099998417,
              -27.994110000576
            ],
            [
              24.8474107231264,
              -27.9579746651987
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Phokwane Local Municipality",
        "Code": "NC094",
        "Parent_cod": "DC9",
        "Area": 82811
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              19.7247370043094,
              -34.7672489992418
            ],
            [
              19.8722299999146,
              -34.765899999985
            ],
            [
              19.9891799980585,
              -34.833370003323
            ],
            [
              20.0466800011812,
              -34.788310001905
            ],
            [
              20.0797800014459,
              -34.7365100017352
            ],
            [
              20.1629399962838,
              -34.6974999969273
            ],
            [
              20.232589996731,
              -34.6896200040599
            ],
            [
              20.2588400021644,
              -34.6382899985845
            ],
            [
              20.4072400018247,
              -34.5634300015932
            ],
            [
              20.4760900040505,
              -34.4923299981309
            ],
            [
              20.5978499982788,
              -34.4552700014094
            ],
            [
              20.6911199988889,
              -34.4502700001604
            ],
            [
              20.8483799988379,
              -34.4723499967549
            ],
            [
              20.8713900050448,
              -34.4524400004056
            ],
            [
              20.8167999967226,
              -34.4288699989512
            ],
            [
              20.7117699996858,
              -34.412649999198
            ],
            [
              20.5317299987405,
              -34.360520002696
            ],
            [
              20.4847500014115,
              -34.401319989326
            ],
            [
              20.3919799968794,
              -34.4262900013824
            ],
            [
              20.3573099997568,
              -34.3884400024042
            ],
            [
              20.289080000042,
              -34.4177700032829
            ],
            [
              20.286330007224,
              -34.3451500016712
            ],
            [
              20.2448500000275,
              -34.2888899990742
            ],
            [
              20.1485699982068,
              -34.2712000007793
            ],
            [
              20.1339700021139,
              -34.2503800002367
            ],
            [
              20.0655299981109,
              -34.2412699956138
            ],
            [
              20.0324299978462,
              -34.2035999968424
            ],
            [
              19.9400299995848,
              -34.2395500026305
            ],
            [
              19.8804300048409,
              -34.2201100009757
            ],
            [
              19.8453999983114,
              -34.2804399988068
            ],
            [
              19.7409399996813,
              -34.3126200043098
            ],
            [
              19.7050136163853,
              -34.3502670272015
            ],
            [
              19.6412072217359,
              -34.3723010018896
            ],
            [
              19.6269399972831,
              -34.416900000035
            ],
            [
              19.6958699996009,
              -34.4322399987769
            ],
            [
              19.7133499963054,
              -34.4685600018425
            ],
            [
              19.6867000003048,
              -34.5164500042642
            ],
            [
              19.6881600001839,
              -34.5622099983926
            ],
            [
              19.7197199977798,
              -34.5997700010846
            ],
            [
              19.7145500030802,
              -34.6877999956733
            ],
            [
              19.7385499991832,
              -34.7129399939855
            ],
            [
              19.7247370043094,
              -34.7672489992418
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Cape Agulhas Local Municipality",
        "Code": "WC033",
        "Parent_cod": "DC3",
        "Area": 346998
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              24.6158199987939,
              -27.9036000013389
            ],
            [
              24.6293500031002,
              -27.9943099999065
            ],
            [
              24.6143700056712,
              -28.0223500006519
            ],
            [
              24.5628100003813,
              -28.0362200008523
            ],
            [
              24.5346390025879,
              -28.0920889962102
            ],
            [
              24.5479300003692,
              -28.1178400029137
            ],
            [
              24.6562499989383,
              -28.2023900060939
            ],
            [
              24.6300500003073,
              -28.2271000061603
            ],
            [
              24.6979699983168,
              -28.277829996557
            ],
            [
              24.7333193819839,
              -28.3411363285786
            ],
            [
              24.7039099952501,
              -28.3766000007894
            ],
            [
              24.7264900041105,
              -28.4497399913075
            ],
            [
              24.7679399982324,
              -28.4223499989532
            ],
            [
              24.7960500040046,
              -28.4465899998286
            ],
            [
              24.8449700017643,
              -28.4277900043052
            ],
            [
              24.8993299958827,
              -28.430469999291
            ],
            [
              24.9376199890712,
              -28.3249199899655
            ],
            [
              24.8903299972316,
              -28.3102300014134
            ],
            [
              24.9266799980835,
              -28.2468999947389
            ],
            [
              24.9645699944097,
              -28.2507399991516
            ],
            [
              25.0280800003917,
              -28.0734800023002
            ],
            [
              24.972599998691,
              -28.0814500101099
            ],
            [
              24.9505599976458,
              -28.1131400002108
            ],
            [
              24.8474107231264,
              -27.9579746651987
            ],
            [
              24.7752099998417,
              -27.994110000576
            ],
            [
              24.7432900027315,
              -27.9669000003347
            ],
            [
              24.732835663635,
              -27.9202253453234
            ],
            [
              24.6158199987939,
              -27.9036000013389
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Magareng Local Municipality",
        "Code": "NC093",
        "Parent_cod": "DC9",
        "Area": 154638
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              19.7247370043094,
              -34.7672489992418
            ],
            [
              19.7385499991832,
              -34.7129399939855
            ],
            [
              19.7145500030802,
              -34.6877999956733
            ],
            [
              19.7197199977798,
              -34.5997700010846
            ],
            [
              19.6881600001839,
              -34.5622099983926
            ],
            [
              19.6867000003048,
              -34.5164500042642
            ],
            [
              19.7133499963054,
              -34.4685600018425
            ],
            [
              19.6958699996009,
              -34.4322399987769
            ],
            [
              19.6269399972831,
              -34.416900000035
            ],
            [
              19.590390003396,
              -34.3905400030187
            ],
            [
              19.4951300018481,
              -34.3998300051507
            ],
            [
              19.4029707161257,
              -34.3756037594059
            ],
            [
              19.3516400028839,
              -34.3875600040908
            ],
            [
              19.300587522796,
              -34.3752793253805
            ],
            [
              19.302979812968,
              -34.328559905715
            ],
            [
              19.2069822396387,
              -34.2967317527681
            ],
            [
              19.1300978516346,
              -34.2431196501517
            ],
            [
              19.0391200097807,
              -34.2742300020129
            ],
            [
              18.947733599626,
              -34.2454104032674
            ],
            [
              18.9307093874284,
              -34.2035278658184
            ],
            [
              18.8458149996625,
              -34.2695900029762
            ],
            [
              18.8119099973486,
              -34.2987699987364
            ],
            [
              18.8271499977742,
              -34.3760999981164
            ],
            [
              18.9646200033105,
              -34.3629700005651
            ],
            [
              19.0470800036393,
              -34.3421900000684
            ],
            [
              19.21848000275,
              -34.4381200010372
            ],
            [
              19.2753800033845,
              -34.4090500013564
            ],
            [
              19.3577399982024,
              -34.4854800032994
            ],
            [
              19.3781199991387,
              -34.5403900011976
            ],
            [
              19.3261600113755,
              -34.6101899995688
            ],
            [
              19.402229996717,
              -34.6064200001829
            ],
            [
              19.4491499993731,
              -34.6546300011735
            ],
            [
              19.5158200017917,
              -34.6697400010002
            ],
            [
              19.5960499973096,
              -34.7466699999205
            ],
            [
              19.7247370043094,
              -34.7672489992418
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Overstrand Local Municipality",
        "Code": "WC032",
        "Parent_cod": "DC3",
        "Area": 167460
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              24.7264900041105,
              -28.4497399913075
            ],
            [
              24.7039099952501,
              -28.3766000007894
            ],
            [
              24.7333193819839,
              -28.3411363285786
            ],
            [
              24.6979699983168,
              -28.277829996557
            ],
            [
              24.6300500003073,
              -28.2271000061603
            ],
            [
              24.6562499989383,
              -28.2023900060939
            ],
            [
              24.5479300003692,
              -28.1178400029137
            ],
            [
              24.5346390025879,
              -28.0920889962102
            ],
            [
              24.4654799969043,
              -28.0358400058116
            ],
            [
              24.467289999434,
              -27.980569999406
            ],
            [
              24.4099499982938,
              -27.9233000023932
            ],
            [
              24.3604599940335,
              -27.9106700027184
            ],
            [
              24.452310004703,
              -27.7828800029098
            ],
            [
              24.4088399992666,
              -27.7610999967674
            ],
            [
              24.4467599996743,
              -27.7028500040244
            ],
            [
              24.4052800005716,
              -27.6811800020554
            ],
            [
              24.111000001449,
              -27.7389800010262
            ],
            [
              23.644100000015,
              -27.8334899985645
            ],
            [
              23.5809300043163,
              -27.8793100008558
            ],
            [
              23.8345999958931,
              -28.015079999942
            ],
            [
              23.7906600020575,
              -28.0828499964302
            ],
            [
              23.8914200018317,
              -28.1259400059265
            ],
            [
              23.8484500032651,
              -28.2593899969507
            ],
            [
              23.8143799996373,
              -28.3338000028678
            ],
            [
              23.8280499897152,
              -28.3909800029248
            ],
            [
              23.7672499998876,
              -28.4714699933455
            ],
            [
              23.7547000003048,
              -28.528780003894
            ],
            [
              23.8126500016963,
              -28.5644800008513
            ],
            [
              23.9086600081529,
              -28.6414400056517
            ],
            [
              23.969300004092,
              -28.6710800019405
            ],
            [
              24.0009400026791,
              -28.6619399986319
            ],
            [
              23.9495899971807,
              -28.6033600041608
            ],
            [
              24.0464500005672,
              -28.5998100041284
            ],
            [
              24.0866099945556,
              -28.5583400036882
            ],
            [
              24.1170399607257,
              -28.5986132250203
            ],
            [
              24.1990123108695,
              -28.516369641146
            ],
            [
              24.3334800070967,
              -28.5608200047394
            ],
            [
              24.4089400047774,
              -28.6268000050161
            ],
            [
              24.5216999940595,
              -28.6745999951936
            ],
            [
              24.5486699949244,
              -28.7136999987559
            ],
            [
              24.6082499986386,
              -28.5972200060984
            ],
            [
              24.5931799988579,
              -28.5418500022757
            ],
            [
              24.6065999989908,
              -28.4954799971041
            ],
            [
              24.6880200026211,
              -28.5141799961098
            ],
            [
              24.7264900041105,
              -28.4497399913075
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Dikgatlong Local Municipality",
        "Code": "NC092",
        "Parent_cod": "DC9",
        "Area": 731554
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              19.6269399972831,
              -34.416900000035
            ],
            [
              19.6412072217359,
              -34.3723010018896
            ],
            [
              19.7050136163853,
              -34.3502670272015
            ],
            [
              19.7409399996813,
              -34.3126200043098
            ],
            [
              19.8453999983114,
              -34.2804399988068
            ],
            [
              19.8804300048409,
              -34.2201100009757
            ],
            [
              19.9657200025761,
              -34.1762700063557
            ],
            [
              20.0074600001789,
              -34.0939200021063
            ],
            [
              19.9865400049173,
              -34.0781700069402
            ],
            [
              19.7001399959641,
              -34.0464000050562
            ],
            [
              19.6806600041559,
              -34.0091400063062
            ],
            [
              19.5898300009538,
              -34.0123600064091
            ],
            [
              19.5068899982749,
              -33.9717000010541
            ],
            [
              19.4557999975719,
              -33.9998800037591
            ],
            [
              19.3188600011882,
              -33.9471900030162
            ],
            [
              19.297400005306,
              -33.889680003929
            ],
            [
              19.2438000003698,
              -33.8974499989183
            ],
            [
              19.2065800007665,
              -33.9504100067163
            ],
            [
              19.1260600008684,
              -33.9617200048743
            ],
            [
              18.9846041316753,
              -34.0358991467282
            ],
            [
              19.0048242259573,
              -34.0755668572246
            ],
            [
              18.9439000028828,
              -34.138239999976
            ],
            [
              18.9802700019591,
              -34.154989992694
            ],
            [
              18.9307093874284,
              -34.2035278658184
            ],
            [
              18.947733599626,
              -34.2454104032674
            ],
            [
              19.0391200097807,
              -34.2742300020129
            ],
            [
              19.1300978516346,
              -34.2431196501517
            ],
            [
              19.2069822396387,
              -34.2967317527681
            ],
            [
              19.302979812968,
              -34.328559905715
            ],
            [
              19.300587522796,
              -34.3752793253805
            ],
            [
              19.3516400028839,
              -34.3875600040908
            ],
            [
              19.4029707161257,
              -34.3756037594059
            ],
            [
              19.4951300018481,
              -34.3998300051507
            ],
            [
              19.590390003396,
              -34.3905400030187
            ],
            [
              19.6269399972831,
              -34.416900000035
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Theewaterskloof Local Municipality",
        "Code": "WC031",
        "Parent_cod": "DC3",
        "Area": 326059
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              24.8018269997163,
              -28.8282580044033
            ],
            [
              24.9018400001159,
              -28.6480300010836
            ],
            [
              24.8277299963423,
              -28.6269599971061
            ],
            [
              24.8678199978946,
              -28.5170599976208
            ],
            [
              24.8468900012725,
              -28.5037699980869
            ],
            [
              24.8993299958827,
              -28.430469999291
            ],
            [
              24.8449700017643,
              -28.4277900043052
            ],
            [
              24.7960500040046,
              -28.4465899998286
            ],
            [
              24.7679399982324,
              -28.4223499989532
            ],
            [
              24.7264900041105,
              -28.4497399913075
            ],
            [
              24.6880200026211,
              -28.5141799961098
            ],
            [
              24.6065999989908,
              -28.4954799971041
            ],
            [
              24.5931799988579,
              -28.5418500022757
            ],
            [
              24.6082499986386,
              -28.5972200060984
            ],
            [
              24.5486699949244,
              -28.7136999987559
            ],
            [
              24.5216999940595,
              -28.6745999951936
            ],
            [
              24.4089400047774,
              -28.6268000050161
            ],
            [
              24.3334800070967,
              -28.5608200047394
            ],
            [
              24.1990123108695,
              -28.516369641146
            ],
            [
              24.1170399607257,
              -28.5986132250203
            ],
            [
              24.0620199982244,
              -28.6857100030142
            ],
            [
              24.0545579203118,
              -28.7867898089026
            ],
            [
              24.1485110036799,
              -28.828270754092
            ],
            [
              24.1164470961566,
              -28.8559197880677
            ],
            [
              24.1806065025881,
              -28.9004105743884
            ],
            [
              24.2026208252909,
              -28.8768113863364
            ],
            [
              24.2523755782703,
              -28.9466751844122
            ],
            [
              24.3106193540001,
              -28.9240093226721
            ],
            [
              24.3955200037452,
              -28.9423999908668
            ],
            [
              24.4338799965646,
              -28.9975500043292
            ],
            [
              24.4854700032381,
              -28.9973900014473
            ],
            [
              24.5352499992881,
              -29.0422099953949
            ],
            [
              24.6670099960146,
              -29.0388799956153
            ],
            [
              24.6917800033445,
              -29.0257199993785
            ],
            [
              24.8018269997163,
              -28.8282580044033
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Sol Plaatje Local Municipality",
        "Code": "NC091",
        "Parent_cod": "DC9",
        "Area": 331158
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              28.400099997417,
              -26.6550450003265
            ],
            [
              28.4832500007869,
              -26.6183800002367
            ],
            [
              28.5329799990277,
              -26.577899995988
            ],
            [
              28.5276599992097,
              -26.5022099966939
            ],
            [
              28.5849099988974,
              -26.5385600020424
            ],
            [
              28.63815000342,
              -26.5473099990572
            ],
            [
              28.6416200006625,
              -26.5075699956587
            ],
            [
              28.7639100031442,
              -26.5180099995618
            ],
            [
              28.7899300006691,
              -26.4264500031651
            ],
            [
              28.8612899981349,
              -26.3985699963083
            ],
            [
              28.8384400029039,
              -26.3407500027104
            ],
            [
              28.8050800023403,
              -26.3065900021268
            ],
            [
              28.7101200101304,
              -26.3412400019245
            ],
            [
              28.6269000017338,
              -26.2924399971081
            ],
            [
              28.6222900031812,
              -26.248379998638
            ],
            [
              28.5305399989218,
              -26.2253099959595
            ],
            [
              28.5271500026705,
              -26.1787400040479
            ],
            [
              28.5136300042214,
              -26.2214300013934
            ],
            [
              28.5178799969643,
              -26.3619599978556
            ],
            [
              28.4990799996423,
              -26.4393000021933
            ],
            [
              28.4502300024128,
              -26.4407499971147
            ],
            [
              28.3702949980158,
              -26.3936309969729
            ],
            [
              28.2740100013606,
              -26.3586799976837
            ],
            [
              28.2710999975669,
              -26.4136999997551
            ],
            [
              28.2203999986611,
              -26.4362800041188
            ],
            [
              28.1997300032371,
              -26.4625300005591
            ],
            [
              28.2713699974275,
              -26.5029999980515
            ],
            [
              28.2737500001624,
              -26.5487799966995
            ],
            [
              28.2734999967275,
              -26.5490300001344
            ],
            [
              28.2209600020025,
              -26.5468299967069
            ],
            [
              28.1794699970428,
              -26.5793700026235
            ],
            [
              28.219370000625,
              -26.6362999974469
            ],
            [
              28.2598499967799,
              -26.621449997919
            ],
            [
              28.2817299994399,
              -26.6760100030592
            ],
            [
              28.400099997417,
              -26.6550450003265
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Lesedi Local Municipality",
        "Code": "GT423",
        "Parent_cod": "DC42",
        "Area": 148439
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              28.400099997417,
              -26.6550450003265
            ],
            [
              28.2817299994399,
              -26.6760100030592
            ],
            [
              28.2598499967799,
              -26.621449997919
            ],
            [
              28.219370000625,
              -26.6362999974469
            ],
            [
              28.1794699970428,
              -26.5793700026235
            ],
            [
              28.2209600020025,
              -26.5468299967069
            ],
            [
              28.2734999967275,
              -26.5490300001344
            ],
            [
              28.2737500001624,
              -26.5487799966995
            ],
            [
              28.2713699974275,
              -26.5029999980515
            ],
            [
              28.1997300032371,
              -26.4625300005591
            ],
            [
              28.2203999986611,
              -26.4362800041188
            ],
            [
              28.1876900010927,
              -26.4531200036852
            ],
            [
              28.1472281487601,
              -26.423929809613
            ],
            [
              28.0771799995573,
              -26.4173000002947
            ],
            [
              28.0975160020619,
              -26.3603099991071
            ],
            [
              28.0671019988582,
              -26.3419400036282
            ],
            [
              27.9843430018281,
              -26.344967997575
            ],
            [
              27.9699800022753,
              -26.3417000069498
            ],
            [
              27.9122299957178,
              -26.358949996645
            ],
            [
              27.8690749994117,
              -26.4448009986672
            ],
            [
              27.8872100011407,
              -26.5262500009367
            ],
            [
              27.9065399986221,
              -26.5172699897183
            ],
            [
              27.9064000011591,
              -26.5175500044291
            ],
            [
              27.9830200001729,
              -26.5558299971566
            ],
            [
              27.9623957352751,
              -26.6448702847358
            ],
            [
              28.0016193038879,
              -26.6525731633208
            ],
            [
              28.0004899982149,
              -26.7033200007175
            ],
            [
              28.0081800012062,
              -26.7701499988234
            ],
            [
              28.0801599975859,
              -26.8346900109353
            ],
            [
              28.1148100063768,
              -26.8443799982383
            ],
            [
              28.1191300032471,
              -26.8892800120628
            ],
            [
              28.1713300020779,
              -26.8837100007159
            ],
            [
              28.2015500017312,
              -26.9100899986545
            ],
            [
              28.2442800000221,
              -26.8847799996972
            ],
            [
              28.325010000611,
              -26.8410700038775
            ],
            [
              28.3194100040685,
              -26.7926699977222
            ],
            [
              28.406850002026,
              -26.7617100026145
            ],
            [
              28.3939699989163,
              -26.7167500004122
            ],
            [
              28.400099997417,
              -26.6550450003265
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Midvaal Local Municipality",
        "Code": "GT422",
        "Parent_cod": "DC42",
        "Area": 172269
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              30.1144899426569,
              -30.4020399405907
            ],
            [
              30.1714499430001,
              -30.402590066
            ],
            [
              30.1782706256889,
              -30.4578543749794
            ],
            [
              30.2211128215995,
              -30.4370519372971
            ],
            [
              30.2397499427057,
              -30.3739999407446
            ],
            [
              30.2958229429745,
              -30.368675940742
            ],
            [
              30.3241399430001,
              -30.327909941
            ],
            [
              30.377339942984,
              -30.2223199409125
            ],
            [
              30.4361099426198,
              -30.182869940995
            ],
            [
              30.4166599432019,
              -30.1429300659697
            ],
            [
              30.4454899426069,
              -30.0843699402205
            ],
            [
              30.3966399426794,
              -30.1023000655955
            ],
            [
              30.3328499426708,
              -30.0347299398348
            ],
            [
              30.2818299430001,
              -30.0044199399999
            ],
            [
              30.2124299427878,
              -30.0173399400861
            ],
            [
              30.150319942911,
              -29.9821699396909
            ],
            [
              30.1057599429671,
              -29.9746499400425
            ],
            [
              30.0650969356751,
              -30.0024080348029
            ],
            [
              30.043649048265,
              -30.0564791738747
            ],
            [
              29.9284499420113,
              -30.1120599410134
            ],
            [
              29.8523769420001,
              -30.117639941
            ],
            [
              29.871139942,
              -30.1585400659999
            ],
            [
              29.9142599420001,
              -30.181649941
            ],
            [
              29.9479399420002,
              -30.2776499409999
            ],
            [
              30.0408699416945,
              -30.3291999414241
            ],
            [
              30.1144899426569,
              -30.4020399405907
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Ubuhlebezwe Local Municipality",
        "Code": "KZN434",
        "Parent_cod": "DC43",
        "Area": 166965
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              29.64063994178,
              -30.5620399409904
            ],
            [
              29.6015072150001,
              -30.521902257
            ],
            [
              29.6217599420001,
              -30.490359941
            ],
            [
              29.573779942,
              -30.404852941
            ],
            [
              29.4978400670001,
              -30.3403099409999
            ],
            [
              29.4983099420001,
              -30.2699299409999
            ],
            [
              29.523289942,
              -30.230149941
            ],
            [
              29.5236099420001,
              -30.2282099409999
            ],
            [
              29.388029942,
              -30.1575500659999
            ],
            [
              29.4066940250001,
              -30.095976589
            ],
            [
              29.4789199420001,
              -30.0403699399999
            ],
            [
              29.476579943,
              -30.014070065
            ],
            [
              29.4172899418775,
              -29.9691349402253
            ],
            [
              29.357379941831,
              -29.9395599397394
            ],
            [
              29.2776399419298,
              -29.9420499403524
            ],
            [
              29.220219941597,
              -29.9057499400076
            ],
            [
              29.1688249420001,
              -29.912705065
            ],
            [
              29.1089899420001,
              -29.93696994
            ],
            [
              29.0147399716724,
              -30.0017999698927
            ],
            [
              29.044949978,
              -30.012969982
            ],
            [
              29.117240037,
              -30.100189968
            ],
            [
              29.1036899727141,
              -30.1805400358939
            ],
            [
              29.1322099686152,
              -30.2163599700365
            ],
            [
              29.1371699707177,
              -30.2623399716123
            ],
            [
              29.1881099725972,
              -30.2887399677752
            ],
            [
              29.3018599650001,
              -30.320119957
            ],
            [
              29.3050099756299,
              -30.3798599501765
            ],
            [
              29.1967699816494,
              -30.4343900348722
            ],
            [
              29.19835997,
              -30.4623399689999
            ],
            [
              29.1352500008868,
              -30.6051399779276
            ],
            [
              29.2613299757978,
              -30.6211599765516
            ],
            [
              29.3728000377915,
              -30.648960034578
            ],
            [
              29.512359972,
              -30.618219983
            ],
            [
              29.5435502956097,
              -30.6471865301342
            ],
            [
              29.5722000410002,
              -30.6551499729999
            ],
            [
              29.5862499417815,
              -30.6170799412862
            ],
            [
              29.64063994178,
              -30.5620399409904
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Greater Kokstad Local Municipality",
        "Code": "KZN433",
        "Parent_cod": "DC43",
        "Area": 267984
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              26.8562299972167,
              -33.1149200021564
            ],
            [
              26.911820009386,
              -33.1221500010216
            ],
            [
              26.9758099997318,
              -33.049660000009
            ],
            [
              27.1206399966386,
              -33.0251000023631
            ],
            [
              27.1302300009138,
              -32.9866099990522
            ],
            [
              27.1965399984223,
              -32.8951099982278
            ],
            [
              27.2179100036438,
              -32.890130000599
            ],
            [
              27.2328799970144,
              -32.8523499976543
            ],
            [
              27.1576100000016,
              -32.8384600001288
            ],
            [
              27.0558899991242,
              -32.838510000636
            ],
            [
              27.0864699982919,
              -32.8057299989402
            ],
            [
              27.0172300023628,
              -32.7851500022708
            ],
            [
              27.0255700011546,
              -32.6817700021838
            ],
            [
              27.0045149978689,
              -32.6050950006337
            ],
            [
              27.0364300001444,
              -32.5663499999525
            ],
            [
              27.0171000017637,
              -32.5112500031851
            ],
            [
              26.9505700004053,
              -32.5478300002542
            ],
            [
              26.8651500002723,
              -32.5115499999325
            ],
            [
              26.8056199997633,
              -32.4536299999245
            ],
            [
              26.834320001267,
              -32.4389599988048
            ],
            [
              26.775780001446,
              -32.3332799996722
            ],
            [
              26.7117599998242,
              -32.3400200002228
            ],
            [
              26.7350729993195,
              -32.3908059976986
            ],
            [
              26.6624499975694,
              -32.4279299991701
            ],
            [
              26.5392399940305,
              -32.3859650028825
            ],
            [
              26.5336900123842,
              -32.3601799982083
            ],
            [
              26.4044699969928,
              -32.363949996695
            ],
            [
              26.3096200008624,
              -32.3760099961643
            ],
            [
              26.2025200009973,
              -32.3312700014094
            ],
            [
              26.191329996682,
              -32.2852300006639
            ],
            [
              26.1412850037,
              -32.2717450083254
            ],
            [
              26.0816400005856,
              -32.3178800026599
            ],
            [
              26.05204037936,
              -32.312290049746
            ],
            [
              25.9962276536833,
              -32.3544709318879
            ],
            [
              25.9510696117732,
              -32.3640473626956
            ],
            [
              25.9392700002104,
              -32.4060600032665
            ],
            [
              25.8993599970663,
              -32.4329300004192
            ],
            [
              25.8873099971587,
              -32.4868000016187
            ],
            [
              25.9299900039356,
              -32.4946199980144
            ],
            [
              25.9398300026526,
              -32.5387199974298
            ],
            [
              26.0808400005656,
              -32.5465800019655
            ],
            [
              26.1271749996266,
              -32.595439996059
            ],
            [
              26.0476199992636,
              -32.6328000030177
            ],
            [
              26.063979997379,
              -32.6855999989408
            ],
            [
              26.0320400029438,
              -32.7640100031591
            ],
            [
              26.065959998755,
              -32.786930000719
            ],
            [
              26.1795100028844,
              -32.7634400020543
            ],
            [
              26.1900499961105,
              -32.8122300010137
            ],
            [
              26.223600002738,
              -32.8571299986504
            ],
            [
              26.2850799996423,
              -32.8991899984197
            ],
            [
              26.2749399978827,
              -32.9369799991277
            ],
            [
              26.3586300009738,
              -32.9344699957936
            ],
            [
              26.3880720007223,
              -32.973388996405
            ],
            [
              26.4363400043877,
              -32.9474600030767
            ],
            [
              26.4850000018487,
              -32.9818200002927
            ],
            [
              26.5361400021594,
              -32.9810000038471
            ],
            [
              26.6301099963793,
              -33.0043299996298
            ],
            [
              26.6419300063648,
              -33.0502899975852
            ],
            [
              26.6905700011047,
              -33.056430001943
            ],
            [
              26.7481999967325,
              -33.0309400036782
            ],
            [
              26.7932900004332,
              -33.053559999994
            ],
            [
              26.8255000010243,
              -33.0394700004401
            ],
            [
              26.8562299972167,
              -33.1149200021564
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Raymond Mhlaba Local Municipality",
        "Code": "EC129",
        "Parent_cod": "DC12",
        "Area": 635733,
        "detail": "The Municipality is named after anti apartheid stalwart, Raymond Mhlaba Local Municipality, often called \"Oom Ray,\" is a rural municipality in the Eastern Cape formed through the 2016 amalgamation of the former Nkonkobe and Nxuba municipalities. Major towns include Alice, Fort Beaufort, Adelaide, Bedford, Middledrift, Hogsback, and Seymour. The municipality lies along the historic Winterberg mountain range (intaba zeNkonkobe), where key resistance battles—like the War of the Axe and War of Maqoma—took place.\nThe local economy is predominantly agricultural, driven by citrus farming, forestry, and crop production. Citrus is one of the largest employment sectors, alongside timber processing. While the area is rich in cultural heritage and natural beauty, its tourism sector remains underdeveloped. Important but underutilised heritage institutions include Lovedale College, Healdtown, and the University of Fort Hare. Natural assets like the Amathole Mountains also hold untapped tourism potential.\n",
        "link_to_webpage": "https://www.raymondmhlaba.gov.za/home/about_us",
        "image": "https://corruptionwatch-my.sharepoint.com/:i:/g/personal/nontobekog_corruptionwatch_org_za/EeIPubYHWMlIq07_QWfd9UIBX3-a1A_NZQ2ih1s2UIFDUg?e=yQSJ83",
        "image_alt": "https://web.facebook.com/raymondmhlabam/?_rdc=1&amp;_rdr"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              27.1356000003398,
              -33.49632999933
            ],
            [
              27.2106200002129,
              -33.4624899964162
            ],
            [
              27.3537099987175,
              -33.3649300021179
            ],
            [
              27.4224700012896,
              -33.3336599990097
            ],
            [
              27.4918300000545,
              -33.2820399981474
            ],
            [
              27.4429499987434,
              -33.2583799979385
            ],
            [
              27.4247300011887,
              -33.1930199983741
            ],
            [
              27.3748899987744,
              -33.1800899956567
            ],
            [
              27.3601329432808,
              -33.1299472841398
            ],
            [
              27.4441700109373,
              -33.0797600058195
            ],
            [
              27.5039100022449,
              -32.9952199968053
            ],
            [
              27.3616813690001,
              -32.9672064496179
            ],
            [
              27.2958642827105,
              -33.0241727293878
            ],
            [
              27.2397528912829,
              -32.956689917006
            ],
            [
              27.2179100036438,
              -32.890130000599
            ],
            [
              27.1965399984223,
              -32.8951099982278
            ],
            [
              27.1302300009138,
              -32.9866099990522
            ],
            [
              27.1206399966386,
              -33.0251000023631
            ],
            [
              26.9758099997318,
              -33.049660000009
            ],
            [
              26.911820009386,
              -33.1221500010216
            ],
            [
              26.8562299972167,
              -33.1149200021564
            ],
            [
              26.8205099984378,
              -33.1291800041538
            ],
            [
              26.8374600021774,
              -33.1742200001528
            ],
            [
              26.8781599976857,
              -33.1709099976981
            ],
            [
              26.9625600002439,
              -33.2023900023967
            ],
            [
              27.0082400005756,
              -33.2504899983147
            ],
            [
              26.9689499990433,
              -33.2676600032065
            ],
            [
              27.0037600017228,
              -33.3020299981858
            ],
            [
              26.9852599975509,
              -33.3562000024282
            ],
            [
              27.0156700041674,
              -33.3783900040953
            ],
            [
              27.0790500005571,
              -33.4704700109822
            ],
            [
              27.1356000003398,
              -33.49632999933
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Ngqushwa Local Municipality",
        "Code": "EC126",
        "Parent_cod": "DC12",
        "Area": 211246,
        "detail": "Ngqushwa Local Municipality is a Category B municipality within the Amathole District in the Eastern Cape Province. It is predominantly rural and accounts for 10% of the district's geographical area, making it one of the smaller municipalities in the district.\nThe municipality is bordered by the Keiskamma River to the east, the Great Fish River to the west, and the Indian Ocean to the south.\n",
        "link_to_webpage": "https://ngqushwamun.gov.za/about/",
        "image": "https://corruptionwatch-my.sharepoint.com/:i:/g/personal/nontobekog_corruptionwatch_org_za/EbXt1OgrKNZOommwecjC8jcB8rNU58Kmf41nc4aJBXXCQQ?e=2K1dcj",
        "image_alt": "https://en.wikipedia.org/wiki/Ngqushwa_Local_Municipality#/media/File:Ngqushwa_CoA.png"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              31.9814329440001,
              -28.350419939
            ],
            [
              32.0284199436255,
              -28.220219938899
            ],
            [
              32.1209999438923,
              -28.1171899387646
            ],
            [
              32.2675199449896,
              -28.145899938931
            ],
            [
              32.3393999448517,
              -28.0989799389729
            ],
            [
              32.3498389450001,
              -28.0522690639999
            ],
            [
              32.4434776308881,
              -28.1095771794432
            ],
            [
              32.6148327480001,
              -28.13314803
            ],
            [
              32.6160469450001,
              -28.0925639389999
            ],
            [
              32.6494719450001,
              -27.9423979379999
            ],
            [
              32.6457139450002,
              -27.901695063
            ],
            [
              32.6628446170001,
              -27.7947082559999
            ],
            [
              32.5230760800001,
              -27.775447617
            ],
            [
              32.525783228,
              -27.6846950659999
            ],
            [
              32.4750543657666,
              -27.6604108356915
            ],
            [
              32.4157330770001,
              -27.6619801499999
            ],
            [
              32.3491599450001,
              -27.720189938
            ],
            [
              32.3372879445829,
              -27.753563062885
            ],
            [
              32.2597689445813,
              -27.8073650627474
            ],
            [
              32.1902300688627,
              -27.784149938269
            ],
            [
              32.1855714538596,
              -27.816735483156
            ],
            [
              32.139869944,
              -27.8666300629999
            ],
            [
              32.0849400688291,
              -27.8649400630334
            ],
            [
              32.0318799440001,
              -27.928580063
            ],
            [
              31.9687099438088,
              -27.9309200633102
            ],
            [
              31.9370400688442,
              -27.9765899390744
            ],
            [
              31.9480599439114,
              -28.0131300638014
            ],
            [
              31.8744199438253,
              -28.0368599386352
            ],
            [
              31.8192399440002,
              -28.038040064
            ],
            [
              31.807209944,
              -28.105149939
            ],
            [
              31.8073600690001,
              -28.216039939
            ],
            [
              31.733409944,
              -28.2185099389999
            ],
            [
              31.7030599438614,
              -28.2273099394021
            ],
            [
              31.719799944,
              -28.2992799389999
            ],
            [
              31.7020649438421,
              -28.3714550639
            ],
            [
              31.7410599440002,
              -28.433460064
            ],
            [
              31.811069944,
              -28.431680939
            ],
            [
              31.9625299440001,
              -28.406219939
            ],
            [
              31.9814329440001,
              -28.350419939
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Big Five Hlabisa Local Municipality",
        "Code": "KZN276",
        "Parent_cod": "DC27",
        "Area": 347012
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              31.9814329440001,
              -28.350419939
            ],
            [
              31.9907799440001,
              -28.3885899389998
            ],
            [
              32.0479099439889,
              -28.4077899390544
            ],
            [
              32.0683599436565,
              -28.4566699385668
            ],
            [
              32.1119399440002,
              -28.4362299389999
            ],
            [
              32.2121899439109,
              -28.4589499393882
            ],
            [
              32.305199945,
              -28.5185100639999
            ],
            [
              32.3371799449985,
              -28.4938600635909
            ],
            [
              32.4147679445852,
              -28.4763929388828
            ],
            [
              32.4706079449009,
              -28.485335939402
            ],
            [
              32.4829979451991,
              -28.3882920642273
            ],
            [
              32.5662189446487,
              -28.2493500636545
            ],
            [
              32.6148327480001,
              -28.13314803
            ],
            [
              32.4434776308881,
              -28.1095771794432
            ],
            [
              32.3498389450001,
              -28.0522690639999
            ],
            [
              32.3393999448517,
              -28.0989799389729
            ],
            [
              32.2675199449896,
              -28.145899938931
            ],
            [
              32.1209999438923,
              -28.1171899387646
            ],
            [
              32.0284199436255,
              -28.220219938899
            ],
            [
              31.9814329440001,
              -28.350419939
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Mtubatuba Local Municipality",
        "Code": "KZN275",
        "Parent_cod": "DC27",
        "Area": 196983
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              32.0318799440001,
              -27.928580063
            ],
            [
              32.0849400688291,
              -27.8649400630334
            ],
            [
              32.139869944,
              -27.8666300629999
            ],
            [
              32.1855714538596,
              -27.816735483156
            ],
            [
              32.1902300688627,
              -27.784149938269
            ],
            [
              32.2597689445813,
              -27.8073650627474
            ],
            [
              32.3372879445829,
              -27.753563062885
            ],
            [
              32.3491599450001,
              -27.720189938
            ],
            [
              32.4157330770001,
              -27.6619801499999
            ],
            [
              32.4022829453018,
              -27.6480730626216
            ],
            [
              32.4085999452314,
              -27.4836490632536
            ],
            [
              32.3018299452958,
              -27.5061299380461
            ],
            [
              32.2998599452802,
              -27.5054300631469
            ],
            [
              32.2580599449107,
              -27.5098300628071
            ],
            [
              32.2230699447222,
              -27.4785699378523
            ],
            [
              32.2614599452204,
              -27.3505800628195
            ],
            [
              32.2203399447328,
              -27.3313400631932
            ],
            [
              32.2533399448826,
              -27.2496799378788
            ],
            [
              32.2162800695695,
              -27.2038299378014
            ],
            [
              32.2490299448761,
              -27.1447999378669
            ],
            [
              32.2645599451854,
              -27.080439937653
            ],
            [
              32.2506899449851,
              -27.0408700626033
            ],
            [
              32.3017699452269,
              -27.020810062934
            ],
            [
              32.2817299446813,
              -26.964490062966
            ],
            [
              32.3286999451465,
              -26.9428499382739
            ],
            [
              32.3458899446653,
              -26.8559000618383
            ],
            [
              32.3324299453857,
              -26.8638200619463
            ],
            [
              32.2202999446869,
              -26.8328499368751
            ],
            [
              32.1863300688776,
              -26.8629900623414
            ],
            [
              32.1202399439184,
              -26.8388200619962
            ],
            [
              32.0925599435866,
              -26.8048700621037
            ],
            [
              32.0158599435816,
              -26.8198800618153
            ],
            [
              31.9959599440962,
              -26.924149938369
            ],
            [
              31.9745499442245,
              -27.1164099380682
            ],
            [
              31.9777599438665,
              -27.3175200626007
            ],
            [
              31.999789943551,
              -27.3835899384249
            ],
            [
              32.0206999437474,
              -27.5128400631183
            ],
            [
              32.0501399440002,
              -27.583799938
            ],
            [
              31.9869599436467,
              -27.579909938293
            ],
            [
              31.9516199440001,
              -27.619079938
            ],
            [
              31.996179944349,
              -27.8852699375575
            ],
            [
              32.0318799440001,
              -27.928580063
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Jozini Local Municipality",
        "Code": "KZN272",
        "Parent_cod": "DC27",
        "Area": 343827
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              32.6628446170001,
              -27.7947082559999
            ],
            [
              32.7361949446411,
              -27.5416130625927
            ],
            [
              32.7342339450407,
              -27.5064620630737
            ],
            [
              32.7663079447559,
              -27.4477119375558
            ],
            [
              32.804870945138,
              -27.3404879382677
            ],
            [
              32.8964989446705,
              -27.1204150634044
            ],
            [
              32.9309349453916,
              -26.9745479377371
            ],
            [
              32.9449849448994,
              -26.8719749379929
            ],
            [
              32.8913339448058,
              -26.8578629374245
            ],
            [
              32.6829499452839,
              -26.8681399374082
            ],
            [
              32.3468499448691,
              -26.8640500617609
            ],
            [
              32.3458899446653,
              -26.8559000618383
            ],
            [
              32.3286999451465,
              -26.9428499382739
            ],
            [
              32.2817299446813,
              -26.964490062966
            ],
            [
              32.3017699452269,
              -27.020810062934
            ],
            [
              32.2506899449851,
              -27.0408700626033
            ],
            [
              32.2645599451854,
              -27.080439937653
            ],
            [
              32.2490299448761,
              -27.1447999378669
            ],
            [
              32.2162800695695,
              -27.2038299378014
            ],
            [
              32.2533399448826,
              -27.2496799378788
            ],
            [
              32.2203399447328,
              -27.3313400631932
            ],
            [
              32.2614599452204,
              -27.3505800628195
            ],
            [
              32.2230699447222,
              -27.4785699378523
            ],
            [
              32.2580599449107,
              -27.5098300628071
            ],
            [
              32.2998599452802,
              -27.5054300631469
            ],
            [
              32.3018299452958,
              -27.5061299380461
            ],
            [
              32.4085999452314,
              -27.4836490632536
            ],
            [
              32.4022829453018,
              -27.6480730626216
            ],
            [
              32.4157330770001,
              -27.6619801499999
            ],
            [
              32.4750543657666,
              -27.6604108356915
            ],
            [
              32.525783228,
              -27.6846950659999
            ],
            [
              32.5230760800001,
              -27.775447617
            ],
            [
              32.6628446170001,
              -27.7947082559999
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Umhlabuyalingana Local Municipality",
        "Code": "KZN271",
        "Parent_cod": "DC27",
        "Area": 497713
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              18.7875399967735,
              -33.6376300007239
            ],
            [
              18.8443072583733,
              -33.5749963319151
            ],
            [
              18.9380900011526,
              -33.5459999993005
            ],
            [
              18.9340500019061,
              -33.4921500089157
            ],
            [
              18.9927700010348,
              -33.3547900003582
            ],
            [
              18.9973500062978,
              -33.3079100004461
            ],
            [
              18.9457500018611,
              -33.2526999986061
            ],
            [
              18.9390050001806,
              -33.1963899981998
            ],
            [
              18.9105700010048,
              -33.1576500004471
            ],
            [
              18.844649998099,
              -33.1173200013169
            ],
            [
              18.8078000029678,
              -33.0300200017216
            ],
            [
              18.7265800022653,
              -32.9505300007589
            ],
            [
              18.6779099971486,
              -32.9229300077136
            ],
            [
              18.5960000005996,
              -32.9007200087214
            ],
            [
              18.5113440033231,
              -32.9460459882317
            ],
            [
              18.5385499970848,
              -33.0050899987044
            ],
            [
              18.5039299986706,
              -33.0463700020739
            ],
            [
              18.5353599965666,
              -33.0816500012466
            ],
            [
              18.4871099964293,
              -33.1586600011581
            ],
            [
              18.5169000023332,
              -33.1983200008673
            ],
            [
              18.4993299978812,
              -33.2275899971806
            ],
            [
              18.4443400061864,
              -33.2180599965715
            ],
            [
              18.3637399891092,
              -33.1602299980159
            ],
            [
              18.3083999956633,
              -33.1799300008688
            ],
            [
              18.2878900031212,
              -33.130030001983
            ],
            [
              18.2443599976158,
              -33.1533500000024
            ],
            [
              18.2384199979846,
              -33.1956899955968
            ],
            [
              18.2032799980735,
              -33.2154499967199
            ],
            [
              18.2266399970383,
              -33.3094699977422
            ],
            [
              18.1561600086775,
              -33.3206299988753
            ],
            [
              18.1660399939506,
              -33.3686100009507
            ],
            [
              18.2550500040545,
              -33.4267500012115
            ],
            [
              18.3212499955909,
              -33.5158300055503
            ],
            [
              18.3430400057917,
              -33.5706300010736
            ],
            [
              18.3888199972451,
              -33.5089100002962
            ],
            [
              18.4261629998226,
              -33.5111829980969
            ],
            [
              18.4554349989262,
              -33.4712999979965
            ],
            [
              18.495749995566,
              -33.4811299989502
            ],
            [
              18.5241600043808,
              -33.5252299965671
            ],
            [
              18.5764199996833,
              -33.5314799970043
            ],
            [
              18.5743700022739,
              -33.5735000030227
            ],
            [
              18.6179937603039,
              -33.5843588652694
            ],
            [
              18.6270000002499,
              -33.6245900001284
            ],
            [
              18.7367300098821,
              -33.6870300017331
            ],
            [
              18.7875399967735,
              -33.6376300007239
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Swartland Local Municipality",
        "Code": "WC015",
        "Parent_cod": "DC1",
        "Area": 370801
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              18.1561600086775,
              -33.3206299988753
            ],
            [
              18.2266399970383,
              -33.3094699977422
            ],
            [
              18.2032799980735,
              -33.2154499967199
            ],
            [
              18.2384199979846,
              -33.1956899955968
            ],
            [
              18.2443599976158,
              -33.1533500000024
            ],
            [
              18.2878900031212,
              -33.130030001983
            ],
            [
              18.3083999956633,
              -33.1799300008688
            ],
            [
              18.3637399891092,
              -33.1602299980159
            ],
            [
              18.4443400061864,
              -33.2180599965715
            ],
            [
              18.4993299978812,
              -33.2275899971806
            ],
            [
              18.5169000023332,
              -33.1983200008673
            ],
            [
              18.4871099964293,
              -33.1586600011581
            ],
            [
              18.5353599965666,
              -33.0816500012466
            ],
            [
              18.5039299986706,
              -33.0463700020739
            ],
            [
              18.5385499970848,
              -33.0050899987044
            ],
            [
              18.5113440033231,
              -32.9460459882317
            ],
            [
              18.3400799969943,
              -32.9464699978921
            ],
            [
              18.2926000008893,
              -32.9619900040354
            ],
            [
              18.2403699979771,
              -32.9323100023047
            ],
            [
              18.2327700018342,
              -32.896789999259
            ],
            [
              18.164149999423,
              -32.8883100021049
            ],
            [
              18.1717100018152,
              -32.8510900016022
            ],
            [
              18.1248050016496,
              -32.7777849998778
            ],
            [
              18.06035000335,
              -32.783539997273
            ],
            [
              18.0152699983118,
              -32.7404199980844
            ],
            [
              17.9576500004472,
              -32.7180899971555
            ],
            [
              17.8969899999885,
              -32.7406499961004
            ],
            [
              17.8787799992976,
              -32.9189899986894
            ],
            [
              17.8914400021544,
              -33.02863999474
            ],
            [
              17.9927500003123,
              -32.9971600062293
            ],
            [
              18.0426800005816,
              -33.0486800006814
            ],
            [
              17.9552699977123,
              -33.1105700030032
            ],
            [
              18.0510400038931,
              -33.1841400007604
            ],
            [
              18.1064900006131,
              -33.2406999983062
            ],
            [
              18.1561600086775,
              -33.3206299988753
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Saldanha Bay Local Municipality",
        "Code": "WC014",
        "Parent_cod": "DC1",
        "Area": 201537
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              19.2140490061567,
              -33.8570679955915
            ],
            [
              19.1645699997058,
              -33.8685199958011
            ],
            [
              19.0941600082778,
              -33.8316700006699
            ],
            [
              18.9819799971792,
              -33.8529000003347
            ],
            [
              18.9315399985721,
              -33.8790800016407
            ],
            [
              18.8933261024177,
              -33.826780184358
            ],
            [
              18.896780002695,
              -33.7933599966665
            ],
            [
              18.7897479762881,
              -33.8201062021395
            ],
            [
              18.7528700014494,
              -33.8344199997831
            ],
            [
              18.7108100016803,
              -33.9211689973513
            ],
            [
              18.7444300043412,
              -34.0248200018416
            ],
            [
              18.7922699990612,
              -34.0533799977886
            ],
            [
              18.8418400016148,
              -34.0471100018251
            ],
            [
              18.9437100022148,
              -34.0037200027759
            ],
            [
              18.9846041316753,
              -34.0358991467282
            ],
            [
              19.1260600008684,
              -33.9617200048743
            ],
            [
              19.2065800007665,
              -33.9504100067163
            ],
            [
              19.2438000003698,
              -33.8974499989183
            ],
            [
              19.2140490061567,
              -33.8570679955915
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Stellenbosch Local Municipality",
        "Code": "WC024",
        "Parent_cod": "DC2",
        "Area": 83559
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              19.2140490061567,
              -33.8570679955915
            ],
            [
              19.1839899977402,
              -33.715390001947
            ],
            [
              19.1487500076068,
              -33.7022099975933
            ],
            [
              19.1474900043602,
              -33.6561000017136
            ],
            [
              19.101960000154,
              -33.6067600061693
            ],
            [
              19.1070400032935,
              -33.541139997313
            ],
            [
              19.1113299960825,
              -33.509170000595
            ],
            [
              19.0863500015513,
              -33.4310699971826
            ],
            [
              19.0839699997157,
              -33.3196100004011
            ],
            [
              19.0677979958809,
              -33.2918649970719
            ],
            [
              19.0577300010387,
              -33.2001400011601
            ],
            [
              19.0823600100064,
              -33.165359999864
            ],
            [
              19.0724199967855,
              -33.1276599979106
            ],
            [
              18.9801000004148,
              -33.1521100003762
            ],
            [
              18.9390050001806,
              -33.1963899981998
            ],
            [
              18.9457500018611,
              -33.2526999986061
            ],
            [
              18.9973500062978,
              -33.3079100004461
            ],
            [
              18.9927700010348,
              -33.3547900003582
            ],
            [
              18.9340500019061,
              -33.4921500089157
            ],
            [
              18.9380900011526,
              -33.5459999993005
            ],
            [
              18.8443072583733,
              -33.5749963319151
            ],
            [
              18.7875399967735,
              -33.6376300007239
            ],
            [
              18.8094599985801,
              -33.7407800018955
            ],
            [
              18.7897479762881,
              -33.8201062021395
            ],
            [
              18.896780002695,
              -33.7933599966665
            ],
            [
              18.8933261024177,
              -33.826780184358
            ],
            [
              18.9315399985721,
              -33.8790800016407
            ],
            [
              18.9819799971792,
              -33.8529000003347
            ],
            [
              19.0941600082778,
              -33.8316700006699
            ],
            [
              19.1645699997058,
              -33.8685199958011
            ],
            [
              19.2140490061567,
              -33.8570679955915
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Drakenstein Local Municipality",
        "Code": "WC023",
        "Parent_cod": "DC2",
        "Area": 153664
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              21.1953999938147,
              -29.63724999659
            ],
            [
              21.2262001038518,
              -29.523880005258
            ],
            [
              21.2786304928031,
              -29.5114892009658
            ],
            [
              21.2495548957419,
              -29.4041679633808
            ],
            [
              21.2741700011447,
              -29.3579800070716
            ],
            [
              21.2250769819173,
              -29.2882293257227
            ],
            [
              21.1824122573199,
              -29.2585730930737
            ],
            [
              21.3016642411119,
              -29.1546669913886
            ],
            [
              21.3085712520617,
              -29.0674364976962
            ],
            [
              21.2113219177723,
              -29.0089084867373
            ],
            [
              21.2510499961604,
              -28.9309449968141
            ],
            [
              21.1398049967033,
              -28.8631399942153
            ],
            [
              21.1257699969878,
              -28.8316000074343
            ],
            [
              21.1960000025981,
              -28.7584400007054
            ],
            [
              21.2604600047255,
              -28.7114800033994
            ],
            [
              21.1913900031462,
              -28.6076699987714
            ],
            [
              21.1603690043262,
              -28.5931960003951
            ],
            [
              21.0177900006081,
              -28.4438700065955
            ],
            [
              21.0011799945612,
              -28.4007100001664
            ],
            [
              20.9262499934425,
              -28.4126999982063
            ],
            [
              20.849555001762,
              -28.3509699951691
            ],
            [
              20.8050000083438,
              -28.3548299996047
            ],
            [
              20.7123298636324,
              -28.2814998654264
            ],
            [
              20.6642157159826,
              -28.22945461294
            ],
            [
              20.6380148899752,
              -28.1748534889973
            ],
            [
              20.5799807273287,
              -28.181939241103
            ],
            [
              20.5579891197021,
              -28.0348205568232
            ],
            [
              20.5117702482984,
              -27.95871925439
            ],
            [
              20.4834499360658,
              -27.9395408628205
            ],
            [
              20.3253610561679,
              -27.986465239779
            ],
            [
              20.2655556104032,
              -27.9410816452017
            ],
            [
              20.2708189430399,
              -27.9148809361063
            ],
            [
              20.2486000056858,
              -27.7905693053292
            ],
            [
              20.1536693565556,
              -27.8525600434112
            ],
            [
              20.0002100012906,
              -27.7740199990236
            ],
            [
              19.9991599933391,
              -28.4276800019305
            ],
            [
              19.8472300035619,
              -28.4600500054034
            ],
            [
              19.8129899992891,
              -28.5083399929962
            ],
            [
              19.7300499993081,
              -28.4879099969488
            ],
            [
              19.6708499960305,
              -28.5293699978271
            ],
            [
              19.6219000022833,
              -28.5110100028093
            ],
            [
              19.5484799979536,
              -28.5408399997661
            ],
            [
              19.5092899983348,
              -28.5965400008203
            ],
            [
              19.6191100040235,
              -28.6905600099365
            ],
            [
              19.6662299970168,
              -28.8297900040054
            ],
            [
              19.7795100057822,
              -28.8764200067779
            ],
            [
              19.6810500068523,
              -28.9926000017886
            ],
            [
              19.5766900002434,
              -29.0946819986752
            ],
            [
              19.6013199957213,
              -29.2718500011766
            ],
            [
              19.6569900052846,
              -29.3210300019331
            ],
            [
              19.7053200001179,
              -29.4009300074139
            ],
            [
              19.740250002036,
              -29.4286099897592
            ],
            [
              19.7669899958916,
              -29.5399700008148
            ],
            [
              19.7621699957487,
              -29.5820400019445
            ],
            [
              19.5859699983169,
              -29.6099200007074
            ],
            [
              19.6108999977367,
              -29.680859995892
            ],
            [
              19.5748200003428,
              -29.7252900033309
            ],
            [
              19.6590800063372,
              -29.7930199997731
            ],
            [
              19.8814157760173,
              -29.7770297210447
            ],
            [
              19.995640000086,
              -29.8667300012885
            ],
            [
              20.0461400068558,
              -29.8617699982868
            ],
            [
              20.1045699989064,
              -29.8279399940355
            ],
            [
              20.1752099973436,
              -29.7643799983382
            ],
            [
              20.1567100003663,
              -29.652509997938
            ],
            [
              20.2733799999871,
              -29.643549996635
            ],
            [
              20.3858300010537,
              -29.6037699958885
            ],
            [
              20.4368400052621,
              -29.6158499989782
            ],
            [
              20.519840010708,
              -29.7190199938775
            ],
            [
              20.59447000069,
              -29.6348400005655
            ],
            [
              20.6614100038687,
              -29.6430699987813
            ],
            [
              20.6368499981289,
              -29.7521400013599
            ],
            [
              20.6263899978002,
              -29.8631700088887
            ],
            [
              20.7081399950647,
              -29.9856300039215
            ],
            [
              20.7548099969839,
              -29.982650005893
            ],
            [
              20.8037500001624,
              -29.9422999950487
            ],
            [
              20.8575800004167,
              -29.8585600013429
            ],
            [
              20.8985600034414,
              -29.8503199963707
            ],
            [
              20.9615199984492,
              -29.7962300048108
            ],
            [
              21.1953999938147,
              -29.63724999659
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Kai !Garib Local Municipality",
        "Code": "NC082",
        "Parent_cod": "DC8",
        "Area": 2623636
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              19.1070400032935,
              -33.541139997313
            ],
            [
              19.1693900016473,
              -33.5974899923692
            ],
            [
              19.1853999998102,
              -33.5619900010377
            ],
            [
              19.2394699976423,
              -33.5588400005655
            ],
            [
              19.3113200024162,
              -33.6071000011641
            ],
            [
              19.3785900010278,
              -33.6190900037007
            ],
            [
              19.4053000033925,
              -33.4805099991371
            ],
            [
              19.473200001379,
              -33.4616500116387
            ],
            [
              19.537909997948,
              -33.4264400013049
            ],
            [
              19.5806900021419,
              -33.364520003895
            ],
            [
              19.6686699989214,
              -33.3818600013379
            ],
            [
              19.7544999990757,
              -33.3726400024341
            ],
            [
              19.830580000167,
              -33.3794200021313
            ],
            [
              19.9084700010897,
              -33.3626999964076
            ],
            [
              19.9720399972482,
              -33.3167799913035
            ],
            [
              20.0137699988864,
              -33.2387880036633
            ],
            [
              20.0869840027096,
              -33.1932779958827
            ],
            [
              20.2021799991077,
              -33.1701099976782
            ],
            [
              20.2512499956908,
              -33.1499099969488
            ],
            [
              20.3064400002059,
              -33.1593399992415
            ],
            [
              20.3184900010128,
              -33.1208899959765
            ],
            [
              20.3025499988833,
              -33.0679999932051
            ],
            [
              20.3342600015978,
              -33.0357899998086
            ],
            [
              20.3837500031602,
              -33.036279999922
            ],
            [
              20.3949600030018,
              -32.9932399936307
            ],
            [
              20.438599994694,
              -32.9400600035663
            ],
            [
              20.3800499989084,
              -32.9018499996777
            ],
            [
              20.2998999962878,
              -32.8049599994044
            ],
            [
              20.2190400031936,
              -32.7847399950547
            ],
            [
              20.1876099972036,
              -32.7526700027184
            ],
            [
              20.1917199996783,
              -32.6857600000239
            ],
            [
              20.1411900023168,
              -32.6437399958041
            ],
            [
              20.1227899982599,
              -32.5569800040239
            ],
            [
              20.0968099998817,
              -32.5029599968064
            ],
            [
              20.0796900035908,
              -32.3974999943293
            ],
            [
              20.1320200012222,
              -32.421120002586
            ],
            [
              20.1704500017662,
              -32.3808699972526
            ],
            [
              20.1635200041449,
              -32.3510200056687
            ],
            [
              20.216030004681,
              -32.3031599947379
            ],
            [
              20.2541699981469,
              -32.3108499986285
            ],
            [
              20.2408400030637,
              -32.2241899961713
            ],
            [
              20.1663600011132,
              -32.2274900035608
            ],
            [
              20.1518300019531,
              -32.186519994702
            ],
            [
              20.0969600041009,
              -32.2502399986769
            ],
            [
              20.0536099997018,
              -32.252310000606
            ],
            [
              20.0386199991137,
              -32.2964400032036
            ],
            [
              19.9374900029613,
              -32.3772799980734
            ],
            [
              19.8738899946276,
              -32.3832000021784
            ],
            [
              19.8178000106621,
              -32.3607199970301
            ],
            [
              19.8027000023033,
              -32.3937000016537
            ],
            [
              19.7302400017747,
              -32.442360000014
            ],
            [
              19.6218500035749,
              -32.4706200010122
            ],
            [
              19.607119998789,
              -32.5453800005866
            ],
            [
              19.6049500003423,
              -32.6294599982803
            ],
            [
              19.5282499958407,
              -32.6732399982273
            ],
            [
              19.4868050028486,
              -32.5654399957592
            ],
            [
              19.4755900009778,
              -32.5969200013569
            ],
            [
              19.4190199975748,
              -32.622319999968
            ],
            [
              19.3569300004193,
              -32.616360003911
            ],
            [
              19.320050002106,
              -32.5746400000359
            ],
            [
              19.264700002803,
              -32.5887200018266
            ],
            [
              19.1591699988964,
              -32.5719300009688
            ],
            [
              19.1429900000885,
              -32.6214399980574
            ],
            [
              19.204800001419,
              -32.7111399878202
            ],
            [
              19.1717699962884,
              -32.7368200002428
            ],
            [
              19.1844299991452,
              -32.827070001879
            ],
            [
              19.1861499921285,
              -32.8681600000839
            ],
            [
              19.153710000716,
              -32.9840399992466
            ],
            [
              19.1729900003882,
              -33.0919200018066
            ],
            [
              19.0724199967855,
              -33.1276599979106
            ],
            [
              19.0823600100064,
              -33.165359999864
            ],
            [
              19.0577300010387,
              -33.2001400011601
            ],
            [
              19.0677979958809,
              -33.2918649970719
            ],
            [
              19.0839699997157,
              -33.3196100004011
            ],
            [
              19.0863500015513,
              -33.4310699971826
            ],
            [
              19.1113299960825,
              -33.509170000595
            ],
            [
              19.1070400032935,
              -33.541139997313
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Witzenberg Local Municipality",
        "Code": "WC022",
        "Parent_cod": "DC2",
        "Area": 1075315
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              30.0453613570001,
              -29.8299619079999
            ],
            [
              29.9574130650001,
              -29.780812339
            ],
            [
              29.918522931,
              -29.7674807449999
            ],
            [
              29.7634254329375,
              -29.6741823606274
            ],
            [
              29.6872406005733,
              -29.6755599978956
            ],
            [
              29.7028197170002,
              -29.6357434479999
            ],
            [
              29.592859924646,
              -29.5773600298415
            ],
            [
              29.49370888,
              -29.5868603249999
            ],
            [
              29.399520874,
              -29.524938583
            ],
            [
              29.2998455207542,
              -29.4989355186592
            ],
            [
              29.319739941745,
              -29.5813999400551
            ],
            [
              29.2847999420638,
              -29.5864399395515
            ],
            [
              29.279189942362,
              -29.6447399399962
            ],
            [
              29.2358799416061,
              -29.6397799396924
            ],
            [
              29.1834299420383,
              -29.6682199399982
            ],
            [
              29.14523994177,
              -29.7164099400666
            ],
            [
              29.1316599423525,
              -29.8256300646757
            ],
            [
              29.1026400672855,
              -29.8501399404058
            ],
            [
              29.1599900670881,
              -29.8828899398188
            ],
            [
              29.1688249420001,
              -29.912705065
            ],
            [
              29.220219941597,
              -29.9057499400076
            ],
            [
              29.2776399419298,
              -29.9420499403524
            ],
            [
              29.357379941831,
              -29.9395599397394
            ],
            [
              29.4172899418775,
              -29.9691349402253
            ],
            [
              29.4797399420001,
              -29.9652699399999
            ],
            [
              29.5089099419404,
              -30.001819940238
            ],
            [
              29.6328799418559,
              -30.0338899397688
            ],
            [
              29.673859942,
              -30.0794099399999
            ],
            [
              29.7308199419869,
              -30.0863299397749
            ],
            [
              29.7722799419658,
              -30.0614500649684
            ],
            [
              29.8283899420002,
              -30.07303994
            ],
            [
              29.8523769420001,
              -30.117639941
            ],
            [
              29.9284499420113,
              -30.1120599410134
            ],
            [
              30.043649048265,
              -30.0564791738747
            ],
            [
              30.0650969356751,
              -30.0024080348029
            ],
            [
              30.1057599429671,
              -29.9746499400425
            ],
            [
              30.0852699430002,
              -29.9213599399999
            ],
            [
              30.0370499418015,
              -29.8670800650929
            ],
            [
              30.0453613570001,
              -29.8299619079999
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Dr Nkosazana Dlamini Zuma Local Municipality",
        "Code": "KZN436",
        "Parent_cod": "DC43",
        "Area": 360196
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              30.056959941748,
              -30.4673499414466
            ],
            [
              30.1144899426569,
              -30.4020399405907
            ],
            [
              30.0408699416945,
              -30.3291999414241
            ],
            [
              29.9479399420002,
              -30.2776499409999
            ],
            [
              29.9142599420001,
              -30.181649941
            ],
            [
              29.871139942,
              -30.1585400659999
            ],
            [
              29.8523769420001,
              -30.117639941
            ],
            [
              29.8283899420002,
              -30.07303994
            ],
            [
              29.7722799419658,
              -30.0614500649684
            ],
            [
              29.7308199419869,
              -30.0863299397749
            ],
            [
              29.673859942,
              -30.0794099399999
            ],
            [
              29.6328799418559,
              -30.0338899397688
            ],
            [
              29.5089099419404,
              -30.001819940238
            ],
            [
              29.4797399420001,
              -29.9652699399999
            ],
            [
              29.4172899418775,
              -29.9691349402253
            ],
            [
              29.476579943,
              -30.014070065
            ],
            [
              29.4789199420001,
              -30.0403699399999
            ],
            [
              29.4066940250001,
              -30.095976589
            ],
            [
              29.388029942,
              -30.1575500659999
            ],
            [
              29.5236099420001,
              -30.2282099409999
            ],
            [
              29.523289942,
              -30.230149941
            ],
            [
              29.4983099420001,
              -30.2699299409999
            ],
            [
              29.4978400670001,
              -30.3403099409999
            ],
            [
              29.573779942,
              -30.404852941
            ],
            [
              29.6217599420001,
              -30.490359941
            ],
            [
              29.6015072150001,
              -30.521902257
            ],
            [
              29.64063994178,
              -30.5620399409904
            ],
            [
              29.6696999418989,
              -30.5196099412457
            ],
            [
              29.782159941628,
              -30.5104599410733
            ],
            [
              29.8133250666985,
              -30.5350949412785
            ],
            [
              29.8937665467888,
              -30.5606959941248
            ],
            [
              29.954525398,
              -30.5656303019999
            ],
            [
              29.9932299418084,
              -30.5427900659088
            ],
            [
              30.0015999419838,
              -30.4937099411608
            ],
            [
              30.056959941748,
              -30.4673499414466
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Umzimkhulu Local Municipality",
        "Code": "KZN435",
        "Parent_cod": "DC43",
        "Area": 243562
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              27.7163060006215,
              -26.7616770001934
            ],
            [
              27.7476600031067,
              -26.785889998025
            ],
            [
              27.8050000033476,
              -26.7507300007888
            ],
            [
              27.8057500037597,
              -26.7507300007889
            ],
            [
              27.8458609999853,
              -26.7462389987308
            ],
            [
              27.8461800012062,
              -26.7461499964252
            ],
            [
              27.8736400030837,
              -26.7476300008238
            ],
            [
              27.9409600013031,
              -26.6758999988858
            ],
            [
              28.0004899982149,
              -26.7033200007175
            ],
            [
              28.0016193038879,
              -26.6525731633208
            ],
            [
              27.9623957352751,
              -26.6448702847358
            ],
            [
              27.9830200001729,
              -26.5558299971566
            ],
            [
              27.9064000011591,
              -26.5175500044291
            ],
            [
              27.9065399986221,
              -26.5172699897183
            ],
            [
              27.8872100011407,
              -26.5262500009367
            ],
            [
              27.8216899977952,
              -26.4848799979135
            ],
            [
              27.7597100039136,
              -26.4838699882094
            ],
            [
              27.761289999434,
              -26.4191500010717
            ],
            [
              27.7096699976723,
              -26.4546700041173
            ],
            [
              27.7101300026975,
              -26.5300099935663
            ],
            [
              27.6759799998771,
              -26.5243499996527
            ],
            [
              27.6679299982708,
              -26.6105499970846
            ],
            [
              27.5796000006396,
              -26.6075299990102
            ],
            [
              27.5690900016023,
              -26.6471600036312
            ],
            [
              27.5904299973466,
              -26.7383600032115
            ],
            [
              27.6613699979271,
              -26.7731900032161
            ],
            [
              27.7163060006215,
              -26.7616770001934
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Emfuleni Local Municipality",
        "Code": "GT421",
        "Parent_cod": "DC42",
        "Area": 96564
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              26.2749399978827,
              -32.9369799991277
            ],
            [
              26.2850799996423,
              -32.8991899984197
            ],
            [
              26.223600002738,
              -32.8571299986504
            ],
            [
              26.1900499961105,
              -32.8122300010137
            ],
            [
              26.1795100028844,
              -32.7634400020543
            ],
            [
              26.065959998755,
              -32.786930000719
            ],
            [
              26.0320400029438,
              -32.7640100031591
            ],
            [
              26.063979997379,
              -32.6855999989408
            ],
            [
              26.0476199992636,
              -32.6328000030177
            ],
            [
              26.1271749996266,
              -32.595439996059
            ],
            [
              26.0808400005656,
              -32.5465800019655
            ],
            [
              25.9398300026526,
              -32.5387199974298
            ],
            [
              25.9299900039356,
              -32.4946199980144
            ],
            [
              25.8873099971587,
              -32.4868000016187
            ],
            [
              25.7973899909554,
              -32.4772200040999
            ],
            [
              25.7855599993945,
              -32.5379000009843
            ],
            [
              25.6550819979359,
              -32.5069070025561
            ],
            [
              25.6217200017767,
              -32.4567899963612
            ],
            [
              25.5743699990762,
              -32.4577999979715
            ],
            [
              25.5340599963718,
              -32.3944699993909
            ],
            [
              25.4931099983279,
              -32.4104900034109
            ],
            [
              25.3987299959926,
              -32.4130300009338
            ],
            [
              25.4077099991173,
              -32.374009996564
            ],
            [
              25.3095500014315,
              -32.3133299915858
            ],
            [
              25.2786299991752,
              -32.3455599975958
            ],
            [
              25.1675600032916,
              -32.3287100002663
            ],
            [
              25.1283100018052,
              -32.2910999979666
            ],
            [
              25.0550500039546,
              -32.2800500010067
            ],
            [
              25.0033149959903,
              -32.2503600006135
            ],
            [
              24.9496099997018,
              -32.2411800017557
            ],
            [
              24.9317300043362,
              -32.2837499971646
            ],
            [
              24.8601800017058,
              -32.3296800000319
            ],
            [
              24.7951800007565,
              -32.409229999265
            ],
            [
              24.7614100010708,
              -32.3775800011161
            ],
            [
              24.5898199958962,
              -32.4438399981173
            ],
            [
              24.5640500000076,
              -32.4782699976622
            ],
            [
              24.5453299955829,
              -32.5620400017447
            ],
            [
              24.4565792078642,
              -32.6408195499822
            ],
            [
              24.4136799958352,
              -32.7369800031246
            ],
            [
              24.4718200041899,
              -32.7654099975733
            ],
            [
              24.5428699999506,
              -32.7166699982218
            ],
            [
              24.6910300038317,
              -32.6916799969343
            ],
            [
              24.7832500018861,
              -32.7041200067328
            ],
            [
              24.7840500019061,
              -32.7230599961219
            ],
            [
              24.9108314066441,
              -32.7432300026625
            ],
            [
              24.9339699997157,
              -32.7815100043832
            ],
            [
              24.9925400090143,
              -32.8002899971856
            ],
            [
              24.9890199968754,
              -32.8375300022078
            ],
            [
              25.0440999972171,
              -32.834450005863
            ],
            [
              25.0874100015704,
              -32.871030002033
            ],
            [
              25.0161600010832,
              -32.9149000007345
            ],
            [
              25.0558899959266,
              -32.9462899976852
            ],
            [
              25.101609998103,
              -32.9512400011251
            ],
            [
              25.0770500013565,
              -33.0029299971216
            ],
            [
              25.1136999989559,
              -33.1157200021763
            ],
            [
              25.1739699976174,
              -33.1195999967424
            ],
            [
              25.1782600002988,
              -33.2516800001319
            ],
            [
              25.3156799981334,
              -33.2599199997082
            ],
            [
              25.4507200022264,
              -33.2835300012086
            ],
            [
              25.5145800009663,
              -33.2738099963342
            ],
            [
              25.6080800013909,
              -33.2811999980814
            ],
            [
              25.6336400019845,
              -33.3069300011186
            ],
            [
              25.6977299987405,
              -33.2854300015933
            ],
            [
              25.7896399977877,
              -33.2845199991986
            ],
            [
              25.9276800044288,
              -33.3123800006365
            ],
            [
              25.9879399972332,
              -33.3066100034489
            ],
            [
              26.0164900026116,
              -33.2504099973234
            ],
            [
              25.9708399955694,
              -33.232930000619
            ],
            [
              25.9819499988934,
              -33.1796399982872
            ],
            [
              25.9481899978702,
              -33.1726600019575
            ],
            [
              25.9625799995673,
              -33.1099699996158
            ],
            [
              26.021529996712,
              -33.081929997971
            ],
            [
              26.0961300005991,
              -32.9830900031011
            ],
            [
              26.1356699902779,
              -32.9601699974474
            ],
            [
              26.2749399978827,
              -32.9369799991277
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Blue Crane Route Local Municipality",
        "Code": "EC102",
        "Parent_cod": "DC10",
        "Area": 1106846,
        "detail": "Blue Crane Route Local Municipality is a Category B municipality in the Sarah Baartman District Municipality of the Eastern Cape Province. Named after South Africa’s national bird, the Blue Crane, it is the second largest of seven municipalities in the district, accounting for 19% of the district’s geographical area. The municipality covers approximately 11,068 km² and has a population of nearly 40,000 people living in the three towns of Cookhouse, Pearston, and Somerset East. Somerset East, situated at the foot of the Boschberg Mountains, serves as the administrative center of the municipality.",
        "link_to_webpage": "https://www.bcrm.gov.za/",
        "image": "https://corruptionwatch-my.sharepoint.com/:i:/g/personal/nontobekog_corruptionwatch_org_za/Eb7gJNjStapPgCqi7YHuckwBrupIxlPiQnpWtKCoyUOkbw?e=R8yPLl",
        "image_alt": ""
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              24.7307400013501,
              -33.6203800020354
            ],
            [
              24.6341900005681,
              -33.5968200001428
            ],
            [
              24.673050002056,
              -33.5716000017387
            ],
            [
              24.7018500018761,
              -33.5145300013585
            ],
            [
              24.8044050025889,
              -33.5382400002757
            ],
            [
              24.7980399959492,
              -33.4834200020314
            ],
            [
              24.8418199958961,
              -33.4088000008193
            ],
            [
              24.839673009302,
              -33.3515134697708
            ],
            [
              24.8802900027815,
              -33.2574700018391
            ],
            [
              24.9592799977737,
              -33.270609998053
            ],
            [
              24.9778099970338,
              -33.2565699972076
            ],
            [
              25.1347700029333,
              -33.2950699982818
            ],
            [
              25.131879997364,
              -33.2502000029277
            ],
            [
              25.1782600002988,
              -33.2516800001319
            ],
            [
              25.1739699976174,
              -33.1195999967424
            ],
            [
              25.1136999989559,
              -33.1157200021763
            ],
            [
              25.0770500013565,
              -33.0029299971216
            ],
            [
              25.101609998103,
              -32.9512400011251
            ],
            [
              25.0558899959266,
              -32.9462899976852
            ],
            [
              25.0161600010832,
              -32.9149000007345
            ],
            [
              25.0874100015704,
              -32.871030002033
            ],
            [
              25.0440999972171,
              -32.834450005863
            ],
            [
              24.9890199968754,
              -32.8375300022078
            ],
            [
              24.9925400090143,
              -32.8002899971856
            ],
            [
              24.9339699997157,
              -32.7815100043832
            ],
            [
              24.9108314066441,
              -32.7432300026625
            ],
            [
              24.7840500019061,
              -32.7230599961219
            ],
            [
              24.7832500018861,
              -32.7041200067328
            ],
            [
              24.6910300038317,
              -32.6916799969343
            ],
            [
              24.5428699999506,
              -32.7166699982218
            ],
            [
              24.4718200041899,
              -32.7654099975733
            ],
            [
              24.4136799958352,
              -32.7369800031246
            ],
            [
              24.4565792078642,
              -32.6408195499822
            ],
            [
              24.5453299955829,
              -32.5620400017447
            ],
            [
              24.5640500000076,
              -32.4782699976622
            ],
            [
              24.5898199958962,
              -32.4438399981173
            ],
            [
              24.7614100010708,
              -32.3775800011161
            ],
            [
              24.7951800007565,
              -32.409229999265
            ],
            [
              24.8601800017058,
              -32.3296800000319
            ],
            [
              24.9317300043362,
              -32.2837499971646
            ],
            [
              24.9496099997018,
              -32.2411800017557
            ],
            [
              24.9040199990238,
              -32.2219400039281
            ],
            [
              24.915539998772,
              -32.1721199979395
            ],
            [
              24.9671199986891,
              -32.1075099987874
            ],
            [
              24.9380499990083,
              -32.0532600007484
            ],
            [
              24.9506899973455,
              -32.0072699996107
            ],
            [
              24.9244899987146,
              -31.9415900023767
            ],
            [
              24.9391199979895,
              -31.9050499990582
            ],
            [
              24.8992500038846,
              -31.8372700039075
            ],
            [
              24.8556299987256,
              -31.834884998244
            ],
            [
              24.8019299981709,
              -31.7849699977671
            ],
            [
              24.7334699977422,
              -31.7872900031311
            ],
            [
              24.7043999980615,
              -31.744280000022
            ],
            [
              24.6164600022273,
              -31.7261699967479
            ],
            [
              24.5507100008658,
              -31.7611699991961
            ],
            [
              24.510420002681,
              -31.7541699983467
            ],
            [
              24.5062700001604,
              -31.7068300024026
            ],
            [
              24.3459900012376,
              -31.7144800053479
            ],
            [
              24.3140300049808,
              -31.7512999981963
            ],
            [
              24.2682500027355,
              -31.7666699974225
            ],
            [
              24.1615899961814,
              -31.7401499939271
            ],
            [
              24.1524599951327,
              -31.7886099983527
            ],
            [
              24.1053800003867,
              -31.9068500020259
            ],
            [
              24.1641999969324,
              -31.902410003219
            ],
            [
              24.2224100004212,
              -31.9556400009852
            ],
            [
              24.1408700011496,
              -32.0117099984176
            ],
            [
              24.1096749970035,
              -32.0842899990842
            ],
            [
              24.1355299968119,
              -32.1231400010102
            ],
            [
              24.1001299957028,
              -32.1640000002997
            ],
            [
              24.0380299998847,
              -32.1581300038965
            ],
            [
              24.0305299939641,
              -32.1934799982033
            ],
            [
              23.9611499987735,
              -32.2065200041948
            ],
            [
              23.8922999974469,
              -32.2549499964451
            ],
            [
              23.851080006737,
              -32.2425199996982
            ],
            [
              23.7978500008769,
              -32.1940700029282
            ],
            [
              23.7470700009798,
              -32.2006800100743
            ],
            [
              23.670450001966,
              -32.2376700035677
            ],
            [
              23.6488700023487,
              -32.2980199960259
            ],
            [
              23.6651499985736,
              -32.3442299983157
            ],
            [
              23.4489599979056,
              -32.3232699976122
            ],
            [
              23.409850001976,
              -32.3891999991805
            ],
            [
              23.3330500036548,
              -32.3511399977127
            ],
            [
              23.3073299992801,
              -32.3959200024061
            ],
            [
              23.221610003299,
              -32.425039999896
            ],
            [
              23.2475400020695,
              -32.4653299980809
            ],
            [
              23.2444700043872,
              -32.5132299991651
            ],
            [
              23.2881550008526,
              -32.5512099978431
            ],
            [
              23.3072899983348,
              -32.6116499980489
            ],
            [
              23.3013099977583,
              -32.6517899992091
            ],
            [
              23.3516000074344,
              -32.7637900029063
            ],
            [
              23.3977369973646,
              -32.7634800029997
            ],
            [
              23.3786200007125,
              -32.8250199963757
            ],
            [
              23.1493299957827,
              -32.7667399977527
            ],
            [
              23.0893500006021,
              -32.799179997259
            ],
            [
              23.1164200015818,
              -32.8579900041353
            ],
            [
              23.098009997963,
              -32.8736900086869
            ],
            [
              23.0074399968584,
              -32.8728199991436
            ],
            [
              23.0036800042288,
              -32.8982800023202
            ],
            [
              22.9487500009118,
              -32.9500400006455
            ],
            [
              22.9692500037846,
              -32.9933700032231
            ],
            [
              22.9340900002534,
              -33.0216599993094
            ],
            [
              22.9553100012556,
              -33.0731400009102
            ],
            [
              22.892269998062,
              -33.1416300036217
            ],
            [
              22.8772080022475,
              -33.1869039969219
            ],
            [
              22.8402200025511,
              -33.2202100012905
            ],
            [
              22.7733899963513,
              -33.3262599986
            ],
            [
              22.7392699958137,
              -33.3239800031745
            ],
            [
              22.7357400012001,
              -33.3947699977371
            ],
            [
              22.7744300002443,
              -33.4197400016997
            ],
            [
              22.9347800032946,
              -33.4291400008104
            ],
            [
              23.1348000038172,
              -33.3876200007624
            ],
            [
              23.2971249981202,
              -33.3886400010352
            ],
            [
              23.3548799986131,
              -33.4411699970977
            ],
            [
              23.4956199975648,
              -33.4434400109477
            ],
            [
              23.6039999989008,
              -33.4964000016587
            ],
            [
              23.616870003348,
              -33.5702399992766
            ],
            [
              23.7222900030813,
              -33.6174899973655
            ],
            [
              23.760490002012,
              -33.6093200001178
            ],
            [
              23.8428099958847,
              -33.6504499983687
            ],
            [
              23.9620399993466,
              -33.6704899962163
            ],
            [
              24.0607400030488,
              -33.6983899985995
            ],
            [
              24.0571600016329,
              -33.7259400010302
            ],
            [
              24.1876899955969,
              -33.7647600006735
            ],
            [
              24.2629199979596,
              -33.7443150003369
            ],
            [
              24.29097999603,
              -33.7119000001848
            ],
            [
              24.4996208320358,
              -33.7784549262538
            ],
            [
              24.5366999996053,
              -33.7264999998751
            ],
            [
              24.5353199998182,
              -33.6628599995893
            ],
            [
              24.5984400004058,
              -33.6571699997956
            ],
            [
              24.7307400013501,
              -33.6203800020354
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Dr Beyers Naude Local Municipality",
        "Code": "EC101",
        "Parent_cod": "DC10",
        "Area": 2865303,
        "detail": "Dr Beyers Naudé Local Municipality is the third-largest local municipality in South Africa by area, covering approximately 28,690 km². It is located in the Karoo region and includes towns such as Graaff-Reinet, Willowmore, Aberdeen, Jansenville, Steytlerville, Nieu-Bethesda, Klipplaat, and Rietbron, along with various smaller settlements and farms. The municipality is known for its natural beauty, rich heritage, diverse cultures, and appealing climate, making it a notable tourist destination. Graaff-Reinet, the fourth-oldest town in South Africa and known as the “Gem of the Karoo,” serves as the political and administrative centre and is the main hub for agri-tourism and population concentration.\n",
        "link_to_webpage": "https://bnlm.gov.za/profile/",
        "image": "https://corruptionwatch-my.sharepoint.com/:i:/g/personal/nontobekog_corruptionwatch_org_za/EdwpPwuYlTlFqM83zNM38WcB3SU8F__SCjgfcf5vWJb8cg?e=71q9PF",
        "image_alt": "https://web.facebook.com/p/Dr-Beyers-Naude-Local-Municipality-100064785546997/?_rdc=1&amp;_rdr"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              24.3202050118519,
              -27.0826950011733
            ],
            [
              24.3414100040685,
              -27.0680299966869
            ],
            [
              24.2658499972796,
              -26.960619996016
            ],
            [
              24.3044399980075,
              -26.942919999958
            ],
            [
              24.2769800042238,
              -26.8832399979275
            ],
            [
              24.3336200018616,
              -26.8594200029307
            ],
            [
              24.5096600036063,
              -26.7671800003567
            ],
            [
              24.7015199983493,
              -26.6854699986415
            ],
            [
              24.7802500002373,
              -26.6425800073614
            ],
            [
              24.7292499991882,
              -26.5963999920659
            ],
            [
              24.6573799988879,
              -26.4858099976332
            ],
            [
              24.6021799966096,
              -26.515449999318
            ],
            [
              24.5361300011987,
              -26.4016900007929
            ],
            [
              24.677920002706,
              -26.3291100001264
            ],
            [
              24.6350800011412,
              -26.2696999979565
            ],
            [
              24.6903200043647,
              -26.2341900007678
            ],
            [
              24.7641799984083,
              -26.2052500007868
            ],
            [
              24.8170799989429,
              -26.1987899996587
            ],
            [
              24.7624700022888,
              -26.0932999966974
            ],
            [
              24.7528500029254,
              -26.0766799982832
            ],
            [
              24.7338500008769,
              -26.0395700010546
            ],
            [
              24.6538799993626,
              -25.9593200019165
            ],
            [
              24.6670300014335,
              -25.9212500026854
            ],
            [
              24.4650699977822,
              -25.7901700040424
            ],
            [
              24.4852750023396,
              -25.7493899976502
            ],
            [
              24.4484700029883,
              -25.7341200030357
            ],
            [
              24.3808100016803,
              -25.7648599969913
            ],
            [
              24.2784699991911,
              -25.7132500028853
            ],
            [
              24.1940699957337,
              -25.6210699967829
            ],
            [
              24.1043400036882,
              -25.6303599998141
            ],
            [
              24.0662599986001,
              -25.6500399990466
            ],
            [
              24.0035299962125,
              -25.6501900041654
            ],
            [
              23.9033799966895,
              -25.6268100006809
            ],
            [
              23.8802399988769,
              -25.5774499997177
            ],
            [
              23.8160899957567,
              -25.5501800030047
            ],
            [
              23.7582599972012,
              -25.469259997251
            ],
            [
              23.6764900071082,
              -25.4264800002518
            ],
            [
              23.5943800004367,
              -25.3970100010107
            ],
            [
              23.500439998607,
              -25.3318499962803
            ],
            [
              23.4682699989614,
              -25.2794699972426
            ],
            [
              23.4198600031367,
              -25.3137400019995
            ],
            [
              23.3604999915814,
              -25.2862299933195
            ],
            [
              23.2940300082783,
              -25.2939900004381
            ],
            [
              23.2737999971722,
              -25.2745999956932
            ],
            [
              23.1922500001375,
              -25.2773100028543
            ],
            [
              23.1365199968005,
              -25.316790003256
            ],
            [
              23.1136000073345,
              -25.3035600001938
            ],
            [
              22.9779400034285,
              -25.3398599978405
            ],
            [
              22.9676100036987,
              -25.3834299961973
            ],
            [
              22.9099499976943,
              -25.4223100013054
            ],
            [
              22.8637500030603,
              -25.4796199983642
            ],
            [
              22.8526499912042,
              -25.5355200023462
            ],
            [
              22.8148199958462,
              -25.5788200008423
            ],
            [
              22.8534599961819,
              -25.6116299967269
            ],
            [
              22.7999199976099,
              -25.7231199966904
            ],
            [
              22.7637199901854,
              -25.7787299971916
            ],
            [
              22.7814099956748,
              -25.8287999976217
            ],
            [
              22.7380699971327,
              -25.8550400043927
            ],
            [
              22.722869996753,
              -25.9083600018126
            ],
            [
              22.7210499982588,
              -26.0185600034413
            ],
            [
              22.6691800020555,
              -26.0139100021449
            ],
            [
              22.6730800101345,
              -26.0736699970726
            ],
            [
              22.6321700058411,
              -26.1212800009712
            ],
            [
              22.7029400020001,
              -26.119850006
            ],
            [
              22.7088000008195,
              -26.4107899986595
            ],
            [
              22.8031599968364,
              -26.4536800007314
            ],
            [
              22.84187,
              -26.393300003
            ],
            [
              22.899290004,
              -26.213630001
            ],
            [
              22.9070599990001,
              -26.145920002
            ],
            [
              22.9811499985736,
              -26.1525600000439
            ],
            [
              22.98704,
              -26.089979996
            ],
            [
              23.0648000030001,
              -26.099059995
            ],
            [
              23.088140003,
              -26.0435699999999
            ],
            [
              23.086910001,
              -25.982559996
            ],
            [
              23.3205499970001,
              -25.992839996
            ],
            [
              23.387359998,
              -26.00616
            ],
            [
              23.3538819966569,
              -26.0894780057054
            ],
            [
              23.2321499970001,
              -26.052690003
            ],
            [
              23.2158199988939,
              -26.1157300040365
            ],
            [
              23.2519200026061,
              -26.1138300036517
            ],
            [
              23.3109799949309,
              -26.1418499998776
            ],
            [
              23.2217400038981,
              -26.2712700011096
            ],
            [
              23.2820500026056,
              -26.3394700030382
            ],
            [
              23.2664100017203,
              -26.4853999994104
            ],
            [
              23.4629599978057,
              -26.5310899984047
            ],
            [
              23.5837500000001,
              -26.617149998
            ],
            [
              23.4871300026476,
              -26.7397090051664
            ],
            [
              23.6465300020001,
              -26.807480002
            ],
            [
              23.7607500020001,
              -26.8409600009999
            ],
            [
              23.8532300040001,
              -26.8901400029999
            ],
            [
              23.8695000009243,
              -26.8567499976142
            ],
            [
              23.9160700036278,
              -26.8582899975853
            ],
            [
              23.970370001,
              -26.8942000019999
            ],
            [
              24.026019999,
              -26.999289997
            ],
            [
              24.03745,
              -27.053699999
            ],
            [
              24.1313599978656,
              -27.0119000018836
            ],
            [
              24.1957899977103,
              -27.0726000032875
            ],
            [
              24.2238600016379,
              -27.1252900031311
            ],
            [
              24.3202050118519,
              -27.0826950011733
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Kagisano/Molopo Local Municipality",
        "Code": "NW397",
        "Parent_cod": "DC39",
        "Area": 2382721
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              25.0280800003917,
              -28.0734800023002
            ],
            [
              25.0746500093905,
              -28.0642499957407
            ],
            [
              25.1049399969833,
              -28.0166899905506
            ],
            [
              25.0906000020885,
              -27.9840299988853
            ],
            [
              25.2009400011802,
              -27.886589999329
            ],
            [
              25.2497200023762,
              -27.8686499975993
            ],
            [
              25.238070002029,
              -27.8370499990581
            ],
            [
              25.2774100031691,
              -27.7953199956213
            ],
            [
              25.3235299968119,
              -27.793790000608
            ],
            [
              25.3640299965871,
              -27.7505400008204
            ],
            [
              25.479430003292,
              -27.6933800007863
            ],
            [
              25.555830002053,
              -27.6866599975608
            ],
            [
              25.5966099985526,
              -27.6550699967828
            ],
            [
              25.65780000007,
              -27.6948599970912
            ],
            [
              25.6774200019316,
              -27.6307899967609
            ],
            [
              25.8302399958791,
              -27.5661900025666
            ],
            [
              25.8348200011422,
              -27.5117900012075
            ],
            [
              25.7537200032756,
              -27.5344899976153
            ],
            [
              25.7386699999206,
              -27.469160001233
            ],
            [
              25.8049799956303,
              -27.4463599966165
            ],
            [
              25.7970300004342,
              -27.3906499986984
            ],
            [
              25.8248019888208,
              -27.3630420025864
            ],
            [
              25.8060399968484,
              -27.2906099961544
            ],
            [
              25.7989800004268,
              -27.2818900023217
            ],
            [
              25.7723000003448,
              -27.2092519998798
            ],
            [
              25.6743750566636,
              -27.222110529877
            ],
            [
              25.6465099983378,
              -27.2710700042772
            ],
            [
              25.6751299988504,
              -27.2872100021399
            ],
            [
              25.6833799979886,
              -27.3364100002212
            ],
            [
              25.5709599983053,
              -27.3733699986265
            ],
            [
              25.4699399964338,
              -27.3912499948914
            ],
            [
              25.2725900012276,
              -27.405459997281
            ],
            [
              25.2551600041309,
              -27.450630001973
            ],
            [
              25.188980000027,
              -27.4480700008298
            ],
            [
              25.1464499992681,
              -27.5330399963987
            ],
            [
              25.113990003336,
              -27.5454200007324
            ],
            [
              25.0943399991917,
              -27.4629600004037
            ],
            [
              25.0158999998852,
              -27.4928899965761
            ],
            [
              25.0063899966011,
              -27.5241699983467
            ],
            [
              25.0145699997058,
              -27.5555399979724
            ],
            [
              25.0878399962189,
              -27.6575099968888
            ],
            [
              25.0479099984477,
              -27.6997399964037
            ],
            [
              24.8298400001159,
              -27.9312900003332
            ],
            [
              24.8474107231264,
              -27.9579746651987
            ],
            [
              24.9505599976458,
              -28.1131400002108
            ],
            [
              24.972599998691,
              -28.0814500101099
            ],
            [
              25.0280800003917,
              -28.0734800023002
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Lekwa-Teemane Local Municipality",
        "Code": "NW396",
        "Parent_cod": "DC39",
        "Area": 365363
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              27.8951199971902,
              -24.582679994686
            ],
            [
              27.996049999408,
              -24.6384300016432
            ],
            [
              28.094860000089,
              -24.6302599972011
            ],
            [
              28.1761360168637,
              -24.6816005706098
            ],
            [
              28.2106099986526,
              -24.7306199983143
            ],
            [
              28.2762300003144,
              -24.7519699990162
            ],
            [
              28.2921099969788,
              -24.795669997972
            ],
            [
              28.366117999646,
              -24.7864939966006
            ],
            [
              28.5048800000121,
              -24.8735400033684
            ],
            [
              28.6576299979261,
              -24.8377000017537
            ],
            [
              28.7137799972491,
              -24.9536200018616
            ],
            [
              28.7593799965896,
              -24.9113500014014
            ],
            [
              28.8373900012476,
              -24.9160099995618
            ],
            [
              28.9240699740501,
              -24.9015299784257
            ],
            [
              28.9618299697774,
              -24.9139500322682
            ],
            [
              29.0559299798847,
              -24.9122599912056
            ],
            [
              29.0828799717333,
              -24.981209942285
            ],
            [
              29.1831499633002,
              -24.9399200409771
            ],
            [
              29.2297799705692,
              -24.8126499662229
            ],
            [
              29.2755799998172,
              -24.7913700002253
            ],
            [
              29.2720400002458,
              -24.7425899999285
            ],
            [
              29.2473799997872,
              -24.7136099999015
            ],
            [
              29.369900037157,
              -24.6633560287577
            ],
            [
              29.4004899828265,
              -24.6085300203441
            ],
            [
              29.3345400064162,
              -24.5557500010617
            ],
            [
              29.2921699986465,
              -24.4497400028988
            ],
            [
              29.2304200036802,
              -24.3376599982103
            ],
            [
              29.1122199991537,
              -24.3741100018751
            ],
            [
              29.0508500073221,
              -24.3711099993269
            ],
            [
              29.0029000003348,
              -24.3590400020944
            ],
            [
              28.91317000739,
              -24.4147800031946
            ],
            [
              28.8012700011098,
              -24.3316100016003
            ],
            [
              28.8508799983133,
              -24.2567399996513
            ],
            [
              28.7744100026196,
              -24.2526500007968
            ],
            [
              28.7400599977708,
              -24.2064800003517
            ],
            [
              28.6653100031542,
              -24.2000099996616
            ],
            [
              28.6657899992092,
              -24.1457899976103
            ],
            [
              28.6928786026654,
              -24.1164815112128
            ],
            [
              28.5787599976758,
              -24.0569200020565
            ],
            [
              28.5258500047739,
              -24.0754699977422
            ],
            [
              28.4345299969618,
              -24.0435000019235
            ],
            [
              28.415825998671,
              -23.9971770043153
            ],
            [
              28.3563449959249,
              -24.0161299988003
            ],
            [
              28.2796400001859,
              -23.9929099990971
            ],
            [
              28.2360599959721,
              -24.0057100003163
            ],
            [
              28.19244999667,
              -24.0685400010202
            ],
            [
              28.1588700039476,
              -24.1575799981184
            ],
            [
              28.1579100010458,
              -24.1913099959595
            ],
            [
              28.0407500013115,
              -24.1769399987819
            ],
            [
              27.9902300017132,
              -24.1802699967629
            ],
            [
              28.009690000693,
              -24.2326700012195
            ],
            [
              27.9995582538104,
              -24.3076667050544
            ],
            [
              27.9511500008719,
              -24.2792899999335
            ],
            [
              27.9215900019771,
              -24.2975400015698
            ],
            [
              27.8005199964008,
              -24.3083800041339
            ],
            [
              27.8189300000195,
              -24.3494400000559
            ],
            [
              27.7578700080945,
              -24.4040300002842
            ],
            [
              27.6982899971857,
              -24.3941999993305
            ],
            [
              27.6488299979061,
              -24.3548800009113
            ],
            [
              27.5640500003073,
              -24.3823000027429
            ],
            [
              27.5746700026186,
              -24.4281999970322
            ],
            [
              27.5809399985821,
              -24.4711100009258
            ],
            [
              27.653309996759,
              -24.4812900027314
            ],
            [
              27.6850000039471,
              -24.4687399968533
            ],
            [
              27.7489190018105,
              -24.4774479982264
            ],
            [
              27.7394899977652,
              -24.5067199964306
            ],
            [
              27.6742273174368,
              -24.5007322140204
            ],
            [
              27.7007000013041,
              -24.5991099960295
            ],
            [
              27.8612099910484,
              -24.5782700071551
            ],
            [
              27.8951199971902,
              -24.582679994686
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Modimolle-Mookgophong Local Municipality",
        "Code": "LIM368",
        "Parent_cod": "DC36",
        "Area": 1036752
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              31.1585399440633,
              -28.5511149394029
            ],
            [
              31.1895299441517,
              -28.4993799386333
            ],
            [
              31.2491399438535,
              -28.4622099386378
            ],
            [
              31.2749276114202,
              -28.4836679299309
            ],
            [
              31.3294509440059,
              -28.4491649387109
            ],
            [
              31.3585099440788,
              -28.3939500643439
            ],
            [
              31.4108739441774,
              -28.4585629386287
            ],
            [
              31.4454599437214,
              -28.4771599391798
            ],
            [
              31.5043999440024,
              -28.4719799386232
            ],
            [
              31.535959944296,
              -28.3943300638813
            ],
            [
              31.610439944448,
              -28.3768699385968
            ],
            [
              31.6258999442271,
              -28.4076800643834
            ],
            [
              31.6706499439399,
              -28.4023999387061
            ],
            [
              31.7020649438421,
              -28.3714550639
            ],
            [
              31.719799944,
              -28.2992799389999
            ],
            [
              31.7030599438614,
              -28.2273099394021
            ],
            [
              31.733409944,
              -28.2185099389999
            ],
            [
              31.6451499443146,
              -28.1864099391674
            ],
            [
              31.6452099443835,
              -28.1500299387307
            ],
            [
              31.5862899441257,
              -28.1118100638833
            ],
            [
              31.5578599442812,
              -28.1430100637633
            ],
            [
              31.4995799438594,
              -28.1183299391753
            ],
            [
              31.4755799441593,
              -27.9757199394237
            ],
            [
              31.5024099439638,
              -27.9464699386367
            ],
            [
              31.4888399441082,
              -27.857709938263
            ],
            [
              31.345099944407,
              -27.9700900638054
            ],
            [
              31.3076899441358,
              -28.0373299387256
            ],
            [
              31.2180199440653,
              -28.0217400642525
            ],
            [
              31.1420899435961,
              -28.0331299392952
            ],
            [
              30.9943410333121,
              -27.995629796378
            ],
            [
              30.9869099433393,
              -28.0568899387197
            ],
            [
              30.9503599431569,
              -28.1435900644298
            ],
            [
              30.9941099426198,
              -28.1540759391532
            ],
            [
              31.047564942668,
              -28.2000920637977
            ],
            [
              31.0015199425913,
              -28.26015993893
            ],
            [
              30.9421999427733,
              -28.3123299390753
            ],
            [
              30.9609599427472,
              -28.340944064317
            ],
            [
              30.9654199433758,
              -28.40632006372
            ],
            [
              31.0181299432425,
              -28.4257700640372
            ],
            [
              31.1063600675632,
              -28.5280699387766
            ],
            [
              31.1585399440633,
              -28.5511149394029
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Ulundi Local Municipality",
        "Code": "KZN266",
        "Parent_cod": "DC26",
        "Area": 325058
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              29.1889699987665,
              -24.256940002579
            ],
            [
              29.1917199978796,
              -24.1702800010212
            ],
            [
              29.2284999978766,
              -24.1441399997611
            ],
            [
              29.2300399996463,
              -24.1090599981203
            ],
            [
              29.1621500012216,
              -24.0792800061673
            ],
            [
              29.1485099990373,
              -24.0091399966135
            ],
            [
              29.0934299995949,
              -23.9846500021958
            ],
            [
              29.0449299960226,
              -23.9055699985565
            ],
            [
              28.9821100011756,
              -23.8777999967724
            ],
            [
              28.998438002312,
              -23.8411550012023
            ],
            [
              28.921390003346,
              -23.8112200012021
            ],
            [
              28.9054000016088,
              -23.8586399999361
            ],
            [
              28.8432000002798,
              -23.8339799958801
            ],
            [
              28.8843500030503,
              -23.7846899990442
            ],
            [
              28.8578100022299,
              -23.7572299971666
            ],
            [
              28.8787900056543,
              -23.6971859981353
            ],
            [
              28.8755199969504,
              -23.6466199982143
            ],
            [
              28.9314199928385,
              -23.5982799966245
            ],
            [
              28.96924981103,
              -23.5978325281486
            ],
            [
              28.9100599709909,
              -23.5444600301063
            ],
            [
              28.7956099712233,
              -23.416060029147
            ],
            [
              28.7357699717069,
              -23.3309100306733
            ],
            [
              28.6851199823014,
              -23.3361300285779
            ],
            [
              28.6597000007545,
              -23.385749999263
            ],
            [
              28.5959380523992,
              -23.4047280515583
            ],
            [
              28.5916399998861,
              -23.4520800003917
            ],
            [
              28.5406300010738,
              -23.4692600021473
            ],
            [
              28.4643099961095,
              -23.5453400113325
            ],
            [
              28.4160099963643,
              -23.5156100019
            ],
            [
              28.3830200002729,
              -23.438269996663
            ],
            [
              28.3413900041454,
              -23.4308100078755
            ],
            [
              28.3216199971652,
              -23.4670800041388
            ],
            [
              28.2560799982933,
              -23.494430001843
            ],
            [
              28.2214299966971,
              -23.4771900027163
            ],
            [
              28.166709996769,
              -23.508380003934
            ],
            [
              28.1677063412747,
              -23.5751291736724
            ],
            [
              28.1181250621219,
              -23.5820229079308
            ],
            [
              28.1155900018771,
              -23.6121200017366
            ],
            [
              28.1626599997593,
              -23.6324399981074
            ],
            [
              28.2517600023223,
              -23.7303600000139
            ],
            [
              28.2586999968075,
              -23.7809100009957
            ],
            [
              28.2996200006626,
              -23.804319998669
            ],
            [
              28.3468399955694,
              -23.9009799964297
            ],
            [
              28.34124999679,
              -23.9189999991505
            ],
            [
              28.415825998671,
              -23.9971770043153
            ],
            [
              28.4345299969618,
              -24.0435000019235
            ],
            [
              28.5258500047739,
              -24.0754699977422
            ],
            [
              28.5787599976758,
              -24.0569200020565
            ],
            [
              28.6928786026654,
              -24.1164815112128
            ],
            [
              28.6657899992092,
              -24.1457899976103
            ],
            [
              28.6653100031542,
              -24.2000099996616
            ],
            [
              28.7400599977708,
              -24.2064800003517
            ],
            [
              28.7744100026196,
              -24.2526500007968
            ],
            [
              28.8508799983133,
              -24.2567399996513
            ],
            [
              28.8012700011098,
              -24.3316100016003
            ],
            [
              28.91317000739,
              -24.4147800031946
            ],
            [
              29.0029000003348,
              -24.3590400020944
            ],
            [
              29.0508500073221,
              -24.3711099993269
            ],
            [
              29.0631600003338,
              -24.2998400024141
            ],
            [
              29.0320400032436,
              -24.2478299997546
            ],
            [
              29.0726700036178,
              -24.2064499989683
            ],
            [
              29.0995300021079,
              -24.2320699969327
            ],
            [
              29.1479899966411,
              -24.2237799977486
            ],
            [
              29.1889699987665,
              -24.256940002579
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Mogalakwena Local Municipality",
        "Code": "LIM367",
        "Parent_cod": "DC36",
        "Area": 615617
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              31.733409944,
              -28.2185099389999
            ],
            [
              31.8073600690001,
              -28.216039939
            ],
            [
              31.807209944,
              -28.105149939
            ],
            [
              31.8192399440002,
              -28.038040064
            ],
            [
              31.8744199438253,
              -28.0368599386352
            ],
            [
              31.9480599439114,
              -28.0131300638014
            ],
            [
              31.9370400688442,
              -27.9765899390744
            ],
            [
              31.9687099438088,
              -27.9309200633102
            ],
            [
              32.0318799440001,
              -27.928580063
            ],
            [
              31.996179944349,
              -27.8852699375575
            ],
            [
              31.9516199440001,
              -27.619079938
            ],
            [
              31.8055199437904,
              -27.6240799382384
            ],
            [
              31.7653199440001,
              -27.651370063
            ],
            [
              31.7697199440001,
              -27.703300063
            ],
            [
              31.6584999439174,
              -27.7613800627397
            ],
            [
              31.5883699438178,
              -27.7741200629904
            ],
            [
              31.5114129436525,
              -27.8382340626518
            ],
            [
              31.4888399441082,
              -27.857709938263
            ],
            [
              31.5024099439638,
              -27.9464699386367
            ],
            [
              31.4755799441593,
              -27.9757199394237
            ],
            [
              31.4995799438594,
              -28.1183299391753
            ],
            [
              31.5578599442812,
              -28.1430100637633
            ],
            [
              31.5862899441257,
              -28.1118100638833
            ],
            [
              31.6452099443835,
              -28.1500299387307
            ],
            [
              31.6451499443146,
              -28.1864099391674
            ],
            [
              31.733409944,
              -28.2185099389999
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Nongoma Local Municipality",
        "Code": "KZN265",
        "Parent_cod": "DC26",
        "Area": 218211
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              28.7137799972491,
              -24.9536200018616
            ],
            [
              28.6576299979261,
              -24.8377000017537
            ],
            [
              28.5048800000121,
              -24.8735400033684
            ],
            [
              28.366117999646,
              -24.7864939966006
            ],
            [
              28.2921099969788,
              -24.795669997972
            ],
            [
              28.2762300003144,
              -24.7519699990162
            ],
            [
              28.2106099986526,
              -24.7306199983143
            ],
            [
              28.1761360168637,
              -24.6816005706098
            ],
            [
              28.094860000089,
              -24.6302599972011
            ],
            [
              27.996049999408,
              -24.6384300016432
            ],
            [
              27.8951199971902,
              -24.582679994686
            ],
            [
              27.8647099986676,
              -24.6952300030621
            ],
            [
              27.8267399977528,
              -24.7133200009173
            ],
            [
              27.870664003441,
              -24.7683579966242
            ],
            [
              27.8309800008264,
              -24.8494100003711
            ],
            [
              27.8599199999082,
              -24.8713700031231
            ],
            [
              27.9778600032367,
              -24.9010200016716
            ],
            [
              27.9835599980954,
              -24.9578499981788
            ],
            [
              28.0378499970797,
              -24.9838300037516
            ],
            [
              28.1200100042584,
              -24.9794699906475
            ],
            [
              28.1252199909099,
              -25.0048000022183
            ],
            [
              28.2597599971262,
              -25.0504500002673
            ],
            [
              28.198270003358,
              -25.1275900007778
            ],
            [
              28.1539300000695,
              -25.0867800010961
            ],
            [
              28.0838500040744,
              -25.1003699955787
            ],
            [
              28.0943499963552,
              -25.1484699995907
            ],
            [
              28.1289700019641,
              -25.1456899901009
            ],
            [
              28.1357199993785,
              -25.2056399982873
            ],
            [
              28.2111899984197,
              -25.1980699972325
            ],
            [
              28.2462700009598,
              -25.2128550036555
            ],
            [
              28.2981600007834,
              -25.3103700021739
            ],
            [
              28.379160997682,
              -25.2920559975863
            ],
            [
              28.3826000042868,
              -25.3211500001724
            ],
            [
              28.503590000778,
              -25.3088399990667
            ],
            [
              28.5132800033695,
              -25.2561499992231
            ],
            [
              28.5948100039785,
              -25.2494299959975
            ],
            [
              28.6326299997747,
              -25.279970003213
            ],
            [
              28.6593099989573,
              -25.234780001196
            ],
            [
              28.6158700020989,
              -25.1516299969268
            ],
            [
              28.6515699963583,
              -25.1428999972371
            ],
            [
              28.635959998655,
              -25.1281299995998
            ],
            [
              28.5385299968619,
              -25.1521099983776
            ],
            [
              28.5366099991522,
              -25.1524199991836
            ],
            [
              28.5320599970712,
              -25.1697899989092
            ],
            [
              28.4514300010937,
              -25.2033299987804
            ],
            [
              28.4299700043122,
              -25.2066199967154
            ],
            [
              28.3792599986501,
              -25.1552999988958
            ],
            [
              28.4429700012646,
              -25.1289899888968
            ],
            [
              28.4737399984022,
              -25.089319998619
            ],
            [
              28.5969000023333,
              -25.0718400019145
            ],
            [
              28.606873002687,
              -25.0703939981844
            ],
            [
              28.6342899962863,
              -25.0582400015747
            ],
            [
              28.6055400032686,
              -25.0037999983712
            ],
            [
              28.7137799972491,
              -24.9536200018616
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Bela-Bela Local Municipality",
        "Code": "LIM366",
        "Parent_cod": "DC36",
        "Area": 340619
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              30.6021400680002,
              -27.933599938
            ],
            [
              30.6358500678266,
              -27.9330399380427
            ],
            [
              30.6844400683545,
              -27.9710899390494
            ],
            [
              30.6127899433012,
              -28.0351999394256
            ],
            [
              30.6868999425784,
              -28.1292999387411
            ],
            [
              30.7900399432888,
              -28.1414599392247
            ],
            [
              30.8639099431894,
              -28.116839938812
            ],
            [
              30.9139999427432,
              -28.1701600639357
            ],
            [
              30.9503599431569,
              -28.1435900644298
            ],
            [
              30.9869099433393,
              -28.0568899387197
            ],
            [
              30.9943410333121,
              -27.995629796378
            ],
            [
              31.1420899435961,
              -28.0331299392952
            ],
            [
              31.2180199440653,
              -28.0217400642525
            ],
            [
              31.3076899441358,
              -28.0373299387256
            ],
            [
              31.345099944407,
              -27.9700900638054
            ],
            [
              31.4888399441082,
              -27.857709938263
            ],
            [
              31.5114129436525,
              -27.8382340626518
            ],
            [
              31.5043409439795,
              -27.8124780629123
            ],
            [
              31.5707799438396,
              -27.6486100631038
            ],
            [
              31.519929944,
              -27.670030063
            ],
            [
              31.4783049439181,
              -27.6486179375678
            ],
            [
              31.4553399440001,
              -27.609170063
            ],
            [
              31.3763999440001,
              -27.5576599379999
            ],
            [
              31.3860299440001,
              -27.539239938
            ],
            [
              31.2973699439677,
              -27.5117000627076
            ],
            [
              31.254949943785,
              -27.5817400631534
            ],
            [
              31.2019899440001,
              -27.5892699379999
            ],
            [
              31.1714499440001,
              -27.5639899379999
            ],
            [
              31.189004478,
              -27.454314526
            ],
            [
              31.0873599432069,
              -27.5197699384318
            ],
            [
              31.0325600681926,
              -27.5210400626487
            ],
            [
              31.0484199434257,
              -27.6222399379228
            ],
            [
              30.9581799431499,
              -27.6187599384204
            ],
            [
              30.798539943164,
              -27.6633300629321
            ],
            [
              30.6642399426193,
              -27.6791500631249
            ],
            [
              30.6916499430001,
              -27.7155399379999
            ],
            [
              30.673099942908,
              -27.7531699377424
            ],
            [
              30.6269899430002,
              -27.7397399379999
            ],
            [
              30.6294199430001,
              -27.810289938
            ],
            [
              30.597980067926,
              -27.8353100627092
            ],
            [
              30.5813899430001,
              -27.888569938
            ],
            [
              30.6021400680002,
              -27.933599938
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Abaqulusi Local Municipality",
        "Code": "KZN263",
        "Parent_cod": "DC26",
        "Area": 431356
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              31.9777599438665,
              -27.3175200626007
            ],
            [
              31.4936899440001,
              -27.3151600629999
            ],
            [
              31.2743299800001,
              -27.243170021
            ],
            [
              31.1658699916069,
              -27.368520013288
            ],
            [
              31.1408650238018,
              -27.3626599795743
            ],
            [
              31.107499942968,
              -27.3898100633837
            ],
            [
              31.1582999437875,
              -27.4164799379987
            ],
            [
              31.189004478,
              -27.454314526
            ],
            [
              31.1714499440001,
              -27.5639899379999
            ],
            [
              31.2019899440001,
              -27.5892699379999
            ],
            [
              31.254949943785,
              -27.5817400631534
            ],
            [
              31.2973699439677,
              -27.5117000627076
            ],
            [
              31.3860299440001,
              -27.539239938
            ],
            [
              31.3763999440001,
              -27.5576599379999
            ],
            [
              31.4553399440001,
              -27.609170063
            ],
            [
              31.4783049439181,
              -27.6486179375678
            ],
            [
              31.519929944,
              -27.670030063
            ],
            [
              31.5707799438396,
              -27.6486100631038
            ],
            [
              31.5043409439795,
              -27.8124780629123
            ],
            [
              31.5114129436525,
              -27.8382340626518
            ],
            [
              31.5883699438178,
              -27.7741200629904
            ],
            [
              31.6584999439174,
              -27.7613800627397
            ],
            [
              31.7697199440001,
              -27.703300063
            ],
            [
              31.7653199440001,
              -27.651370063
            ],
            [
              31.8055199437904,
              -27.6240799382384
            ],
            [
              31.9516199440001,
              -27.619079938
            ],
            [
              31.9869599436467,
              -27.579909938293
            ],
            [
              32.0501399440002,
              -27.583799938
            ],
            [
              32.0206999437474,
              -27.5128400631183
            ],
            [
              31.999789943551,
              -27.3835899384249
            ],
            [
              31.9777599438665,
              -27.3175200626007
            ]
          ]
        ]
      },
      "properties": {
        "Name": "UPhongolo Local Municipality",
        "Code": "KZN262",
        "Parent_cod": "DC26",
        "Area": 311006
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              31.1408650238018,
              -27.3626599795743
            ],
            [
              31.1009599876134,
              -27.3357600206085
            ],
            [
              30.9557899894165,
              -27.3597099829293
            ],
            [
              30.8978099866416,
              -27.3089899831012
            ],
            [
              30.897629990032,
              -27.30919001121
            ],
            [
              30.8296799888404,
              -27.3501499818361
            ],
            [
              30.7909899817023,
              -27.3184500209517
            ],
            [
              30.7067999897278,
              -27.2832899868434
            ],
            [
              30.6606199906202,
              -27.2879200097006
            ],
            [
              30.5877399887096,
              -27.3229499811567
            ],
            [
              30.52704999676,
              -27.31574998997
            ],
            [
              30.448269997962,
              -27.3277399376479
            ],
            [
              30.444679943,
              -27.357399938
            ],
            [
              30.5004299427877,
              -27.3905500633347
            ],
            [
              30.5096399430001,
              -27.4565899379999
            ],
            [
              30.5867499430002,
              -27.499829938
            ],
            [
              30.592539942964,
              -27.5324980631351
            ],
            [
              30.6675599428371,
              -27.6448900633257
            ],
            [
              30.6642399426193,
              -27.6791500631249
            ],
            [
              30.798539943164,
              -27.6633300629321
            ],
            [
              30.9581799431499,
              -27.6187599384204
            ],
            [
              31.0484199434257,
              -27.6222399379228
            ],
            [
              31.0325600681926,
              -27.5210400626487
            ],
            [
              31.0873599432069,
              -27.5197699384318
            ],
            [
              31.189004478,
              -27.454314526
            ],
            [
              31.1582999437875,
              -27.4164799379987
            ],
            [
              31.107499942968,
              -27.3898100633837
            ],
            [
              31.1408650238018,
              -27.3626599795743
            ]
          ]
        ]
      },
      "properties": {
        "Name": "eDumbe Local Municipality",
        "Code": "KZN261",
        "Parent_cod": "DC26",
        "Area": 194276
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              28.415825998671,
              -23.9971770043153
            ],
            [
              28.34124999679,
              -23.9189999991505
            ],
            [
              28.3468399955694,
              -23.9009799964297
            ],
            [
              28.2996200006626,
              -23.804319998669
            ],
            [
              28.2586999968075,
              -23.7809100009957
            ],
            [
              28.2517600023223,
              -23.7303600000139
            ],
            [
              28.1626599997593,
              -23.6324399981074
            ],
            [
              28.1155900018771,
              -23.6121200017366
            ],
            [
              28.1181250621219,
              -23.5820229079308
            ],
            [
              28.1677063412747,
              -23.5751291736724
            ],
            [
              28.166709996769,
              -23.508380003934
            ],
            [
              28.2214299966971,
              -23.4771900027163
            ],
            [
              28.2560799982933,
              -23.494430001843
            ],
            [
              28.3216199971652,
              -23.4670800041388
            ],
            [
              28.3413900041454,
              -23.4308100078755
            ],
            [
              28.3830200002729,
              -23.438269996663
            ],
            [
              28.4160099963643,
              -23.5156100019
            ],
            [
              28.4643099961095,
              -23.5453400113325
            ],
            [
              28.5406300010738,
              -23.4692600021473
            ],
            [
              28.5916399998861,
              -23.4520800003917
            ],
            [
              28.5959380523992,
              -23.4047280515583
            ],
            [
              28.5395899998786,
              -23.3509699997656
            ],
            [
              28.4975100000865,
              -23.3449500000425
            ],
            [
              28.4740399996463,
              -23.3121900001683
            ],
            [
              28.4132900004332,
              -23.3516699996707
            ],
            [
              28.3555400001709,
              -23.2834500004171
            ],
            [
              28.3200900003532,
              -23.2040200004226
            ],
            [
              28.3532899998337,
              -23.1841499996227
            ],
            [
              28.3370700000805,
              -23.1228399997662
            ],
            [
              28.291179999957,
              -23.0909800000269
            ],
            [
              28.2517700000855,
              -23.1086599996593
            ],
            [
              28.2243399995913,
              -23.0493300002793
            ],
            [
              28.2345599996443,
              -22.9670399996962
            ],
            [
              28.1827200003278,
              -22.9492100003413
            ],
            [
              28.1476399995864,
              -22.9160400004456
            ],
            [
              28.09693696367,
              -22.8110530359688
            ],
            [
              28.0391400044077,
              -22.8419100074408
            ],
            [
              28.0368199990437,
              -22.9130299992351
            ],
            [
              27.9352900006331,
              -22.9655700020539
            ],
            [
              27.9434900001634,
              -23.0362199991536
            ],
            [
              27.9205499980839,
              -23.0677799967494
            ],
            [
              27.7652999945991,
              -23.1424200015817
            ],
            [
              27.7845800023652,
              -23.1724799992526
            ],
            [
              27.7416199979645,
              -23.2304100042183
            ],
            [
              27.6720099966641,
              -23.2004799990527
            ],
            [
              27.5755799978187,
              -23.2613400042378
            ],
            [
              27.5638899974255,
              -23.3481600005835
            ],
            [
              27.5286499991981,
              -23.3852699978121
            ],
            [
              27.4612099990423,
              -23.3840000030976
            ],
            [
              27.4270399997962,
              -23.4257799962498
            ],
            [
              27.3488100029793,
              -23.3975200024461
            ],
            [
              27.3029600011032,
              -23.4626600017577
            ],
            [
              27.1920799950957,
              -23.4984700010896
            ],
            [
              27.1340499999077,
              -23.5366399896438
            ],
            [
              27.0811499975744,
              -23.6433100029543
            ],
            [
              26.9996599979106,
              -23.6524400031036
            ],
            [
              27.0010566189678,
              -23.6890343920236
            ],
            [
              27.0110893253122,
              -23.7909908291633
            ],
            [
              27.1060199744423,
              -23.9082794193596
            ],
            [
              27.127679824864,
              -23.9534206385516
            ],
            [
              27.2450809481273,
              -24.0138607026093
            ],
            [
              27.3184604640792,
              -24.0285491937902
            ],
            [
              27.4419193271153,
              -24.1043491361037
            ],
            [
              27.4949116943193,
              -24.0782822452294
            ],
            [
              27.5383432339531,
              -24.1678097378291
            ],
            [
              27.5023574828116,
              -24.219268798716
            ],
            [
              27.4903583530556,
              -24.2730579382732
            ],
            [
              27.4936656953157,
              -24.3552150730172
            ],
            [
              27.5139579772789,
              -24.416219710771
            ],
            [
              27.5746700026186,
              -24.4281999970322
            ],
            [
              27.5640500003073,
              -24.3823000027429
            ],
            [
              27.6488299979061,
              -24.3548800009113
            ],
            [
              27.6982899971857,
              -24.3941999993305
            ],
            [
              27.7578700080945,
              -24.4040300002842
            ],
            [
              27.8189300000195,
              -24.3494400000559
            ],
            [
              27.8005199964008,
              -24.3083800041339
            ],
            [
              27.9215900019771,
              -24.2975400015698
            ],
            [
              27.9511500008719,
              -24.2792899999335
            ],
            [
              27.9995582538104,
              -24.3076667050544
            ],
            [
              28.009690000693,
              -24.2326700012195
            ],
            [
              27.9902300017132,
              -24.1802699967629
            ],
            [
              28.0407500013115,
              -24.1769399987819
            ],
            [
              28.1579100010458,
              -24.1913099959595
            ],
            [
              28.1588700039476,
              -24.1575799981184
            ],
            [
              28.19244999667,
              -24.0685400010202
            ],
            [
              28.2360599959721,
              -24.0057100003163
            ],
            [
              28.2796400001859,
              -23.9929099990971
            ],
            [
              28.3563449959249,
              -24.0161299988003
            ],
            [
              28.415825998671,
              -23.9971770043153
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Lephalale Local Municipality",
        "Code": "LIM362",
        "Parent_cod": "DC36",
        "Area": 1379351
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              26.4582800017207,
              -24.8094700021388
            ],
            [
              26.5664500023658,
              -24.8198999992855
            ],
            [
              26.6220100032591,
              -24.8098600039359
            ],
            [
              26.6993000007944,
              -24.8672900038306
            ],
            [
              26.7512599957522,
              -24.8829599989048
            ],
            [
              26.7795400030688,
              -24.837690003091
            ],
            [
              26.9433200024162,
              -24.7813700031231
            ],
            [
              26.9807200022263,
              -24.7757699975872
            ],
            [
              26.975909998048,
              -24.7206700017191
            ],
            [
              27.0263299993301,
              -24.7186300020728
            ],
            [
              27.0412199989039,
              -24.8869700030632
            ],
            [
              27.1011500025706,
              -24.9000400032435
            ],
            [
              27.1453584943991,
              -24.9509949581507
            ],
            [
              27.1540499968099,
              -24.9789600031016
            ],
            [
              27.1834199986341,
              -24.9485200022963
            ],
            [
              27.2260920023441,
              -24.9639370018911
            ],
            [
              27.2034680004479,
              -25.0331829980968
            ],
            [
              27.3135999998402,
              -25.0420899969558
            ],
            [
              27.3369500001424,
              -25.0878199968953
            ],
            [
              27.4245999996902,
              -25.0689100025946
            ],
            [
              27.4869000011342,
              -25.0784199977846
            ],
            [
              27.5435999961429,
              -25.0958799980634
            ],
            [
              27.5940400019446,
              -25.0294400008553
            ],
            [
              27.5974900027614,
              -24.9848699995508
            ],
            [
              27.6846699986216,
              -24.9858399930212
            ],
            [
              27.7591400028089,
              -24.9689100009957
            ],
            [
              27.821660002707,
              -24.9745800016657
            ],
            [
              27.9464699981919,
              -25.0012199999031
            ],
            [
              27.9835599980954,
              -24.9578499981788
            ],
            [
              27.9778600032367,
              -24.9010200016716
            ],
            [
              27.8599199999082,
              -24.8713700031231
            ],
            [
              27.8309800008264,
              -24.8494100003711
            ],
            [
              27.870664003441,
              -24.7683579966242
            ],
            [
              27.8267399977528,
              -24.7133200009173
            ],
            [
              27.8647099986676,
              -24.6952300030621
            ],
            [
              27.8951199971902,
              -24.582679994686
            ],
            [
              27.8612099910484,
              -24.5782700071551
            ],
            [
              27.7007000013041,
              -24.5991099960295
            ],
            [
              27.6742273174368,
              -24.5007322140204
            ],
            [
              27.7394899977652,
              -24.5067199964306
            ],
            [
              27.7489190018105,
              -24.4774479982264
            ],
            [
              27.6850000039471,
              -24.4687399968533
            ],
            [
              27.653309996759,
              -24.4812900027314
            ],
            [
              27.5809399985821,
              -24.4711100009258
            ],
            [
              27.5746700026186,
              -24.4281999970322
            ],
            [
              27.5139579772789,
              -24.416219710771
            ],
            [
              27.4936656953157,
              -24.3552150730172
            ],
            [
              27.4903583530556,
              -24.2730579382732
            ],
            [
              27.5023574828116,
              -24.219268798716
            ],
            [
              27.5383432339531,
              -24.1678097378291
            ],
            [
              27.4949116943193,
              -24.0782822452294
            ],
            [
              27.4419193271153,
              -24.1043491361037
            ],
            [
              27.3184604640792,
              -24.0285491937902
            ],
            [
              27.2450809481273,
              -24.0138607026093
            ],
            [
              27.127679824864,
              -23.9534206385516
            ],
            [
              27.1060199744423,
              -23.9082794193596
            ],
            [
              27.0110893253122,
              -23.7909908291633
            ],
            [
              27.0010566189678,
              -23.6890343920236
            ],
            [
              26.9710699996807,
              -23.7027599988748
            ],
            [
              26.940289999384,
              -23.8436500011466
            ],
            [
              26.9552599990498,
              -23.8735799991176
            ],
            [
              26.927699998856,
              -23.9235599989948
            ],
            [
              26.9089400006806,
              -24.0291800025551
            ],
            [
              26.8632000029778,
              -24.0997200035753
            ],
            [
              26.8806100027495,
              -24.1965799970691
            ],
            [
              26.8688099981829,
              -24.2438199955962
            ],
            [
              26.7999300008689,
              -24.2999599971561
            ],
            [
              26.7039900021369,
              -24.3218200015918
            ],
            [
              26.6470500023558,
              -24.3818299999546
            ],
            [
              26.5105200032955,
              -24.4879100004461
            ],
            [
              26.4695499998326,
              -24.5908599977907
            ],
            [
              26.4087800032946,
              -24.6461299961024
            ],
            [
              26.4273100016553,
              -24.6575200033455
            ],
            [
              26.4263199955713,
              -24.7719700040124
            ],
            [
              26.4582800017207,
              -24.8094700021388
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Thabazimbi Local Municipality",
        "Code": "LIM361",
        "Parent_cod": "DC36",
        "Area": 1118998
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              21.2604600047255,
              -28.7114800033994
            ],
            [
              21.3417999938747,
              -28.631930000569
            ],
            [
              21.531649999348,
              -28.5634300009937
            ],
            [
              21.6099870002,
              -28.5510450018253
            ],
            [
              21.6534399958592,
              -28.5058699987014
            ],
            [
              21.7015599980955,
              -28.5124700026884
            ],
            [
              21.738519994702,
              -28.4752500012865
            ],
            [
              21.7869999991507,
              -28.5050899969058
            ],
            [
              21.8376099939061,
              -28.3827399979525
            ],
            [
              21.8168199875524,
              -28.3479399993315
            ],
            [
              21.7741795680327,
              -28.353029206133
            ],
            [
              21.7464699952941,
              -28.3008300059001
            ],
            [
              21.6895599366418,
              -28.2751808168411
            ],
            [
              21.7479400630835,
              -28.236259460006
            ],
            [
              21.6812591545864,
              -28.2096004492013
            ],
            [
              21.8089809417171,
              -28.0800495147733
            ],
            [
              21.8328895568076,
              -28.0106391908459
            ],
            [
              21.7885398858072,
              -27.9682407384193
            ],
            [
              21.9872493735598,
              -27.8068904878057
            ],
            [
              22.006195183361,
              -27.7604203494195
            ],
            [
              21.9163208006645,
              -27.5538101196412
            ],
            [
              21.9994106285977,
              -27.5247993466125
            ],
            [
              21.9994900036608,
              -27.1102499984386
            ],
            [
              21.9994600049753,
              -27.0247900063537
            ],
            [
              21.9516300070001,
              -26.948810012
            ],
            [
              21.9171399886196,
              -26.9586899942478
            ],
            [
              21.8723500030001,
              -26.860149998
            ],
            [
              21.8310399966985,
              -26.7977800040438
            ],
            [
              21.7928699990001,
              -26.769629999
            ],
            [
              21.7801900025666,
              -26.8025299982607
            ],
            [
              21.6948399993665,
              -26.8612400041229
            ],
            [
              21.6270699947845,
              -26.8666599968613
            ],
            [
              21.6044800016508,
              -26.8458799990627
            ],
            [
              21.4858599957423,
              -26.8415499963353
            ],
            [
              21.4054299963973,
              -26.8220999951187
            ],
            [
              21.2645600004437,
              -26.8375399966734
            ],
            [
              21.1341700039426,
              -26.8737599978256
            ],
            [
              21.0788800038092,
              -26.8485099944407
            ],
            [
              21.0066299949783,
              -26.8443100031041
            ],
            [
              20.9778299987555,
              -26.8115099986875
            ],
            [
              20.8852300002643,
              -26.7972699994109
            ],
            [
              20.8177900001084,
              -26.8229900010876
            ],
            [
              20.7631100002264,
              -26.8664700042873
            ],
            [
              20.6761499929278,
              -26.8612500036847
            ],
            [
              20.6224299968469,
              -26.7862499957407
            ],
            [
              20.6168900003733,
              -26.6773100045531
            ],
            [
              20.6338100018302,
              -26.6687199969303
            ],
            [
              20.631460004076,
              -26.5840499990082
            ],
            [
              20.6085599993446,
              -26.5540600000689
            ],
            [
              20.6172999932002,
              -26.4439900044351
            ],
            [
              20.6461499953261,
              -26.4350800000419
            ],
            [
              20.7589200003578,
              -26.2869900002882
            ],
            [
              20.7902900017822,
              -26.2714100030691
            ],
            [
              20.8227800008964,
              -26.1765000122657
            ],
            [
              20.8632799979735,
              -26.1326799969842
            ],
            [
              20.8209100000965,
              -26.1054799963047
            ],
            [
              20.8393400010402,
              -26.076599994594
            ],
            [
              20.8153500053985,
              -26.0058999996852
            ],
            [
              20.8374300019931,
              -25.9507499943168
            ],
            [
              20.8050700052766,
              -25.9252899983348
            ],
            [
              20.7867400008504,
              -25.8606000053859
            ],
            [
              20.729790008702,
              -25.7684499961703
            ],
            [
              20.7220600002689,
              -25.7249600006035
            ],
            [
              20.6825599962469,
              -25.6945200042947
            ],
            [
              20.6981899993691,
              -25.5951100011256
            ],
            [
              20.5982799992227,
              -25.4217399984021
            ],
            [
              20.5392299983658,
              -25.3445300027574
            ],
            [
              20.5428900025716,
              -25.2925799947709
            ],
            [
              20.4964400009054,
              -25.268980000027
            ],
            [
              20.4989200019566,
              -25.2283600001139
            ],
            [
              20.4463800009364,
              -25.198970001864
            ],
            [
              20.4125500047789,
              -25.0827199937326
            ],
            [
              20.3841700009448,
              -25.0343000028428
            ],
            [
              20.286079994796,
              -24.9695700035528
            ],
            [
              20.2657099970188,
              -24.928519994602
            ],
            [
              20.2037300040366,
              -24.896479994656
            ],
            [
              20.1158299929599,
              -24.880889997875
            ],
            [
              20.0902400026741,
              -24.8328200024411
            ],
            [
              20.0382900027815,
              -24.8095500031301
            ],
            [
              19.9988700042474,
              -24.7658600082327
            ],
            [
              19.998910003394,
              -25.1035499983337
            ],
            [
              20.0001900102609,
              -25.531559995997
            ],
            [
              19.9994199990337,
              -26.1426300007739
            ],
            [
              19.998839989374,
              -26.6187099947704
            ],
            [
              20.0002100012906,
              -26.9610100014104
            ],
            [
              19.9999200041049,
              -27.405459994583
            ],
            [
              20.0002100012906,
              -27.7740199990236
            ],
            [
              20.1536693565556,
              -27.8525600434112
            ],
            [
              20.2486000056858,
              -27.7905693053292
            ],
            [
              20.2708189430399,
              -27.9148809361063
            ],
            [
              20.2655556104032,
              -27.9410816452017
            ],
            [
              20.3253610561679,
              -27.986465239779
            ],
            [
              20.4834499360658,
              -27.9395408628205
            ],
            [
              20.5117702482984,
              -27.95871925439
            ],
            [
              20.5579891197021,
              -28.0348205568232
            ],
            [
              20.5799807273287,
              -28.181939241103
            ],
            [
              20.6380148899752,
              -28.1748534889973
            ],
            [
              20.6642157159826,
              -28.22945461294
            ],
            [
              20.7123298636324,
              -28.2814998654264
            ],
            [
              20.8050000083438,
              -28.3548299996047
            ],
            [
              20.849555001762,
              -28.3509699951691
            ],
            [
              20.9262499934425,
              -28.4126999982063
            ],
            [
              21.0011799945612,
              -28.4007100001664
            ],
            [
              21.0177900006081,
              -28.4438700065955
            ],
            [
              21.1603690043262,
              -28.5931960003951
            ],
            [
              21.1913900031462,
              -28.6076699987714
            ],
            [
              21.2604600047255,
              -28.7114800033994
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Dawid Kruiper Local Municipality",
        "Code": "NC087",
        "Parent_cod": "DC8",
        "Area": 4439921
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              23.7547000003048,
              -28.528780003894
            ],
            [
              23.7672499998876,
              -28.4714699933455
            ],
            [
              23.8280499897152,
              -28.3909800029248
            ],
            [
              23.8143799996373,
              -28.3338000028678
            ],
            [
              23.8484500032651,
              -28.2593899969507
            ],
            [
              23.8914200018317,
              -28.1259400059265
            ],
            [
              23.7906600020575,
              -28.0828499964302
            ],
            [
              23.8345999958931,
              -28.015079999942
            ],
            [
              23.5809300043163,
              -27.8793100008558
            ],
            [
              23.4438999983863,
              -27.9551800003567
            ],
            [
              23.4165500015813,
              -27.9158499978791
            ],
            [
              23.362025980115,
              -27.9421671314079
            ],
            [
              23.4413150005869,
              -28.0860499929128
            ],
            [
              23.5236300014235,
              -28.0953000003946
            ],
            [
              23.487219998704,
              -28.160220001252
            ],
            [
              23.4420499967101,
              -28.2030400045925
            ],
            [
              23.3988399906731,
              -28.2823600004137
            ],
            [
              23.4200599961719,
              -28.2950400041928
            ],
            [
              23.3887200006276,
              -28.3716299901319
            ],
            [
              23.5034699953441,
              -28.4152149981736
            ],
            [
              23.5681900031661,
              -28.4499100009458
            ],
            [
              23.5431290004031,
              -28.5172880027391
            ],
            [
              23.7069699989663,
              -28.5877200005776
            ],
            [
              23.7547000003048,
              -28.528780003894
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Kgatelopele Local Municipality",
        "Code": "NC086",
        "Parent_cod": "DC8",
        "Area": 247845
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              23.7069699989663,
              -28.5877200005776
            ],
            [
              23.5431290004031,
              -28.5172880027391
            ],
            [
              23.5681900031661,
              -28.4499100009458
            ],
            [
              23.5034699953441,
              -28.4152149981736
            ],
            [
              23.3887200006276,
              -28.3716299901319
            ],
            [
              23.4200599961719,
              -28.2950400041928
            ],
            [
              23.3988399906731,
              -28.2823600004137
            ],
            [
              23.4420499967101,
              -28.2030400045925
            ],
            [
              23.487219998704,
              -28.160220001252
            ],
            [
              23.5236300014235,
              -28.0953000003946
            ],
            [
              23.4413150005869,
              -28.0860499929128
            ],
            [
              23.362025980115,
              -27.9421671314079
            ],
            [
              23.3043600071087,
              -27.9365300000594
            ],
            [
              23.2202900098762,
              -27.9542800020204
            ],
            [
              23.1122100016903,
              -27.9627800045935
            ],
            [
              23.097749994067,
              -27.8887700000355
            ],
            [
              23.0230499990583,
              -27.8579899997386
            ],
            [
              22.9915500024307,
              -27.8980400138355
            ],
            [
              22.9330899946076,
              -27.8879499990932
            ],
            [
              22.7728099956848,
              -27.9841400057566
            ],
            [
              22.6740300008839,
              -27.9843600051101
            ],
            [
              22.642420000083,
              -27.9397199978796
            ],
            [
              22.727434176646,
              -27.9303502780428
            ],
            [
              22.7149761012661,
              -27.8950702617832
            ],
            [
              22.7887084356458,
              -27.8901546906864
            ],
            [
              22.7395499952362,
              -27.8507300048857
            ],
            [
              22.8193199956213,
              -27.8316099991021
            ],
            [
              22.8016899973955,
              -27.7928699986515
            ],
            [
              22.7005100061319,
              -27.6870500002572
            ],
            [
              22.7145799957703,
              -27.5491599951376
            ],
            [
              22.7197599990001,
              -27.4563699939999
            ],
            [
              22.6691300040001,
              -27.450710003
            ],
            [
              22.6816499979491,
              -27.3477499988633
            ],
            [
              22.6530500019561,
              -27.314049997909
            ],
            [
              22.6856700050001,
              -27.267329998
            ],
            [
              22.6520899909603,
              -27.2369099920025
            ],
            [
              22.6204300000001,
              -27.263070001
            ],
            [
              22.4877899937133,
              -27.2788899970757
            ],
            [
              22.396400005,
              -27.27818
            ],
            [
              22.3413399949448,
              -27.2611100036237
            ],
            [
              22.3247800037942,
              -27.0776899933985
            ],
            [
              22.251680004,
              -27.039929995
            ],
            [
              22.209400003,
              -27.0944500009999
            ],
            [
              22.1506099920001,
              -27.030939995
            ],
            [
              22.124309996,
              -27.0735599989999
            ],
            [
              21.9994900036608,
              -27.1102499984386
            ],
            [
              21.9994106285977,
              -27.5247993466125
            ],
            [
              21.9163208006645,
              -27.5538101196412
            ],
            [
              22.006195183361,
              -27.7604203494195
            ],
            [
              21.9872493735598,
              -27.8068904878057
            ],
            [
              21.7885398858072,
              -27.9682407384193
            ],
            [
              21.8328895568076,
              -28.0106391908459
            ],
            [
              21.8089809417171,
              -28.0800495147733
            ],
            [
              21.6812591545864,
              -28.2096004492013
            ],
            [
              21.7479400630835,
              -28.236259460006
            ],
            [
              21.6895599366418,
              -28.2751808168411
            ],
            [
              21.7464699952941,
              -28.3008300059001
            ],
            [
              21.7741795680327,
              -28.353029206133
            ],
            [
              21.8168199875524,
              -28.3479399993315
            ],
            [
              21.8376099939061,
              -28.3827399979525
            ],
            [
              21.9007099998666,
              -28.4252100004411
            ],
            [
              21.9266299936794,
              -28.5205199997981
            ],
            [
              22.045949996795,
              -28.6816500064426
            ],
            [
              22.0988599995894,
              -28.709750012653
            ],
            [
              22.1233299939841,
              -28.763200002578
            ],
            [
              22.4606000006895,
              -28.4444600014279
            ],
            [
              22.5243449977235,
              -28.4973499970047
            ],
            [
              22.6672400052221,
              -28.5026800008813
            ],
            [
              22.7296190013159,
              -28.517632080656
            ],
            [
              22.7967097227755,
              -28.5772905960841
            ],
            [
              22.9176300011237,
              -28.5769799963298
            ],
            [
              22.9624700013895,
              -28.5613699923313
            ],
            [
              22.9957300027375,
              -28.5802899969857
            ],
            [
              23.1284600046256,
              -28.5966099977531
            ],
            [
              23.2229599963069,
              -28.5572899957367
            ],
            [
              23.2022299963173,
              -28.629594993614
            ],
            [
              23.2551399991117,
              -28.6143500001524
            ],
            [
              23.2920099987624,
              -28.6499400010302
            ],
            [
              23.3790850005724,
              -28.636309993911
            ],
            [
              23.4102900015824,
              -28.6952799973739
            ],
            [
              23.479420001432,
              -28.7138599998391
            ],
            [
              23.5424099960245,
              -28.7474399970582
            ],
            [
              23.6685000037722,
              -28.766740003948
            ],
            [
              23.6929600057997,
              -28.7368500024256
            ],
            [
              23.6238099987325,
              -28.7083900011975
            ],
            [
              23.7069699989663,
              -28.5877200005776
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Tsantsabane Local Municipality",
        "Code": "NC085",
        "Parent_cod": "DC8",
        "Area": 1828935
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              31.3159399981325,
              -25.7430400006954
            ],
            [
              31.2620800018907,
              -25.6923199981693
            ],
            [
              31.3032699984117,
              -25.663850001876
            ],
            [
              31.3307799989978,
              -25.6089800040239
            ],
            [
              31.2758499956808,
              -25.5602400028738
            ],
            [
              31.3354500039146,
              -25.5225599982453
            ],
            [
              31.4826793668594,
              -25.4966297152891
            ],
            [
              31.5368299988055,
              -25.4640800038891
            ],
            [
              31.5813198093618,
              -25.3439693447094
            ],
            [
              31.6270294189725,
              -25.2729206088989
            ],
            [
              31.6228199011176,
              -25.1873798370098
            ],
            [
              31.5863800049333,
              -25.0251293182634
            ],
            [
              31.6108938961365,
              -24.9892469396945
            ],
            [
              31.5642485005678,
              -24.9604220331503
            ],
            [
              31.4842347893042,
              -24.9773421560157
            ],
            [
              31.4685401923761,
              -24.9873104097476
            ],
            [
              31.4674958987168,
              -24.9868531980166
            ],
            [
              31.4674203331819,
              -24.9868201371396
            ],
            [
              31.467354859839,
              -24.986797630706
            ],
            [
              31.4444961106071,
              -24.9870384026002
            ],
            [
              31.4437999732902,
              -24.9873504637528
            ],
            [
              31.4358100886647,
              -24.9860305791478
            ],
            [
              31.4350410532021,
              -24.9855409369646
            ],
            [
              31.427959441575,
              -24.9818801881202
            ],
            [
              31.4275206056915,
              -24.9814908212443
            ],
            [
              31.4172096248244,
              -24.9707603444144
            ],
            [
              31.4165484027866,
              -24.9703832559824
            ],
            [
              31.414890288556,
              -24.9698600771808
            ],
            [
              31.4147933749144,
              -24.9698419387544
            ],
            [
              31.3749554020702,
              -24.9658003423119
            ],
            [
              31.3745098113788,
              -24.9658203126573
            ],
            [
              31.3717600002239,
              -24.9669500023407
            ],
            [
              31.2672899966361,
              -24.9796200020614
            ],
            [
              31.2493000033925,
              -25.0183601383097
            ],
            [
              31.1531080946629,
              -25.0224063212946
            ],
            [
              31.1405847186099,
              -24.9819340116453
            ],
            [
              31.1405311819685,
              -24.9818864231199
            ],
            [
              31.0606999989058,
              -24.9954000031076
            ],
            [
              31.0252300026626,
              -25.0300999944192
            ],
            [
              30.9841500031202,
              -25.0621000006144
            ],
            [
              30.9672599967515,
              -25.121820002691
            ],
            [
              30.9411200035853,
              -25.1288880039781
            ],
            [
              30.9172199986041,
              -25.2083099964092
            ],
            [
              30.9781559992,
              -25.2901540034045
            ],
            [
              30.9009400023792,
              -25.321039995999
            ],
            [
              30.9456629999475,
              -25.3576639977952
            ],
            [
              30.8548515173837,
              -25.3980125751202
            ],
            [
              30.7906799961849,
              -25.3533100020549
            ],
            [
              30.7456999966575,
              -25.3767399961539
            ],
            [
              30.7032399982274,
              -25.3615399957742
            ],
            [
              30.6298900088169,
              -25.2849999986509
            ],
            [
              30.5889400017797,
              -25.321850001876
            ],
            [
              30.5482600017977,
              -25.3131100044231
            ],
            [
              30.5319709970639,
              -25.3495900022768
            ],
            [
              30.4492399986271,
              -25.3449599983053
            ],
            [
              30.4424299966471,
              -25.380820002641
            ],
            [
              30.4801100021749,
              -25.4523900016971
            ],
            [
              30.5653459992186,
              -25.481235996444
            ],
            [
              30.5341200026361,
              -25.5360000028977
            ],
            [
              30.5937099969188,
              -25.5541300016982
            ],
            [
              30.6656199981645,
              -25.6729800011261
            ],
            [
              30.6466299947785,
              -25.7124200086764
            ],
            [
              30.7326500009968,
              -25.741350001901
            ],
            [
              30.7736499986486,
              -25.861939990738
            ],
            [
              30.8230599983203,
              -25.8765199975997
            ],
            [
              30.8498600003388,
              -25.9263400035883
            ],
            [
              30.9680999968175,
              -25.9347600042707
            ],
            [
              31.0395199988489,
              -25.8662600028967
            ],
            [
              31.0556909972417,
              -25.9239209981555
            ],
            [
              31.1265700031033,
              -25.9211499971747
            ],
            [
              31.2635699968579,
              -25.8096300030221
            ],
            [
              31.3159399981325,
              -25.7430400006954
            ]
          ]
        ]
      },
      "properties": {
        "Name": "City of Mbombela Local Municipality",
        "Code": "MP326",
        "Parent_cod": "DC32",
        "Area": 715158
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              18.1248050016496,
              -32.7777849998778
            ],
            [
              18.1717100018152,
              -32.8510900016022
            ],
            [
              18.164149999423,
              -32.8883100021049
            ],
            [
              18.2327700018342,
              -32.896789999259
            ],
            [
              18.2403699979771,
              -32.9323100023047
            ],
            [
              18.2926000008893,
              -32.9619900040354
            ],
            [
              18.3400799969943,
              -32.9464699978921
            ],
            [
              18.5113440033231,
              -32.9460459882317
            ],
            [
              18.5960000005996,
              -32.9007200087214
            ],
            [
              18.6779099971486,
              -32.9229300077136
            ],
            [
              18.7265800022653,
              -32.9505300007589
            ],
            [
              18.8078000029678,
              -33.0300200017216
            ],
            [
              18.844649998099,
              -33.1173200013169
            ],
            [
              18.9105700010048,
              -33.1576500004471
            ],
            [
              18.9390050001806,
              -33.1963899981998
            ],
            [
              18.9801000004148,
              -33.1521100003762
            ],
            [
              19.0724199967855,
              -33.1276599979106
            ],
            [
              19.1729900003882,
              -33.0919200018066
            ],
            [
              19.153710000716,
              -32.9840399992466
            ],
            [
              19.1861499921285,
              -32.8681600000839
            ],
            [
              19.1844299991452,
              -32.827070001879
            ],
            [
              19.1505299988604,
              -32.8721199974399
            ],
            [
              19.098609996754,
              -32.87911999739
            ],
            [
              19.0356699999706,
              -32.8488700017491
            ],
            [
              19.007160002732,
              -32.7161899958716
            ],
            [
              18.9309699983668,
              -32.606790003256
            ],
            [
              18.8489399998811,
              -32.5217899973104
            ],
            [
              18.7865899997288,
              -32.5204400007054
            ],
            [
              18.7914399886646,
              -32.5594399996562
            ],
            [
              18.7249000021334,
              -32.5664899992141
            ],
            [
              18.6427199976299,
              -32.456019998624
            ],
            [
              18.5912699992111,
              -32.4648399988668
            ],
            [
              18.4928000007195,
              -32.4383399989917
            ],
            [
              18.4585199981994,
              -32.4764300018431
            ],
            [
              18.3988299984057,
              -32.4255100026844
            ],
            [
              18.3344899982149,
              -32.4429499993429
            ],
            [
              18.3203199958711,
              -32.5477800087404
            ],
            [
              18.2794300023928,
              -32.6332299976662
            ],
            [
              18.1614999977268,
              -32.7586799965845
            ],
            [
              18.1248050016496,
              -32.7777849998778
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Bergrivier Local Municipality",
        "Code": "WC013",
        "Parent_cod": "DC1",
        "Area": 440704
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              22.2529200039551,
              -29.1752100043381
            ],
            [
              22.2574999966276,
              -29.1247100038636
            ],
            [
              22.2041799938117,
              -29.0818400018146
            ],
            [
              22.2120699970328,
              -29.0498999983862
            ],
            [
              22.1669500000425,
              -29.0156899999935
            ],
            [
              22.1799799983783,
              -28.9746499995978
            ],
            [
              22.1425599949478,
              -28.9145500069772
            ],
            [
              22.0418700010997,
              -28.8399100021448
            ],
            [
              22.1233299939841,
              -28.763200002578
            ],
            [
              22.0988599995894,
              -28.709750012653
            ],
            [
              22.045949996795,
              -28.6816500064426
            ],
            [
              21.9266299936794,
              -28.5205199997981
            ],
            [
              21.9007099998666,
              -28.4252100004411
            ],
            [
              21.8376099939061,
              -28.3827399979525
            ],
            [
              21.7869999991507,
              -28.5050899969058
            ],
            [
              21.738519994702,
              -28.4752500012865
            ],
            [
              21.7015599980955,
              -28.5124700026884
            ],
            [
              21.6534399958592,
              -28.5058699987014
            ],
            [
              21.6099870002,
              -28.5510450018253
            ],
            [
              21.531649999348,
              -28.5634300009937
            ],
            [
              21.3417999938747,
              -28.631930000569
            ],
            [
              21.2604600047255,
              -28.7114800033994
            ],
            [
              21.1960000025981,
              -28.7584400007054
            ],
            [
              21.1257699969878,
              -28.8316000074343
            ],
            [
              21.1398049967033,
              -28.8631399942153
            ],
            [
              21.2510499961604,
              -28.9309449968141
            ],
            [
              21.2113219177723,
              -29.0089084867373
            ],
            [
              21.3085712520617,
              -29.0674364976962
            ],
            [
              21.3016642411119,
              -29.1546669913886
            ],
            [
              21.1824122573199,
              -29.2585730930737
            ],
            [
              21.2250769819173,
              -29.2882293257227
            ],
            [
              21.2741700011447,
              -29.3579800070716
            ],
            [
              21.2495548957419,
              -29.4041679633808
            ],
            [
              21.2786304928031,
              -29.5114892009658
            ],
            [
              21.2262001038518,
              -29.523880005258
            ],
            [
              21.1953999938147,
              -29.63724999659
            ],
            [
              21.2755999951437,
              -29.6871599950377
            ],
            [
              21.272040002744,
              -29.7362799993224
            ],
            [
              21.1541300016982,
              -29.8726200004126
            ],
            [
              21.3052600058447,
              -29.9804099952251
            ],
            [
              21.2429800008264,
              -30.0390899943078
            ],
            [
              21.3713400017397,
              -30.017459995982
            ],
            [
              21.4256699989713,
              -29.9863799989378
            ],
            [
              21.507410004768,
              -30.0313000028927
            ],
            [
              21.5752799968745,
              -30.0444099986225
            ],
            [
              21.592180000107,
              -30.011559997296
            ],
            [
              21.6947499943169,
              -29.9954399967584
            ],
            [
              21.8326699990213,
              -30.0278699976023
            ],
            [
              21.9145599991447,
              -29.9911100021249
            ],
            [
              21.9383549938879,
              -30.0242800002218
            ],
            [
              22.0142100007909,
              -30.0057800023452
            ],
            [
              21.9943599991147,
              -29.9538100033289
            ],
            [
              22.0103500053486,
              -29.9024400050022
            ],
            [
              21.8114199939377,
              -29.8419600029518
            ],
            [
              21.7216100000016,
              -29.7748200067379
            ],
            [
              21.7789200042548,
              -29.6659600129442
            ],
            [
              21.8299699977173,
              -29.6231900056142
            ],
            [
              21.7849300062149,
              -29.5566099965541
            ],
            [
              21.8998199938976,
              -29.4491300061449
            ],
            [
              21.8456699977723,
              -29.3958899989242
            ],
            [
              21.9109800004268,
              -29.353850004574
            ],
            [
              21.9793099975584,
              -29.2777599994244
            ],
            [
              21.8990499997577,
              -29.1648700068453
            ],
            [
              21.8381081499713,
              -29.0973641799129
            ],
            [
              21.9586199958162,
              -29.0157099991171
            ],
            [
              21.9909600006036,
              -28.9460700027284
            ],
            [
              22.0863100000065,
              -28.9506200048093
            ],
            [
              22.1169999952536,
              -29.0120500030052
            ],
            [
              22.1812499975893,
              -29.0624099997216
            ],
            [
              22.2349533463199,
              -29.1694657412509
            ],
            [
              22.2529200039551,
              -29.1752100043381
            ]
          ]
        ]
      },
      "properties": {
        "Name": "!Kheis Local Municipality",
        "Code": "NC084",
        "Parent_cod": "DC8",
        "Area": 1110236
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              31.0252300026626,
              -25.0300999944192
            ],
            [
              31.0606999989058,
              -24.9954000031076
            ],
            [
              31.1405311819685,
              -24.9818864231199
            ],
            [
              31.1405847186099,
              -24.9819340116453
            ],
            [
              31.1531080946629,
              -25.0224063212946
            ],
            [
              31.2493000033925,
              -25.0183601383097
            ],
            [
              31.2672899966361,
              -24.9796200020614
            ],
            [
              31.3717600002239,
              -24.9669500023407
            ],
            [
              31.3745098113788,
              -24.9658203126573
            ],
            [
              31.3749554020702,
              -24.9658003423119
            ],
            [
              31.4147933749144,
              -24.9698419387544
            ],
            [
              31.414890288556,
              -24.9698600771808
            ],
            [
              31.4165484027866,
              -24.9703832559824
            ],
            [
              31.4172096248244,
              -24.9707603444144
            ],
            [
              31.4275206056915,
              -24.9814908212443
            ],
            [
              31.427959441575,
              -24.9818801881202
            ],
            [
              31.4350410532021,
              -24.9855409369646
            ],
            [
              31.4358100886647,
              -24.9860305791478
            ],
            [
              31.4437999732902,
              -24.9873504637528
            ],
            [
              31.4444961106071,
              -24.9870384026002
            ],
            [
              31.467354859839,
              -24.986797630706
            ],
            [
              31.4674203331819,
              -24.9868201371396
            ],
            [
              31.4674958987168,
              -24.9868531980166
            ],
            [
              31.4685401923761,
              -24.9873104097476
            ],
            [
              31.4842347893042,
              -24.9773421560157
            ],
            [
              31.5642485005678,
              -24.9604220331503
            ],
            [
              31.6108938961365,
              -24.9892469396945
            ],
            [
              31.7169090024486,
              -24.9542999990457
            ],
            [
              31.7698549889167,
              -24.9965679967156
            ],
            [
              31.8231600009333,
              -25.0619079998543
            ],
            [
              31.9420040000846,
              -25.12476399816
            ],
            [
              31.9589450106038,
              -25.1647860001737
            ],
            [
              32.0319799971792,
              -25.1830950000342
            ],
            [
              32.0301700036428,
              -25.065690000693
            ],
            [
              32.0154799998022,
              -24.9251200032855
            ],
            [
              31.9982700029584,
              -24.6897400016996
            ],
            [
              32.0130999979666,
              -24.4545899999285
            ],
            [
              31.9871299982509,
              -24.3021999997302
            ],
            [
              31.9080100026595,
              -24.182429999245
            ],
            [
              31.8838346630393,
              -23.984594453771
            ],
            [
              31.7674799981034,
              -23.984619999913
            ],
            [
              31.7358100026296,
              -24.0460800003916
            ],
            [
              31.6837199998781,
              -24.0595300037066
            ],
            [
              31.6659800019756,
              -24.016699999905
            ],
            [
              31.6208899991742,
              -24.0232500015863
            ],
            [
              31.5946999992056,
              -24.0563699982768
            ],
            [
              31.5425599968464,
              -24.0539900036357
            ],
            [
              31.440939998782,
              -24.0209800030247
            ],
            [
              31.4280499979091,
              -24.0545000001748
            ],
            [
              31.2522800032196,
              -24.0977300026375
            ],
            [
              31.2347000010043,
              -24.0575699969577
            ],
            [
              31.1942500080315,
              -24.0311499989732
            ],
            [
              31.133779997449,
              -24.0736999970572
            ],
            [
              31.0634300015934,
              -24.09145999858
            ],
            [
              31.120569998007,
              -24.090259999899
            ],
            [
              31.1072699989114,
              -24.1457300011386
            ],
            [
              31.0499399982324,
              -24.1873199972201
            ],
            [
              31.0560200043198,
              -24.321889996726
            ],
            [
              31.1525200063932,
              -24.3186699948243
            ],
            [
              31.2000599989698,
              -24.3049499916488
            ],
            [
              31.2420299981859,
              -24.3654300008938
            ],
            [
              31.1599699974175,
              -24.3755700017541
            ],
            [
              31.1599500000925,
              -24.4374099981729
            ],
            [
              31.2032400008254,
              -24.4264599914354
            ],
            [
              31.2536600021074,
              -24.4991200011871
            ],
            [
              31.2261800109987,
              -24.5560100022598
            ],
            [
              30.9593199984192,
              -24.58207000073
            ],
            [
              30.9543300111212,
              -24.5212799996722
            ],
            [
              30.8717099989173,
              -24.5385000032725
            ],
            [
              30.7950400011951,
              -24.5774900035608
            ],
            [
              30.8988800063073,
              -24.6303300076237
            ],
            [
              30.9132100034389,
              -24.6728500034249
            ],
            [
              30.8899299982709,
              -24.7087500024106
            ],
            [
              30.919410003369,
              -24.8051599958371
            ],
            [
              31.0054200028309,
              -24.8370199955763
            ],
            [
              31.0268099972836,
              -24.914109999177
            ],
            [
              31.0252300026626,
              -25.0300999944192
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Bushbuckridge Local Municipality",
        "Code": "MP325",
        "Parent_cod": "DC32",
        "Area": 1024821
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              19.1844299991452,
              -32.827070001879
            ],
            [
              19.1717699962884,
              -32.7368200002428
            ],
            [
              19.204800001419,
              -32.7111399878202
            ],
            [
              19.1429900000885,
              -32.6214399980574
            ],
            [
              19.1591699988964,
              -32.5719300009688
            ],
            [
              19.264700002803,
              -32.5887200018266
            ],
            [
              19.320050002106,
              -32.5746400000359
            ],
            [
              19.3569300004193,
              -32.616360003911
            ],
            [
              19.4190199975748,
              -32.622319999968
            ],
            [
              19.4755900009778,
              -32.5969200013569
            ],
            [
              19.4868050028486,
              -32.5654399957592
            ],
            [
              19.4963700032731,
              -32.4748199977447
            ],
            [
              19.4302000041269,
              -32.3657099987174
            ],
            [
              19.4090800023403,
              -32.2900799976937
            ],
            [
              19.4914999999251,
              -32.2523700060708
            ],
            [
              19.5013899982498,
              -32.179869999201
            ],
            [
              19.4752200045996,
              -32.1462899875928
            ],
            [
              19.5151900051146,
              -32.11519999998
            ],
            [
              19.3958499956808,
              -32.015110003224
            ],
            [
              19.3629699956688,
              -32.0428400022642
            ],
            [
              19.3233499969048,
              -31.9848000012191
            ],
            [
              19.2648400011651,
              -31.9657399937057
            ],
            [
              19.2896799964347,
              -31.8630399979975
            ],
            [
              19.2107099996668,
              -31.9480399967484
            ],
            [
              19.1996799991327,
              -31.9047700023336
            ],
            [
              19.1424500021659,
              -31.9120800021903
            ],
            [
              19.0262200012521,
              -31.8766399992366
            ],
            [
              18.981950002091,
              -31.855700003952
            ],
            [
              18.8755100029843,
              -31.8524199956862
            ],
            [
              18.7409000007345,
              -31.8788900022717
            ],
            [
              18.622859999989,
              -31.9563400026889
            ],
            [
              18.5612399966286,
              -31.8788599990897
            ],
            [
              18.4945099959396,
              -31.8681100042733
            ],
            [
              18.4515999992406,
              -31.8438199965955
            ],
            [
              18.3956899965961,
              -31.873970002014
            ],
            [
              18.4119200031057,
              -31.9455899997786
            ],
            [
              18.2902669967246,
              -32.006652999936
            ],
            [
              18.3139299979711,
              -32.0835700009548
            ],
            [
              18.3103100037038,
              -32.17262000391
            ],
            [
              18.3422200021514,
              -32.2656999993554
            ],
            [
              18.3142300001145,
              -32.3165200001978
            ],
            [
              18.3344899982149,
              -32.4429499993429
            ],
            [
              18.3988299984057,
              -32.4255100026844
            ],
            [
              18.4585199981994,
              -32.4764300018431
            ],
            [
              18.4928000007195,
              -32.4383399989917
            ],
            [
              18.5912699992111,
              -32.4648399988668
            ],
            [
              18.6427199976299,
              -32.456019998624
            ],
            [
              18.7249000021334,
              -32.5664899992141
            ],
            [
              18.7914399886646,
              -32.5594399996562
            ],
            [
              18.7865899997288,
              -32.5204400007054
            ],
            [
              18.8489399998811,
              -32.5217899973104
            ],
            [
              18.9309699983668,
              -32.606790003256
            ],
            [
              19.007160002732,
              -32.7161899958716
            ],
            [
              19.0356699999706,
              -32.8488700017491
            ],
            [
              19.098609996754,
              -32.87911999739
            ],
            [
              19.1505299988604,
              -32.8721199974399
            ],
            [
              19.1844299991452,
              -32.827070001879
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Cederberg Local Municipality",
        "Code": "WC012",
        "Parent_cod": "DC1",
        "Area": 800748
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              24.5671900009178,
              -31.4186400008354
            ],
            [
              24.6649900008879,
              -31.3836600101014
            ],
            [
              24.7048100025796,
              -31.4005900021269
            ],
            [
              24.7886799977837,
              -31.3894600032765
            ],
            [
              24.852990004685,
              -31.328209989999
            ],
            [
              24.9419700053115,
              -31.3150699991811
            ],
            [
              25.0056199997632,
              -31.2630999992655
            ],
            [
              25.0584700042873,
              -31.2693800001868
            ],
            [
              25.130679998683,
              -31.2393999981114
            ],
            [
              25.1704799976538,
              -31.2391799987579
            ],
            [
              25.2250400027939,
              -31.1952000003797
            ],
            [
              25.3544199967854,
              -31.2359999942044
            ],
            [
              25.3862100013905,
              -31.217840003913
            ],
            [
              25.3845600008434,
              -31.1509700012645
            ],
            [
              25.4463899985996,
              -31.1002000018286
            ],
            [
              25.4867500009118,
              -31.0369100041934
            ],
            [
              25.4750199995733,
              -30.9838800003617
            ],
            [
              25.5109499981439,
              -30.9557200003777
            ],
            [
              25.5175900003782,
              -30.9033899982498
            ],
            [
              25.471289999334,
              -30.8698400006155
            ],
            [
              25.5216299978262,
              -30.8331800007564
            ],
            [
              25.5248500024257,
              -30.7963999989608
            ],
            [
              25.4802000019286,
              -30.7789099999964
            ],
            [
              25.4564800043487,
              -30.6370000037471
            ],
            [
              25.4670999967675,
              -30.6242100110831
            ],
            [
              25.3765800015658,
              -30.5598899974254
            ],
            [
              25.3071199990887,
              -30.5770799978435
            ],
            [
              25.2371099991272,
              -30.5012299929698
            ],
            [
              25.2099599890623,
              -30.5050900028014
            ],
            [
              25.1519099974484,
              -30.4572999968973
            ],
            [
              25.0937199966805,
              -30.3714599971811
            ],
            [
              25.0356199991636,
              -30.3442099977932
            ],
            [
              25.0349800047234,
              -30.2868700092435
            ],
            [
              24.9863199946721,
              -30.289969996618
            ],
            [
              24.9501690056951,
              -30.2248450033942
            ],
            [
              24.8791719449294,
              -30.2710912285772
            ],
            [
              24.8429470163917,
              -30.3660674661406
            ],
            [
              24.755996771234,
              -30.4596016668834
            ],
            [
              24.6795799956204,
              -30.6259599955573
            ],
            [
              24.6458102639326,
              -30.7541581904481
            ],
            [
              24.6673530442077,
              -30.7669748588027
            ],
            [
              24.6303467478042,
              -30.8362158736636
            ],
            [
              24.6812699962135,
              -30.8514899979651
            ],
            [
              24.7038099987325,
              -30.8284999962777
            ],
            [
              24.757820000093,
              -30.8705499982838
            ],
            [
              24.8026200012121,
              -30.9724099957247
            ],
            [
              24.8472699999106,
              -30.9918900037206
            ],
            [
              24.8223761541363,
              -31.0403940470476
            ],
            [
              24.7508600019876,
              -31.0959599969562
            ],
            [
              24.7515099932916,
              -31.1403199993684
            ],
            [
              24.6615099977882,
              -31.2878199979945
            ],
            [
              24.5639699963184,
              -31.3773700024236
            ],
            [
              24.5671900009178,
              -31.4186400008354
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Umsobomvu Local Municipality",
        "Code": "NC072",
        "Parent_cod": "DC7",
        "Area": 681343
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              31.3159399981325,
              -25.7430400006954
            ],
            [
              31.4162999992456,
              -25.7187599997741
            ],
            [
              31.8678600028369,
              -25.9996000023381
            ],
            [
              31.9736900007929,
              -25.9532000029777
            ],
            [
              31.9305499970848,
              -25.8407699974374
            ],
            [
              31.9785600023423,
              -25.693670001969
            ],
            [
              32.006098999769,
              -25.6451940004027
            ],
            [
              31.9957599996243,
              -25.5262700002603
            ],
            [
              31.9796200017617,
              -25.4570599994194
            ],
            [
              32.0146499983988,
              -25.3855600035913
            ],
            [
              32.0319799971792,
              -25.1830950000342
            ],
            [
              31.9589450106038,
              -25.1647860001737
            ],
            [
              31.9420040000846,
              -25.12476399816
            ],
            [
              31.8231600009333,
              -25.0619079998543
            ],
            [
              31.7698549889167,
              -24.9965679967156
            ],
            [
              31.7169090024486,
              -24.9542999990457
            ],
            [
              31.6108938961365,
              -24.9892469396945
            ],
            [
              31.5863800049333,
              -25.0251293182634
            ],
            [
              31.6228199011176,
              -25.1873798370098
            ],
            [
              31.6270294189725,
              -25.2729206088989
            ],
            [
              31.5813198093618,
              -25.3439693447094
            ],
            [
              31.5368299988055,
              -25.4640800038891
            ],
            [
              31.4826793668594,
              -25.4966297152891
            ],
            [
              31.3354500039146,
              -25.5225599982453
            ],
            [
              31.2758499956808,
              -25.5602400028738
            ],
            [
              31.3307799989978,
              -25.6089800040239
            ],
            [
              31.3032699984117,
              -25.663850001876
            ],
            [
              31.2620800018907,
              -25.6923199981693
            ],
            [
              31.3159399981325,
              -25.7430400006954
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Nkomazi Local Municipality",
        "Code": "MP324",
        "Parent_cod": "DC32",
        "Area": 478532
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              18.2902669967246,
              -32.006652999936
            ],
            [
              18.4119200031057,
              -31.9455899997786
            ],
            [
              18.3956899965961,
              -31.873970002014
            ],
            [
              18.4515999992406,
              -31.8438199965955
            ],
            [
              18.4945099959396,
              -31.8681100042733
            ],
            [
              18.5612399966286,
              -31.8788599990897
            ],
            [
              18.622859999989,
              -31.9563400026889
            ],
            [
              18.7409000007345,
              -31.8788900022717
            ],
            [
              18.8755100029843,
              -31.8524199956862
            ],
            [
              18.981950002091,
              -31.855700003952
            ],
            [
              19.0262200012521,
              -31.8766399992366
            ],
            [
              19.0304599971313,
              -31.8336199992635
            ],
            [
              19.0862700023587,
              -31.7944800001518
            ],
            [
              19.0946599962619,
              -31.7502100009907
            ],
            [
              19.0655600032916,
              -31.7063099991072
            ],
            [
              19.0705099977383,
              -31.6240500026055
            ],
            [
              19.090520001397,
              -31.5977799998471
            ],
            [
              19.085420002731,
              -31.5269300007189
            ],
            [
              19.0196800009314,
              -31.4992500039845
            ],
            [
              19.042989999389,
              -31.4249699995658
            ],
            [
              19.0308799994125,
              -31.3895399943751
            ],
            [
              18.9801300017982,
              -31.3552399900335
            ],
            [
              19.0130100018102,
              -31.3056800032295
            ],
            [
              18.9664199972851,
              -31.2844900027114
            ],
            [
              18.944460002627,
              -31.2373199984191
            ],
            [
              18.9476000044367,
              -31.1129100042932
            ],
            [
              18.9034700018391,
              -31.0417799949508
            ],
            [
              18.9117700095783,
              -30.9789299969218
            ],
            [
              18.9844900023118,
              -30.9458100029293
            ],
            [
              18.8753900091416,
              -30.8870599997191
            ],
            [
              18.9604699998906,
              -30.8661100003762
            ],
            [
              18.9514799990028,
              -30.744439998607
            ],
            [
              18.8629703519003,
              -30.7171192171781
            ],
            [
              18.7945003510104,
              -30.6676197052851
            ],
            [
              18.7958699978022,
              -30.6248600041858
            ],
            [
              18.7587108607177,
              -30.5678691864138
            ],
            [
              18.6551495411184,
              -30.5567092985952
            ],
            [
              18.5701200032356,
              -30.4302599982004
            ],
            [
              18.5021500011217,
              -30.4444200018816
            ],
            [
              18.4836199946671,
              -30.5219099951501
            ],
            [
              18.4137599989249,
              -30.5273499996027
            ],
            [
              18.3711500025706,
              -30.5920900002533
            ],
            [
              18.3710399992965,
              -30.6596299969268
            ],
            [
              18.2641699992461,
              -30.8183199935728
            ],
            [
              18.2135399999711,
              -30.8104399917122
            ],
            [
              18.1691800038541,
              -30.848559998645
            ],
            [
              18.089179997359,
              -30.7878699959035
            ],
            [
              18.0064790030036,
              -30.7912399957292
            ],
            [
              17.9948399986671,
              -30.8192200000029
            ],
            [
              17.9933799987879,
              -30.9187400037482
            ],
            [
              17.8802999983463,
              -30.9239399989318
            ],
            [
              17.8779200019066,
              -30.9486500007969
            ],
            [
              17.9264099987225,
              -31.0113900027465
            ],
            [
              17.8113200009173,
              -31.0925400002207
            ],
            [
              17.834419998684,
              -31.1765199995983
            ],
            [
              17.7575800030148,
              -31.1519699997157
            ],
            [
              17.8773199994185,
              -31.2787700024336
            ],
            [
              17.9004400008054,
              -31.3520600025671
            ],
            [
              18.0978299960575,
              -31.5593799979885
            ],
            [
              18.1154999979267,
              -31.5977599962268
            ],
            [
              18.2227899957618,
              -31.7443200009672
            ],
            [
              18.2335899982798,
              -31.8207100091596
            ],
            [
              18.280079997294,
              -31.8981700010447
            ],
            [
              18.2654599885877,
              -31.9340399968484
            ],
            [
              18.2902669967246,
              -32.006652999936
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Matzikama Local Municipality",
        "Code": "WC011",
        "Parent_cod": "DC1",
        "Area": 1298145
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              24.5671900009178,
              -31.4186400008354
            ],
            [
              24.4787800013959,
              -31.431749996565
            ],
            [
              24.4457399994015,
              -31.4786399978376
            ],
            [
              24.4009499978442,
              -31.4435999917461
            ],
            [
              24.3875299977112,
              -31.3868000020184
            ],
            [
              24.3213699972276,
              -31.3636499983487
            ],
            [
              24.3225800071617,
              -31.3177399991017
            ],
            [
              24.2656299979261,
              -31.3240399982472
            ],
            [
              24.2372320112484,
              -31.2737330003776
            ],
            [
              24.2348900039706,
              -31.2179999996002
            ],
            [
              24.1522999976468,
              -31.1803500062478
            ],
            [
              24.1705600051402,
              -31.1534800010012
            ],
            [
              24.1235000023232,
              -31.1053300000794
            ],
            [
              24.1367876420361,
              -31.0428608784268
            ],
            [
              24.0547721837893,
              -30.977753198951
            ],
            [
              23.9506285064005,
              -30.9716802633335
            ],
            [
              23.9876422977539,
              -30.9109126149251
            ],
            [
              23.8604299936494,
              -30.8649400048773
            ],
            [
              23.8140233599902,
              -30.9068508071189
            ],
            [
              23.7616929792477,
              -30.9054291597278
            ],
            [
              23.7033201112342,
              -30.9419734905841
            ],
            [
              23.6582986196856,
              -30.8969092884329
            ],
            [
              23.5992743439358,
              -30.9428786582234
            ],
            [
              23.5894071200426,
              -31.0030314338536
            ],
            [
              23.5567496401838,
              -31.0075753718059
            ],
            [
              23.5134849958359,
              -30.950600005286
            ],
            [
              23.4017299917458,
              -31.0340999996153
            ],
            [
              23.3255100003863,
              -30.9539899961414
            ],
            [
              23.2253000025931,
              -30.9537299976412
            ],
            [
              23.164820001442,
              -30.8625999976916
            ],
            [
              23.1093700056213,
              -30.8282099990922
            ],
            [
              23.0561900056643,
              -30.8822699991612
            ],
            [
              22.896850003325,
              -30.8563299972316
            ],
            [
              22.8966099958547,
              -30.8797499989632
            ],
            [
              22.781910000746,
              -30.9476200072576
            ],
            [
              22.6901400018597,
              -30.9754999979265
            ],
            [
              22.6647400041479,
              -30.9543399978925
            ],
            [
              22.4624099807361,
              -31.0068408361356
            ],
            [
              22.501217946551,
              -31.0583368267831
            ],
            [
              22.4976299942288,
              -31.095800003967
            ],
            [
              22.4435199972501,
              -31.1309500052385
            ],
            [
              22.3184900042104,
              -31.1429399951845
            ],
            [
              22.2665499957857,
              -31.1658300093474
            ],
            [
              22.2145099908435,
              -31.2162600029967
            ],
            [
              22.1874799917083,
              -31.1688999962378
            ],
            [
              22.0770400023943,
              -31.1342699982618
            ],
            [
              22.0822099961944,
              -31.0514999989257
            ],
            [
              22.0032100052376,
              -31.0123700056712
            ],
            [
              21.949669994075,
              -31.0128700026485
            ],
            [
              21.9182599944033,
              -31.0435199996482
            ],
            [
              21.8459500043893,
              -31.0640899985546
            ],
            [
              21.7001099977782,
              -31.0635100050826
            ],
            [
              21.670689992749,
              -31.0975999907469
            ],
            [
              21.7022149968247,
              -31.1647550020417
            ],
            [
              21.6218599937438,
              -31.1513599940684
            ],
            [
              21.6147550024415,
              -31.2499009976329
            ],
            [
              21.7624000032576,
              -31.2714000007094
            ],
            [
              21.822829999405,
              -31.3535100010856
            ],
            [
              21.8144900051097,
              -31.3977699988863
            ],
            [
              21.8801600009833,
              -31.3995200040449
            ],
            [
              21.9327800065921,
              -31.4342399980775
            ],
            [
              21.8498799967645,
              -31.4564399984071
            ],
            [
              21.8654799940066,
              -31.4973200049143
            ],
            [
              21.9198899958266,
              -31.4911599996343
            ],
            [
              21.9619499973945,
              -31.5122000040269
            ],
            [
              22.0116599956124,
              -31.5904499999674
            ],
            [
              21.9497100013155,
              -31.6009799972291
            ],
            [
              21.9155150027153,
              -31.6457150007467
            ],
            [
              21.9440600006686,
              -31.6822399979775
            ],
            [
              22.0495800023153,
              -31.7699799989777
            ],
            [
              22.116139996064,
              -31.7584200000828
            ],
            [
              22.1797300003393,
              -31.7816900002932
            ],
            [
              22.2040100003613,
              -31.7640300015833
            ],
            [
              22.2601000023133,
              -31.6624700008898
            ],
            [
              22.2729199999581,
              -31.5925400010202
            ],
            [
              22.3122900015823,
              -31.5834600022773
            ],
            [
              22.4957600006236,
              -31.6703399959939
            ],
            [
              22.56481498982,
              -31.6779199948119
            ],
            [
              22.566139996064,
              -31.7131699997955
            ],
            [
              22.619070003378,
              -31.7246500012965
            ],
            [
              22.5783400010902,
              -31.805510000686
            ],
            [
              22.6515299966121,
              -31.8216700021688
            ],
            [
              22.7351000049613,
              -31.79937999589
            ],
            [
              22.7768799999121,
              -31.8569100003962
            ],
            [
              22.858970002064,
              -31.8182900000834
            ],
            [
              22.9019500010917,
              -31.8757699977871
            ],
            [
              22.9758300023528,
              -31.8608299986055
            ],
            [
              23.0673899996488,
              -31.8907399956543
            ],
            [
              23.0525899988294,
              -31.9397800007464
            ],
            [
              23.0876199990637,
              -31.9722900007829
            ],
            [
              23.1394499952211,
              -31.9515399989717
            ],
            [
              23.2303699989763,
              -31.8756900030911
            ],
            [
              23.2623599966167,
              -31.8153900012475
            ],
            [
              23.2634400041529,
              -31.7783400013899
            ],
            [
              23.3024200003828,
              -31.7301499986235
            ],
            [
              23.3451100112181,
              -31.7108899980749
            ],
            [
              23.4070899979051,
              -31.7138000000699
            ],
            [
              23.4231400051072,
              -31.6821400023592
            ],
            [
              23.496109996779,
              -31.7026899994438
            ],
            [
              23.5745299996599,
              -31.6891699973974
            ],
            [
              23.6394800019006,
              -31.6600999959181
            ],
            [
              23.7151300002494,
              -31.6470400042927
            ],
            [
              23.7564899956169,
              -31.6957100022148
            ],
            [
              23.8476200018616,
              -31.7292199971051
            ],
            [
              23.8085200018966,
              -31.7636599980104
            ],
            [
              23.8786300019731,
              -31.8336800047284
            ],
            [
              23.9158699971027,
              -31.8219999976018
            ],
            [
              23.9486599992596,
              -31.773330000579
            ],
            [
              23.963060001418,
              -31.7066700067154
            ],
            [
              24.0285199966006,
              -31.7301700013444
            ],
            [
              24.0709400021794,
              -31.8070899971056
            ],
            [
              24.1524599951327,
              -31.7886099983527
            ],
            [
              24.1615899961814,
              -31.7401499939271
            ],
            [
              24.2682500027355,
              -31.7666699974225
            ],
            [
              24.3140300049808,
              -31.7512999981963
            ],
            [
              24.3459900012376,
              -31.7144800053479
            ],
            [
              24.5062700001604,
              -31.7068300024026
            ],
            [
              24.522960002702,
              -31.6036899980949
            ],
            [
              24.5039100019451,
              -31.5684199993834
            ],
            [
              24.5588500012266,
              -31.4818399961188
            ],
            [
              24.5671900009178,
              -31.4186400008354
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Ubuntu Local Municipality",
        "Code": "NC071",
        "Parent_cod": "DC7",
        "Area": 2039319
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              31.0252300026626,
              -25.0300999944192
            ],
            [
              31.0268099972836,
              -24.914109999177
            ],
            [
              31.0054200028309,
              -24.8370199955763
            ],
            [
              30.919410003369,
              -24.8051599958371
            ],
            [
              30.8899299982709,
              -24.7087500024106
            ],
            [
              30.9132100034389,
              -24.6728500034249
            ],
            [
              30.8988800063073,
              -24.6303300076237
            ],
            [
              30.7950400011951,
              -24.5774900035608
            ],
            [
              30.8717099989173,
              -24.5385000032725
            ],
            [
              30.7992800033695,
              -24.4988900022718
            ],
            [
              30.7589799993276,
              -24.4602199987539
            ],
            [
              30.7301799986081,
              -24.4984999995753
            ],
            [
              30.7303199969703,
              -24.6087299962922
            ],
            [
              30.6792400030238,
              -24.6236700017692
            ],
            [
              30.7201000023133,
              -24.7052380086271
            ],
            [
              30.6785699964082,
              -24.735809996634
            ],
            [
              30.6348800042089,
              -24.8527700006349
            ],
            [
              30.5628800033095,
              -24.8964600009282
            ],
            [
              30.4515399922769,
              -24.9120000043966
            ],
            [
              30.4250700027784,
              -24.854859999889
            ],
            [
              30.3541700031432,
              -24.8492799988728
            ],
            [
              30.2972899998336,
              -24.8677400020994
            ],
            [
              30.1919799889853,
              -24.8554700091336
            ],
            [
              30.1720699989314,
              -24.9891699990961
            ],
            [
              30.1485099970388,
              -25.0323500037496
            ],
            [
              30.144389996801,
              -25.1237899991092
            ],
            [
              30.0298399969183,
              -25.0845699999055
            ],
            [
              29.978949982056,
              -25.0921199820515
            ],
            [
              30.0054099710934,
              -25.1443800313133
            ],
            [
              30.0098399712378,
              -25.2312800313483
            ],
            [
              29.9905899828415,
              -25.3382500261178
            ],
            [
              30.0254600035764,
              -25.3677200001779
            ],
            [
              30.083440000056,
              -25.2940799991926
            ],
            [
              30.1432300062599,
              -25.245810009824
            ],
            [
              30.19075000331,
              -25.2758100020299
            ],
            [
              30.1880799970942,
              -25.3203400023892
            ],
            [
              30.190850000727,
              -25.3253400036382
            ],
            [
              30.205579997419,
              -25.3568200002428
            ],
            [
              30.2517099969189,
              -25.3572870028928
            ],
            [
              30.2294599978807,
              -25.4324100012205
            ],
            [
              30.2626300022728,
              -25.4730300038316
            ],
            [
              30.3014199978347,
              -25.4449799963297
            ],
            [
              30.3509900012876,
              -25.4924799969543
            ],
            [
              30.4178000029678,
              -25.4235000022234
            ],
            [
              30.40138999805,
              -25.380839999966
            ],
            [
              30.4492399986271,
              -25.3449599983053
            ],
            [
              30.5319709970639,
              -25.3495900022768
            ],
            [
              30.5482600017977,
              -25.3131100044231
            ],
            [
              30.5889400017797,
              -25.321850001876
            ],
            [
              30.6298900088169,
              -25.2849999986509
            ],
            [
              30.7032399982274,
              -25.3615399957742
            ],
            [
              30.7456999966575,
              -25.3767399961539
            ],
            [
              30.7906799961849,
              -25.3533100020549
            ],
            [
              30.8548515173837,
              -25.3980125751202
            ],
            [
              30.9456629999475,
              -25.3576639977952
            ],
            [
              30.9009400023792,
              -25.321039995999
            ],
            [
              30.9781559992,
              -25.2901540034045
            ],
            [
              30.9172199986041,
              -25.2083099964092
            ],
            [
              30.9411200035853,
              -25.1288880039781
            ],
            [
              30.9672599967515,
              -25.121820002691
            ],
            [
              30.9841500031202,
              -25.0621000006144
            ],
            [
              31.0252300026626,
              -25.0300999944192
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Thaba Chweu Local Municipality",
        "Code": "MP321",
        "Parent_cod": "DC32",
        "Area": 571048
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              24.4449499989434,
              -34.1435899993789
            ],
            [
              24.4618343998378,
              -34.0978210740832
            ],
            [
              24.5148999997352,
              -34.1107900003582
            ],
            [
              24.5239300042664,
              -34.0404249966163
            ],
            [
              24.5705500029804,
              -34.0632400019245
            ],
            [
              24.6203799986381,
              -34.0137900013075
            ],
            [
              24.5346499959007,
              -33.9839700012146
            ],
            [
              24.4945799988679,
              -33.9510099993119
            ],
            [
              24.5177000002548,
              -33.8876300020229
            ],
            [
              24.5773099990572,
              -33.8985499992829
            ],
            [
              24.6325199990987,
              -33.8744099967239
            ],
            [
              24.6618349992858,
              -33.8073099987573
            ],
            [
              24.4996208320358,
              -33.7784549262538
            ],
            [
              24.29097999603,
              -33.7119000001848
            ],
            [
              24.2629199979596,
              -33.7443150003369
            ],
            [
              24.1876899955969,
              -33.7647600006735
            ],
            [
              24.0571600016329,
              -33.7259400010302
            ],
            [
              24.0607400030488,
              -33.6983899985995
            ],
            [
              23.9620399993466,
              -33.6704899962163
            ],
            [
              23.8428099958847,
              -33.6504499983687
            ],
            [
              23.760490002012,
              -33.6093200001178
            ],
            [
              23.7222900030813,
              -33.6174899973655
            ],
            [
              23.616870003348,
              -33.5702399992766
            ],
            [
              23.6749800004267,
              -33.6258700123911
            ],
            [
              23.6704400042029,
              -33.6725599981453
            ],
            [
              23.5555299976113,
              -33.6729599977057
            ],
            [
              23.5412700037078,
              -33.6995400003707
            ],
            [
              23.4399400019295,
              -33.717390000648
            ],
            [
              23.4300700000305,
              -33.7617599981254
            ],
            [
              23.3950399961989,
              -33.7926399994364
            ],
            [
              23.4680499987085,
              -33.8074800003017
            ],
            [
              23.5179200043048,
              -33.7856200030607
            ],
            [
              23.5619499977942,
              -33.8289399979825
            ],
            [
              23.703299998796,
              -33.8640600005686
            ],
            [
              23.6552299979661,
              -33.8873899972505
            ],
            [
              23.6345899958317,
              -33.9520500041043
            ],
            [
              23.6470199997732,
              -33.9805600004436
            ],
            [
              23.6529400029788,
              -33.9896000000399
            ],
            [
              23.846519998799,
              -34.0270900004032
            ],
            [
              23.9033299979811,
              -34.0291200022862
            ],
            [
              24.1936099988024,
              -34.0660300019829
            ],
            [
              24.3239200006076,
              -34.1033800030846
            ],
            [
              24.3819499975944,
              -34.1030800009412
            ],
            [
              24.4449499989434,
              -34.1435899993789
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Kou-Kamma Local Municipality",
        "Code": "EC109",
        "Parent_cod": "DC10",
        "Area": 364181,
        "detail": "KouKamma Local Municipality spans 3,575 km² and features diverse geography, including a rugged coastline, coastal plains, and mountain ranges such as the Kouga and Tsitsikamma. Its western boundary is marked by the Bloukrans River, which separates it from the Western Cape. Known for its scenic landscapes and low population density, the municipality has no large towns, only small villages and hamlets spread across 6 electoral wards and governed by a 12-member council.\nThe coastal region, Tsitsikamma, is notable for dairy farming, forestry, and tourism, including attractions like the Storms River Mouth in the Garden Route National Park. Inland lies the Langkloof Valley, a fertile region for deciduous fruit farming, separated from the coast by the Tsitsikamma Mountains and bordered to the north by the Kouga Mountains.",
        "link_to_webpage": "https://www.koukammamunicipality.gov.za/",
        "image": "https://corruptionwatch-my.sharepoint.com/:i:/g/personal/nontobekog_corruptionwatch_org_za/ERU5zvC65ldNoz6_sd7SNIMBnc-NImjMz8ic3P9MeVZKnw?e=S2YxON",
        "image_alt": ""
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              24.4449499989434,
              -34.1435899993789
            ],
            [
              24.4753800091801,
              -34.1619200020065
            ],
            [
              24.5990600002189,
              -34.1879300017682
            ],
            [
              24.6589500029403,
              -34.1749100011955
            ],
            [
              24.8272799971742,
              -34.2111500023707
            ],
            [
              24.8429400016798,
              -34.1415800020155
            ],
            [
              24.9215400038681,
              -34.0788400009652
            ],
            [
              24.9288549985593,
              -34.043300998842
            ],
            [
              24.9280600032666,
              -34.0154999974269
            ],
            [
              24.9751499966751,
              -33.985120001187
            ],
            [
              25.0778499995779,
              -33.9647499989132
            ],
            [
              25.2214900027615,
              -33.9707700004351
            ],
            [
              25.2008199992436,
              -33.8992099991421
            ],
            [
              25.2350299913411,
              -33.8369000008343
            ],
            [
              25.0814200032307,
              -33.7866800033794
            ],
            [
              24.9755299998097,
              -33.7164900032111
            ],
            [
              24.8294600032766,
              -33.6425699974074
            ],
            [
              24.7307400013501,
              -33.6203800020354
            ],
            [
              24.5984400004058,
              -33.6571699997956
            ],
            [
              24.5353199998182,
              -33.6628599995893
            ],
            [
              24.5366999996053,
              -33.7264999998751
            ],
            [
              24.4996208320358,
              -33.7784549262538
            ],
            [
              24.6618349992858,
              -33.8073099987573
            ],
            [
              24.6325199990987,
              -33.8744099967239
            ],
            [
              24.5773099990572,
              -33.8985499992829
            ],
            [
              24.5177000002548,
              -33.8876300020229
            ],
            [
              24.4945799988679,
              -33.9510099993119
            ],
            [
              24.5346499959007,
              -33.9839700012146
            ],
            [
              24.6203799986381,
              -34.0137900013075
            ],
            [
              24.5705500029804,
              -34.0632400019245
            ],
            [
              24.5239300042664,
              -34.0404249966163
            ],
            [
              24.5148999997352,
              -34.1107900003582
            ],
            [
              24.4618343998378,
              -34.0978210740832
            ],
            [
              24.4449499989434,
              -34.1435899993789
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Kouga Local Municipality",
        "Code": "EC108",
        "Parent_cod": "DC10",
        "Area": 267048,
        "detail": "Kouga Local Municipality (KLM) is located in the Sarah Baartman District of the Eastern Cape, west of Nelson Mandela Bay, covering 2,419 km². It comprises nine towns—Jeffreys Bay, Humansdorp, St Francis Bay, Cape St Francis, Oyster Bay, Hankey, Patensie, Loerie, and Thornhill—along with smaller settlements and agricultural areas.\nAs of the 2022 Census, Kouga has an estimated population of 107,014. Afrikaans is the most spoken language (58.4%), followed by isiXhosa (29.9%) and English (6.1%).\nTraditionally reliant on tourism and agriculture, Kouga is now emerging as a key renewable energy hub in South Africa. Several wind farms are operational, and additional renewable energy projects—such as solar and biomass—are in development.\n",
        "link_to_webpage": "https://www.kouga.gov.za/",
        "image": "https://corruptionwatch-my.sharepoint.com/:i:/g/personal/nontobekog_corruptionwatch_org_za/EQoMMuD1RTJDkAYFOUU1Y68BOOy75RMNcqYkQkgHWfG7qQ?e=iRIImI",
        "image_alt": ""
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              26.5300499983088,
              -33.7541499961254
            ],
            [
              26.4628699975524,
              -33.7565900043252
            ],
            [
              26.4615200009473,
              -33.7052000023782
            ],
            [
              26.388249998139,
              -33.7070899960065
            ],
            [
              26.3477600042208,
              -33.6898399991166
            ],
            [
              26.3807199971302,
              -33.5625600021423
            ],
            [
              26.3295309963585,
              -33.5275690010086
            ],
            [
              26.263500000025,
              -33.5202399939805
            ],
            [
              26.1097150002471,
              -33.5346800033794
            ],
            [
              26.1255500011316,
              -33.4927499970147
            ],
            [
              26.0512700039076,
              -33.4747599965765
            ],
            [
              26.0374399956593,
              -33.4236300039216
            ],
            [
              26.0631900032161,
              -33.3330999956683
            ],
            [
              25.9879399972332,
              -33.3066100034489
            ],
            [
              25.9276800044288,
              -33.3123800006365
            ],
            [
              25.7896399977877,
              -33.2845199991986
            ],
            [
              25.6977299987405,
              -33.2854300015933
            ],
            [
              25.6336400019845,
              -33.3069300011186
            ],
            [
              25.6080800013909,
              -33.2811999980814
            ],
            [
              25.5145800009663,
              -33.2738099963342
            ],
            [
              25.4507200022264,
              -33.2835300012086
            ],
            [
              25.3156799981334,
              -33.2599199997082
            ],
            [
              25.1782600002988,
              -33.2516800001319
            ],
            [
              25.131879997364,
              -33.2502000029277
            ],
            [
              25.1347700029333,
              -33.2950699982818
            ],
            [
              24.9778099970338,
              -33.2565699972076
            ],
            [
              24.9592799977737,
              -33.270609998053
            ],
            [
              24.8802900027815,
              -33.2574700018391
            ],
            [
              24.839673009302,
              -33.3515134697708
            ],
            [
              24.8418199958961,
              -33.4088000008193
            ],
            [
              24.7980399959492,
              -33.4834200020314
            ],
            [
              24.8044050025889,
              -33.5382400002757
            ],
            [
              24.7018500018761,
              -33.5145300013585
            ],
            [
              24.673050002056,
              -33.5716000017387
            ],
            [
              24.6341900005681,
              -33.5968200001428
            ],
            [
              24.7307400013501,
              -33.6203800020354
            ],
            [
              24.8294600032766,
              -33.6425699974074
            ],
            [
              24.9755299998097,
              -33.7164900032111
            ],
            [
              25.0814200032307,
              -33.7866800033794
            ],
            [
              25.2350299913411,
              -33.8369000008343
            ],
            [
              25.3016540968592,
              -33.7263116000004
            ],
            [
              25.2657664977258,
              -33.6979158697216
            ],
            [
              25.3273291513193,
              -33.7263963943781
            ],
            [
              25.3478400000161,
              -33.6709100002962
            ],
            [
              25.3080599983703,
              -33.6378500009767
            ],
            [
              25.3462999982464,
              -33.5570700088738
            ],
            [
              25.437709999417,
              -33.5530800011411
            ],
            [
              25.5580100000615,
              -33.5961600002838
            ],
            [
              25.7367900040555,
              -33.6299299990702
            ],
            [
              25.7800599993695,
              -33.692310000606
            ],
            [
              25.8498000012691,
              -33.6654100011706
            ],
            [
              25.8490099990123,
              -33.7224599979305
            ],
            [
              26.015859996042,
              -33.7053099975582
            ],
            [
              26.1883400008904,
              -33.7261899963712
            ],
            [
              26.3218800041589,
              -33.7677700009847
            ],
            [
              26.3801899969709,
              -33.75939999991
            ],
            [
              26.4683900011976,
              -33.7733799970892
            ],
            [
              26.5300499983088,
              -33.7541499961254
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Sundays River Valley Local Municipality",
        "Code": "EC106",
        "Parent_cod": "DC10",
        "Area": 599517,
        "detail": "Sundays River Valley Municipality is located in the Sarah Baartman District of the Eastern Cape, South Africa, with a population of approximately 70,000. It is a major citrus-producing region in the country and includes significant conservation areas such as the Addo Elephant National Park.\n",
        "link_to_webpage": "https://www.srvm.gov.za/",
        "image": "https://corruptionwatch-my.sharepoint.com/:i:/g/personal/nontobekog_corruptionwatch_org_za/EaOJHWpQXAxPr1tpBKL5uOUBzSaDnHlCdydKqv6zj-XJHw?e=vwaQzS",
        "image_alt": ""
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              26.5300499983088,
              -33.7541499961254
            ],
            [
              26.6259200010073,
              -33.7190800003417
            ],
            [
              26.75172999944,
              -33.6500099978631
            ],
            [
              26.8667100011657,
              -33.6263300012286
            ],
            [
              26.9363200015669,
              -33.5819999957032
            ],
            [
              27.1109699985666,
              -33.5253400007404
            ],
            [
              27.1356000003398,
              -33.49632999933
            ],
            [
              27.0790500005571,
              -33.4704700109822
            ],
            [
              27.0156700041674,
              -33.3783900040953
            ],
            [
              26.9852599975509,
              -33.3562000024282
            ],
            [
              27.0037600017228,
              -33.3020299981858
            ],
            [
              26.9689499990433,
              -33.2676600032065
            ],
            [
              26.8829899982898,
              -33.3060099991621
            ],
            [
              26.8017999998701,
              -33.2846099988523
            ],
            [
              26.7908500012266,
              -33.3132899967359
            ],
            [
              26.719749988771,
              -33.3523599989148
            ],
            [
              26.7235700030532,
              -33.3844300011436
            ],
            [
              26.6177300001395,
              -33.4250299992351
            ],
            [
              26.6543100026046,
              -33.4684099987224
            ],
            [
              26.5935214197778,
              -33.4918203480306
            ],
            [
              26.5358300022529,
              -33.5726799993824
            ],
            [
              26.5143930991623,
              -33.5536841459066
            ],
            [
              26.4154599965816,
              -33.5408100000814
            ],
            [
              26.3807199971302,
              -33.5625600021423
            ],
            [
              26.3477600042208,
              -33.6898399991166
            ],
            [
              26.388249998139,
              -33.7070899960065
            ],
            [
              26.4615200009473,
              -33.7052000023782
            ],
            [
              26.4628699975524,
              -33.7565900043252
            ],
            [
              26.5300499983088,
              -33.7541499961254
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Ndlambe Local Municipality",
        "Code": "EC105",
        "Parent_cod": "DC10",
        "Area": 183988,
        "detail": "Ndlambe Local Municipality is a Category B municipality within the Sarah Baartman District in the Eastern Cape. Bordered by Makana, Ngqushwa, Sundays River Valley, and the Atlantic Ocean, it is the smallest of the seven municipalities in the district, covering just 3% of its total area.\nLocated in the Eastern Coastal Zone, Ndlambe is known for its unspoiled coastline, well-preserved river mouths, intertidal areas, and diverse vegetation. The area has low-density coastal development and significant tourism potential.\n",
        "link_to_webpage": "https://www.ndlambe.gov.za/about-3/",
        "image": "https://corruptionwatch-my.sharepoint.com/:i:/g/personal/nontobekog_corruptionwatch_org_za/EYORYipB1BtBtg76IoyE-BEBfE7kVc1VN6jIk0sU-5V9Gw?e=3T9KO1",
        "image_alt": ""
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              26.9689499990433,
              -33.2676600032065
            ],
            [
              27.0082400005756,
              -33.2504899983147
            ],
            [
              26.9625600002439,
              -33.2023900023967
            ],
            [
              26.8781599976857,
              -33.1709099976981
            ],
            [
              26.8374600021774,
              -33.1742200001528
            ],
            [
              26.8205099984378,
              -33.1291800041538
            ],
            [
              26.8562299972167,
              -33.1149200021564
            ],
            [
              26.8255000010243,
              -33.0394700004401
            ],
            [
              26.7932900004332,
              -33.053559999994
            ],
            [
              26.7481999967325,
              -33.0309400036782
            ],
            [
              26.6905700011047,
              -33.056430001943
            ],
            [
              26.6419300063648,
              -33.0502899975852
            ],
            [
              26.6301099963793,
              -33.0043299996298
            ],
            [
              26.5361400021594,
              -32.9810000038471
            ],
            [
              26.4850000018487,
              -32.9818200002927
            ],
            [
              26.4363400043877,
              -32.9474600030767
            ],
            [
              26.3880720007223,
              -32.973388996405
            ],
            [
              26.3586300009738,
              -32.9344699957936
            ],
            [
              26.2749399978827,
              -32.9369799991277
            ],
            [
              26.1356699902779,
              -32.9601699974474
            ],
            [
              26.0961300005991,
              -32.9830900031011
            ],
            [
              26.021529996712,
              -33.081929997971
            ],
            [
              25.9625799995673,
              -33.1099699996158
            ],
            [
              25.9481899978702,
              -33.1726600019575
            ],
            [
              25.9819499988934,
              -33.1796399982872
            ],
            [
              25.9708399955694,
              -33.232930000619
            ],
            [
              26.0164900026116,
              -33.2504099973234
            ],
            [
              25.9879399972332,
              -33.3066100034489
            ],
            [
              26.0631900032161,
              -33.3330999956683
            ],
            [
              26.0374399956593,
              -33.4236300039216
            ],
            [
              26.0512700039076,
              -33.4747599965765
            ],
            [
              26.1255500011316,
              -33.4927499970147
            ],
            [
              26.1097150002471,
              -33.5346800033794
            ],
            [
              26.263500000025,
              -33.5202399939805
            ],
            [
              26.3295309963585,
              -33.5275690010086
            ],
            [
              26.3807199971302,
              -33.5625600021423
            ],
            [
              26.4154599965816,
              -33.5408100000814
            ],
            [
              26.5143930991623,
              -33.5536841459066
            ],
            [
              26.5358300022529,
              -33.5726799993824
            ],
            [
              26.5935214197778,
              -33.4918203480306
            ],
            [
              26.6543100026046,
              -33.4684099987224
            ],
            [
              26.6177300001395,
              -33.4250299992351
            ],
            [
              26.7235700030532,
              -33.3844300011436
            ],
            [
              26.719749988771,
              -33.3523599989148
            ],
            [
              26.7908500012266,
              -33.3132899967359
            ],
            [
              26.8017999998701,
              -33.2846099988523
            ],
            [
              26.8829899982898,
              -33.3060099991621
            ],
            [
              26.9689499990433,
              -33.2676600032065
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Makana Local Municipality",
        "Code": "EC104",
        "Parent_cod": "DC10",
        "Area": 437638,
        "detail": "Makana Local Municipality is a Category B municipality in the western part of the Eastern Cape, within the Sarah Baartman District. It lies strategically between Gqeberha (120 km west) and East London (180 km east), both major industrial hubs with container ports and airports.\nThe area is renowned for conservation, with nearly a million hectares dedicated to game reserves, including well-known sites such as Shamwari, Double Drift, and Kwandwe. Makhanda (formerly Grahamstown) is the municipal centre and cultural heart, home to over 70 declared National Heritage Sites.\n",
        "link_to_webpage": "https://www.makana.gov.za/",
        "image": "https://corruptionwatch-my.sharepoint.com/:i:/g/personal/nontobekog_corruptionwatch_org_za/EY3bOxXHVndOn57gL8bPGdIB_2quM4P6UNmwh8FQlb4vrA?e=51pHco",
        "image_alt": ""
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              29.978949982056,
              -25.0921199820515
            ],
            [
              30.0298399969183,
              -25.0845699999055
            ],
            [
              30.144389996801,
              -25.1237899991092
            ],
            [
              30.1485099970388,
              -25.0323500037496
            ],
            [
              30.1720699989314,
              -24.9891699990961
            ],
            [
              30.1919799889853,
              -24.8554700091336
            ],
            [
              30.2972899998336,
              -24.8677400020994
            ],
            [
              30.3541700031432,
              -24.8492799988728
            ],
            [
              30.4250700027784,
              -24.854859999889
            ],
            [
              30.4515399922769,
              -24.9120000043966
            ],
            [
              30.5628800033095,
              -24.8964600009282
            ],
            [
              30.6348800042089,
              -24.8527700006349
            ],
            [
              30.6785699964082,
              -24.735809996634
            ],
            [
              30.7201000023133,
              -24.7052380086271
            ],
            [
              30.6792400030238,
              -24.6236700017692
            ],
            [
              30.7303199969703,
              -24.6087299962922
            ],
            [
              30.7301799986081,
              -24.4984999995753
            ],
            [
              30.7589799993276,
              -24.4602199987539
            ],
            [
              30.6418299973565,
              -24.4508600005886
            ],
            [
              30.6183300000295,
              -24.4330299958376
            ],
            [
              30.5335299979111,
              -24.4397099981178
            ],
            [
              30.518180001406,
              -24.4056399971881
            ],
            [
              30.4092000038771,
              -24.3336299976263
            ],
            [
              30.3662150001223,
              -24.2830949973362
            ],
            [
              30.3250399979976,
              -24.3106900027414
            ],
            [
              30.2731599968365,
              -24.3200400031436
            ],
            [
              30.237589994183,
              -24.2834400033534
            ],
            [
              30.1775000029229,
              -24.304190000668
            ],
            [
              30.1469599966066,
              -24.2926499964002
            ],
            [
              30.1394300036918,
              -24.2472400031236
            ],
            [
              30.0677599991247,
              -24.2369799994274
            ],
            [
              30.0410999963678,
              -24.2068199962458
            ],
            [
              29.8757000005546,
              -24.2457199968803
            ],
            [
              29.8070100030093,
              -24.2521200024362
            ],
            [
              29.7691099972286,
              -24.2729900016872
            ],
            [
              29.7202900031812,
              -24.4582100022897
            ],
            [
              29.6965600087375,
              -24.4667899887669
            ],
            [
              29.7203000207295,
              -24.5266699829333
            ],
            [
              29.773490019349,
              -24.5507499854235
            ],
            [
              29.7763400221743,
              -24.6046699817342
            ],
            [
              29.8083400301683,
              -24.6260399725666
            ],
            [
              29.8397800186331,
              -24.5966799828948
            ],
            [
              29.9017100210007,
              -24.5945999832026
            ],
            [
              29.943590020563,
              -24.6217199828909
            ],
            [
              29.9902850119438,
              -24.5808099848929
            ],
            [
              30.0186706500305,
              -24.6164392366814
            ],
            [
              30.0872700112021,
              -24.6205899874379
            ],
            [
              30.1197800130372,
              -24.6996799879411
            ],
            [
              30.0835100221698,
              -24.7794099810857
            ],
            [
              30.0212300198496,
              -24.8391499840844
            ],
            [
              29.983190022002,
              -24.8411799805716
            ],
            [
              29.9341600263642,
              -24.8139749769635
            ],
            [
              29.895950020677,
              -24.8584699838026
            ],
            [
              29.9050960017791,
              -24.9323989990146
            ],
            [
              29.9754399595865,
              -24.9353499633301
            ],
            [
              29.959419970855,
              -24.9866099673761
            ],
            [
              29.9058899853347,
              -25.0474899707855
            ],
            [
              29.978949982056,
              -25.0921199820515
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Fetakgomo Tubatse Local Municipality",
        "Code": "LIM476",
        "Parent_cod": "DC47",
        "Area": 569345
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              26.5060160024367,
              -25.5018909992701
            ],
            [
              26.419300000095,
              -25.4776400041828
            ],
            [
              26.4326399992366,
              -25.4026200043097
            ],
            [
              26.4343000038421,
              -25.3982800029197
            ],
            [
              26.4356400017847,
              -25.3947900011575
            ],
            [
              26.4660400007454,
              -25.2906699993209
            ],
            [
              26.4050200016718,
              -25.28592999927
            ],
            [
              26.4226799976838,
              -25.1325449990524
            ],
            [
              26.3849800038242,
              -25.0593400028388
            ],
            [
              26.4181099991771,
              -25.0467999947239
            ],
            [
              26.455109999427,
              -24.9528499969298
            ],
            [
              26.4421299980011,
              -24.9354699976423
            ],
            [
              26.4582800017207,
              -24.8094700021388
            ],
            [
              26.4263199955713,
              -24.7719700040124
            ],
            [
              26.4273100016553,
              -24.6575200033455
            ],
            [
              26.4087800032946,
              -24.6461299961024
            ],
            [
              26.3932800007715,
              -24.6366299986755
            ],
            [
              26.1870000029478,
              -24.6874999991256
            ],
            [
              26.00741000207,
              -24.7242800063172
            ],
            [
              25.9644099967241,
              -24.7494400001559
            ],
            [
              25.8583100079006,
              -24.7571800027549
            ],
            [
              25.8765700001054,
              -24.8883000023432
            ],
            [
              25.7291000001649,
              -25.2568800032095
            ],
            [
              25.6998199979945,
              -25.2910000028478
            ],
            [
              25.6882300022129,
              -25.3760000015988
            ],
            [
              25.6623699985767,
              -25.4665499981838
            ],
            [
              25.629790000708,
              -25.5378200031906
            ],
            [
              25.7406699986216,
              -25.5138500021759
            ],
            [
              25.7965529991217,
              -25.5249679995735
            ],
            [
              25.8134399972581,
              -25.5665400020194
            ],
            [
              25.8165132100167,
              -25.5729635122562
            ],
            [
              25.8455999991407,
              -25.6656399980874
            ],
            [
              25.8869399989818,
              -25.6753099970586
            ],
            [
              26.095410003369,
              -25.6177799988478
            ],
            [
              26.1092449965594,
              -25.7021099981778
            ],
            [
              26.1845200027959,
              -25.674620001212
            ],
            [
              26.1850047580632,
              -25.756553753353
            ],
            [
              26.2582923848857,
              -25.7749497113601
            ],
            [
              26.2977025223536,
              -25.6675001926797
            ],
            [
              26.3963800016358,
              -25.692889999274
            ],
            [
              26.3904199983843,
              -25.7576399967884
            ],
            [
              26.4463700010748,
              -25.7693299980809
            ],
            [
              26.4623699996758,
              -25.7453699957287
            ],
            [
              26.4846900019421,
              -25.6774900031611
            ],
            [
              26.5112300027625,
              -25.6552199996033
            ],
            [
              26.5060160024367,
              -25.5018909992701
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Ramotshere Moiloa Local Municipality",
        "Code": "NW385",
        "Parent_cod": "DC38",
        "Area": 732286
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              29.9050960017791,
              -24.9323989990146
            ],
            [
              29.895950020677,
              -24.8584699838026
            ],
            [
              29.9341600263642,
              -24.8139749769635
            ],
            [
              29.983190022002,
              -24.8411799805716
            ],
            [
              30.0212300198496,
              -24.8391499840844
            ],
            [
              30.0835100221698,
              -24.7794099810857
            ],
            [
              30.1197800130372,
              -24.6996799879411
            ],
            [
              30.0872700112021,
              -24.6205899874379
            ],
            [
              30.0186706500305,
              -24.6164392366814
            ],
            [
              29.9902850119438,
              -24.5808099848929
            ],
            [
              29.943590020563,
              -24.6217199828909
            ],
            [
              29.9017100210007,
              -24.5945999832026
            ],
            [
              29.8397800186331,
              -24.5966799828948
            ],
            [
              29.8083400301683,
              -24.6260399725666
            ],
            [
              29.7763400221743,
              -24.6046699817342
            ],
            [
              29.773490019349,
              -24.5507499854235
            ],
            [
              29.7203000207295,
              -24.5266699829333
            ],
            [
              29.6965600087375,
              -24.4667899887669
            ],
            [
              29.6472800195573,
              -24.48229998006
            ],
            [
              29.6132800209563,
              -24.4594699812546
            ],
            [
              29.5628500219111,
              -24.5051399829239
            ],
            [
              29.5502300208989,
              -24.5521199820515
            ],
            [
              29.4811900207029,
              -24.605179980072
            ],
            [
              29.4707550008427,
              -24.6406150025803
            ],
            [
              29.434069944972,
              -24.7097700566428
            ],
            [
              29.4944774373838,
              -24.7322390747734
            ],
            [
              29.478030017971,
              -24.7636199822764
            ],
            [
              29.6347199439703,
              -24.8005200597529
            ],
            [
              29.7442799430649,
              -24.791230060319
            ],
            [
              29.6367299458304,
              -24.953060056976
            ],
            [
              29.6850499429006,
              -24.9323500597075
            ],
            [
              29.718319942911,
              -25.0003300595846
            ],
            [
              29.7825500207669,
              -24.9787899835709
            ],
            [
              29.8812879479805,
              -24.9772640507953
            ],
            [
              29.9050960017791,
              -24.9323989990146
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Makhuduthamaga Local Municipality",
        "Code": "LIM473",
        "Parent_cod": "DC47",
        "Area": 210965
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              29.9904299420001,
              -28.184929939
            ],
            [
              30.015649942,
              -28.1530799389999
            ],
            [
              30.132089943,
              -28.1774399389999
            ],
            [
              30.1237999430001,
              -28.129429939
            ],
            [
              30.180889943,
              -28.1459599389999
            ],
            [
              30.1977199430001,
              -28.071520064
            ],
            [
              30.255839943,
              -28.0778899389998
            ],
            [
              30.2452619430002,
              -27.995296939
            ],
            [
              30.2923369430001,
              -27.9511939389999
            ],
            [
              30.2738599430001,
              -27.919429938
            ],
            [
              30.306800068,
              -27.8919199379999
            ],
            [
              30.280709943,
              -27.8149899379999
            ],
            [
              30.2085949430001,
              -27.788359938
            ],
            [
              30.1196199430002,
              -27.8205699379999
            ],
            [
              30.0567399420001,
              -27.822649938
            ],
            [
              30.0744700680001,
              -27.8742100629999
            ],
            [
              30.0009699420001,
              -27.8992599379999
            ],
            [
              29.9141100670001,
              -27.9887900639999
            ],
            [
              29.850239942,
              -28.015899939
            ],
            [
              29.832389942,
              -27.992070064
            ],
            [
              29.6768499586587,
              -27.9595100426543
            ],
            [
              29.6506999720001,
              -27.967120035
            ],
            [
              29.6168619828942,
              -28.0468380156618
            ],
            [
              29.6554799768196,
              -28.0900200258035
            ],
            [
              29.6632899340001,
              -28.142020045
            ],
            [
              29.7275999418839,
              -28.1256499385938
            ],
            [
              29.7887027270002,
              -28.1742505569999
            ],
            [
              29.8140841538607,
              -28.2150348688641
            ],
            [
              29.8831437188077,
              -28.1956047516579
            ],
            [
              29.9904299420001,
              -28.184929939
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Dannhauser Local Municipality",
        "Code": "KZN254",
        "Parent_cod": "DC25",
        "Area": 170731
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              29.978949982056,
              -25.0921199820515
            ],
            [
              29.9058899853347,
              -25.0474899707855
            ],
            [
              29.959419970855,
              -24.9866099673761
            ],
            [
              29.9754399595865,
              -24.9353499633301
            ],
            [
              29.9050960017791,
              -24.9323989990146
            ],
            [
              29.8812879479805,
              -24.9772640507953
            ],
            [
              29.7825500207669,
              -24.9787899835709
            ],
            [
              29.718319942911,
              -25.0003300595846
            ],
            [
              29.6850499429006,
              -24.9323500597075
            ],
            [
              29.6367299458304,
              -24.953060056976
            ],
            [
              29.6307699416795,
              -24.9884600607832
            ],
            [
              29.5143529420347,
              -24.9935500607866
            ],
            [
              29.4698599415831,
              -24.9696100611554
            ],
            [
              29.4303599420578,
              -24.9949300605738
            ],
            [
              29.431599941684,
              -25.0392599356975
            ],
            [
              29.3587899421022,
              -25.0769400608351
            ],
            [
              29.3613899423919,
              -25.0979500611464
            ],
            [
              29.2647499419564,
              -25.0979500611464
            ],
            [
              29.2476899421372,
              -25.0595999356884
            ],
            [
              29.200699941649,
              -25.0546500608516
            ],
            [
              29.1550100667612,
              -25.107099936313
            ],
            [
              29.1184999623035,
              -25.107520041117
            ],
            [
              29.0868699713722,
              -25.1365400312974
            ],
            [
              29.0425099806511,
              -25.1405000196601
            ],
            [
              29.032259982812,
              -25.2493300201643
            ],
            [
              29.0354499734375,
              -25.2548100309581
            ],
            [
              29.0364299718657,
              -25.2558499656034
            ],
            [
              29.090169968869,
              -25.2893999659356
            ],
            [
              29.0958899727441,
              -25.3211800321328
            ],
            [
              29.1669599604339,
              -25.3033600422321
            ],
            [
              29.1641199697608,
              -25.3544800299294
            ],
            [
              29.1956999709769,
              -25.3702800309986
            ],
            [
              29.2073389789108,
              -25.4145720212817
            ],
            [
              29.2644339597595,
              -25.3754630415861
            ],
            [
              29.3421299733197,
              -25.3730700319564
            ],
            [
              29.3624599791447,
              -25.4071100207108
            ],
            [
              29.4527799732172,
              -25.407250029865
            ],
            [
              29.51882997942,
              -25.4227900216421
            ],
            [
              29.5226299613037,
              -25.4050400403656
            ],
            [
              29.6127899731787,
              -25.4006100303286
            ],
            [
              29.6738599718603,
              -25.3721600295617
            ],
            [
              29.7702399719971,
              -25.4015300295872
            ],
            [
              29.7931899682424,
              -25.3620599666941
            ],
            [
              29.8402999715665,
              -25.3863200314443
            ],
            [
              29.8879199624363,
              -25.3385799559002
            ],
            [
              29.9905899828415,
              -25.3382500261178
            ],
            [
              30.0098399712378,
              -25.2312800313483
            ],
            [
              30.0054099710934,
              -25.1443800313133
            ],
            [
              29.978949982056,
              -25.0921199820515
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Elias Motsoaledi Local Municipality",
        "Code": "LIM472",
        "Parent_cod": "DC47",
        "Area": 371333
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              30.6642399426193,
              -27.6791500631249
            ],
            [
              30.6675599428371,
              -27.6448900633257
            ],
            [
              30.592539942964,
              -27.5324980631351
            ],
            [
              30.5867499430002,
              -27.499829938
            ],
            [
              30.5096399430001,
              -27.4565899379999
            ],
            [
              30.5004299427877,
              -27.3905500633347
            ],
            [
              30.444679943,
              -27.357399938
            ],
            [
              30.448269997962,
              -27.3277399376479
            ],
            [
              30.426449989,
              -27.2698300189999
            ],
            [
              30.3676099880002,
              -27.26742998
            ],
            [
              30.2824899860001,
              -27.3144399829999
            ],
            [
              30.2799300158576,
              -27.3685899760465
            ],
            [
              30.1980799840002,
              -27.3551800229999
            ],
            [
              30.1502399859866,
              -27.3922499861479
            ],
            [
              30.0682899785997,
              -27.365870020585
            ],
            [
              30.0162419858789,
              -27.3975890201172
            ],
            [
              29.9784699869004,
              -27.3729900179749
            ],
            [
              29.9150199870001,
              -27.3598599819999
            ],
            [
              29.9118899877328,
              -27.3671400179974
            ],
            [
              29.8991399770001,
              -27.385490028
            ],
            [
              29.9248799420001,
              -27.538879938
            ],
            [
              29.920159942,
              -27.5792299379999
            ],
            [
              30.081719943,
              -27.724890063
            ],
            [
              30.1162699430001,
              -27.7077999379999
            ],
            [
              30.210589943,
              -27.7323199379999
            ],
            [
              30.2085949430001,
              -27.788359938
            ],
            [
              30.280709943,
              -27.8149899379999
            ],
            [
              30.306800068,
              -27.8919199379999
            ],
            [
              30.2738599430001,
              -27.919429938
            ],
            [
              30.2923369430001,
              -27.9511939389999
            ],
            [
              30.2965399430002,
              -27.9309399379999
            ],
            [
              30.3862100680001,
              -27.9305599379999
            ],
            [
              30.432390943,
              -27.973680064
            ],
            [
              30.569700067804,
              -28.0089500643939
            ],
            [
              30.6021400680002,
              -27.933599938
            ],
            [
              30.5813899430001,
              -27.888569938
            ],
            [
              30.597980067926,
              -27.8353100627092
            ],
            [
              30.6294199430001,
              -27.810289938
            ],
            [
              30.6269899430002,
              -27.7397399379999
            ],
            [
              30.673099942908,
              -27.7531699377424
            ],
            [
              30.6916499430001,
              -27.7155399379999
            ],
            [
              30.6642399426193,
              -27.6791500631249
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Emadlangeni Local Municipality",
        "Code": "KZN253",
        "Parent_cod": "DC25",
        "Area": 353932
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              29.4004899828265,
              -24.6085300203441
            ],
            [
              29.4340299692078,
              -24.598730029767
            ],
            [
              29.4707550008427,
              -24.6406150025803
            ],
            [
              29.4811900207029,
              -24.605179980072
            ],
            [
              29.5502300208989,
              -24.5521199820515
            ],
            [
              29.5628500219111,
              -24.5051399829239
            ],
            [
              29.6132800209563,
              -24.4594699812546
            ],
            [
              29.6472800195573,
              -24.48229998006
            ],
            [
              29.6965600087375,
              -24.4667899887669
            ],
            [
              29.7202900031812,
              -24.4582100022897
            ],
            [
              29.7691099972286,
              -24.2729900016872
            ],
            [
              29.8070100030093,
              -24.2521200024362
            ],
            [
              29.8757000005546,
              -24.2457199968803
            ],
            [
              30.0410999963678,
              -24.2068199962458
            ],
            [
              30.0677599991247,
              -24.2369799994274
            ],
            [
              30.1394300036918,
              -24.2472400031236
            ],
            [
              30.1469599966066,
              -24.2926499964002
            ],
            [
              30.1775000029229,
              -24.304190000668
            ],
            [
              30.237589994183,
              -24.2834400033534
            ],
            [
              30.2731599968365,
              -24.3200400031436
            ],
            [
              30.3250399979976,
              -24.3106900027414
            ],
            [
              30.3662150001223,
              -24.2830949973362
            ],
            [
              30.3371899971208,
              -24.2340300108763
            ],
            [
              30.2753299970818,
              -24.2129600068988
            ],
            [
              30.3616399977878,
              -24.1682800023202
            ],
            [
              30.3215299998097,
              -24.129690000693
            ],
            [
              30.2948900006731,
              -24.0958700031981
            ],
            [
              30.2382600007985,
              -24.1392699991112
            ],
            [
              30.2156200008623,
              -24.0856999991555
            ],
            [
              30.0745499965851,
              -24.0120199972251
            ],
            [
              30.0431049979973,
              -23.9724899981149
            ],
            [
              29.9974700006401,
              -24.0006600003587
            ],
            [
              29.8637499989634,
              -23.951380001286
            ],
            [
              29.8101399980625,
              -23.9685499971846
            ],
            [
              29.8272600033465,
              -24.040580001266
            ],
            [
              29.7823499989534,
              -24.0595300037066
            ],
            [
              29.7358900031212,
              -24.1072399978276
            ],
            [
              29.5965199963008,
              -24.1811099896342
            ],
            [
              29.4461006517237,
              -24.2406474554157
            ],
            [
              29.3322899961864,
              -24.2969100030941
            ],
            [
              29.2664699987915,
              -24.283880003859
            ],
            [
              29.2329600012031,
              -24.2344300032421
            ],
            [
              29.1889699987665,
              -24.256940002579
            ],
            [
              29.1479899966411,
              -24.2237799977486
            ],
            [
              29.0995300021079,
              -24.2320699969327
            ],
            [
              29.0726700036178,
              -24.2064499989683
            ],
            [
              29.0320400032436,
              -24.2478299997546
            ],
            [
              29.0631600003338,
              -24.2998400024141
            ],
            [
              29.0508500073221,
              -24.3711099993269
            ],
            [
              29.1122199991537,
              -24.3741100018751
            ],
            [
              29.2304200036802,
              -24.3376599982103
            ],
            [
              29.2921699986465,
              -24.4497400028988
            ],
            [
              29.3345400064162,
              -24.5557500010617
            ],
            [
              29.4004899828265,
              -24.6085300203441
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Lepele-Nkumpi Local Municipality",
        "Code": "LIM355",
        "Parent_cod": "DC35",
        "Area": 348428
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              24.5346390025879,
              -28.0920889962102
            ],
            [
              24.5628100003813,
              -28.0362200008523
            ],
            [
              24.6143700056712,
              -28.0223500006519
            ],
            [
              24.6293500031002,
              -27.9943099999065
            ],
            [
              24.6158199987939,
              -27.9036000013389
            ],
            [
              24.6583100013055,
              -27.8526700026185
            ],
            [
              24.6993200030157,
              -27.8282899970857
            ],
            [
              24.6586699972226,
              -27.790939993286
            ],
            [
              24.6954700044372,
              -27.7182500001373
            ],
            [
              24.6748700014494,
              -27.6926399963387
            ],
            [
              24.6922999976468,
              -27.6452199994035
            ],
            [
              24.7620600049653,
              -27.633240000026
            ],
            [
              24.79771999738,
              -27.6561799958102
            ],
            [
              24.8011699999956,
              -27.7017799969492
            ],
            [
              24.9997200010772,
              -27.6808300039015
            ],
            [
              25.0479099984477,
              -27.6997399964037
            ],
            [
              25.0878399962189,
              -27.6575099968888
            ],
            [
              25.0145699997058,
              -27.5555399979724
            ],
            [
              25.0063899966011,
              -27.5241699983467
            ],
            [
              24.9737199990787,
              -27.5173700013245
            ],
            [
              24.9769900005881,
              -27.464519998599
            ],
            [
              24.9189800018257,
              -27.4592399997261
            ],
            [
              24.8920876781039,
              -27.3961104006744
            ],
            [
              24.7958999988859,
              -27.4175899990792
            ],
            [
              24.7800499964102,
              -27.3632299968668
            ],
            [
              24.7802200051491,
              -27.3562199991536
            ],
            [
              24.7771900003183,
              -27.3332400042227
            ],
            [
              24.7440295746052,
              -27.308718914846
            ],
            [
              24.6993110889357,
              -27.2342099727121
            ],
            [
              24.5857291399879,
              -27.2928474203721
            ],
            [
              24.6129450074062,
              -27.337962009739
            ],
            [
              24.4561678462691,
              -27.4245754336094
            ],
            [
              24.3791615686515,
              -27.2726435156857
            ],
            [
              24.3524299978462,
              -27.2388399991666
            ],
            [
              24.4153999978116,
              -27.2116100033989
            ],
            [
              24.4019299971717,
              -27.1774400041528
            ],
            [
              24.3202050118519,
              -27.0826950011733
            ],
            [
              24.2238600016379,
              -27.1252900031311
            ],
            [
              24.1957899977103,
              -27.0726000032875
            ],
            [
              24.1313599978656,
              -27.0119000018836
            ],
            [
              24.03745,
              -27.053699999
            ],
            [
              23.973559999994,
              -27.0963799982383
            ],
            [
              23.8964699936953,
              -27.2526599988599
            ],
            [
              24.014949996745,
              -27.3236700062658
            ],
            [
              24.0862700013595,
              -27.3534900036607
            ],
            [
              24.057510003384,
              -27.4294199996333
            ],
            [
              24.0506100008509,
              -27.6027299968918
            ],
            [
              24.1186200039101,
              -27.6217399976028
            ],
            [
              24.0933399964437,
              -27.7049100063916
            ],
            [
              24.111000001449,
              -27.7389800010262
            ],
            [
              24.4052800005716,
              -27.6811800020554
            ],
            [
              24.4467599996743,
              -27.7028500040244
            ],
            [
              24.4088399992666,
              -27.7610999967674
            ],
            [
              24.452310004703,
              -27.7828800029098
            ],
            [
              24.3604599940335,
              -27.9106700027184
            ],
            [
              24.4099499982938,
              -27.9233000023932
            ],
            [
              24.467289999434,
              -27.980569999406
            ],
            [
              24.4654799969043,
              -28.0358400058116
            ],
            [
              24.5346390025879,
              -28.0920889962102
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Greater Taung Local Municipality",
        "Code": "NW394",
        "Parent_cod": "DC39",
        "Area": 563653
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              29.4004899828265,
              -24.6085300203441
            ],
            [
              29.369900037157,
              -24.6633560287577
            ],
            [
              29.2473799997872,
              -24.7136099999015
            ],
            [
              29.2720400002458,
              -24.7425899999285
            ],
            [
              29.2755799998172,
              -24.7913700002253
            ],
            [
              29.2297799705692,
              -24.8126499662229
            ],
            [
              29.1831499633002,
              -24.9399200409771
            ],
            [
              29.0828799717333,
              -24.981209942285
            ],
            [
              29.0559299798847,
              -24.9122599912056
            ],
            [
              28.9618299697774,
              -24.9139500322682
            ],
            [
              28.9240699740501,
              -24.9015299784257
            ],
            [
              28.9417599696469,
              -24.9336400310625
            ],
            [
              28.8917399688245,
              -24.9557570302627
            ],
            [
              28.9032194703024,
              -24.9823586562269
            ],
            [
              28.9093699661511,
              -24.9954900306404
            ],
            [
              28.9348600345629,
              -25.0006599623873
            ],
            [
              28.9717099703389,
              -25.0701799667321
            ],
            [
              29.0188099714031,
              -25.0548999662604
            ],
            [
              29.0706639596741,
              -25.0654660416245
            ],
            [
              29.1184999623035,
              -25.107520041117
            ],
            [
              29.1550100667612,
              -25.107099936313
            ],
            [
              29.200699941649,
              -25.0546500608516
            ],
            [
              29.2476899421372,
              -25.0595999356884
            ],
            [
              29.2647499419564,
              -25.0979500611464
            ],
            [
              29.3613899423919,
              -25.0979500611464
            ],
            [
              29.3587899421022,
              -25.0769400608351
            ],
            [
              29.431599941684,
              -25.0392599356975
            ],
            [
              29.4303599420578,
              -24.9949300605738
            ],
            [
              29.4698599415831,
              -24.9696100611554
            ],
            [
              29.5143529420347,
              -24.9935500607866
            ],
            [
              29.6307699416795,
              -24.9884600607832
            ],
            [
              29.6367299458304,
              -24.953060056976
            ],
            [
              29.7442799430649,
              -24.791230060319
            ],
            [
              29.6347199439703,
              -24.8005200597529
            ],
            [
              29.478030017971,
              -24.7636199822764
            ],
            [
              29.4944774373838,
              -24.7322390747734
            ],
            [
              29.434069944972,
              -24.7097700566428
            ],
            [
              29.4707550008427,
              -24.6406150025803
            ],
            [
              29.4340299692078,
              -24.598730029767
            ],
            [
              29.4004899828265,
              -24.6085300203441
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Ephraim Mogale Local Municipality",
        "Code": "LIM471",
        "Parent_cod": "DC47",
        "Area": 201131
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              30.2085949430001,
              -27.788359938
            ],
            [
              30.210589943,
              -27.7323199379999
            ],
            [
              30.1162699430001,
              -27.7077999379999
            ],
            [
              30.081719943,
              -27.724890063
            ],
            [
              29.920159942,
              -27.5792299379999
            ],
            [
              29.9248799420001,
              -27.538879938
            ],
            [
              29.8991399770001,
              -27.385490028
            ],
            [
              29.8401899988694,
              -27.3789899817023
            ],
            [
              29.8106899865537,
              -27.4447699808499
            ],
            [
              29.7586799856928,
              -27.442570015194
            ],
            [
              29.70316998081,
              -27.4719999712216
            ],
            [
              29.7123650370001,
              -27.5184399689999
            ],
            [
              29.7583599718352,
              -27.5271100332014
            ],
            [
              29.779559971,
              -27.5873000319999
            ],
            [
              29.7348099700001,
              -27.607099968
            ],
            [
              29.6701199790001,
              -27.6701299769999
            ],
            [
              29.7089900369607,
              -27.6984999662004
            ],
            [
              29.703039969,
              -27.761449968
            ],
            [
              29.7312599700001,
              -27.808079966
            ],
            [
              29.6970299790001,
              -27.824480039
            ],
            [
              29.6903499705747,
              -27.8957299666646
            ],
            [
              29.6576499779642,
              -27.9374000239918
            ],
            [
              29.6768499586587,
              -27.9595100426543
            ],
            [
              29.832389942,
              -27.992070064
            ],
            [
              29.850239942,
              -28.015899939
            ],
            [
              29.9141100670001,
              -27.9887900639999
            ],
            [
              30.0009699420001,
              -27.8992599379999
            ],
            [
              30.0744700680001,
              -27.8742100629999
            ],
            [
              30.0567399420001,
              -27.822649938
            ],
            [
              30.1196199430002,
              -27.8205699379999
            ],
            [
              30.2085949430001,
              -27.788359938
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Newcastle Local Municipality",
        "Code": "KZN252",
        "Parent_cod": "DC25",
        "Area": 185579
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              29.1889699987665,
              -24.256940002579
            ],
            [
              29.2329600012031,
              -24.2344300032421
            ],
            [
              29.2664699987915,
              -24.283880003859
            ],
            [
              29.3322899961864,
              -24.2969100030941
            ],
            [
              29.4461006517237,
              -24.2406474554157
            ],
            [
              29.5965199963008,
              -24.1811099896342
            ],
            [
              29.7358900031212,
              -24.1072399978276
            ],
            [
              29.7823499989534,
              -24.0595300037066
            ],
            [
              29.8272600033465,
              -24.040580001266
            ],
            [
              29.8101399980625,
              -23.9685499971846
            ],
            [
              29.8637499989634,
              -23.951380001286
            ],
            [
              29.8544400004057,
              -23.921904998217
            ],
            [
              29.8965499970848,
              -23.8987199956313
            ],
            [
              29.8865200003978,
              -23.8551199958911
            ],
            [
              29.9281799988079,
              -23.7976799982333
            ],
            [
              29.8883799998372,
              -23.7416000021384
            ],
            [
              29.8879200029058,
              -23.6794199963357
            ],
            [
              29.8456600011082,
              -23.6961499998226
            ],
            [
              29.7952300011637,
              -23.6808299984056
            ],
            [
              29.6759800030748,
              -23.7513299975812
            ],
            [
              29.5476100017003,
              -23.8059500009917
            ],
            [
              29.5007599887825,
              -23.8113599995643
            ],
            [
              29.465940002729,
              -23.7634900016622
            ],
            [
              29.4137199993786,
              -23.6211299999496
            ],
            [
              29.355430002093,
              -23.6400500001073
            ],
            [
              29.3365100019351,
              -23.5769900013874
            ],
            [
              29.3480400012451,
              -23.5271599967364
            ],
            [
              29.2446487560353,
              -23.5464340806682
            ],
            [
              29.2265509673534,
              -23.5799937801888
            ],
            [
              29.0664787513933,
              -23.5543398921722
            ],
            [
              29.010201079816,
              -23.6204511718841
            ],
            [
              28.96924981103,
              -23.5978325281486
            ],
            [
              28.9314199928385,
              -23.5982799966245
            ],
            [
              28.8755199969504,
              -23.6466199982143
            ],
            [
              28.8787900056543,
              -23.6971859981353
            ],
            [
              28.8578100022299,
              -23.7572299971666
            ],
            [
              28.8843500030503,
              -23.7846899990442
            ],
            [
              28.8432000002798,
              -23.8339799958801
            ],
            [
              28.9054000016088,
              -23.8586399999361
            ],
            [
              28.921390003346,
              -23.8112200012021
            ],
            [
              28.998438002312,
              -23.8411550012023
            ],
            [
              28.9821100011756,
              -23.8777999967724
            ],
            [
              29.0449299960226,
              -23.9055699985565
            ],
            [
              29.0934299995949,
              -23.9846500021958
            ],
            [
              29.1485099990373,
              -24.0091399966135
            ],
            [
              29.1621500012216,
              -24.0792800061673
            ],
            [
              29.2300399996463,
              -24.1090599981203
            ],
            [
              29.2284999978766,
              -24.1441399997611
            ],
            [
              29.1917199978796,
              -24.1702800010212
            ],
            [
              29.1889699987665,
              -24.256940002579
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Polokwane Local Municipality",
        "Code": "LIM354",
        "Parent_cod": "DC35",
        "Area": 505372
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              25.3826799977837,
              -26.8616599983103
            ],
            [
              25.4215399983723,
              -26.9200999998151
            ],
            [
              25.3491399970133,
              -26.9524400010052
            ],
            [
              25.3991100000265,
              -27.037700000055
            ],
            [
              25.3654399977578,
              -27.063650003345
            ],
            [
              25.324459997431,
              -27.0142599920051
            ],
            [
              25.2605599968465,
              -27.0073099988573
            ],
            [
              25.2225799981684,
              -27.0292700016093
            ],
            [
              25.1873700031232,
              -26.9793899919545
            ],
            [
              25.1080600023673,
              -27.0179200034054
            ],
            [
              25.1345900117197,
              -27.0707700061308
            ],
            [
              25.1536100021,
              -27.1587299983906
            ],
            [
              25.0763899987995,
              -27.2015099935913
            ],
            [
              25.0073000007945,
              -27.0932600018476
            ],
            [
              24.9646899972456,
              -27.137759999924
            ],
            [
              24.8952499983888,
              -27.1789900036857
            ],
            [
              24.8349899965911,
              -27.2731100039235
            ],
            [
              24.7771900003183,
              -27.3332400042227
            ],
            [
              24.7802200051491,
              -27.3562199991536
            ],
            [
              24.7800499964102,
              -27.3632299968668
            ],
            [
              24.7958999988859,
              -27.4175899990792
            ],
            [
              24.8920876781039,
              -27.3961104006744
            ],
            [
              24.9189800018257,
              -27.4592399997261
            ],
            [
              24.9769900005881,
              -27.464519998599
            ],
            [
              24.9737199990787,
              -27.5173700013245
            ],
            [
              25.0063899966011,
              -27.5241699983467
            ],
            [
              25.0158999998852,
              -27.4928899965761
            ],
            [
              25.0943399991917,
              -27.4629600004037
            ],
            [
              25.113990003336,
              -27.5454200007324
            ],
            [
              25.1464499992681,
              -27.5330399963987
            ],
            [
              25.188980000027,
              -27.4480700008298
            ],
            [
              25.2551600041309,
              -27.450630001973
            ],
            [
              25.2725900012276,
              -27.405459997281
            ],
            [
              25.4699399964338,
              -27.3912499948914
            ],
            [
              25.5709599983053,
              -27.3733699986265
            ],
            [
              25.6833799979886,
              -27.3364100002212
            ],
            [
              25.6751299988504,
              -27.2872100021399
            ],
            [
              25.6465099983378,
              -27.2710700042772
            ],
            [
              25.6743750566636,
              -27.222110529877
            ],
            [
              25.6537100102089,
              -27.2228399987669
            ],
            [
              25.6163299987305,
              -27.1429000004346
            ],
            [
              25.6871099973285,
              -27.0979699987165
            ],
            [
              25.6321900079625,
              -26.988569998007
            ],
            [
              25.6656299951282,
              -26.962720001127
            ],
            [
              25.6658100016304,
              -26.8991339988349
            ],
            [
              25.583119432216,
              -26.943860413827
            ],
            [
              25.4926099986525,
              -26.9178700021988
            ],
            [
              25.3985200015969,
              -26.8552899959365
            ],
            [
              25.3826799977837,
              -26.8616599983103
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Mamusa Local Municipality",
        "Code": "NW393",
        "Parent_cod": "DC39",
        "Area": 360332
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              30.0376999816688,
              -23.3387100216502
            ],
            [
              29.9971599719552,
              -23.3374500291954
            ],
            [
              29.9651599720551,
              -23.378180027886
            ],
            [
              29.8668399813801,
              -23.4374100199564
            ],
            [
              29.8095999713616,
              -23.4265700281842
            ],
            [
              29.7418699731208,
              -23.4352500282661
            ],
            [
              29.6167499714341,
              -23.3964500313438
            ],
            [
              29.6004300390151,
              -23.3720100293393
            ],
            [
              29.6220799699147,
              -23.3284100286998
            ],
            [
              29.5918599702615,
              -23.2682600310756
            ],
            [
              29.4277499718837,
              -23.2800300279634
            ],
            [
              29.4405099721576,
              -23.246330029707
            ],
            [
              29.3579699708375,
              -23.2388100291595
            ],
            [
              29.315549971554,
              -23.2515300275886
            ],
            [
              29.2678099652578,
              -23.2386400303131
            ],
            [
              29.1572399690494,
              -23.3188000037172
            ],
            [
              29.0820599564019,
              -23.29996004502
            ],
            [
              29.0262800029198,
              -23.3766299977761
            ],
            [
              29.0768669966146,
              -23.3885800002668
            ],
            [
              29.0664787513933,
              -23.5543398921722
            ],
            [
              29.2265509673534,
              -23.5799937801888
            ],
            [
              29.2446487560353,
              -23.5464340806682
            ],
            [
              29.3480400012451,
              -23.5271599967364
            ],
            [
              29.3365100019351,
              -23.5769900013874
            ],
            [
              29.355430002093,
              -23.6400500001073
            ],
            [
              29.4137199993786,
              -23.6211299999496
            ],
            [
              29.465940002729,
              -23.7634900016622
            ],
            [
              29.5007599887825,
              -23.8113599995643
            ],
            [
              29.5476100017003,
              -23.8059500009917
            ],
            [
              29.6759800030748,
              -23.7513299975812
            ],
            [
              29.7952300011637,
              -23.6808299984056
            ],
            [
              29.8456600011082,
              -23.6961499998226
            ],
            [
              29.8879200029058,
              -23.6794199963357
            ],
            [
              29.9611200042848,
              -23.6600700024286
            ],
            [
              29.9490199957762,
              -23.6276999980564
            ],
            [
              30.0364399982074,
              -23.5729699985665
            ],
            [
              30.0473470038612,
              -23.5352370022858
            ],
            [
              30.005999997402,
              -23.4478100031291
            ],
            [
              30.0432599979506,
              -23.4256500028453
            ],
            [
              30.0376999816688,
              -23.3387100216502
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Molemole Local Municipality",
        "Code": "LIM353",
        "Parent_cod": "DC35",
        "Area": 362757
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              25.3826799977837,
              -26.8616599983103
            ],
            [
              25.3207799967994,
              -26.8862599969013
            ],
            [
              25.2574900000635,
              -26.8022499961403
            ],
            [
              25.1941980796777,
              -26.857581672656
            ],
            [
              25.1483252494108,
              -26.8005801178781
            ],
            [
              25.12001212456,
              -26.7972479921012
            ],
            [
              25.1476499979491,
              -26.7140199968254
            ],
            [
              25.2267050022341,
              -26.6147662778414
            ],
            [
              25.1769190823498,
              -26.5583293021555
            ],
            [
              25.1695899970808,
              -26.5199299981708
            ],
            [
              25.066202999369,
              -26.5502950000142
            ],
            [
              25.0251900029164,
              -26.4454899908704
            ],
            [
              24.9912000029778,
              -26.3909399915873
            ],
            [
              24.9302099998916,
              -26.4206300000744
            ],
            [
              24.9007300001895,
              -26.3634500000174
            ],
            [
              24.8578500003772,
              -26.3949999998501
            ],
            [
              24.8317399996014,
              -26.3269500003422
            ],
            [
              24.7641799984083,
              -26.2052500007868
            ],
            [
              24.6903200043647,
              -26.2341900007678
            ],
            [
              24.6350800011412,
              -26.2696999979565
            ],
            [
              24.677920002706,
              -26.3291100001264
            ],
            [
              24.5361300011987,
              -26.4016900007929
            ],
            [
              24.6021799966096,
              -26.515449999318
            ],
            [
              24.6573799988879,
              -26.4858099976332
            ],
            [
              24.7292499991882,
              -26.5963999920659
            ],
            [
              24.7802500002373,
              -26.6425800073614
            ],
            [
              24.7015199983493,
              -26.6854699986415
            ],
            [
              24.5096600036063,
              -26.7671800003567
            ],
            [
              24.3336200018616,
              -26.8594200029307
            ],
            [
              24.2769800042238,
              -26.8832399979275
            ],
            [
              24.3044399980075,
              -26.942919999958
            ],
            [
              24.2658499972796,
              -26.960619996016
            ],
            [
              24.3414100040685,
              -27.0680299966869
            ],
            [
              24.3202050118519,
              -27.0826950011733
            ],
            [
              24.4019299971717,
              -27.1774400041528
            ],
            [
              24.4153999978116,
              -27.2116100033989
            ],
            [
              24.3524299978462,
              -27.2388399991666
            ],
            [
              24.3791615686515,
              -27.2726435156857
            ],
            [
              24.4561678462691,
              -27.4245754336094
            ],
            [
              24.6129450074062,
              -27.337962009739
            ],
            [
              24.5857291399879,
              -27.2928474203721
            ],
            [
              24.6993110889357,
              -27.2342099727121
            ],
            [
              24.7440295746052,
              -27.308718914846
            ],
            [
              24.7771900003183,
              -27.3332400042227
            ],
            [
              24.8349899965911,
              -27.2731100039235
            ],
            [
              24.8952499983888,
              -27.1789900036857
            ],
            [
              24.9646899972456,
              -27.137759999924
            ],
            [
              25.0073000007945,
              -27.0932600018476
            ],
            [
              25.0763899987995,
              -27.2015099935913
            ],
            [
              25.1536100021,
              -27.1587299983906
            ],
            [
              25.1345900117197,
              -27.0707700061308
            ],
            [
              25.1080600023673,
              -27.0179200034054
            ],
            [
              25.1873700031232,
              -26.9793899919545
            ],
            [
              25.2225799981684,
              -27.0292700016093
            ],
            [
              25.2605599968465,
              -27.0073099988573
            ],
            [
              25.324459997431,
              -27.0142599920051
            ],
            [
              25.3654399977578,
              -27.063650003345
            ],
            [
              25.3991100000265,
              -27.037700000055
            ],
            [
              25.3491399970133,
              -26.9524400010052
            ],
            [
              25.4215399983723,
              -26.9200999998151
            ],
            [
              25.3826799977837,
              -26.8616599983103
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Naledi Local Municipality",
        "Code": "NW392",
        "Parent_cod": "DC39",
        "Area": 703204
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              29.0664787513933,
              -23.5543398921722
            ],
            [
              29.0768669966146,
              -23.3885800002668
            ],
            [
              29.0262800029198,
              -23.3766299977761
            ],
            [
              29.0820599564019,
              -23.29996004502
            ],
            [
              29.1572399690494,
              -23.3188000037172
            ],
            [
              29.2678099652578,
              -23.2386400303131
            ],
            [
              29.2517299998396,
              -23.1070700000804
            ],
            [
              29.3101500004222,
              -23.0738000000699
            ],
            [
              29.2844899997137,
              -23.0023199997681
            ],
            [
              29.2574500001174,
              -22.9925200001978
            ],
            [
              29.2463499999526,
              -22.9383899995988
            ],
            [
              29.1833300003792,
              -22.9735500004322
            ],
            [
              29.1669699420093,
              -22.9177900586643
            ],
            [
              29.2229199420018,
              -22.8074300586503
            ],
            [
              29.2448999420787,
              -22.7352600589045
            ],
            [
              29.2047199417719,
              -22.7126399339858
            ],
            [
              29.209359941708,
              -22.6627800592523
            ],
            [
              29.1658799421057,
              -22.5531200582441
            ],
            [
              29.1073399422845,
              -22.5392500580437
            ],
            [
              28.9791100660767,
              -22.5811300594047
            ],
            [
              28.9329100660467,
              -22.521060058275
            ],
            [
              28.9035099414307,
              -22.5126800576384
            ],
            [
              28.9232789618546,
              -22.4570350384363
            ],
            [
              28.8808799968144,
              -22.4478400002158
            ],
            [
              28.8310500011567,
              -22.4882500012365
            ],
            [
              28.710359998715,
              -22.5147500002123
            ],
            [
              28.6392799988729,
              -22.5587100075608
            ],
            [
              28.5627400017498,
              -22.5613600011631
            ],
            [
              28.5089500006421,
              -22.589109999327
            ],
            [
              28.4828500012266,
              -22.5717600041208
            ],
            [
              28.3426400006356,
              -22.5737200009772
            ],
            [
              28.2791500009718,
              -22.6146299998745
            ],
            [
              28.2456800016309,
              -22.6566999983063
            ],
            [
              28.2096700011697,
              -22.6644600018276
            ],
            [
              28.1597200008774,
              -22.7183299994299
            ],
            [
              28.162369998077,
              -22.7558599989397
            ],
            [
              28.09693696367,
              -22.8110530359688
            ],
            [
              28.1476399995864,
              -22.9160400004456
            ],
            [
              28.1827200003278,
              -22.9492100003413
            ],
            [
              28.2345599996443,
              -22.9670399996962
            ],
            [
              28.2243399995913,
              -23.0493300002793
            ],
            [
              28.2517700000855,
              -23.1086599996593
            ],
            [
              28.291179999957,
              -23.0909800000269
            ],
            [
              28.3370700000805,
              -23.1228399997662
            ],
            [
              28.3532899998337,
              -23.1841499996227
            ],
            [
              28.3200900003532,
              -23.2040200004226
            ],
            [
              28.3555400001709,
              -23.2834500004171
            ],
            [
              28.4132900004332,
              -23.3516699996707
            ],
            [
              28.4740399996463,
              -23.3121900001683
            ],
            [
              28.4975100000865,
              -23.3449500000425
            ],
            [
              28.5395899998786,
              -23.3509699997656
            ],
            [
              28.5959380523992,
              -23.4047280515583
            ],
            [
              28.6597000007545,
              -23.385749999263
            ],
            [
              28.6851199823014,
              -23.3361300285779
            ],
            [
              28.7357699717069,
              -23.3309100306733
            ],
            [
              28.7956099712233,
              -23.416060029147
            ],
            [
              28.9100599709909,
              -23.5444600301063
            ],
            [
              28.96924981103,
              -23.5978325281486
            ],
            [
              29.010201079816,
              -23.6204511718841
            ],
            [
              29.0664787513933,
              -23.5543398921722
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Blouberg Local Municipality",
        "Code": "LIM351",
        "Parent_cod": "DC35",
        "Area": 953988
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              23.2278022771535,
              -29.5373687738498
            ],
            [
              23.2792205807652,
              -29.4761295317524
            ],
            [
              23.3645095829509,
              -29.4527091981709
            ],
            [
              23.3627300260699,
              -29.3919696805562
            ],
            [
              23.4472904209163,
              -29.3146400454018
            ],
            [
              23.5145299963623,
              -29.3058700051965
            ],
            [
              23.4881000060105,
              -29.2406350006048
            ],
            [
              23.5088099987824,
              -29.21270999527
            ],
            [
              23.57307000068,
              -29.1846600030566
            ],
            [
              23.6238300059501,
              -29.1166999978066
            ],
            [
              23.6393800035843,
              -29.0739599990547
            ],
            [
              23.7044499987685,
              -29.1110300070292
            ],
            [
              23.688779997399,
              -29.1550599969213
            ],
            [
              23.7139800029748,
              -29.1932300025626
            ],
            [
              23.7640400029439,
              -29.1984200053789
            ],
            [
              23.7853900036458,
              -29.2248499957307
            ],
            [
              23.7800999980166,
              -29.2863999967624
            ],
            [
              23.8645999943943,
              -29.2867399998511
            ],
            [
              23.9311999953835,
              -29.3964800009512
            ],
            [
              23.9159699918217,
              -29.4440899976553
            ],
            [
              23.9375899986795,
              -29.4820899945575
            ],
            [
              24.0126700031182,
              -29.5185800018655
            ],
            [
              24.045069998082,
              -29.5034499948214
            ],
            [
              24.1431499956758,
              -29.5385500072769
            ],
            [
              24.1951600091272,
              -29.5224399901135
            ],
            [
              24.2129700012646,
              -29.5499999930052
            ],
            [
              24.2731100002264,
              -29.5811400036083
            ],
            [
              24.2399199958112,
              -29.6152499973894
            ],
            [
              24.3045100012356,
              -29.661189995322
            ],
            [
              24.3466199997132,
              -29.6559299955728
            ],
            [
              24.6917800033445,
              -29.0257199993785
            ],
            [
              24.6670099960146,
              -29.0388799956153
            ],
            [
              24.5352499992881,
              -29.0422099953949
            ],
            [
              24.4854700032381,
              -28.9973900014473
            ],
            [
              24.4338799965646,
              -28.9975500043292
            ],
            [
              24.3955200037452,
              -28.9423999908668
            ],
            [
              24.3106193540001,
              -28.9240093226721
            ],
            [
              24.2523755782703,
              -28.9466751844122
            ],
            [
              24.2026208252909,
              -28.8768113863364
            ],
            [
              24.1806065025881,
              -28.9004105743884
            ],
            [
              24.1164470961566,
              -28.8559197880677
            ],
            [
              24.1485110036799,
              -28.828270754092
            ],
            [
              24.0545579203118,
              -28.7867898089026
            ],
            [
              24.0620199982244,
              -28.6857100030142
            ],
            [
              24.1170399607257,
              -28.5986132250203
            ],
            [
              24.0866099945556,
              -28.5583400036882
            ],
            [
              24.0464500005672,
              -28.5998100041284
            ],
            [
              23.9495899971807,
              -28.6033600041608
            ],
            [
              24.0009400026791,
              -28.6619399986319
            ],
            [
              23.969300004092,
              -28.6710800019405
            ],
            [
              23.9086600081529,
              -28.6414400056517
            ],
            [
              23.8126500016963,
              -28.5644800008513
            ],
            [
              23.7547000003048,
              -28.528780003894
            ],
            [
              23.7069699989663,
              -28.5877200005776
            ],
            [
              23.6238099987325,
              -28.7083900011975
            ],
            [
              23.6929600057997,
              -28.7368500024256
            ],
            [
              23.6685000037722,
              -28.766740003948
            ],
            [
              23.5424099960245,
              -28.7474399970582
            ],
            [
              23.479420001432,
              -28.7138599998391
            ],
            [
              23.4102900015824,
              -28.6952799973739
            ],
            [
              23.3790850005724,
              -28.636309993911
            ],
            [
              23.2920099987624,
              -28.6499400010302
            ],
            [
              23.2551399991117,
              -28.6143500001524
            ],
            [
              23.2022299963173,
              -28.629594993614
            ],
            [
              23.2229599963069,
              -28.5572899957367
            ],
            [
              23.1284600046256,
              -28.5966099977531
            ],
            [
              22.9957300027375,
              -28.5802899969857
            ],
            [
              22.9624700013895,
              -28.5613699923313
            ],
            [
              22.9176300011237,
              -28.5769799963298
            ],
            [
              22.7967097227755,
              -28.5772905960841
            ],
            [
              22.7296190013159,
              -28.517632080656
            ],
            [
              22.6672400052221,
              -28.5026800008813
            ],
            [
              22.5243449977235,
              -28.4973499970047
            ],
            [
              22.4606000006895,
              -28.4444600014279
            ],
            [
              22.1233299939841,
              -28.763200002578
            ],
            [
              22.0418700010997,
              -28.8399100021448
            ],
            [
              22.1425599949478,
              -28.9145500069772
            ],
            [
              22.1799799983783,
              -28.9746499995978
            ],
            [
              22.1669500000425,
              -29.0156899999935
            ],
            [
              22.2120699970328,
              -29.0498999983862
            ],
            [
              22.2041799938117,
              -29.0818400018146
            ],
            [
              22.2574999966276,
              -29.1247100038636
            ],
            [
              22.2529200039551,
              -29.1752100043381
            ],
            [
              22.2779399931362,
              -29.2303400015897
            ],
            [
              22.2697399936059,
              -29.3193700018241
            ],
            [
              22.3384349940797,
              -29.3148100001813
            ],
            [
              22.3555400130612,
              -29.2318900074178
            ],
            [
              22.4156399975879,
              -29.1907600019725
            ],
            [
              22.4427530023492,
              -29.1343729953175
            ],
            [
              22.6354899925692,
              -29.1382400000759
            ],
            [
              22.6513249961517,
              -29.1963650041415
            ],
            [
              22.678329996832,
              -29.1995200030457
            ],
            [
              22.6799999974021,
              -29.2584699920964
            ],
            [
              22.7264899982149,
              -29.2827000024032
            ],
            [
              22.8527100011657,
              -29.2736299969268
            ],
            [
              22.8310203553052,
              -29.1298503883847
            ],
            [
              22.9075800008164,
              -29.1294000007095
            ],
            [
              22.9068200062383,
              -29.1579899971406
            ],
            [
              22.9864444729341,
              -29.1759605407463
            ],
            [
              23.0721893306731,
              -29.1806602475724
            ],
            [
              23.1112800055678,
              -29.2182300007139
            ],
            [
              23.1648998261661,
              -29.1403503419946
            ],
            [
              23.2234096537326,
              -29.1298503883847
            ],
            [
              23.3207199980295,
              -29.1511500027704
            ],
            [
              23.3499374388618,
              -29.2186126712377
            ],
            [
              23.3330535892518,
              -29.2745513919331
            ],
            [
              23.2711009977129,
              -29.2755508417979
            ],
            [
              23.2051506040172,
              -29.3070259092182
            ],
            [
              23.1935922203048,
              -29.3362212312248
            ],
            [
              23.2452798609769,
              -29.3961998414495
            ],
            [
              23.2131200038851,
              -29.4375500000324
            ],
            [
              23.2278022771535,
              -29.5373687738498
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Siyancuma Local Municipality",
        "Code": "NC078",
        "Parent_cod": "DC7",
        "Area": 1658738
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              22.9820399973481,
              -30.2381299999994
            ],
            [
              23.1131399978127,
              -30.1564299915509
            ],
            [
              23.1141429999995,
              -30.132131999692
            ],
            [
              23.1820160003382,
              -30.094968996422
            ],
            [
              23.206658357897,
              -30.0393860151525
            ],
            [
              23.1836770328688,
              -29.9380646738456
            ],
            [
              23.2394499977192,
              -29.9019599909608
            ],
            [
              23.3452800037692,
              -29.8963199988688
            ],
            [
              23.3248670004118,
              -29.8434069959361
            ],
            [
              23.2828699963534,
              -29.7906600015578
            ],
            [
              23.3418499993781,
              -29.7309600022024
            ],
            [
              23.2907499991133,
              -29.7008400008653
            ],
            [
              23.29991000874,
              -29.65129000463
            ],
            [
              23.2330699939851,
              -29.6386899982448
            ],
            [
              23.2278022771535,
              -29.5373687738498
            ],
            [
              23.2131200038851,
              -29.4375500000324
            ],
            [
              23.2452798609769,
              -29.3961998414495
            ],
            [
              23.1935922203048,
              -29.3362212312248
            ],
            [
              23.2051506040172,
              -29.3070259092182
            ],
            [
              23.2711009977129,
              -29.2755508417979
            ],
            [
              23.3330535892518,
              -29.2745513919331
            ],
            [
              23.3499374388618,
              -29.2186126712377
            ],
            [
              23.3207199980295,
              -29.1511500027704
            ],
            [
              23.2234096537326,
              -29.1298503883847
            ],
            [
              23.1648998261661,
              -29.1403503419946
            ],
            [
              23.1112800055678,
              -29.2182300007139
            ],
            [
              23.0721893306731,
              -29.1806602475724
            ],
            [
              22.9864444729341,
              -29.1759605407463
            ],
            [
              22.9068200062383,
              -29.1579899971406
            ],
            [
              22.9075800008164,
              -29.1294000007095
            ],
            [
              22.8310203553052,
              -29.1298503883847
            ],
            [
              22.8527100011657,
              -29.2736299969268
            ],
            [
              22.7264899982149,
              -29.2827000024032
            ],
            [
              22.6799999974021,
              -29.2584699920964
            ],
            [
              22.678329996832,
              -29.1995200030457
            ],
            [
              22.6513249961517,
              -29.1963650041415
            ],
            [
              22.6354899925692,
              -29.1382400000759
            ],
            [
              22.4427530023492,
              -29.1343729953175
            ],
            [
              22.4156399975879,
              -29.1907600019725
            ],
            [
              22.3555400130612,
              -29.2318900074178
            ],
            [
              22.3384349940797,
              -29.3148100001813
            ],
            [
              22.2697399936059,
              -29.3193700018241
            ],
            [
              22.2779399931362,
              -29.2303400015897
            ],
            [
              22.2529200039551,
              -29.1752100043381
            ],
            [
              22.2349533463199,
              -29.1694657412509
            ],
            [
              22.1812499975893,
              -29.0624099997216
            ],
            [
              22.1169999952536,
              -29.0120500030052
            ],
            [
              22.0863100000065,
              -28.9506200048093
            ],
            [
              21.9909600006036,
              -28.9460700027284
            ],
            [
              21.9586199958162,
              -29.0157099991171
            ],
            [
              21.8381081499713,
              -29.0973641799129
            ],
            [
              21.8990499997577,
              -29.1648700068453
            ],
            [
              21.9793099975584,
              -29.2777599994244
            ],
            [
              21.9109800004268,
              -29.353850004574
            ],
            [
              21.8456699977723,
              -29.3958899989242
            ],
            [
              21.8998199938976,
              -29.4491300061449
            ],
            [
              21.7849300062149,
              -29.5566099965541
            ],
            [
              21.8299699977173,
              -29.6231900056142
            ],
            [
              21.7789200042548,
              -29.6659600129442
            ],
            [
              21.7216100000016,
              -29.7748200067379
            ],
            [
              21.8114199939377,
              -29.8419600029518
            ],
            [
              22.0103500053486,
              -29.9024400050022
            ],
            [
              21.9943599991147,
              -29.9538100033289
            ],
            [
              22.0142100007909,
              -30.0057800023452
            ],
            [
              22.0345799985681,
              -30.0575899993789
            ],
            [
              22.1355199922539,
              -30.1131500047688
            ],
            [
              22.2089899943928,
              -30.1248699975523
            ],
            [
              22.1819300037667,
              -30.1756599943133
            ],
            [
              22.2044400004058,
              -30.217720003975
            ],
            [
              22.2558599956423,
              -30.1738299998545
            ],
            [
              22.2995999892482,
              -30.1964300087379
            ],
            [
              22.4662999991457,
              -30.1904200058785
            ],
            [
              22.5235399965736,
              -30.1583599987149
            ],
            [
              22.6080899997537,
              -30.199300002593
            ],
            [
              22.6738600002388,
              -30.1885999956932
            ],
            [
              22.6477999945741,
              -30.1302300010137
            ],
            [
              22.7483399949948,
              -30.0792699946145
            ],
            [
              22.8107799939017,
              -30.0838500043741
            ],
            [
              22.8648400020646,
              -30.1122399996762
            ],
            [
              22.8670199982744,
              -30.1703199980694
            ],
            [
              22.9375699997558,
              -30.1235499996328
            ],
            [
              22.955499994729,
              -30.1546499958007
            ],
            [
              22.9549200012571,
              -30.2221500023207
            ],
            [
              22.9820399973481,
              -30.2381299999994
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Siyathemba Local Municipality",
        "Code": "NC077",
        "Parent_cod": "DC7",
        "Area": 1470400
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              23.8420799981934,
              -30.195130001848
            ],
            [
              23.9392999965976,
              -30.2102600007983
            ],
            [
              23.9257599936288,
              -30.1441399976627
            ],
            [
              23.9452200034005,
              -30.1055299996098
            ],
            [
              23.9928699992511,
              -30.1126600001588
            ],
            [
              24.0399006841693,
              -30.0904715066546
            ],
            [
              24.0296480306322,
              -30.0207612219528
            ],
            [
              24.056519999998,
              -30.0036900021919
            ],
            [
              24.1958930051581,
              -30.0023679960861
            ],
            [
              24.2788199901504,
              -29.9643000023432
            ],
            [
              24.2982699985616,
              -29.8971700056912
            ],
            [
              24.3773900022468,
              -29.8877800052431
            ],
            [
              24.4028599968914,
              -29.9162399983772
            ],
            [
              24.453640001285,
              -29.8677200028758
            ],
            [
              24.4700200003228,
              -29.8117800042438
            ],
            [
              24.4115799997173,
              -29.7907399998511
            ],
            [
              24.3486600011581,
              -29.7019899981398
            ],
            [
              24.3466199997132,
              -29.6559299955728
            ],
            [
              24.3045100012356,
              -29.661189995322
            ],
            [
              24.2399199958112,
              -29.6152499973894
            ],
            [
              24.2731100002264,
              -29.5811400036083
            ],
            [
              24.2129700012646,
              -29.5499999930052
            ],
            [
              24.1951600091272,
              -29.5224399901135
            ],
            [
              24.1431499956758,
              -29.5385500072769
            ],
            [
              24.045069998082,
              -29.5034499948214
            ],
            [
              24.0126700031182,
              -29.5185800018655
            ],
            [
              23.9375899986795,
              -29.4820899945575
            ],
            [
              23.9159699918217,
              -29.4440899976553
            ],
            [
              23.9311999953835,
              -29.3964800009512
            ],
            [
              23.8645999943943,
              -29.2867399998511
            ],
            [
              23.7800999980166,
              -29.2863999967624
            ],
            [
              23.7853900036458,
              -29.2248499957307
            ],
            [
              23.7640400029439,
              -29.1984200053789
            ],
            [
              23.7139800029748,
              -29.1932300025626
            ],
            [
              23.688779997399,
              -29.1550599969213
            ],
            [
              23.7044499987685,
              -29.1110300070292
            ],
            [
              23.6393800035843,
              -29.0739599990547
            ],
            [
              23.6238300059501,
              -29.1166999978066
            ],
            [
              23.57307000068,
              -29.1846600030566
            ],
            [
              23.5088099987824,
              -29.21270999527
            ],
            [
              23.4881000060105,
              -29.2406350006048
            ],
            [
              23.5145299963623,
              -29.3058700051965
            ],
            [
              23.4472904209163,
              -29.3146400454018
            ],
            [
              23.3627300260699,
              -29.3919696805562
            ],
            [
              23.3645095829509,
              -29.4527091981709
            ],
            [
              23.2792205807652,
              -29.4761295317524
            ],
            [
              23.2278022771535,
              -29.5373687738498
            ],
            [
              23.2330699939851,
              -29.6386899982448
            ],
            [
              23.29991000874,
              -29.65129000463
            ],
            [
              23.2907499991133,
              -29.7008400008653
            ],
            [
              23.3418499993781,
              -29.7309600022024
            ],
            [
              23.2828699963534,
              -29.7906600015578
            ],
            [
              23.3248670004118,
              -29.8434069959361
            ],
            [
              23.3452800037692,
              -29.8963199988688
            ],
            [
              23.2394499977192,
              -29.9019599909608
            ],
            [
              23.296089995357,
              -29.9940400032435
            ],
            [
              23.3528900021719,
              -30.0661300010986
            ],
            [
              23.4977199981794,
              -30.0586200001128
            ],
            [
              23.5568700027485,
              -30.1021100028743
            ],
            [
              23.6053900063438,
              -30.1121900018671
            ],
            [
              23.6424599981304,
              -30.1443499983537
            ],
            [
              23.6860699974325,
              -30.0901199967404
            ],
            [
              23.7139700034129,
              -30.1201600015827
            ],
            [
              23.776339997293,
              -30.1030399998961
            ],
            [
              23.8207099992671,
              -30.1413999981113
            ],
            [
              23.8420799981934,
              -30.195130001848
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Thembelihle Local Municipality",
        "Code": "NC076",
        "Parent_cod": "DC7",
        "Area": 802309
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              28.7395900012776,
              -25.2885300013584
            ],
            [
              28.7599300012686,
              -25.3041999964326
            ],
            [
              28.7709880021946,
              -25.313048004262
            ],
            [
              28.7910099983128,
              -25.3283399980924
            ],
            [
              28.8991340040311,
              -25.2350770032011
            ],
            [
              29.032259982812,
              -25.2493300201643
            ],
            [
              29.0425099806511,
              -25.1405000196601
            ],
            [
              29.0868699713722,
              -25.1365400312974
            ],
            [
              29.1184999623035,
              -25.107520041117
            ],
            [
              29.0706639596741,
              -25.0654660416245
            ],
            [
              29.0188099714031,
              -25.0548999662604
            ],
            [
              28.9717099703389,
              -25.0701799667321
            ],
            [
              28.9348600345629,
              -25.0006599623873
            ],
            [
              28.9093699661511,
              -24.9954900306404
            ],
            [
              28.9032194703024,
              -24.9823586562269
            ],
            [
              28.8917399688245,
              -24.9557570302627
            ],
            [
              28.9417599696469,
              -24.9336400310625
            ],
            [
              28.9240699740501,
              -24.9015299784257
            ],
            [
              28.8373900012476,
              -24.9160099995618
            ],
            [
              28.7593799965896,
              -24.9113500014014
            ],
            [
              28.7137799972491,
              -24.9536200018616
            ],
            [
              28.6055400032686,
              -25.0037999983712
            ],
            [
              28.6342899962863,
              -25.0582400015747
            ],
            [
              28.606873002687,
              -25.0703939981844
            ],
            [
              28.5969000023333,
              -25.0718400019145
            ],
            [
              28.4737399984022,
              -25.089319998619
            ],
            [
              28.4429700012646,
              -25.1289899888968
            ],
            [
              28.3792599986501,
              -25.1552999988958
            ],
            [
              28.4299700043122,
              -25.2066199967154
            ],
            [
              28.4514300010937,
              -25.2033299987804
            ],
            [
              28.5320599970712,
              -25.1697899989092
            ],
            [
              28.5366099991522,
              -25.1524199991836
            ],
            [
              28.5385299968619,
              -25.1521099983776
            ],
            [
              28.635959998655,
              -25.1281299995998
            ],
            [
              28.6515699963583,
              -25.1428999972371
            ],
            [
              28.7445889970846,
              -25.1096120017924
            ],
            [
              28.7754100001714,
              -25.183770003283
            ],
            [
              28.7324299984457,
              -25.2691700006949
            ],
            [
              28.7395900012776,
              -25.2885300013584
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Dr JS Moroka Local Municipality",
        "Code": "MP316",
        "Parent_cod": "DC31",
        "Area": 141647
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              24.7984876676718,
              -30.0341701469347
            ],
            [
              24.793970003413,
              -29.9989799981284
            ],
            [
              24.7247399989518,
              -29.9922499980389
            ],
            [
              24.671299998696,
              -29.9714500002173
            ],
            [
              24.6677999982713,
              -29.9065099948404
            ],
            [
              24.6079299982709,
              -29.9112600034463
            ],
            [
              24.4700200003228,
              -29.8117800042438
            ],
            [
              24.453640001285,
              -29.8677200028758
            ],
            [
              24.4028599968914,
              -29.9162399983772
            ],
            [
              24.3773900022468,
              -29.8877800052431
            ],
            [
              24.2982699985616,
              -29.8971700056912
            ],
            [
              24.2788199901504,
              -29.9643000023432
            ],
            [
              24.1958930051581,
              -30.0023679960861
            ],
            [
              24.056519999998,
              -30.0036900021919
            ],
            [
              24.0296480306322,
              -30.0207612219528
            ],
            [
              24.0399006841693,
              -30.0904715066546
            ],
            [
              23.9928699992511,
              -30.1126600001588
            ],
            [
              23.9452200034005,
              -30.1055299996098
            ],
            [
              23.9257599936288,
              -30.1441399976627
            ],
            [
              23.9392999965976,
              -30.2102600007983
            ],
            [
              23.8420799981934,
              -30.195130001848
            ],
            [
              23.956340002689,
              -30.2366200023112
            ],
            [
              23.9316899999935,
              -30.2781799979085
            ],
            [
              24.0188700066455,
              -30.3399699992161
            ],
            [
              24.0766500001974,
              -30.330990005984
            ],
            [
              24.108260000099,
              -30.3730699976822
            ],
            [
              24.2057835556665,
              -30.4105291791782
            ],
            [
              24.2776170812633,
              -30.4489229820099
            ],
            [
              24.2525799995674,
              -30.5121599978856
            ],
            [
              24.2916399886946,
              -30.5466799997821
            ],
            [
              24.2743000029428,
              -30.5838599957422
            ],
            [
              24.3781199900455,
              -30.6205700024037
            ],
            [
              24.4123390832821,
              -30.6588507847358
            ],
            [
              24.4524199998832,
              -30.6583699981768
            ],
            [
              24.511295534961,
              -30.713245944145
            ],
            [
              24.6111997245877,
              -30.7521563562308
            ],
            [
              24.6458102639326,
              -30.7541581904481
            ],
            [
              24.6795799956204,
              -30.6259599955573
            ],
            [
              24.755996771234,
              -30.4596016668834
            ],
            [
              24.8429470163917,
              -30.3660674661406
            ],
            [
              24.8791719449294,
              -30.2710912285772
            ],
            [
              24.9501690056951,
              -30.2248450033942
            ],
            [
              24.9015600051901,
              -30.208240003873
            ],
            [
              24.8676899972956,
              -30.1309399977826
            ],
            [
              24.801960001353,
              -30.0587800020954
            ],
            [
              24.7984876676718,
              -30.0341701469347
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Renosterberg Local Municipality",
        "Code": "NC075",
        "Parent_cod": "DC7",
        "Area": 552928
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              29.3624599791447,
              -25.4071100207108
            ],
            [
              29.3421299733197,
              -25.3730700319564
            ],
            [
              29.2644339597595,
              -25.3754630415861
            ],
            [
              29.2073389789108,
              -25.4145720212817
            ],
            [
              29.1956999709769,
              -25.3702800309986
            ],
            [
              29.1641199697608,
              -25.3544800299294
            ],
            [
              29.1669599604339,
              -25.3033600422321
            ],
            [
              29.0958899727441,
              -25.3211800321328
            ],
            [
              29.090169968869,
              -25.2893999659356
            ],
            [
              29.0364299718657,
              -25.2558499656034
            ],
            [
              29.0354499734375,
              -25.2548100309581
            ],
            [
              29.032259982812,
              -25.2493300201643
            ],
            [
              28.8991340040311,
              -25.2350770032011
            ],
            [
              28.7910099983128,
              -25.3283399980924
            ],
            [
              28.7709880021946,
              -25.313048004262
            ],
            [
              28.7599300012686,
              -25.3041999964326
            ],
            [
              28.7395900012776,
              -25.2885300013584
            ],
            [
              28.6956300020231,
              -25.2944600032265
            ],
            [
              28.6225799976688,
              -25.333649999248
            ],
            [
              28.6389399966836,
              -25.3939800042737
            ],
            [
              28.6197899976104,
              -25.4113899959515
            ],
            [
              28.6336800014309,
              -25.5151399969132
            ],
            [
              28.6425120031265,
              -25.5898650029675
            ],
            [
              28.6837799969493,
              -25.6753800002867
            ],
            [
              28.723869999401,
              -25.6317700009847
            ],
            [
              28.7663100014055,
              -25.6469799991276
            ],
            [
              28.7528498888114,
              -25.6939105841061
            ],
            [
              28.7927300002893,
              -25.7024299958476
            ],
            [
              28.8469500032401,
              -25.6824200011821
            ],
            [
              28.8583800033346,
              -25.6348099963842
            ],
            [
              28.8431099997268,
              -25.5664400037032
            ],
            [
              28.7970540009414,
              -25.54204499568
            ],
            [
              28.8517800029448,
              -25.5018100000314
            ],
            [
              28.9465399994215,
              -25.5997999970722
            ],
            [
              29.0077600023223,
              -25.5741600017826
            ],
            [
              28.9932400000261,
              -25.5425200022963
            ],
            [
              29.0322700012596,
              -25.5207199943323
            ],
            [
              29.0399999980016,
              -25.6175499999326
            ],
            [
              29.008290003381,
              -25.6605700017042
            ],
            [
              29.0415499984338,
              -25.7080300013834
            ],
            [
              29.1172700000105,
              -25.6565000001748
            ],
            [
              29.2425200031957,
              -25.7087599981753
            ],
            [
              29.2891299960525,
              -25.7453599979654
            ],
            [
              29.3044099974235,
              -25.681000001349
            ],
            [
              29.2868599983903,
              -25.6421999981313
            ],
            [
              29.2328399992666,
              -25.6237900017071
            ],
            [
              29.1982500112291,
              -25.5624200017816
            ],
            [
              29.2471499990733,
              -25.5329199993584
            ],
            [
              29.2543799979386,
              -25.4959100013455
            ],
            [
              29.3085799972691,
              -25.4390699989812
            ],
            [
              29.3624599791447,
              -25.4071100207108
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Thembisile Hani Local Municipality",
        "Code": "MP315",
        "Parent_cod": "DC31",
        "Area": 238436
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              22.9820399973481,
              -30.2381299999994
            ],
            [
              22.9549200012571,
              -30.2221500023207
            ],
            [
              22.955499994729,
              -30.1546499958007
            ],
            [
              22.9375699997558,
              -30.1235499996328
            ],
            [
              22.8670199982744,
              -30.1703199980694
            ],
            [
              22.8648400020646,
              -30.1122399996762
            ],
            [
              22.8107799939017,
              -30.0838500043741
            ],
            [
              22.7483399949948,
              -30.0792699946145
            ],
            [
              22.6477999945741,
              -30.1302300010137
            ],
            [
              22.6738600002388,
              -30.1885999956932
            ],
            [
              22.6080899997537,
              -30.199300002593
            ],
            [
              22.5235399965736,
              -30.1583599987149
            ],
            [
              22.4662999991457,
              -30.1904200058785
            ],
            [
              22.2995999892482,
              -30.1964300087379
            ],
            [
              22.2558599956423,
              -30.1738299998545
            ],
            [
              22.2044400004058,
              -30.217720003975
            ],
            [
              22.1819300037667,
              -30.1756599943133
            ],
            [
              22.2089899943928,
              -30.1248699975523
            ],
            [
              22.1355199922539,
              -30.1131500047688
            ],
            [
              22.0345799985681,
              -30.0575899993789
            ],
            [
              22.0142100007909,
              -30.0057800023452
            ],
            [
              21.9383549938879,
              -30.0242800002218
            ],
            [
              21.9145599991447,
              -29.9911100021249
            ],
            [
              21.8326699990213,
              -30.0278699976023
            ],
            [
              21.6947499943169,
              -29.9954399967584
            ],
            [
              21.592180000107,
              -30.011559997296
            ],
            [
              21.5752799968745,
              -30.0444099986225
            ],
            [
              21.507410004768,
              -30.0313000028927
            ],
            [
              21.4256699989713,
              -29.9863799989378
            ],
            [
              21.3713400017397,
              -30.017459995982
            ],
            [
              21.2429800008264,
              -30.0390899943078
            ],
            [
              21.1652400032236,
              -30.0856500001474
            ],
            [
              21.1430600011182,
              -30.256230004611
            ],
            [
              21.0748800046086,
              -30.3025699949093
            ],
            [
              21.0729100000965,
              -30.3322499966399
            ],
            [
              21.2198099971338,
              -30.3329300028173
            ],
            [
              21.2514857149938,
              -30.3970233630377
            ],
            [
              21.2652199994035,
              -30.474439998607
            ],
            [
              21.3081100005761,
              -30.5435599988948
            ],
            [
              21.2709149976291,
              -30.5894699981419
            ],
            [
              21.3364200002829,
              -30.6383199962707
            ],
            [
              21.3815200053441,
              -30.6992399970282
            ],
            [
              21.4209200047545,
              -30.7285900042252
            ],
            [
              21.4834399929613,
              -30.7460799995923
            ],
            [
              21.4476899981949,
              -30.7842000002298
            ],
            [
              21.4933100002564,
              -30.8281400021594
            ],
            [
              21.4696100009008,
              -30.8752399951296
            ],
            [
              21.5019799971792,
              -30.9148099960844
            ],
            [
              21.4830300001345,
              -30.9938600010382
            ],
            [
              21.5255500004322,
              -31.0034800013011
            ],
            [
              21.5098200007924,
              -31.0572200045995
            ],
            [
              21.5672499997877,
              -31.0969200007574
            ],
            [
              21.5880899958566,
              -31.0619200019065
            ],
            [
              21.670689992749,
              -31.0975999907469
            ],
            [
              21.7001099977782,
              -31.0635100050826
            ],
            [
              21.8459500043893,
              -31.0640899985546
            ],
            [
              21.9182599944033,
              -31.0435199996482
            ],
            [
              21.949669994075,
              -31.0128700026485
            ],
            [
              22.0032100052376,
              -31.0123700056712
            ],
            [
              22.0822099961944,
              -31.0514999989257
            ],
            [
              22.0770400023943,
              -31.1342699982618
            ],
            [
              22.1874799917083,
              -31.1688999962378
            ],
            [
              22.2145099908435,
              -31.2162600029967
            ],
            [
              22.2665499957857,
              -31.1658300093474
            ],
            [
              22.3184900042104,
              -31.1429399951845
            ],
            [
              22.4435199972501,
              -31.1309500052385
            ],
            [
              22.4976299942288,
              -31.095800003967
            ],
            [
              22.501217946551,
              -31.0583368267831
            ],
            [
              22.4624099807361,
              -31.0068408361356
            ],
            [
              22.6647400041479,
              -30.9543399978925
            ],
            [
              22.6901400018597,
              -30.9754999979265
            ],
            [
              22.781910000746,
              -30.9476200072576
            ],
            [
              22.8966099958547,
              -30.8797499989632
            ],
            [
              22.896850003325,
              -30.8563299972316
            ],
            [
              23.0561900056643,
              -30.8822699991612
            ],
            [
              23.1093700056213,
              -30.8282099990922
            ],
            [
              23.0674499988185,
              -30.7993299982808
            ],
            [
              23.0555499977343,
              -30.7285299978611
            ],
            [
              23.0132920041227,
              -30.6587929978985
            ],
            [
              23.0644600021274,
              -30.651169992601
            ],
            [
              23.0943299973315,
              -30.5674499989183
            ],
            [
              23.162300001244,
              -30.588930002018
            ],
            [
              23.170180004004,
              -30.5543200040649
            ],
            [
              23.2425300012586,
              -30.54131999722
            ],
            [
              23.2243000014439,
              -30.4882499987384
            ],
            [
              23.2302599966016,
              -30.398730001988
            ],
            [
              23.1332099997417,
              -30.3814699983417
            ],
            [
              23.0667800011962,
              -30.391630001923
            ],
            [
              22.9979899963413,
              -30.3773500106944
            ],
            [
              22.9591899976204,
              -30.2732299872741
            ],
            [
              22.9820399973481,
              -30.2381299999994
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Kareeberg Local Municipality",
        "Code": "NC074",
        "Parent_cod": "DC7",
        "Area": 1770076
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              29.8617900012076,
              -25.8624500025655
            ],
            [
              29.9437500036598,
              -25.9056600014079
            ],
            [
              29.9898800031597,
              -25.8836599968113
            ],
            [
              30.0866880032488,
              -25.8602939975699
            ],
            [
              30.1497099957198,
              -25.8297199995783
            ],
            [
              30.2008299987055,
              -25.8364299960475
            ],
            [
              30.2137500018612,
              -25.8040199988238
            ],
            [
              30.2703999990608,
              -25.8253700013245
            ],
            [
              30.2434400022544,
              -25.8721100100688
            ],
            [
              30.2990500018562,
              -25.926379997339
            ],
            [
              30.3311099982279,
              -25.8805400013199
            ],
            [
              30.3811499963752,
              -25.8868999960379
            ],
            [
              30.5148500016263,
              -25.7879100041433
            ],
            [
              30.4863799981384,
              -25.7621999984311
            ],
            [
              30.5192999990957,
              -25.728550000682
            ],
            [
              30.5586400083298,
              -25.7682599990997
            ],
            [
              30.6111900089118,
              -25.7190200009722
            ],
            [
              30.6466299947785,
              -25.7124200086764
            ],
            [
              30.6656199981645,
              -25.6729800011261
            ],
            [
              30.5937099969188,
              -25.5541300016982
            ],
            [
              30.5341200026361,
              -25.5360000028977
            ],
            [
              30.5653459992186,
              -25.481235996444
            ],
            [
              30.4801100021749,
              -25.4523900016971
            ],
            [
              30.4424299966471,
              -25.380820002641
            ],
            [
              30.4492399986271,
              -25.3449599983053
            ],
            [
              30.40138999805,
              -25.380839999966
            ],
            [
              30.4178000029678,
              -25.4235000022234
            ],
            [
              30.3509900012876,
              -25.4924799969543
            ],
            [
              30.3014199978347,
              -25.4449799963297
            ],
            [
              30.2626300022728,
              -25.4730300038316
            ],
            [
              30.2294599978807,
              -25.4324100012205
            ],
            [
              30.2517099969189,
              -25.3572870028928
            ],
            [
              30.205579997419,
              -25.3568200002428
            ],
            [
              30.190850000727,
              -25.3253400036382
            ],
            [
              30.1880799970942,
              -25.3203400023892
            ],
            [
              30.19075000331,
              -25.2758100020299
            ],
            [
              30.1432300062599,
              -25.245810009824
            ],
            [
              30.083440000056,
              -25.2940799991926
            ],
            [
              30.0254600035764,
              -25.3677200001779
            ],
            [
              29.9905899828415,
              -25.3382500261178
            ],
            [
              29.8879199624363,
              -25.3385799559002
            ],
            [
              29.8402999715665,
              -25.3863200314443
            ],
            [
              29.7931899682424,
              -25.3620599666941
            ],
            [
              29.7702399719971,
              -25.4015300295872
            ],
            [
              29.6738599718603,
              -25.3721600295617
            ],
            [
              29.6127899731787,
              -25.4006100303286
            ],
            [
              29.5226299613037,
              -25.4050400403656
            ],
            [
              29.51882997942,
              -25.4227900216421
            ],
            [
              29.5114699988414,
              -25.4588100027794
            ],
            [
              29.5477500009618,
              -25.5202000000299
            ],
            [
              29.5801500004223,
              -25.5400599976707
            ],
            [
              29.5859299962724,
              -25.581449998019
            ],
            [
              29.7131100030243,
              -25.5721800004067
            ],
            [
              29.7064200029808,
              -25.6134200019315
            ],
            [
              29.7766699996208,
              -25.6198299971566
            ],
            [
              29.7851799999571,
              -25.6742600016977
            ],
            [
              29.825899999985,
              -25.7014200032305
            ],
            [
              29.850980000027,
              -25.7650199998731
            ],
            [
              29.8106949966769,
              -25.7654299980959
            ],
            [
              29.800940002779,
              -25.8487600016727
            ],
            [
              29.8617900012076,
              -25.8624500025655
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Emakhazeni Local Municipality",
        "Code": "MP314",
        "Parent_cod": "DC31",
        "Area": 473559
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              24.6458102639326,
              -30.7541581904481
            ],
            [
              24.6111997245877,
              -30.7521563562308
            ],
            [
              24.511295534961,
              -30.713245944145
            ],
            [
              24.4524199998832,
              -30.6583699981768
            ],
            [
              24.4123390832821,
              -30.6588507847358
            ],
            [
              24.3781199900455,
              -30.6205700024037
            ],
            [
              24.2743000029428,
              -30.5838599957422
            ],
            [
              24.2916399886946,
              -30.5466799997821
            ],
            [
              24.2525799995674,
              -30.5121599978856
            ],
            [
              24.2776170812633,
              -30.4489229820099
            ],
            [
              24.2057835556665,
              -30.4105291791782
            ],
            [
              24.108260000099,
              -30.3730699976822
            ],
            [
              24.0766500001974,
              -30.330990005984
            ],
            [
              24.0188700066455,
              -30.3399699992161
            ],
            [
              23.9316899999935,
              -30.2781799979085
            ],
            [
              23.956340002689,
              -30.2366200023112
            ],
            [
              23.8420799981934,
              -30.195130001848
            ],
            [
              23.8207099992671,
              -30.1413999981113
            ],
            [
              23.776339997293,
              -30.1030399998961
            ],
            [
              23.7139700034129,
              -30.1201600015827
            ],
            [
              23.6860699974325,
              -30.0901199967404
            ],
            [
              23.6424599981304,
              -30.1443499983537
            ],
            [
              23.6053900063438,
              -30.1121900018671
            ],
            [
              23.5568700027485,
              -30.1021100028743
            ],
            [
              23.4977199981794,
              -30.0586200001128
            ],
            [
              23.3528900021719,
              -30.0661300010986
            ],
            [
              23.296089995357,
              -29.9940400032435
            ],
            [
              23.2394499977192,
              -29.9019599909608
            ],
            [
              23.1836770328688,
              -29.9380646738456
            ],
            [
              23.206658357897,
              -30.0393860151525
            ],
            [
              23.1820160003382,
              -30.094968996422
            ],
            [
              23.1141429999995,
              -30.132131999692
            ],
            [
              23.1131399978127,
              -30.1564299915509
            ],
            [
              22.9820399973481,
              -30.2381299999994
            ],
            [
              22.9591899976204,
              -30.2732299872741
            ],
            [
              22.9979899963413,
              -30.3773500106944
            ],
            [
              23.0667800011962,
              -30.391630001923
            ],
            [
              23.1332099997417,
              -30.3814699983417
            ],
            [
              23.2302599966016,
              -30.398730001988
            ],
            [
              23.2243000014439,
              -30.4882499987384
            ],
            [
              23.2425300012586,
              -30.54131999722
            ],
            [
              23.170180004004,
              -30.5543200040649
            ],
            [
              23.162300001244,
              -30.588930002018
            ],
            [
              23.0943299973315,
              -30.5674499989183
            ],
            [
              23.0644600021274,
              -30.651169992601
            ],
            [
              23.0132920041227,
              -30.6587929978985
            ],
            [
              23.0555499977343,
              -30.7285299978611
            ],
            [
              23.0674499988185,
              -30.7993299982808
            ],
            [
              23.1093700056213,
              -30.8282099990922
            ],
            [
              23.164820001442,
              -30.8625999976916
            ],
            [
              23.2253000025931,
              -30.9537299976412
            ],
            [
              23.3255100003863,
              -30.9539899961414
            ],
            [
              23.4017299917458,
              -31.0340999996153
            ],
            [
              23.5134849958359,
              -30.950600005286
            ],
            [
              23.5567496401838,
              -31.0075753718059
            ],
            [
              23.5894071200426,
              -31.0030314338536
            ],
            [
              23.5992743439358,
              -30.9428786582234
            ],
            [
              23.6582986196856,
              -30.8969092884329
            ],
            [
              23.7033201112342,
              -30.9419734905841
            ],
            [
              23.7616929792477,
              -30.9054291597278
            ],
            [
              23.8140233599902,
              -30.9068508071189
            ],
            [
              23.8604299936494,
              -30.8649400048773
            ],
            [
              23.9876422977539,
              -30.9109126149251
            ],
            [
              23.9506285064005,
              -30.9716802633335
            ],
            [
              24.0547721837893,
              -30.977753198951
            ],
            [
              24.1367876420361,
              -31.0428608784268
            ],
            [
              24.1235000023232,
              -31.1053300000794
            ],
            [
              24.1705600051402,
              -31.1534800010012
            ],
            [
              24.1522999976468,
              -31.1803500062478
            ],
            [
              24.2348900039706,
              -31.2179999996002
            ],
            [
              24.2372320112484,
              -31.2737330003776
            ],
            [
              24.2656299979261,
              -31.3240399982472
            ],
            [
              24.3225800071617,
              -31.3177399991017
            ],
            [
              24.3213699972276,
              -31.3636499983487
            ],
            [
              24.3875299977112,
              -31.3868000020184
            ],
            [
              24.4009499978442,
              -31.4435999917461
            ],
            [
              24.4457399994015,
              -31.4786399978376
            ],
            [
              24.4787800013959,
              -31.431749996565
            ],
            [
              24.5671900009178,
              -31.4186400008354
            ],
            [
              24.5639699963184,
              -31.3773700024236
            ],
            [
              24.6615099977882,
              -31.2878199979945
            ],
            [
              24.7515099932916,
              -31.1403199993684
            ],
            [
              24.7508600019876,
              -31.0959599969562
            ],
            [
              24.8223761541363,
              -31.0403940470476
            ],
            [
              24.8472699999106,
              -30.9918900037206
            ],
            [
              24.8026200012121,
              -30.9724099957247
            ],
            [
              24.757820000093,
              -30.8705499982838
            ],
            [
              24.7038099987325,
              -30.8284999962777
            ],
            [
              24.6812699962135,
              -30.8514899979651
            ],
            [
              24.6303467478042,
              -30.8362158736636
            ],
            [
              24.6673530442077,
              -30.7669748588027
            ],
            [
              24.6458102639326,
              -30.7541581904481
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Emthanjeni Local Municipality",
        "Code": "NC073",
        "Parent_cod": "DC7",
        "Area": 1347214
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              26.8181300109912,
              -28.9271399931162
            ],
            [
              26.946320004065,
              -28.9397200039749
            ],
            [
              26.9624299942489,
              -29.0219400148198
            ],
            [
              26.9948500027255,
              -29.0219300017681
            ],
            [
              27.051339996144,
              -29.070609996554
            ],
            [
              26.9997599908309,
              -29.105259994553
            ],
            [
              26.9172099917478,
              -29.1820999929203
            ],
            [
              26.9174299893026,
              -29.2197599966265
            ],
            [
              26.9632899889419,
              -29.2569399961838
            ],
            [
              26.9427800080909,
              -29.315669991277
            ],
            [
              26.9769199996584,
              -29.3740899990541
            ],
            [
              27.0226499995979,
              -29.3804500027654
            ],
            [
              27.0533500007021,
              -29.3435900017771
            ],
            [
              27.085640004083,
              -29.3856699970727
            ],
            [
              27.0676500027455,
              -29.441589996581
            ],
            [
              27.0109599983054,
              -29.3951399994114
            ],
            [
              26.9629100100889,
              -29.4280399886545
            ],
            [
              26.9989999980516,
              -29.5197599960269
            ],
            [
              27.0607100001664,
              -29.5228300018031
            ],
            [
              27.0814000010093,
              -29.5591799990577
            ],
            [
              27.1274300030923,
              -29.5746700029183
            ],
            [
              27.1855499979342,
              -29.5661399989617
            ],
            [
              27.277870003298,
              -29.5262599989997
            ],
            [
              27.3704699972926,
              -29.4487500003122
            ],
            [
              27.4722899982849,
              -29.3184600030267
            ],
            [
              27.5476299904317,
              -29.2463600029118
            ],
            [
              27.5514000042069,
              -29.1961600018826
            ],
            [
              27.6141699994459,
              -29.1641800002068
            ],
            [
              27.6502499977392,
              -29.1099800008764
            ],
            [
              27.6132300010638,
              -29.0888300040014
            ],
            [
              27.5921999980315,
              -29.0320499990082
            ],
            [
              27.5276699998707,
              -29.012838997122
            ],
            [
              27.4783599976158,
              -28.8733000031926
            ],
            [
              27.4017700017842,
              -28.8707899998586
            ],
            [
              27.3175559988104,
              -28.8389189969142
            ],
            [
              27.2681099965791,
              -28.8386399966385
            ],
            [
              27.1863050021742,
              -28.8052629988882
            ],
            [
              27.1521700000455,
              -28.7566000003897
            ],
            [
              27.0462699988615,
              -28.7699099972486
            ],
            [
              27.02968000273,
              -28.7438899988243
            ],
            [
              26.9469900025866,
              -28.7502600011981
            ],
            [
              26.9110899973055,
              -28.7683300017282
            ],
            [
              26.8537299997398,
              -28.8862800037191
            ],
            [
              26.8181300109912,
              -28.9271399931162
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Mantsopa Local Municipality",
        "Code": "FS196",
        "Parent_cod": "DC19",
        "Area": 429059
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              29.8046899976453,
              -26.1895100033839
            ],
            [
              29.8110599991197,
              -26.1052999987959
            ],
            [
              29.8657899986096,
              -26.0139299985706
            ],
            [
              29.8769599984052,
              -25.96521000194
            ],
            [
              29.830569996808,
              -25.9219299998696
            ],
            [
              29.8617900012076,
              -25.8624500025655
            ],
            [
              29.800940002779,
              -25.8487600016727
            ],
            [
              29.8106949966769,
              -25.7654299980959
            ],
            [
              29.850980000027,
              -25.7650199998731
            ],
            [
              29.825899999985,
              -25.7014200032305
            ],
            [
              29.7851799999571,
              -25.6742600016977
            ],
            [
              29.7766699996208,
              -25.6198299971566
            ],
            [
              29.7064200029808,
              -25.6134200019315
            ],
            [
              29.7131100030243,
              -25.5721800004067
            ],
            [
              29.5859299962724,
              -25.581449998019
            ],
            [
              29.5801500004223,
              -25.5400599976707
            ],
            [
              29.5477500009618,
              -25.5202000000299
            ],
            [
              29.5114699988414,
              -25.4588100027794
            ],
            [
              29.51882997942,
              -25.4227900216421
            ],
            [
              29.4527799732172,
              -25.407250029865
            ],
            [
              29.3624599791447,
              -25.4071100207108
            ],
            [
              29.3085799972691,
              -25.4390699989812
            ],
            [
              29.2543799979386,
              -25.4959100013455
            ],
            [
              29.2471499990733,
              -25.5329199993584
            ],
            [
              29.1982500112291,
              -25.5624200017816
            ],
            [
              29.2328399992666,
              -25.6237900017071
            ],
            [
              29.2868599983903,
              -25.6421999981313
            ],
            [
              29.3044099974235,
              -25.681000001349
            ],
            [
              29.2891299960525,
              -25.7453599979654
            ],
            [
              29.2920099957648,
              -25.7950500033549
            ],
            [
              29.3279799979785,
              -25.7917199963806
            ],
            [
              29.3510400028939,
              -25.899280001271
            ],
            [
              29.3755299982109,
              -25.9133200021164
            ],
            [
              29.3649200008574,
              -25.9429800002268
            ],
            [
              29.3297599973261,
              -25.9869200030557
            ],
            [
              29.4024479993758,
              -26.063212007628
            ],
            [
              29.3336700031681,
              -26.0952200016018
            ],
            [
              29.3910399966986,
              -26.1441900016671
            ],
            [
              29.3879699999157,
              -26.2049000008343
            ],
            [
              29.4555499993331,
              -26.2114000029078
            ],
            [
              29.4934499961205,
              -26.169549999333
            ],
            [
              29.5602259980315,
              -26.2092079962519
            ],
            [
              29.5403500005521,
              -26.2538799977637
            ],
            [
              29.5942800009213,
              -26.2397899982098
            ],
            [
              29.6676299984257,
              -26.2446400024341
            ],
            [
              29.7153599970663,
              -26.2038499991781
            ],
            [
              29.7588400029639,
              -26.2254100023697
            ],
            [
              29.8046899976453,
              -26.1895100033839
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Steve Tshwete Local Municipality",
        "Code": "MP313",
        "Parent_cod": "DC31",
        "Area": 397645
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              16.9946099999516,
              -29.5150050015796
            ],
            [
              17.0372900022319,
              -29.500720011919
            ],
            [
              17.0867700006351,
              -29.4436999967574
            ],
            [
              17.1039600001539,
              -29.3753100013555
            ],
            [
              17.0916199985641,
              -29.3338300022527
            ],
            [
              17.174830004701,
              -29.3027199984292
            ],
            [
              17.1672599982504,
              -29.2728499951311
            ],
            [
              17.2382100010907,
              -29.2406700004202
            ],
            [
              17.2998899973256,
              -29.3044799941563
            ],
            [
              17.3574499987185,
              -29.3279500017912
            ],
            [
              17.3264200003828,
              -29.4043300050257
            ],
            [
              17.369809999432,
              -29.4178399931212
            ],
            [
              17.468120004035,
              -29.4199799991776
            ],
            [
              17.5208500057232,
              -29.4374300052905
            ],
            [
              17.5653400033385,
              -29.3978600043357
            ],
            [
              17.5405899960315,
              -29.3376300003242
            ],
            [
              17.4604599997293,
              -29.0276800061274
            ],
            [
              17.4622069975549,
              -28.854527002619
            ],
            [
              17.3490090006649,
              -28.7944569942948
            ],
            [
              17.4187089953239,
              -28.7219810020216
            ],
            [
              17.4296600012082,
              -28.5698700029982
            ],
            [
              17.3891299973515,
              -28.5711800013559
            ],
            [
              17.365730001938,
              -28.5090100077056
            ],
            [
              17.3330800017407,
              -28.4749099981978
            ],
            [
              17.3553000011941,
              -28.4368400043627
            ],
            [
              17.3965200017967,
              -28.4273799970891
            ],
            [
              17.4140399967485,
              -28.3760400064411
            ],
            [
              17.3757699945896,
              -28.3211599982352
            ],
            [
              17.3822600033965,
              -28.2958999952885
            ],
            [
              17.3339999983014,
              -28.2260900054493
            ],
            [
              17.214980000027,
              -28.2480799969942
            ],
            [
              17.1841500010218,
              -28.208820001342
            ],
            [
              17.196259994703,
              -28.127789991415
            ],
            [
              17.1444599972311,
              -28.0956500030451
            ],
            [
              17.082499996178,
              -28.0330700012795
            ],
            [
              16.884590002127,
              -28.0899399888394
            ],
            [
              16.8879299951732,
              -28.1728799969143
            ],
            [
              16.8569700009648,
              -28.2069300014184
            ],
            [
              16.803059996122,
              -28.2220200003227
            ],
            [
              16.7550199993736,
              -28.3020000022982
            ],
            [
              16.8081600010833,
              -28.3608400033634
            ],
            [
              16.7693700028234,
              -28.3961199989388
            ],
            [
              16.7768299979062,
              -28.4400600008683
            ],
            [
              16.7339900017373,
              -28.4942600028968
            ],
            [
              16.6884699970928,
              -28.4704699993909
            ],
            [
              16.6211299997497,
              -28.5001300028973
            ],
            [
              16.59245999873,
              -28.5354200070277
            ],
            [
              16.4802099987924,
              -28.5654999939295
            ],
            [
              16.4518900004232,
              -28.6320999940195
            ],
            [
              16.5623099987075,
              -28.7190500017561
            ],
            [
              16.5619099982479,
              -28.7589500062378
            ],
            [
              16.6047500016113,
              -28.8767499950162
            ],
            [
              16.6898199927985,
              -28.9269700050616
            ],
            [
              16.7479300060649,
              -29.0425399989218
            ],
            [
              16.8151099996268,
              -29.0902500092305
            ],
            [
              16.8432099986425,
              -29.1860299978861
            ],
            [
              16.8380399958492,
              -29.2109799982283
            ],
            [
              16.8773699983268,
              -29.2925400029188
            ],
            [
              16.9351400004108,
              -29.35956999406
            ],
            [
              16.9461800023053,
              -29.4079900011376
            ],
            [
              16.9946099999516,
              -29.5150050015796
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Richtersveld Local Municipality",
        "Code": "NC061",
        "Parent_cod": "DC6",
        "Area": 960767
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              29.6768499586587,
              -27.9595100426543
            ],
            [
              29.6576499779642,
              -27.9374000239918
            ],
            [
              29.6903499705747,
              -27.8957299666646
            ],
            [
              29.6970299790001,
              -27.824480039
            ],
            [
              29.7312599700001,
              -27.808079966
            ],
            [
              29.703039969,
              -27.761449968
            ],
            [
              29.7089900369607,
              -27.6984999662004
            ],
            [
              29.6701199790001,
              -27.6701299769999
            ],
            [
              29.7348099700001,
              -27.607099968
            ],
            [
              29.779559971,
              -27.5873000319999
            ],
            [
              29.7583599718352,
              -27.5271100332014
            ],
            [
              29.7123650370001,
              -27.5184399689999
            ],
            [
              29.70316998081,
              -27.4719999712216
            ],
            [
              29.7586799856928,
              -27.442570015194
            ],
            [
              29.6992900024317,
              -27.4503399993914
            ],
            [
              29.7042699991611,
              -27.4894000029078
            ],
            [
              29.6189100017952,
              -27.5060200022213
            ],
            [
              29.4689899958917,
              -27.3242000037272
            ],
            [
              29.4629499988435,
              -27.2871399989118
            ],
            [
              29.4188599989898,
              -27.2545200000979
            ],
            [
              29.3395799996173,
              -27.2527300029872
            ],
            [
              29.3314699997408,
              -27.2101000030127
            ],
            [
              29.2298099944357,
              -27.1672299991651
            ],
            [
              29.223870001999,
              -27.1447000034024
            ],
            [
              29.1363699985766,
              -27.1542200035502
            ],
            [
              29.0860100027594,
              -27.1152599983502
            ],
            [
              29.0610300010338,
              -27.0717500027604
            ],
            [
              29.0572300002643,
              -27.0092999997951
            ],
            [
              29.0151413993562,
              -27.0099578439794
            ],
            [
              28.9965190891847,
              -27.0796604160953
            ],
            [
              29.005649566874,
              -27.1669006350562
            ],
            [
              28.9787386325819,
              -27.2063063280746
            ],
            [
              28.9670295719572,
              -27.2800102231932
            ],
            [
              28.9373626706508,
              -27.287685393666
            ],
            [
              28.9160353112807,
              -27.3460874123042
            ],
            [
              28.9264349077449,
              -27.4022305408067
            ],
            [
              28.8807506563178,
              -27.4435005194334
            ],
            [
              28.7855358124279,
              -27.4624938961763
            ],
            [
              28.7739199998082,
              -27.5314599999789
            ],
            [
              28.7456199996633,
              -27.533699999855
            ],
            [
              28.7429200909894,
              -27.5990485843246
            ],
            [
              28.7380899995539,
              -27.635119998589
            ],
            [
              28.7811199999881,
              -27.6870999980664
            ],
            [
              28.7443899986995,
              -27.7285699994059
            ],
            [
              28.7812099987425,
              -27.7720099971636
            ],
            [
              28.7672499997877,
              -27.8121800006065
            ],
            [
              28.7679299969718,
              -27.8887099999665
            ],
            [
              28.7214200024312,
              -27.918229997916
            ],
            [
              28.7379599998542,
              -27.9760999992156
            ],
            [
              28.7520619810756,
              -28.0073127577775
            ],
            [
              28.8047499979141,
              -28.0198299995548
            ],
            [
              28.7697700008848,
              -28.1245799998671
            ],
            [
              28.8791099970288,
              -28.1376699892786
            ],
            [
              28.9989099997967,
              -28.0745400017196
            ],
            [
              29.0068700044472,
              -28.0207600001738
            ],
            [
              29.0659199981094,
              -28.0221700013444
            ],
            [
              29.1176399972881,
              -28.0489499979441
            ],
            [
              29.1611300009489,
              -28.011769999286
            ],
            [
              29.2708300038017,
              -27.9967200040249
            ],
            [
              29.3111399984123,
              -28.0115400003707
            ],
            [
              29.3144599986301,
              -28.0728100028793
            ],
            [
              29.380470002089,
              -28.1202599958022
            ],
            [
              29.405129998051,
              -28.0780000020984
            ],
            [
              29.5640000029978,
              -28.1891300016482
            ],
            [
              29.5199899969408,
              -28.2205500017812
            ],
            [
              29.5099200442747,
              -28.2654399369035
            ],
            [
              29.6197650268346,
              -28.2412199603329
            ],
            [
              29.6263399694141,
              -28.1857399703233
            ],
            [
              29.6632899340001,
              -28.142020045
            ],
            [
              29.6554799768196,
              -28.0900200258035
            ],
            [
              29.6168619828942,
              -28.0468380156618
            ],
            [
              29.6506999720001,
              -27.967120035
            ],
            [
              29.6768499586587,
              -27.9595100426543
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Phumelela Local Municipality",
        "Code": "FS195",
        "Parent_cod": "DC19",
        "Area": 819724
      }
    }
  ]
}